import React, {useEffect, useState, useRef, useCallback, useLayoutEffect, forwardRef, memo} from "react";
import {
    DisplayMode,
    ExcalidrawImperativeAPI,
    ExcalidrawInitialDataState, PageSizeValues,
} from "../../../@excalidraw/packages/excalidraw/types";
import "./DrawIndex.scss";
import "./Leftmenu.scss";
import "../../../@excalidraw/packages/excalidraw/components/VideoNotes/VideoNotes.scss";

import {
    resolvablePromise,
    MenuItem,
    getItem,
    imgPathPerfix,
    generateUUID2,
    getQueryParam,
    isStringNullOrEmpty,
    getUrlQueryParam,
    generateRandomPageKey,
    removeHtmlTags,
    generateShortUUID,
    isDevMode,
    createNoteElementByNote,
    blobToBase64,
    base64ToBlob,
    isFileHtml,
    hasLicense,
    getFileNameWithoutExt,
    getFileNameExt,
    isFileVideoElement,
    createVideoFileElementHtmlFromWeb,
    isDarkMode,
    getImagePathWithTheme,
    getFileName,
    isImage,
    isPdfFileElement,
    isDefaultBackgroundColor,
    blobToFile,
    getMindmapFiles,
    getNoteDocThumbHtml,
    getPdfImageThumb,
    isAudioFileElement,
    getVideoImageThumb,
    createFileElementHtml,
    recursionMindmapData,
    createCopyLink,
    createPdfAnnoTextElement,
    firstLetterUpper,
    logger,
    isString,
    hasPublishLicense,
    isNoteElement,
    getCtrlOrAlt,
    isVideo,
    getMindmapFiles0,
    getTimeText,
    formatDate,
    isYoutubeUrl,
    getYoutubeThumbUrl,
    isArray,
    isCardEmpty,
    isCardEmptyCard,
    getIntValue,
    getFileImportMode,
    extFromMineType,
    createPdfFileElementHtmlFromWeb,
    isSvg,
    decodeDeeplink,
    getBase64ImageSize,
    calcTextAreaHeight,
    calcTextHeight,
    isVideoAnnoElement,
    calcVideoAnnoHeight,
    hasDesktopLicense,
    isPdfAnnoElement,
    getImagePath,
    isAudioAnnoElement,
    isCardAnnoElement,
    isDeepLink,
    isPdf,
    isSupportVideoAnnoUrl,
    isJson,
    hasPremiumLicense,
    isInSidebar,
    jsonToStringReplaceIcon,
    createEmptyProject,
    getCssPath,
    isAudio,
    hasDesktopBaseLicense,
    createCopyLinkByLibraryItem,
    isAnnoElement,
    getCtrlOrAltCmd,
    isLiveVideoElement,
    isLiveVideoType,
    getSafeInt,
    isSupportVideoType,
    getVideoScale,
    getLocalFilePath,
    isObject,
    replaceLast,
    getImagePathWithThemeSvg,
    isMd,
    hasBeyondTextLimit, isShape, isShortcuts,
} from "../../utils";
import {
    debounce,
    isRunningInIframe,
    isTestEnv,
    ResolvablePromise, viewportCoordsToSceneCoords
} from "../../../@excalidraw/packages/excalidraw/utils";
import LeftMenu from "./LeftMenu";
import MyExcalidraw from "./MyExcalidraw";
import {render} from "react-dom";
import clipboard from "clipboardy";
import {
    message,
    Layout,
    Row,
    Col,
    Button,
    Input,
    Space,
    Dropdown,
    MenuProps,
    Popover,
    ColorPicker,
    theme, Modal, Image, Select, Spin, List, ConfigProvider, Tooltip, Progress, Slider, Upload, Checkbox
} from "antd";
import { Header ,Footer} from "antd/es/layout/layout";
import Sider from "antd/es/layout/Sider";
import { Content } from "antd/lib/layout/layout";
import Icon, {
    LeftOutlined,
    RightOutlined,
    LoadingOutlined
} from "@ant-design/icons";
import {APP_WEB, APP_WEB_SITE, APP_WEB_WWW, DEBUG, isOfflineWeb, isWeb, isWebApp} from "../../electron_interactive";
import {
    apiSecondLevelDomain,
    canvasContent,
    noteInfoById,
    notePublish,
    sendGetRequest,
    shareCanvas
} from "../../api/Api";
import {nanoid} from "nanoid";
import querystring from "querystring";
import * as url from "url";
import qs from "qs";
import {useNavigate, useParams} from "react-router-dom";
import {TNote} from "@/index";
import {getNoteName, noteServer} from "@/common/notesServer";
import {
    deleteAllCardFromRefProject,
    delNote, getJsonNoteById,
    getNoteById, getNoteJsonById, getNoteJsonDoc,
    getNoteList,
    getNoteListCount,
    updateNote,
    updateNoteItemToHasUpdate, updateNoteLastView,updateProject, updateProjectViewTime
} from "@model/note";
import {useLocale} from "antd/es/locale";
import {useLocation} from "react-use";
import {ipcInvoke, ipcOn, ipcOnce, ipcRemove, ipcRemoveThisAll, ipcSend} from "@/common/ipc";
import DialogExport from "@/views/Draw/DialogExport";
import {useTranslation} from "react-i18next";
import {postMessage, recvMessage, unSubscribe} from "@/common/event";
import emitter, {
    ARRAY_DEFAULT_PROJECT_ITEM_THUMB_BIG,
    ARRAY_IFRAME_SIZE,
    arrayDarkMenu,
    AUTO_SAVE_TIME_INTERVAL,
    COLOR_CHOOSE_TYPE_MINDMAP_LINE_COLOR,
    COLOR_E5E5E5,
    COLOR_TOOL_BAR,
    COLOR_TRANSPARENT, DEFAULT_AUDIO_HEIGHT, DEFAULT_AUDIO_WIDTH,
    DEFAULT_CANVAS_BACKGROUND,
    DEFAULT_CANVAS_BACKGROUND_DARK, DEFAULT_EMBEDABLE_BOOKMARK_HEIGHT, DEFAULT_EMBEDABLE_ELEMENT_HEIGHT,
    DEFAULT_IMAGE_COLOR, DEFAULT_NOTE_HEIGHT,
    DEFAULT_NOTE_WIDTH,
    DEFAULT_SLIDER_COMMON_WIDTH,
    DEFAULT_SLIDER_LIBRARY_WIDTH,
    DEFAULT_SLIDER_PDF_WIDTH,
    DEFAULT_SLIDER_WIDTH, DEFAULT_STICKYNOTE_BACKGROUND_COLOR,
    DESKTOP_PRO_FROM_IMPORT_FILE,
    DESKTOP_PRO_FROM_IMPORT_FONT,
    DESKTOP_PRO_FROM_LASER_POINTER,
    DESKTOP_PRO_FROM_OCR,
    DRAW_LINK_CLICK,
    DRAW_TOOL_POPOVER_TOP,
    DRAW_TOOLS_HEIGHT,
    EVENT_ADD_NOTE,
    EVENT_CANVAS_REFRESH_ELEMENT_COUNT,
    EVENT_CHANGE_THEME,
    EVENT_CHOOSE_INSERT_PDF_FILE,
    EVENT_CLEAR_CANVAS,
    EVENT_CLOSE_IFRAME_DRAWINDEX,
    EVENT_COPY_DOC_NOTE,
    EVENT_DELETE_ELEMENT,
    EVENT_DELETE_ELEMENT_BY_ID,
    EVENT_DELETE_HTML_NOTE,
    EVENT_DELETE_PDF_FROM_DIALOG,
    EVENT_DIALOG_DRAW_INDEX_ISFULLSCREEN,
    EVENT_FAVIRIATE_CHANGE,
    EVENT_FORCE_UPDATE,
    EVENT_FRAME_PAGE_DESC_VISIBLE,
    EVENT_FRAME_PAGES,
    EVENT_FRAME_PREVIEW_LAST,
    EVENT_FRAME_PREVIEW_NEXT, EVENT_HIDDEN_FLOAT_MENU,
    EVENT_KEY_ESCAPSE,
    EVENT_KEY_ESCAPSE_ESC,
    EVENT_KEYDOWN,
    EVENT_MAX_DRAG_IMAGE,
    EVENT_MINDMAP_ADD_LINK,
    EVENT_MINDMAP_LINE_COLOR,
    EVENT_MINDMAP_LINE_COLOR_OK,
    EVENT_MINDMAP_REMOVE_ATTACH,
    EVENT_NAVIGATE_DEEPLINK,
    EVENT_NOTE_CHANGED,
    EVENT_NOTE_DELETE,
    EVENT_NOTE_ON_SLIDER_RIGHT,
    EVENT_OPEN_NOTE,
    EVENT_OPEN_SELECT_FONT_FAMILY,
    EVENT_OPEN_VIDEO_IN_POPUP,
    EVENT_PDF_ON_SLIDER_RIGHT, EVENT_PROJECT_ON_SlIDER_RIGHT, EVENT_REFRESH_ANNO_NAME,
    EVENT_REFRESH_CANVAS,
    EVENT_REFRESH_CURRENT_CANVAS, EVENT_REFRESH_DRAW_FAVOR,
    EVENT_REFRESH_FAVOR, EVENT_REFRESH_HIGHLIGHT_LIST,
    EVENT_REFRESH_LIBRARY_LIST,
    EVENT_REFRESH_LOGIN_STATUS, EVENT_REFRESH_PDF_ANNO_COMMENT,
    EVENT_REFRESH_PDF_HIGHLIGHT,
    EVENT_REFRESH_RECENTS, EVENT_REFRESH_SLIDER_INFO,
    EVENT_REFRESH_VIDEO_ANNO_ELEMENT, EVENT_RENAME_LIBRARY_ITEM, EVENT_RESET_NO_SELECTED,
    EVENT_RICH_TEXT_SELECTED,
    EVENT_SELECT_ELEMENT_IN_CANVAS_BY_ELEID,
    EVENT_SHOW_DIALOG_DRAWINDEX,
    EVENT_SHOW_FONT_CHOOSE,
    EVENT_SHOW_IMPORT_FILE_VIP,
    EVENT_SHOW_IMPORT_FONT_VIP,
    EVENT_SHOW_PROGRESS,
    EVENT_SWITCH_HOME_LIST_MENU,
    EVENT_TEST_ONDRAG_NOTE,
    EVENT_TOGGLE_THEME,
    EVENT_TOOLBAR_LOCKED_CHANGED,
    EVENT_UPDATE_FORCE_CARD_IIIINNNNNFFFFOOOOOO,
    EVENT_UPDATE_FRAME_LIST,
    EVENT_UPDATE_NOTE,
    EVENT_UPDATE_PROGRESS,
    EVENT_VIDEO_ON_SLIDER_RIGHT, EVENT_WEBLINK_ON_SLIDER_RIGHT,
    EVENT_WINDOW_BAR_VISIBLE, FROM_DIALOG,
    FROM_LIBRARY, FROM_PAGE_CARD, FROM_RIGHT_SIDE, FROM_RIGHT_SIDEBAR, FROM_SIDEBAR_FOLD,
    getNoteElementBackgroundColor, getNoteElementStrokeColor, HAS_VIDEO_CAPTURE_TEST, HEADER_HEIGHT,
    IMPORT_FILE_MODE_ASKME,
    IMPORT_FILE_MODE_IMPORTMODE,
    IMPORT_FILE_MODE_LINKMODE,
    INIT_ID_GETTING_START_0, KEY_CARD_ELEMENT_DEFAULT_STYLE,
    KEY_DEFAULT_PROJECT_ID, KEY_DEFAULT_STICKYNOTE_BACKGROUND_COLOR,
    KEY_DRAW_LEFT_COLLAPSE, KEY_DRAW_LEFT_MENU_WIDTH,
    KEY_FILE_DIR,
    KEY_FILE_IMPORT_MODE, KEY_FREE_DRAW_STROKE_WIDTH, KEY_GLOBAL_CARD_DISPLAY_MODE,
    KEY_IS_FIRST_CLICK_FILE_MODE,
    KEY_MACHINEID,
    KEY_NEW_PROJECT_ID,
    KEY_PROJECT_THUMB_INDEX,
    KEY_SELECT_RIGHT_SLIDER_MENU,
    KEY_SLIDER_RIGHT_LIBRARY_WIDTH,
    KEY_SLIDER_RIGHT_WIDTH,
    KEY_USE_SCROLL_WHEEL_ZOOM,
    LASTEST_NOTE_DOC,
    LEFT_MENU_WIDTH,
    LINK_INFO_TYPE_FRAME,
    LINK_INFO_TYPE_NOTE,
    LINK_INFO_TYPE_PAGE, MAX_AUTO_CARD_EDIT_HEIGHT,
    MAX_SIZE,
    MENU_SEPARATOR,
    PAGE_SIZE,
    POPOVER_TOOLS_TOP,
    PUBLISH_FRAME_SUF,
    SHARE_LIMIT_SIZE,
    SYS_CONFIG_DEV_MODE,
    SYS_CONFIG_KEY_THEME,
    THEME_DARK,
    THEME_LIGHT,
    TITLE_BAR_HEIGHT,
    TOOL_BAR_LEFT_WIDTH,
    ZIP_DATA_DB_NAME,
} from "@/Const";
import DialogLink from "@/views/Draw/DialogLink";
import DialogExportInfo from "@/views/Draw/DialogExportInfo";
import "./DrawIndex.css"
import {
    IconAddToFavor,
    IconAddToProject,
    IconBackgroundColor, IconBoard,
    IconClose,
    IconCopyLink,
    IconDelete,
    IconDrawMakeCopy,
    IconDropdownBlack,
    IconFolder,
    IconHelp,
    IconHelperCenter,
    IconHelperChangelog,
    IconHelperDiscordCommunity, IconHelperRoadmap, IconHelperShortcuts,
    IconHelperToutorialVideo,
    IconHomeSearch,
    IconIndicatorWhite,
    IconInfoMenu,
    IconKeyboardShortcut,
    IconMakeCopy,
    IconManagerTags,
    IconMenuExportAsPdf,
    IconMenuExportAsPdfWhite,
    IconMenuExportAsPng,
    IconMenuExportAsPngWhite,
    IconMenuExportItem,
    IconMenuExportPcanvas,
    IconMenuExportPcanvasWhite,
    IconMenuExportPcanvasx,
    IconMenuExportProject,
    IconMouse,
    IconNote,
    IconNoteSearch,
    IconOfflineOpen,
    IconOpenInFullscreen,
    IconOpenInPopup,
    IconPageBlack,
    IconPreference,
    IconRedo,
    IconRemoveFavor,
    IconRename,
    IconSearch,
    IconSearchMenu,
    IconTransparent,
    IconTreeFolder,
    IconUndo,
    IconVersionHistory,
    IconViewAllHighlight
} from "@/Icon";
import {elementIcons} from "@/views/Draw/ElementIcon";
import DialogMessageBox from "@/common/DialogMessageBox";
import {isValidUrl, toValidURL} from "../../../@excalidraw/packages/excalidraw/data/url";
import {Alpha, hexToHsva, hexToRgba, hsvaToHexa, rgbaToHex, rgbaToHexa, validHex} from "@uiw/react-color";
import {HsvaColor} from "@uiw/color-convert/src/index";
import {isNumber} from "@tiptap/core";
import DialogColorChoose from "@/views/Draw/DialogColorChoose";
import {
    downloadFileDataURL,
    getS3CardData,
    getS3DataNew,
    getShareDataUrl,
    isAliOss,
    uploadS3New
} from "@/api/Aws";
import Global from '@/global'
import "@/publish.css"
import DialogPageSize from "@/views/Draw/DialogPageSize";
import DialogNote from "@/views/Draw/DialogNote";
import {KEYS} from "../../../@excalidraw/packages/excalidraw/keys";
import PopverExport from "@/views/Draw/PopverExport";
import DialogPublishToWeb from "@/views/Draw/DialogPublishToWeb";
import dialogPublishToWeb from "@/views/Draw/DialogPublishToWeb";
import {isNavigator} from "react-use/lib/misc/util";
import {getPublishNoteById} from "@model/publishNote";
import {addPageToCache, getPageCacheById} from "@model/pageCache";
import leftMenu from "./LeftMenu";
import DialogFrameTips from "@/views/Draw/DialogFrameTips";
import PopoverExportFrame from "@/views/Draw/PopoverExportFrame";
import {atom, Provider, useAtom} from "jotai";
import {closeEditor, FullScreen, openEditor, ShowEditor} from "@/state";
import {imgServer} from "@/components/EditorV2/imgServer";
import { saveAs } from 'file-saver';
import jsPDF from "jspdf";
import JSZip from "jszip";
import {blobToArrayBuffer, canvasToBlob, resizeImageFile} from "../../../@excalidraw/packages/excalidraw/data/blob";
import {
    defaultLang,
    FONT_FAMILY,
    MIME_TYPES, mutateElement,
    parseLibraryTokensFromUrl,
    restore
} from "../../../@excalidraw/packages/excalidraw";
import {fileToBase64} from "@/components/EditorV2/ImagePaste";
import ColorChoose from "@/views/Draw/ColorChoose";
import DialogOfflineAlpha from "@/views/Draw/DialogOfflineAlpha";
import RoomDialog from "@/views/Draw/collab/RoomDialog";
import Collab, {CollabAPI, collabAPIAtom, collabDialogShownAtom, isCollaboratingAtom} from "@/views/Draw/collab/Collab";
import {getCollaborationLinkData, isCollaborationLink, loadScene} from "@/views/Draw/data";
import {useAtomWithInitialValue} from "../../../@excalidraw/packages/excalidraw/jotai";
import Dragger from "antd/es/upload/Dragger";
import DialogFontChoose from "@/views/Draw/DialogFontChoose";
import dialogFontChoose from "@/views/Draw/DialogFontChoose";
import DialogProgress from "@/views/Draw/DialogProgress";
import {randomInteger} from "../../../@excalidraw/packages/excalidraw/random";
import {Random} from "roughjs/bin/math";
import DialogRename from "@/views/Draw/DialogRename";
import {fontInfoList, getFontInfo, updateFontInfo} from "@model/fontInfo";
import {glob} from "nx/src/generators/utils/glob";
import global from "@/global";
import DialogImportFileVip from "@/views/Draw/DialogImportFileVip";
import DialogOcrResult from "@/views/Draw/DialogOcrResult";
import DialogHelper from "@/views/DialogHelper";
import {updateSysConfig} from "@model/sysconfig";
import {Simulate} from "react-dom/test-utils";
import input = Simulate.input;
import html2canvas from "html2canvas";
import DialogDesktopPro from "@/views/Draw/DialogDesktopPro";
import {isMobile} from 'react-device-detect';
import FileModal from "@/components/Pdf/compoents/FileModal";
import DialogExportTips from "@/views/Draw/DialogExportTips";
import RenameModal from "@/components/Pdf/compoents/RenameModal";
import {editDoc} from "@model/doc";
import Editor from "@/components/EditorV2";
import {confirmServer} from "@/common/confirmServer";
import {hideLoad, showLoad} from "@/common/loadServer";
import DialogChooseImage from "@/views/Draw/DialogChooseImage";
import ChooseImage from "@/views/Draw/ChooseImage";
import {
    isEmbedableBookmarkElement,
    isEmbeddableElement, isFrameElement,
    isImageElement,
    isMindmapElement, isProjectLinkElement, isStickyNotesElement, isTextElement
} from "../../../@excalidraw/packages/excalidraw/element/typeChecks";
import {
    activeNode,
    clearMindmapActiveNode,
    g_isEditMindmap, g_isEnterMindmap, hiddenToolbar,
    mindMapCache,
    updateMindmapMode
} from "../../../@excalidraw/packages/excalidraw/element/mindMap";
import {
    batchCardHighlight, batchUpdateCard,
    getCardById, getCardByIds,
    getCardByTagName,
    getCardDoc, getCardDocByIds,
    getCardListByLibraryId, getLibraryByFileName,
    getLibraryVideoCount,
    renameCard,
    updateCard
} from "@model/card";
import PageLibrary from "@/views/Library/PageLibrary";
import {updateCanvasToLibrary} from "@/UpgradeUtils";
import DialogTagManager from "@/views/Dialog/DialogTagManager";
import {
    apiElementByBoardKey, apiProjectListBoardNotes,
    apiUpdateProjectAll
} from "@/api/AppApi";
import {downloadS3ImageToBase64, uploadS3File, uploadS3ImageThumb} from "@/api/AwsUpload";
import withGuard from "@/withGuard";
import {atomSliderWidth, mIsDialogDrawIndexFullScreen} from "@/App";
import {staticProject} from "@/UtilityInner";
import {useEditor} from "@tiptap/react";
import StarterKit from "@tiptap/starter-kit";
import {Import} from "@tiptap-pro/extension-import";
import {Export} from "@tiptap-pro/extension-export";
import Text from "@tiptap/extension-text";
import TextStyle from "@tiptap/extension-text-style";
import Heading from "@tiptap/extension-heading";
import Paragraph from "@tiptap/extension-paragraph";
import Highlight from "@tiptap/extension-highlight";
import TextAlign from "@tiptap/extension-text-align";
import Underline from "@tiptap/extension-underline";
import Placeholder from "@tiptap/extension-placeholder";
import FontSize from "tiptap-extension-font-size";
import {Indent} from "@/components/EditorV2/indent";
import Link from "@/components/EditorV2/extension-link/src";
import ImageT from "@tiptap/extension-image";
import {Hyperlink} from "@docs.plus/extension-hyperlink";
import TaskList from "@tiptap/extension-task-list";
import TaskItem from "@tiptap/extension-task-item";
import HorizontalRule from "@tiptap/extension-horizontal-rule";
import Blockquote from "@tiptap/extension-blockquote";
import {FontFamily} from "@tiptap/extension-font-family";
import VideoLocalContent from "../../../@excalidraw/packages/excalidraw/components/VideoNotes/VideoLocalContent";
import VideoContent from "../../../@excalidraw/packages/excalidraw/components/VideoNotes/VideoContent";
import clsx from "clsx";
import {copyToClipboard} from "../../../@excalidraw/packages/excalidraw/clipboard";
import {actionCopy, copyText} from "../../../@excalidraw/packages/excalidraw/actions";
import {saveElementVideoNotesAsJSON} from "../../../@excalidraw/packages/excalidraw/data/json";
import {
    dbGetHighlight,
    dbGetHighlightByLibraryId,
    dbGetYoutubeHightlightCount,
    updateHighlight
} from "@model/highlight";
import {videoCache} from "../../../@excalidraw/packages/excalidraw/components/App";
import {getEmbedLink} from "../../../@excalidraw/packages/excalidraw/element/embeddable";
import {
    atomCommonSliderContainerWidth,
    atomDrawLeftMenuWidth,
    atomHomePaddingLeft,
    atomSelectSliderRightMenu
} from "@/views/Home/HomeIndex";
import HomeNavigator from "@/views/Home/HomeNavigator";
import {
    beyondFreePdfLimit,
    createBreadcrumb, createDeeplinkView,
    getCardPath, getCardTitle, getDrawPath, getFavorChildrenMenu,
    getImageNameFromdeepLinkType,
    getTheme,
    isMac, isSupportLink, pauseAllAudio, pauseAllVideo, updateFavorToFolder
} from "@/Utility";
import cardItem from "@/views/Library/CardItem";
import {getLanguageCode, isZh} from "@/language";
import FileImportMode from "@/views/Draw/FileImportMode";
import DrawIndexSliderHeader from "@/views/Draw/DrawIndexSliderHeader";
import DrawIndexBreadcrumb from "@/views/Draw/DrawIndexBreadcrumb";
import PageJournal from "@/views/Journal/PageJournal";
import PageHighlight from "@/views/Highlight/PageHighlight";
import {t} from "i18next";
import {forceSetCursor, setCursor} from "../../../@excalidraw/packages/excalidraw/cursor";
import SideBarFold from "@/components/EditorV2/SideBarFold/SideBarFold";
import {CURSOR_TYPE, ROUNDNESS} from "../../../@excalidraw/packages/excalidraw/constants";
import LibraryInfos from "@/views/Library/LibraryInfos";
import DialogMoveTo from "@/views/Dialog/DialogMoveTo";
import {createLibraryItemMenu} from "@/MenuUtils";
import HomeIndex from "@/views/Home/views/CanvasListIndex/CanvasListIndex";
import CustomStack from "@/common/CustomStack"
import ProjectTagFilter from "@/views/Home/ProjectTagFilter";
import ProjectSort from "@/views/Home/ProjectSort";
import {filterPublishCheckedTreeData, findNodeWithParents, loop, loopAllNode, loopAllNodeAsync} from "@/TreeUtils";
import {save} from "../../../@excalidraw/packages/excalidraw/components/icons";
import {debugLog} from "@/LogUtils";
import {resetRootPostionNormal, setRootPostionFixed} from "@/Utility0";
import {QuillCache} from "../../../@excalidraw/packages/excalidraw/components/StickyNote/StickyNote";
import {StickyNoteTiptapCache} from "../../../@excalidraw/packages/excalidraw/components/StickyNote/StickyNoteTiptap";
import {getBoardById} from "@model/board";
import CustomWebView from "@/views/Webview/CustomWebView";
import {ShapeCache} from "../../../@excalidraw/packages/excalidraw/scene/ShapeCache";
import {getPropertyList} from "@model/Property";
import {getTagList} from "@model/tag";
import {getAllViewList, getViewList} from "@model/view";
import SharePageCard from "@/views/Note/SharePageCard";
import {sortFramePresent} from "@/elementUtility";
import DrawIndexCanvasConfig from "@/views/Draw/DrawIndexCanvasConfig";
import {getTiptapDoc} from "@model/tiptapDoc";
import {importTranscriptFromContent} from "@/VideoHighlightUtils";
import {getTransctiptById, updateTranscript} from "@model/transcript";



export let PROJECT_ID = '';

let fs:any = null;
let ipcRenderer:any =null;

// if(!APP_WEB){
//     fs = require("fs")
//     ipcRenderer = require("electron").ipcRenderer;
// }

let currentSelectNode:any = null;
let mapMenuKey_ExcalidrawState:any = [];
let excalidrawRef:MyExcalidraw;
let excalidrawHiddenRef:MyExcalidraw;

//分享ID，如果有保存过笔记，则为笔记的ID
export let mPublishId:string;
let mIsPresentMode:boolean = false;
let mExportType = '';//导出类型
// let mCurrentSearchRange = 'currentPage';
let mInitDatas:any='';//初始的画布内容
let mFirstBase64Capture:any;//画布的第一页的缩略图
let mExportInfos:any;//导入的info信息
let mSvgPageNum = 1;
let mIsFirstHighlighterClicked = true;
let mIsSearchVisible = false;
let mMouseMovingTime=0;
let mPageSizeType : 'canvas' | 'frame';
let mProjId:string;
let cachePageDatas:any = {};
var mAutosaveTimeId:number = 0;
//所有页面的默认背景色
let mAllCanvasBackground = isDarkMode()?DEFAULT_CANVAS_BACKGROUND_DARK:DEFAULT_CANVAS_BACKGROUND;
let mSaveTimes = 0;
let mSliderX = 0;
let mIsSliderDownPress = false;
let mIsSliderLibraryDownPress = false;
let mIsSliderCommonDownPress = false;

let mSliderContainerType :''|'pdf'|'card';
let mSliderCardId='';
let mIsFullScreen = false;//是否是全屏状态
let mIsCollapseLeft = false;//左边的状态，预览后用于还原。。。。
//是否是弹出的对话框...
let mIsDialogDrawIndex = (window.location.href.indexOf('/#/p') >= 0) || (window.location.href.indexOf('#p') >= 0);
//拖动pdf注记的信息
let mJsonDragPdfAnnotations:any = null;
//当前打开的pdf的文件名称
let mOpenedPdfFileName:any = null;
//当前右侧打开的元素
let mSliderVideoNotes:any;
let mSliderRightLibraryWidth:any = 0;
let mViewTime:any = undefined;
let mThumbUrl:any;
let mBackupHomeLeftWidth:any = 0;
let mFileImportMode:any;
let mSavePromise:any;
let mIsSaving:boolean = false;
let mIsImagePopoverOpen:boolean = false;
//正在加载的项目的信息.
let mLoadProjectInfo:any = null;
let nTimeoutId:any = 0;
//上一次延迟关闭的ID
let nLastDelayIndicatorTimeoutId:any = 0;
let mIsLoading = false;

export const atomIsPresentMode = atom(APP_WEB ? true : false);
/*
const shareableLinkConfirmDialog = {
    title: t("overwriteConfirm.modal.shareableLink.title"),
    description: (
        <Trans
            i18nKey="overwriteConfirm.modal.shareableLink.description"
            bold={(text) => <strong>{text}</strong>}
            br={() => <br />}
        />
    ),
    actionLabel: t("overwriteConfirm.modal.shareableLink.button"),
    color: "danger",
} as const;


const initializeScene = async (opts: {
    collabAPI: CollabAPI | null;
    excalidrawAPI: ExcalidrawImperativeAPI;
}): Promise<
    { scene: ExcalidrawInitialDataState | null } & (
    | { isExternalScene: true; id: string; key: string }
    | { isExternalScene: false; id?: null; key?: null }
    )
> => {
    const searchParams = new URLSearchParams(window.location.search);
    const id = searchParams.get("id");
    const jsonBackendMatch = window.location.hash.match(
        /^#json=([a-zA-Z0-9_-]+),([a-zA-Z0-9_-]+)$/,
    );
    const externalUrlMatch = window.location.hash.match(/^#url=(.*)$/);

    const localDataState = importFromLocalStorage();

    let scene: RestoredDataState & {
        scrollToContent?: boolean;
    } = await loadScene(null, null, localDataState);

    let roomLinkData = getCollaborationLinkData(window.location.href);
    const isExternalScene = !!(id || jsonBackendMatch || roomLinkData);
    if (isExternalScene) {
        if (
            // don't prompt if scene is empty
            !scene.elements.length ||
            // don't prompt for collab scenes because we don't override local storage
            roomLinkData ||
            // otherwise, prompt whether user wants to override current scene
            (await openConfirmModal(shareableLinkConfirmDialog))
        ) {
            if (jsonBackendMatch) {
                scene = await loadScene(
                    jsonBackendMatch[1],
                    jsonBackendMatch[2],
                    localDataState,
                );
            }
            scene.scrollToContent = true;
            if (!roomLinkData) {
                window.history.replaceState({}, APP_NAME, window.location.origin);
            }
        } else {
            // https://github.com/excalidraw/excalidraw/issues/1919
            if (document.hidden) {
                return new Promise((resolve, reject) => {
                    window.addEventListener(
                        "focus",
                        () => initializeScene(opts).then(resolve).catch(reject),
                        {
                            once: true,
                        },
                    );
                });
            }

            roomLinkData = null;
            window.history.replaceState({}, APP_NAME, window.location.origin);
        }
    } else if (externalUrlMatch) {
        window.history.replaceState({}, APP_NAME, window.location.origin);

        const url = externalUrlMatch[1];
        try {
            const request = await fetch(window.decodeURIComponent(url));
            const data = await loadFromBlob(await request.blob(), null, null);
            if (
                !scene.elements.length ||
                (await openConfirmModal(shareableLinkConfirmDialog))
            ) {
                return { scene: data, isExternalScene };
            }
        } catch (error: any) {
            return {
                scene: {
                    appState: {
                        errorMessage: t("alerts.invalidSceneUrl"),
                    },
                },
                isExternalScene,
            };
        }
    }

    if (roomLinkData && opts.collabAPI) {
        const { excalidrawAPI } = opts;

        const scene = await opts.collabAPI.startCollaboration(roomLinkData);

        return {
            // when collaborating, the state may have already been updated at this
            // point (we may have received updates from other clients), so reconcile
            // elements and appState with existing state
            scene: {
                ...scene,
                appState: {
                    ...restoreAppState(
                        {
                            ...scene?.appState,
                            theme: localDataState?.appState?.theme || scene?.appState?.theme,
                        },
                        excalidrawAPI.getAppState(),
                    ),
                    // necessary if we're invoking from a hashchange handler which doesn't
                    // go through App.initializeScene() that resets this flag
                    isLoading: false,
                },
                elements: reconcileElements(
                    scene?.elements || [],
                    excalidrawAPI.getSceneElementsIncludingDeleted(),
                    excalidrawAPI.getAppState(),
                ),
            },
            isExternalScene: true,
            id: roomLinkData.roomId,
            key: roomLinkData.roomKey,
        };
    } else if (scene) {
        return isExternalScene && jsonBackendMatch
            ? {
                scene,
                isExternalScene,
                id: jsonBackendMatch[1],
                key: jsonBackendMatch[2],
            }
            : { scene, isExternalScene: false };
    }
    return { scene: null, isExternalScene: false };
};

 */

const DEFAULT_TOOL_ITEM_STYLE = {margin:'0 0px',padding:'2px'};

const DrawIndex = forwardRef((props: { projectId?: any }, ref)=> {
    const {t} = useTranslation();
    const navigate = useNavigate();
    const appRef = useRef<any>(null);
    const leftMenuRef = useRef<any>(null);
    const dialogShareRef = useRef<any>(null);
    const dialogLinkRef = useRef<any>(null);
    const dialogExportInfoRef = useRef<any>(null);
    const inputTitleRef = useRef<any>(null);
    const dialogMessageBoxRef = useRef<any>(null);
    const dialogColorChooseRef = useRef(null);
    const divElementSvgContainerRef = useRef(null);
    const dialogPageSizeRef = useRef<any>(null);
    const inputSearchRef = useRef<HTMLInputElement>(null);
    const popoverExportRef = useRef<any>(null);
    const dialogExportRef = useRef<any>(null);
    const popoverExportPresentModeRef = useRef<any>(null);
    const dialogPublishToWebRef = useRef(null);
    const dialogFrameTipsRef = useRef(null);
    const dialogFontChooseRef = useRef(null);
    const dialogProgressRef = useRef(null);
    const dialogRenameRef = useRef(null);
    const divPopoverStyleRef = useRef(null);
    const fileInputRef = useRef(null);
    const filePdfInputRef = useRef(null);
    const fileImportInputRef = useRef(null);
    const dialogImportFileVipRef = useRef(null);
    const dialogOcrResultRef = useRef(null);
    const dialogHelperRef = useRef(null);
    const dialogDesktopProRef = useRef(null);
    const dialogExportTipsRef = useRef(null);
    const iframeRef = useRef(null);
    const divSliderContainerRef = useRef(null);
    const editorRef = useRef(null);
    const pageLibraryRef = useRef(null);
    const pageHighlightRef = useRef(null);
    const dialogTagManagerRef = useRef(null);
    const videoNotesRef = useRef<HTMLDivElement>(null);
    const videoContentRef = useRef<any>(null);
    const sideBarFoldRef = useRef(null);
    const sideInfoRef = useRef(null);
    const sideProjectRef = useRef(null);
    const dialogMoveToRef = useRef(null);
    const mArrayTimeoutIds = useRef<any>([]);
    const inputEmbedUrl = useRef(null);
    const mLastKeyIsHandled = useRef(false);
    const projectTagFilterRef = useRef(null);
    const mIsLeftMouseDownPressed = useRef(false);

    //外部编辑的数据
    let mNoteData:any = useRef(null);
    let mTitle=useRef<any>(null);

    const [isFramePresent, setIsFramePresent] = useState(false);
    const [homePaddingLeft,setHomePaddingLeft] = useAtom(atomHomePaddingLeft)
    const [selectSliderRightMenu,setSelectSliderRightMenu] = useAtom(atomSelectSliderRightMenu);

    const initialStatePromiseRef = useRef<{
        promise: ResolvablePromise<ExcalidrawInitialDataState | null>;
    }>({promise: null!});
    if (!initialStatePromiseRef.current.promise) {
        initialStatePromiseRef.current.promise =
            resolvablePromise<ExcalidrawInitialDataState | null>();
    }
    // const [excalidrawAPI, setExcalidrawRefCallback] = useState(null);

    const [collabAPI] = useAtom(collabAPIAtom);
    const [, setCollabDialogShown] = useAtom(collabDialogShownAtom);
    const [isCollaborating] = useAtomWithInitialValue(isCollaboratingAtom, () => {
        return isCollaborationLink(window.location.href);
    });

    //自定义返回栈
    const mStackHistory = useRef<CustomStack | null>(null);
    const mStackForward = useRef<CustomStack | null>(null);
    if (!mStackHistory.current){
        mStackHistory.current = new CustomStack();
    }
    if (!mStackForward.current){
        mStackForward.current = new CustomStack();
    }

    // 获取navigate中传递的params数据
    // let params = useParams(); // params {"name": "jack"}

    //工具栏菜单
    const ARRAY_TOOLS_INIT = [
        // {
        //     id: 'hand',
        //     imageName: 'pan.png',
        //     title: t('Pan'),
        //     isActive: false
        // },
        // {
        //     id: 'style',
        //     imageName: 'tool_style.png',
        //     title: t('Style'),
        //     isActive: false
        // },
        // {
        //     id: 'selection',
        //     imageName: 'tool_selection',
        //     title: t('Select'),
        //     shortcut:'Ctrl + 1',
        //     isActive: true
        // },
        // {
        //     id: 'iframe',
        //     imageName: 'tool_template.png',
        //     title: t('Template'),
        //     isActive: false
        // },
        {
            id: 'card',
            imageName: 'tool_card.svg',
            title: t('Card'),
            isActive: false
        },
        {
            id: 'text',
            imageName: 'tool_text.svg',
            title: t('Text'),
            shortcut:'T',
            isActive: false
        },
        {
            id: 'image',
            imageName: 'tool_image.svg',
            title: t('Image'),
            isActive: false
        },
        {
            id: 'element',
            imageName: 'tool_element.svg',
            title: t('Element'),
            isActive: false
        },
        // {
        //     id: 'arrow',
        //     imageName: 'tool_arrow',
        //     title: t('Arrow'),
        //     shortcut:'Ctrl + 2',
        //     isActive: false
        // },
        {
            id: 'draw',
            imageName: 'tool_draw.svg',
            title: t('Draw'),
            isActive: false
        },
        // {
        //   id: 'linkRegion',
        //   imageName: '../public/imgs/tool_link_region.png',
        //   title: 'Link region',
        //   isActive: false
        // },
        {
            id: 'embeddable-1',
            imageName: 'tool_embed.svg',
            title: t('Embed'),
            isActive: false
        },
        {
            id: 'frame',
            imageName: 'tool_frame.svg',
            title: t('Frame'),
            isActive: false
        },
        {
            id: 'mindmap',
            imageName: 'tool_mindmap.svg',
            title: t('Mindmap'),
            isActive: false
        },
        {
            id: 'file',
            imageName: 'tool_files.svg',
            title: t('File'),
            isActive: false
        },
        // {
        //     id: 'library',
        //     imageName: 'tool_library',
        //     title: t('Library'),
        //     shortcut:'Ctrl + 3',
        //     isActive: false
        // }
        {
            id: 'stickyNotes',
            imageName: 'sticky_notes.svg',
            title: t('Sticky notes'),
            isActive: false
        },
        {
            id: 'project',
            imageName: 'tool_project.svg',
            title: t('Board'),
            isActive: false
        },
    ]
    var ARRAY_PAGE_SIZE_MUNE = [
        {
            id: 'whiteboard',
            label: t("Whiteboard"),
            icon: 'page_size_whiteboard.png',
            size: t("Infinite"),
        },
        {
            id: 'presentation',
            label: t("Presentation") + "(16:9)",
            icon: 'page_size_presentation.png',
            size: "1920*1080px",
        },
        {
            id: 'portrait',
            label: t("Portrait") + "(9:16)",
            icon: 'page_size_portrait.png',
            size: "1080*1920px"
        },
        {
            id: 'square',
            label: t("Square") + "(1:1)",
            icon: 'page_size_square.png',
            size: "1080*1080px"
        },
        {
            id: 'tv',
            label: t("TV") + "(4:3)",
            icon: 'page_size_tv.png',
            size: "1280*720px"
        },
        {
            id: 'a4',
            label: t("A4") + "(21*29.7cm)",
            icon: 'page_size_a4.png',
            size: "210*297mm"
        },
        {
            id: 'letter',
            label: t("Letter") + "(21.59cm×27.94cm)",
            icon: 'page_size_letter.png',
            size: "215.9*279.4mm"
        },
        {
            id: 'custom',
            label: t("Custom size"),
            icon: 'page_size_custom.png'
        }
    ]

    //分享菜单
    const SHARE_MENU: MenuItem[] = [
        // getItem(t("Output pcanvas"), 'exportCanvas', isFramePresent ? <IconMenuExportPcanvasWhite/> :
        //     <IconMenuExportPcanvasx/>, undefined, undefined, () => {
        //     onShareMenuEvent("exportCanvas")
        // }),
        getItem(t("Output pcanvasx"), 'exportCanvasx', <IconMenuExportPcanvas/>, undefined, undefined, () => {
            onShareMenuEvent("exportCanvasx")
        }),
        getItem(t("Output png"), 'exportPng', isFramePresent ? <IconMenuExportAsPngWhite/> :
            <IconMenuExportAsPng/>, undefined, undefined, () => {
            // onShareMenuEvent("exportPng",leftMenuRef.current.getAllPages(),{});
            onExportPngPopover('png');
        }),
        getItem(t("Export as Pdf"), 'exportPdf', isFramePresent ? <IconMenuExportAsPdfWhite/> :
            <IconMenuExportAsPdf/>, undefined, undefined, () => {
            // onShareMenuEvent("exportPdf",leftMenuRef.current.getAllPages(),{})
            onExportPngPopover("pdf")
        }),
    ];
    //分享菜单
    const SHARE_MENU_FRAME: MenuItem[] = [
        // getItem(t("Output pcanvas"), 'exportCanvas', isFramePresent ? <IconMenuExportPcanvasWhite/> :
        //     <IconMenuExportPcanvasx/>, undefined, undefined, () => {
        //     onShareMenuEvent("exportCanvas", [], {isFrame: true})
        // }),
        getItem(t("Output png"), 'exportPng', isFramePresent ? <IconMenuExportAsPngWhite/> :
            <IconMenuExportAsPng/>, undefined, undefined, () => {
            // onShareMenuEvent("exportPng",leftMenuRef.current.getAllPages(),{});
            onExportFramePngPopover('exportPng');
        }),
        getItem(t("Export as Pdf"), 'exportPdf', isFramePresent ? <IconMenuExportAsPdfWhite/> :
            <IconMenuExportAsPdf/>, undefined, undefined, () => {
            // onShareMenuEvent("exportPdf",leftMenuRef.current.getAllPages(),{})
            onExportFramePngPopover("exportPdf")
        }),
    ];

    //web的更多...
    const MENU_MORE_WEB: MenuItem[] = [
        getItem(t("New"), 'new', <IconTransparent/>, null, undefined, () => {
            newProject();
            refreshRecentlyMoreMenu();
            setTitle(t("Untitled"))
        }),
        getItem(t("Open"), 'open', <IconOfflineOpen/>, undefined, undefined, async () => {
            onOpenFromLocalfile();
        }),
        // getItem(t("Open Recent"), 'openRecent', <IconTransparent/>, undefined, undefined, async () => {
        //     // onOpenFromLocalfile();
        // }),
        getItem(t("Close project"), 'closeProject', <IconTransparent/>, undefined, undefined, async () => {
            // onOpenFromLocalfile();
            newProject();
            setIsWebAlphaVisible(true);
        }),
        getItem(MENU_SEPARATOR, generateUUID2(), null, undefined, 'divider', () => {

        }),
        getItem(t("Export project"), 'exportProject', <IconMenuExportProject/>, SHARE_MENU, undefined, () => {

        }),
        getItem(t("Background color"), 'backgroundColor', <IconBackgroundColor/>, undefined, undefined, () => {
            dialogColorChooseRef.current?.onShowDialog(excalidrawRef?.getAppState()?.viewBackgroundColor, excalidrawRef?.getAppState());
        }),

        getItem(MENU_SEPARATOR, generateUUID2(), null, undefined, 'divider', () => {

        }),

        getItem(t("Undo"), 'undo', <IconUndo/>, undefined, undefined, () => {
            undo();
        }),
        getItem(t("Redo"), 'redo', <IconRedo/>, undefined, undefined, () => {
            redo();
        }),
    ]

    //右下角helper的更多菜单
    const MENU_HELPER_MORE:MenuItem[] = [
        getItem(t("Discord community"), 'discordCommunity', <IconHelperDiscordCommunity/>, undefined, undefined, async () => {
            ipcSend('open-url',import.meta.env.VITE_HTTP_COMMUNITY);
        }),
        // getItem(t("Tutorial video"), 'tutorialVideo', <IconHelperToutorialVideo/>, undefined, undefined, async () => {
        //
        // }),
        getItem(t("Help center"), 'helpCenter', <IconHelperCenter/>, undefined, undefined, async () => {
            if (isZh()){
                ipcSend('open-url',import.meta.env.VITE_HTTP_HELPER_URL_ZH);
            }else{
                ipcSend('open-url',import.meta.env.VITE_HTTP_HELPER_URL);
            }

        }),
        getItem(t("Changelog"), 'changelog', <IconHelperChangelog/>, undefined, undefined, async () => {
            if (isZh()){
                ipcSend('open-url',import.meta.env.VITE_HTTP_CHANGE_LOG_ZH);
            }else{
                ipcSend('open-url',import.meta.env.VITE_HTTP_CHANGE_LOG);
            }
        }),
        getItem(t("Roadmap"), 'roadmap', <IconHelperRoadmap/>, undefined, undefined, async () => {
            if (isZh()){
                ipcSend('open-url',import.meta.env.VITE_HTTP_ROADMAP_ZH);
            }else{
                ipcSend('open-url',import.meta.env.VITE_HTTP_ROADMAP);
            }
        }),
        getItem(t("Shortcuts"), 'shortcuts', <IconHelperShortcuts/>, undefined, undefined, async () => {
            setIsShowDialogHelper(true);
            nTimeoutId = setTimeout(() => {
                dialogHelperRef.current?.onShowDialog();
            }, 200);
            mArrayTimeoutIds.current.push(nTimeoutId);
        }),
    ]

    //高级特性
    const MENU_PREFERENCE = () => {
        return [
            getItem((<div style={{minWidth: '160px', fontSize: '12px !important'}}
                          className={'flex-row-vertical-center'}>{t("UseScrollWheelZoom")}{localStorage.getItem(KEY_USE_SCROLL_WHEEL_ZOOM) &&
                    <img
                        className={'img-mini-small-10 ml-16'}
                        src={getImagePathWithTheme('check_black')}/>}</div>), 'useScrollWheelZoom',
                <IconMouse/>, undefined, undefined, () => {
                    const szValue: any = localStorage.getItem(KEY_USE_SCROLL_WHEEL_ZOOM);
                    if (szValue == 'true') {
                        localStorage.removeItem(KEY_USE_SCROLL_WHEEL_ZOOM);
                    } else {
                        localStorage.setItem(KEY_USE_SCROLL_WHEEL_ZOOM, 'true');
                    }
                    //refresh menu
                    var arrayNewMenus: any = [...arrayMenuMore];
                    for (let i = 0; i < arrayNewMenus.length; i++) {
                        if (arrayNewMenus[i].key == 'preference') {
                            arrayNewMenus.splice(i, 1, getItem(t("Preference"), 'preference',
                                <IconPreference/>, MENU_PREFERENCE(), undefined, () => {
                                }));
                            break;
                        }
                    }
                    setArrayMenuMore(arrayNewMenus);
                }),
        ]
    }


    const MENU_HELPER = [
        getItem(<div style={{minWidth: '160px'}}>{t("Keyboard shortcuts")}</div>, 'keyboardShortcuts',
            <IconKeyboardShortcut/>, undefined, undefined, () => {
                setIsShowDialogHelper(true);
                nTimeoutId = setTimeout(() => {
                    dialogHelperRef.current?.onShowDialog();
                }, 200);
                mArrayTimeoutIds.current.push(nTimeoutId);
            }),
    ]

    //更多菜单
    const MENU_MORE = ()=> {
        let menu = [
            /*
            getItem(t("New project"), 'newCanvas', null, undefined,undefined,()=>{
                leftMenuRef.current.newProject();
                excalidrawRef.newProject();
            }),
            getItem(t("Import"), 'import', null, [
                getItem(t("Import pcanvas"), 'import-pcanvas', null, undefined,undefined,()=>{
                    onMoreMenuEvent("import-pcanvas")
                }),
                getItem(t("Import pcanvasx"), 'import-pcanvasx', null, undefined,undefined,()=>{
                    onMoreMenuEvent("import-pcanvasx")
                }),
            ],undefined,()=>{

            }),*/
            // getItem(t("Export project"), 'exportProject', <IconMenuExportProject/>, SHARE_MENU, undefined, () => {
            //
            // }),
            getItem(t("Background color"), 'backgroundColor', <IconBackgroundColor/>, undefined, undefined, () => {
                dialogColorChooseRef.current?.onShowDialog(excalidrawRef?.getAppState()?.viewBackgroundColor, excalidrawRef?.getAppState());
            }),
            getItem(t("Rename"), 'rename', <IconRename/>, undefined, undefined, () => {
                // inputTitleRef?.current.focus();
                window.showCommonInput(inputTitleRef.current?.value,t("Rename"),"",t("Cancel"),t("Save"),(szContent)=>{
                    inputTitleRef.current.value = szContent;
                    mTitle.current = szContent;
                    refreshTitleBoardPath();
                    window.closeCommonInput();
                })

            }),
            getItem(t("Add to Favorites"), 'favor', <IconAddToFavor/>, getFavorChildrenMenu(mNoteData.current?.isFavirated,async (key)=>{
                if (mNoteData.current == null) {
                    await saveNotes(false);
                }
                mNoteData.current.isFavirated = 1;
                mNoteData.current.favirateTime = new Date().getTime();
                updateNote(mNoteData.current).then(async (res)=>{
                    await updateFavorToFolder(key,{...mNoteData.current,doc:''});
                    postMessage(EVENT_FAVIRIATE_CHANGE);
                });
                setIsFavored(mNoteData.current.isFavirated === 1);
                refreshMenuMore();
            }), undefined, async (info) => {
                if (global.g_arrayFavorFolders.some(p=>p.id == info.key))return;
                if (mNoteData.current == null) {
                    await saveNotes(false);
                }
                if (mNoteData.current.isFavirated === 1) {
                    mNoteData.current.isFavirated = 0;
                } else {
                    mNoteData.current.isFavirated = 1;
                }
                mNoteData.current.favirateTime = new Date().getTime();
                updateNote(mNoteData.current).then(res=>{
                    postMessage(EVENT_FAVIRIATE_CHANGE);
                });
                setIsFavored(mNoteData.current.isFavirated === 1);
                refreshMenuMore();
            }),
            getItem(t("Manage tags"), 'managerTags', <Icon component={() => <img className='img-14 mr-0' style={{
                width: '13px',
                height: '13px',
                marginLeft: '1px',
                marginRight: '-1.5px'
            }} src={imgPathPerfix() + "home_tags_normal.png"}/>}/>, undefined, undefined, () => {
                saveNotes().then(res => {
                    dialogTagManagerRef.current?.onShowDialog([mNoteData.current]);
                })
            }),
            getItem(t("Create copy"), 'copy', <IconMakeCopy/>, undefined, undefined, async () => {
                //先保存.....
                await saveNotes(false);
                var noteCopy = {...mNoteData.current};
                noteCopy.id = generateRandomPageKey();
                noteCopy.name = noteCopy.showName = mTitle.current + '(copy)';
                noteCopy.createTime = Date.now();
                noteCopy.updateTime = new Date().getTime();
                noteCopy.isFavirated = false;
                updateNoteItemToHasUpdate(noteCopy);
                updateNote(noteCopy, mNoteData.current.id).then(res => {
                    postMessage(EVENT_NOTE_CHANGED);
                })
            }),
            getItem(t("Search"), 'search', <IconSearchMenu/>, undefined, undefined, () => {
                setIsSearchVisible(true);

                nTimeoutId = setTimeout(() => {
                    inputSearchRef.current?.select();
                    inputSearchRef.current?.focus();
                }, 200);
                mArrayTimeoutIds.current.push(nTimeoutId);
            }),

            getItem(t("Copy link"), 'copyLink', <IconCopyLink/>, undefined, undefined, () => {
                createCopyLink('project', mNoteData.current.id)
            }),

            getItem(t("Show info"), 'showInfo', <IconInfoMenu/>, undefined, undefined, () => {
                if (mNoteData.current == null) {
                    getCanvasNoteDatas(true,false).then(res => {
                        const doc = JSON.stringify(res, replaceIcon);
                        window.showInfo('project', {
                            id: PROJECT_ID,
                            name: mTitle.current || t("Untitled"),
                            doc: doc,
                            createTime: Date.now(),
                            updateTime: Date.now()
                        });
                    })
                } else {
                    //保存后再显示....
                    saveNotes().then(res=>{
                        window.showInfo('project', mNoteData.current);
                    })
                }
            }),
            getItem(<div>{t("Version history")}<label className={'beta'}>{'Beta'}</label></div>, 'versionHistory',
                <IconVersionHistory/>, undefined, undefined, () => {
                    //历史记录
                    window.showDialogProjectHistory(mNoteData.current.id, (newProject: any) => {
                        //刷新的回调....
                        params.state = {};
                        params.state.usr = {};
                        params.state.usr.noteData = newProject;
                        onLoadData();
                    });
                }),

            getItem(t("Delete"), 'delete', <IconDelete/>, undefined, undefined, async () => {
                /*
                Modal.confirm({
                    title:t("Confirm delete"),
                    centered:true,
                    content:t("Delete note can view trash"),
                    onOk(){
                        var szFolderId = params.state?.usr?.folderId||'';
                        // if (mNoteData.current != null){
                        //     szFolderId = mNoteData.current.folderId;
                        // }
                        if (mNoteData.current == null) {
                            navigate('/home',{state:{folderId: szFolderId}})
                        } else {
                            mNoteData.current.isDeleted = true;
                            mNoteData.current.deleteTime = new Date().getTime();
                            updateNote(mNoteData.current);
                            postMessage(EVENT_NOTE_CHANGED)
                            postMessage(EVENT_NOTE_DELETE);
                            navigate('/home',{state:{folderId: szFolderId}})

                        }
                    }
                })*/
                dialogMessageBoxRef.current.onShowDialog(t("Confirm delete"), t("Delete note can view trash"), t("Delete"), async () => {
                    var szFolderId = params.state?.usr?.folderId || '';
                    // if (mNoteData.current != null){
                    //     szFolderId = mNoteData.current.folderId;
                    // }
                    if (mNoteData.current == null) {
                        // navigate('/home/project', {state: {folderId: szFolderId}})
                        await saveNotes();
                    }
                    mNoteData.current.isDeleted = 1;
                    mNoteData.current.deleteTime = new Date().getTime();
                    updateNote(mNoteData.current);
                    postMessage(EVENT_NOTE_CHANGED)
                    postMessage(EVENT_NOTE_DELETE);

                    postMessage(EVENT_SWITCH_HOME_LIST_MENU,{name:'recent'})
                })
            }),


            getItem(MENU_SEPARATOR, generateUUID2(), null, undefined, 'divider', () => {

            }),

            getItem(t("Preference"), 'preference', <IconPreference/>, MENU_PREFERENCE(), undefined, () => {

            }),
            // getItem(t("Help"), 'help', <IconHelp/>, MENU_HELPER, undefined, () => {
            //
            // }),
            getItem(<div style={{minWidth: '160px'}}>{t("Keyboard shortcuts")}</div>, 'keyboardShortcuts',
                <IconKeyboardShortcut/>, undefined, undefined, () => {
                    setIsShowDialogHelper(true);
                    nTimeoutId = setTimeout(() => {
                        dialogHelperRef.current?.onShowDialog();
                    }, 200);
                    mArrayTimeoutIds.current.push(nTimeoutId);
                }),

            getItem(MENU_SEPARATOR, generateUUID2(), null, undefined, 'divider', () => {

            }),

            getItem(t("Undo"), 'undo', <IconUndo/>, undefined, undefined, () => {
                undo();
            }),
            getItem(t("Redo"), 'redo', <IconRedo/>, undefined, undefined, () => {
                redo();
            }),
        ]

        //删除不要要.
        let arrayNewMenu = [];
        if (PROJECT_ID == KEY_DEFAULT_PROJECT_ID || props.projectId == KEY_DEFAULT_PROJECT_ID){
            const arrayRemoved:any = ['rename','favor','copy','delete'];
            for (let i=0;i<menu.length;i++){
                if (!arrayRemoved.includes(menu[i].key)){
                    arrayNewMenu.push(menu[i]);
                }
            }
        }else{
            arrayNewMenu.push(...menu);
        }

        return arrayNewMenu;
    }

    let params = useLocation();
    let urlParams = useParams();

    // const [excalidrawRef,setExcalidrawRef] = useState(null);
    // const [leftMenuRef,setLeftMenuRef] = useState(null);
    // const [title, setTitle] = useState(APP_WEB ? t("Untitled") : '')
    const {token} = theme.useToken();
    const [isShowShareDialog, setIsShowShareDialog] = useState<any>(false);
    const [isFavored, setIsFavored] = useState(false);
    const [elementType, setElementType] = useState('shape');
    const [isPresentMode, setIsPresentMode] = useAtom(atomIsPresentMode);
    const [isShowExitPresent, setIsShowExitPresent] = useState(false);
    const [isShowClosePresent, setIsShowClosePresent] = useState(false);
    const [isShowTopClosePresent, setIsShowTopClosePresent] = useState(false);
    const [isShowBottomPresent, setIsShowBottomPresent] = useState(false);
    const [isShowLinkDialog, setIsShowLinkDialog] = useState(false);
    const [isShowDialogExportInfo, setIsShowDialogExportInfo] = useState(false);
    const [searchKey, setSearchKey] = useState(params.state?.usr?.searchKey);
    const [arraySearchResult, setArraySearchResult] = useState([]);
    const [currentSearchIndex, setCurrentSearchIndex] = useState(0);
    const [isSearchVisible, setIsSearchVisible] = useState(false)
    const [defaultSearch, setDefaultSearch] = useState(isStringNullOrEmpty(params.state?.usr?.searchKey) ? "currentPage" : 'wholeProject');
    const [isSaving, setIsSaving] = useState(false);
    const [arrayMenuMore, setArrayMenuMore] = useState<any>(MENU_MORE());
    const [embedUrl, setEmbedUrl] = useState('');
    const [isCollapsePage, setIsCollapsePage] = useState((APP_WEB || isInSidebar()) ? true : localStorage.getItem(KEY_DRAW_LEFT_COLLAPSE) == 'true');
    const [canvasBackground, setCanvasBackground] = useState(DEFAULT_CANVAS_BACKGROUND);
    const [isPopoverZoomVisible, setIsPopoverZoomVisible] = useState(false);
    const [isPopoverPresentModeVisible, setIsPopoverPresentModeVisible] = useState(false);
    const [arraySvgData, setArraySvgData] = useState([]);

    const [toolButtons, setToolButtons] = useState(ARRAY_TOOLS_INIT);
    const [zoom, setZoom] = useState('100');
    const [inputZoom, setInputZoom] = useState('100%');
    const [elementPopoverOpen, setElementPopoverOpen] = useState(false);
    const [embedPopoverOpen, setEmbedPopoverOpen] = useState(false);
    const [stylePopoverOpen, setStylePopoverOpen] = useState(false);
    const [stylePageSizePopoverOpen, setStylePageSizePopoverOpen] = useState(false);
    const [drawPopoverOpen, setDrawPopoverOpen] = useState(false);
    const [filePopoverOpen, setFilePopoverOpen] = useState(false);
    const [isFramePopoverOpen, setIsFramePopoverOpen] = useState(false);
    const [isImagePopoverOpen, setIsImagePopoverOpen] = useState(false);
    const [isStickyNotesOpen,setIsStickyNotesOpen] = useState(false);
    const [isCanvasBackgroundOpen, setIsCanvasBackgroundOpen] = useState(false);
    const [svgSearchKey, setSvgSearchKey] = useState('');
    const [arrayPageSizeMenu, setArrayPageSizeMenu] = useState(ARRAY_PAGE_SIZE_MUNE);
    const [presentModeExitTip, setPresentModeExitTip] = useState(t("to exit full screen"))
    const [isPopoverExportPngVisible, setIsPopoverExportPngVisible] = useState(false);
    const [isDialogExportPngVisible, setIsDialogExportPngVisible] = useState(false);
    const [isPopoverExportPngFramePresentModeVisible, setIsPopoverExportPngFramePresentModeVisible] = useState(false);
    const [isPopoverExportPngPresentModeVisible, setIsPopoverExportPngPresentModeVisible] = useState(false);
    const [isShowOverlay, setIsShowOverlay] = useState(false);
    const [pageSizeNumber, setPageSizeNumber] = useState('');
    const [isAppWebFullScreen, setIsAppWebFullScreen] = useState(false);
    const [isShowPageTree, setIsShowPageTree] = useState(APP_WEB ? false : true);
    const [isEnableNavKey, setIsEnableNavKey] = useState(true);
    const [isLoading, setIsLoading] = useState(APP_WEB ? true : false);
    const [isFullScreen, setIsFullScreen] = useState(null);
    const [isDropdownExportVisible, setIsDropdownExportVisible] = useState(false);
    const [showEditor, setShowEditor] = useAtom(ShowEditor);
    const [progressPercent, setProgressPercent] = useState(1);
    const [isLoadingFramePresent, setIsLoadingFramePresent] = useState(false);
    const [isSelectElementLocked, setIsSelectElementLocked] = useState(false);
    const [freeDrawToolName, setFreeDrawToolName] = useState('freedraw');
    const [isShowDrawStyle, setIsShowDrawStyle] = useState(false);
    const [isShowDrawStrokeColor, setIsShowDrawStrokeColor] = useState(false);
    const [drawStrokeWidth, setDrawStrokeWidth] = useState(1);
    const [drawTransparent, setDrawTransparent] = useState(100);
    const [drawStrokeColor, setDrawStrokeColor] = useState('#000000');
    const [activityTool, setActivityTool] = useState('selection');
    const [isAutoSaving, setIsAutoSaving] = useState(false);
    const [lastAutoSavingTime, setLastAutoSavingTime] = useState(Date.now());
    const [isWebAlphaVisible, setIsWebAlphaVisible] = useState(false);
    const [isShowDialogHelper, setIsShowDialogHelper] = useState(false);
    const [isShowDialogImportFileVip, setIsShowDialogImportFileVip] = useState(false);
    const [isShowDialogOcrResult, setIsShowDialogOcrResult] = useState(false);
    const [isShowDialogDesktopPro, setIsShowDialogDesktopPro] = useState(false);
    const [isPopoverPresentMore, setIsPopoverPresentMore] = useState(false);
    const [isShowDialogExportTips, setIsShowDialogExportTips] = useState(false);
    const [pdfFilePath, setPdfFilePath] = useState('')
    const [rightSliderWidth, setRightSliderWidth] = useState(0);
    const [rightSliderLibraryWidth, setRightSliderLibraryWidth] = useState(0);
    const [sliderHeaderVisible,setSliderHeaderVisible] = useState(false);
    const [commonSliderContainerWidth, setCommonSliderContainerWidth] = useAtom(atomCommonSliderContainerWidth);
    const [pdfFileName, setPdfFileName] = useState('');
    const [pdfFileId, setPdfFileId] = useState('');
    const [isShowDialogPdfRename, setIsShowDialogPdfRename] = useState(false);
    const [sliderContainerHtml, setSliderContainerHtml] = useState('');
    const [sliderCardData, setSliderCardData] = useState(null);
    const [sliderWebviewItem,setSliderWebviewItem] = useState(null);
    const [iframePdfContainerPointerEvent, setIframePdfContainerPointerEvent] = useState('all');
    const [libraryContainerPointerEvent,setLibraryContainerPointerEvent] = useState('all');
    const [commonContainerPointerEvent,setCommonContainerPointerEvent] = useState('all');
    const [isLibrarySearch, setIsLibraySearch] = useState(false);
    const [librarySearchKey, setLibrarySearchKey] = useState('');
    const [isCommonSearchVisible, setIsCommonSearchVisible] = useState(false);
    const [commonSearchKey, setCommonSearchKey] = useState('');
    const [isToolbarVisible, setIsToolbarVisible] = useState(true);
    const [loadingTips, setLoadingTips] = useState('');
    const [isShowSmallLoading, setIsShowSmallLoading] = useState(false);
    const [isZenMode, setIsZenMode] = useState(false);
    const [hasElement,setHasElement] = useState(true);//是否有元素
    const [sliderType,setSliderType] = useState<string>('video');
    const [sliderVideoNotes,setSliderVideoNotes] = useState<any>(null);
    const [arrayCommonSliderMoreMenu,setArrayCommonSliderMoreMenu] = useState<any>([]);
    const [toolButtonItemStyle,setToolButtonItemStyle] = useState(DEFAULT_TOOL_ITEM_STYLE);
    const [isTitleDisabled,setIsTitleDisabled] = useState(false);
    const [isShowDialogMoveTo,setIsShowDialogMoveTo] = useState(false);
    const [editor,setEditor] = useState(null);
    const [isDialogDrawIndexFullScreen, setIsDialogDrawIndexFullScreen] = useAtom(mIsDialogDrawIndexFullScreen);
    const [cardFullScreen, setCardFullScreen] = useAtom(FullScreen)
    const [sideBarStatus, setSideBarStatus] = useState<any>(0);
    const [sliderTitleInfo,setSliderTitleInfo] = useState<any>(null);
    const [globalRightSliderWidth] = useAtom(atomSliderWidth);

    const [arrayBreadcrumb,setArrayBreadcrumb] = useState<any>([]);
    const [sliderProjectData,setSliderProjectData] = useState<any>(null);
    const [isShowPopupBoard,setIsShowPopupBoard] = useState<any>(false);
    const [selectTag,setSelectTag] = useState(null);
    const [selectBoard,setSelectBoard] = useState<any>(null);//当前选中的board
    const [isShowMenuMore,setIsShowMenuMore] = useState(false);
    const mSelectElementLastTime = useRef(0);
    const [boardTitlePath,setBoardTitlePath] = useState('');
    const [randomRefreshTitle,setRandomRefreshTitle] = useState(crypto.randomUUID());
    const [isSearching,setIsSearching] = useState(false);
    const [headerTitleWidth,setHeaderTitleWidth] = useState((document.body.clientWidth - homePaddingLeft)/2 - 16);
    const [drawLeftMenuWidth,setDrawLeftMenuWidth] = useAtom(atomDrawLeftMenuWidth);
    const [isShareCardPage,setIsShareCardPage] = useState(false);
    const [shareCardData,setShareCardData] = useState(null);
    const [isShowCanvasConfig,setIsShowCanvasConfig] = useState(false);
    const drawIndexCanvasConfigRef = useRef(null);


    /**
     * 是否展示了激活笔
     */
    const mIsShowLaser = useRef<any>(false);

    // const [homeSaveTimes,setHomeSaveTimes] = useState(0);//通过home保存的次数....
    // const [hasExport,setHasExport] = useState(true);
    const [fileState, setFileState] = useState({
        open: false,
        fileName: '',
        fileId: '',
        filePath: "",
        isFullScreen: false,
        isViewAllHighlight:false
    })

    useEffect(() => {
        mSliderRightLibraryWidth = rightSliderLibraryWidth;
    }, [rightSliderLibraryWidth])

    useEffect(() => {
        setHeaderTitleWidth((document.body.clientWidth - homePaddingLeft - 400)/2 - 16);
        window.backupPaddingLeft = ()=>{
            mBackupHomeLeftWidth = homePaddingLeft;
        }

        return ()=>{
            delete window.backupPaddingLeft;
        }
    }, [homePaddingLeft]);

    useEffect(() => {
        window.closeDrawSearching=()=>{
            setIsSearching(false);
        }

        return ()=>{
            delete  window.closeDrawSearching;
        }
    }, [isSearching]);


    useEffect(()=>{
        mSliderVideoNotes = sliderVideoNotes;
    },[sliderVideoNotes])

    useEffect(() => {
        if (pdfFileId){
            window.refreshList['updatePdfAnnoComment_'+pdfFileId] = ()=>{
                iframeRef.current?.contentWindow?.postMessage(JSON.stringify({
                    fileId: pdfFileId,
                    type: "refresh-annotations"
                }), {
                    targetOrigin: '*'
                })
            }
        }

        return ()=>{
            if (pdfFileId){
                delete window.refreshList['updatePdfAnnoComment_' + pdfFileId];
            }
        }
    }, [pdfFileId]);

    useEffect(()=>{
        mIsImagePopoverOpen = isImagePopoverOpen;
    },[isImagePopoverOpen])

    // const isNoteshowEditor = useAtom(ShowEditor)[0];

    // const isCollabDisabled = isRunningInIframe();
    const [, updateState] = useState();
    const forceUpdate = React.useCallback(() => updateState({}), []);

    //画布更改
    const onCanvasChange = (element: any, state: any) => {
        var zoomValue = parseInt(state.zoom.value * 100 + '', 10);
        setZoom(zoomValue);

        // setTimeout(()=>{
        //     setInputZoom(Math.floor(zoomValue)+'%')
        // },100);
    }

    //画布组件--callback。。。。
    const onRefExcalidraw = (ref: any) => {
        // setExcalidrawRef(ref);
        excalidrawRef = ref;
    }

    //画布，不可见....
    const onRefExcalidrawForHidden = (ref: any) => {
        excalidrawHiddenRef = ref;
    }


    // window.showSmallLoading = () => {
    //     setIsShowSmallLoading(true);
    // }
    // window.closeSmallLoading = () => {
    //     setIsShowSmallLoading(false)
    // }

    function onKeydownListener(e) {
        // debugLog('drawIndex',e);

        const szKey = e.key.toLowerCase();

        if (mLastKeyIsHandled.current && szKey == KEYS.ESCAPE){
            mLastKeyIsHandled.current = false;
            return;
        }
        mLastKeyIsHandled.current = true;

        if (isPresentMode && szKey == KEYS.L) {
            if (mIsShowLaser.current){
                exitLaser();
            }else{
                showLaser();
            }
            return;
        }

        if (embedPopoverOpen){
            //emebed弹窗打开了...
            if (szKey == KEYS.ENTER.toLowerCase()){
                excalidrawRef?.insertEmbedElement(embedUrl);
                setEmbedPopoverOpen(false);
                setEmbedUrl('');
            }
        }

        // if (isNoteshowEditor) {
        //     return;
        // }

        // if (e.target?.className.indexOf('ql-editor') == 0){
        //     //富文本输入
        //     excalidrawRef.showPopupMenu();
        // }

        if (!e.target?.editor && excalidrawRef?.onGetActiveTool() != 'text' &&
            e.target?.type != 'text' &&
            e.target?.type != 'textarea' &&
            e.target?.className?.indexOf('ql-editor') != 0 &&
            e.target?.dataset?.isedit != 'true' &&
            e.target?.className?.indexOf('tiptap') != 0 &&
            e.target?.tagName !== 'INPUT') {
            if (szKey == KEYS.L) {
                excalidrawRef.onSetActiveTool('line');
            } else if (!(e.ctrlKey || e.metaKey) && szKey == KEYS.F) {
                onFrameToolsClick(ARRAY_IFRAME_SIZE[0])
            }  else if (!(e.ctrlKey || e.metaKey) && szKey == KEYS.S) {
                let e = {currentTarget:{dataset:{id:'stickyNotes'}}};
                toolsClicked(e)
            }
            // else if ((e.ctrlKey || e.metaKey) && szKey == "1") {
            //     // onCheckToolbar('selection');
            //     // excalidrawRef.onSetActiveTool('selection');
            //     let e = {currentTarget:{dataset:{id:'selection'}}};
            //     toolsClicked(e);
            // }
            else if (szKey == KEYS.H) {
                if (activityTool == 'hand'){
                    onCheckToolbar('selection');
                }else{
                    onCheckToolbar('hand');
                }
            }else if (!(e.ctrlKey || e.metaKey) && szKey == KEYS.A){
                onCheckToolbar('arrow')
                excalidrawRef.onSetActiveTool('arrow');
            }else if (szKey == '1'){
                //居中所有内容....
                excalidrawRef.getApp().scrollToContent(excalidrawRef.getApp().getSceneElements(),{fitToContent:true})
            }
            else if ((e.ctrlKey || e.metaKey) && szKey == KEYS.P) {
                onCheckToolbar('draw');
                setFreeDrawToolName('highlighter');
                setDrawStrokeColor(excalidrawRef?.getAppState()?.currentItemHighlightStrokeColor);
                setDrawStrokeWidth(excalidrawRef?.getAppState()?.currentItemHighlightStrokeWidth);
                excalidrawRef.onSetActiveTool('highlighter');
                excalidrawRef.getApp().forceSetCursor(CURSOR_TYPE.CROSSHAIR);
            }
            else if (szKey == KEYS.P) {
                onCheckToolbar('draw');
                setFreeDrawToolName('freedraw');
                setDrawStrokeColor(excalidrawRef?.getAppState()?.currentItemDrawStrokeColor);
                setDrawStrokeWidth(excalidrawRef?.getAppState()?.currentItemDrawStrokeWidth);
                excalidrawRef.onSetActiveTool('freedraw')
            }
            else if ((e.ctrlKey || e.metaKey)&& szKey == KEYS.S) {
                if (!excalidrawRef.isZenMode()) {
                    leftMenuRef.current?.onCollapsePages();
                    //更新左边栏
                    excalidrawRef?.setLeftMenuIsCollapse(!leftMenuRef?.current.getCollapseStatus());
                }
            } else if (!(e.ctrlKey || e.metaKey) && isShortcuts(e,'newCard')) {
                global.g_isNewCardInDrawFromC = true;
                postMessage(EVENT_ADD_NOTE);
            }
            // else if ((e.ctrlKey || e.metaKey) && szKey == "2") {
            //     onCheckToolbar('arrow')
            //     excalidrawRef.onSetActiveTool('arrow');
            // }
            else if ((e.ctrlKey || e.metaKey) && szKey == "1") {
                if (localStorage.getItem(KEY_SELECT_RIGHT_SLIDER_MENU) == 'library' && rightSliderLibraryWidth > 0){
                    setRightSliderLibraryWidth(0);
                    return;
                }
                localStorage.setItem(KEY_SELECT_RIGHT_SLIDER_MENU, 'library');
                openRightSlider(false);
            }else if ((e.ctrlKey || e.metaKey) && szKey == "2") {
                if (localStorage.getItem(KEY_SELECT_RIGHT_SLIDER_MENU) == 'journal' && rightSliderLibraryWidth > 0){
                    setRightSliderLibraryWidth(0);
                    return;
                }
                localStorage.setItem(KEY_SELECT_RIGHT_SLIDER_MENU, 'journal');
                openRightSlider(false);
                drawIndexSliderHeaderAction("refresh");
            }else if ((e.ctrlKey || e.metaKey) && szKey == "3") {
                if (localStorage.getItem(KEY_SELECT_RIGHT_SLIDER_MENU) == 'highlight' && rightSliderLibraryWidth > 0){
                    setRightSliderLibraryWidth(0);
                    return;
                }
                localStorage.setItem(KEY_SELECT_RIGHT_SLIDER_MENU, 'highlight');
                openRightSlider(false);
                drawIndexSliderHeaderAction("refresh");
            }else if ((e.ctrlKey || e.metaKey) && szKey == "4") {
                if (localStorage.getItem(KEY_SELECT_RIGHT_SLIDER_MENU) == 'info' && commonSliderContainerWidth > 0){
                    setCommonSliderContainerWidth(0);
                    return;
                }
                localStorage.setItem(KEY_SELECT_RIGHT_SLIDER_MENU, 'info');
                openRightSlider(false);
                drawIndexSliderHeaderAction("info");
            }else if ((e.ctrlKey || e.metaKey) && szKey == "5") {
                if (localStorage.getItem(KEY_SELECT_RIGHT_SLIDER_MENU) == 'project' && commonSliderContainerWidth > 0){
                    setCommonSliderContainerWidth(0);
                    return;
                }
                localStorage.setItem(KEY_SELECT_RIGHT_SLIDER_MENU, 'project');
                openRightSlider(false);
                drawIndexSliderHeaderAction("project");
            }else if ((e.ctrlKey || e.metaKey) && szKey == "6") {
                if (localStorage.getItem(KEY_SELECT_RIGHT_SLIDER_MENU) == 'webview' && commonSliderContainerWidth > 0){
                    setCommonSliderContainerWidth(0);
                    return;
                }
                localStorage.setItem(KEY_SELECT_RIGHT_SLIDER_MENU, 'webview');
                openRightSlider(false);
                drawIndexSliderHeaderAction("webview");
            }
            else if ((e.ctrlKey || e.metaKey) && szKey == KEYS.R) {
                onDrawIconClickEvent("eraser");
                e.preventDefault();
                e.stopPropagation();
                let previewDataURL = '"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAAAXNSR0IArs4c6QAAAUpJREFUOE9jZKAyYKSyeQzDw0AHGRkZjg8fPth++fJlNwMDwwF8wYTTy7Kysu6MjIyThYWFhTk5OblsbW1/7tq16+/bt2/f/v//P/fx48c7sRmM1UCQYY8fP96xf/9+BgcHBxR9jY2NDA0NDQyysrIe2AzFaqCcnNytpKQk1fr6eqy+O3DgAEN8fPztR48eqaErwGagg6Gh4dpz584J4QsrIyOjd+fPnw9GD1MMA3l4eFqzs7OzOzo6+PEZaG1t/ePRo0eBT5482YGsDsNAGRkZDzk5ufVHjx7lwGdgRUXFx6lTp0798uVLNV4DgV6grpdBtoEiZeHCharoMQxzCSim582bR3SkgJIEONmAkgd6TINi2NHRkbRkA3IJcsJ2c3NjPnz4MPv379+/kZWw0SLDgYeHx1VAQODwkydPfpCd9cgt1oZH8UWS7wHGeI4Vsr6iRwAAAABJRU5ErkJggg=="';
                excalidrawRef.getApp().forceSetCursor(`url(${previewDataURL}) ${20 / 2} ${
                    20 / 2
                }, auto`)
            }
            else if (szKey == '3'){
                //如果当前选中的是CARD，就在侧栏打开CARD
                const curSelectElement = excalidrawRef?.onGetCurrentSelectedElement();
                if (isNoteElement(curSelectElement)){
                    onEditNoteData(curSelectElement,false,'dialog',false,false)
                }else if (isPdfFileElement(curSelectElement)){
                    //弹窗打开PDF
                    window.showPdfPreview(curSelectElement.customData?.generationData?.name,curSelectElement.customData?.generationData?.id,curSelectElement.customData?.generationData?.fileName);
                }
            }else if((e.ctrlKey || e.metaKey) && szKey == KEYS.A){
                //全选
                excalidrawRef.onMenuClick("selectAll");
            }else if (szKey == KEYS.BACKSPACE.toLowerCase()){
                //非编辑状态下----删除这个节点
                if (g_isEditMindmap) {

                }else{
                    if (global.g_currentSelectMindmap?.isRoot){
                        window.showMessageBox(t("Tips"),t("DeleteTheMindmap"),t("Cancel"),t("Delete"),null,async ()=>{
                            //删除这个mindmap
                            // const elements = excalidrawRef?.getApp()?.getSceneElements();
                            excalidrawRef.getApp()?.removeElementById(global.g_currentSelectMindmap.uid);
                            mindMapCache.delete(global.g_currentSelectMindmap.uid);
                            excalidrawRef.hidePopupMenu();
                            hiddenToolbar();
                            patchForModalClose()
                        });
                    }else{
                        mindMapCache.forEach((value, key, map) => {
                            value.execCommand("REMOVE_NODE")
                        })
                    }
                }
            }
            // else if(e.key == KEYS.Z){
            //     excalidrawRef.onMenuClick('zenMode');
            // }
            /*
            else if (e.key == KEYS["1"]){
                onCheckToolbar('selection');
                excalidrawRef.onSetActiveTool('selection');
            }else if (e.key == KEYS["2"]){
                let e = {currentTarget:{dataset:{id:'text'}}}
                toolsClicked(e);
            }else if (e.key == KEYS['3']){
                let e = {currentTarget:{dataset:{id:'image'}}}
                toolsClicked(e);
            }else if (e.key == KEYS['4']){
                let e = {currentTarget:{dataset:{id:'element'}}}
                toolsClicked(e);
            }else if (e.key == KEYS['5']){
                let e = {currentTarget:{dataset:{id:'draw'}}}
                toolsClicked(e);
                setDrawPopoverOpen(true)
            }else if (e.key == KEYS['6']){
                let e = {currentTarget:{dataset:{id:'embeddable-1'}}}
                toolsClicked(e);
                setEmbedPopoverOpen(true);
            }else if (e.key == KEYS['7']){
                let e = {currentTarget:{dataset:{id:'frame'}}}
                toolsClicked(e);
            }else if (e.key == KEYS['8']){
                let e = {currentTarget:{dataset:{id:'mindmap'}}}
                toolsClicked(e);
            }else if (e.key == KEYS['9']){
                let e = {currentTarget:{dataset:{id:'file'}}}
                toolsClicked(e);
                setFilePopoverOpen(true);
            }*/
        }


        // if (e.key == KEYS.D || e.key == KEYS.DELETE){
        //     //删除
        //     excalidrawRef.onMenuClick("delete")
        //     return;
        // }

        if (szKey == KEYS.ESCAPE.toLowerCase()) {

            onHandleKeyEscape();
            return;
        }
        if ((e.ctrlKey || e.metaKey) && szKey == KEYS.F) {
            if (sliderCardData && rightSliderWidth > 0){
                //右侧card--打开搜索
                window.GSearchOpen();
            }else{
                setIsSearchVisible(true);
                e.preventDefault();
                e.stopPropagation();
                nTimeoutId = setTimeout(() => {
                    inputSearchRef.current?.focus();
                    inputSearchRef.current?.select();
                }, 200);
                mArrayTimeoutIds.current.push(nTimeoutId);
            }
        }
        if (mIsPresentMode && isEnableNavKey) {

            if (e.keyCode === 37) {
                //left
                if (excalidrawRef.getExcalidrawState().displayMode === "preview") {
                    postMessage(EVENT_FRAME_PREVIEW_LAST)
                } else {
                    const pages = leftMenuRef?.current?.onMoveToPre();
                    setPageSizeNumber(pages);
                }
            } else if (e.keyCode === 39) {
                //right
                if (excalidrawRef.getExcalidrawState().displayMode === "preview") {
                    postMessage(EVENT_FRAME_PREVIEW_NEXT)
                } else {
                    const pages = leftMenuRef?.current?.onMoveToNext();
                    setPageSizeNumber(pages);
                }
            }
        }
        if (isSearchVisible) {
            if (szKey === KEYS.ENTER.toLowerCase()) {
                onSearchNextOrPre(1);
                return;
            }
        }

        //mindmap enter----
        if (e.target?.type != 'text' &&
            e.target?.type != 'textarea' &&
            e.target?.className.indexOf('tiptap') != 0){//排除掉右侧栏输入的部分...
            if (szKey == KEYS.ENTER.toLowerCase()/*&& !g_isEditMindmap*/ && !e.shiftKey) {
                if (g_isEditMindmap) {
                    e.stopPropagation();
                    e.preventDefault();

                    nTimeoutId = setTimeout(()=>{
                        if (!g_isEnterMindmap){
                            const editableDivs = Array.from(
                                document.body.querySelectorAll("div[contenteditable=true]"),
                            );
                            mindMapCache.forEach((value, key, map)=>{
                                // value.emit("hide_text_edit", editableDivs[0],value.renderer.activeNodeList)
                                // value.keyCommand.restore();
                                value.renderer.textEdit.hideEditTextBox();
                            })
                        }
                    },100);
                    mArrayTimeoutIds.current.push(nTimeoutId);
                } else {
                    mindMapCache.forEach((value, key, map) => {
                        value.execCommand("INSERT_NODE")
                    })
                }

                // console.log('****draw enter********')f
            }
        }
    }

    function onMouseMoveListener(e: any) {
        const yBottom = document.body.clientHeight - e.clientY;
        const TOP_OFFSET = 110;
        if (mIsPresentMode || isAppWebFullScreen) {
            let isShowTool = (e.clientY <= TOP_OFFSET) || (yBottom < 58);
            if (!isCollapsePage && e.clientX < LEFT_MENU_WIDTH) {
                isShowTool = true;
            }
            if (isPopoverExportPngFramePresentModeVisible || isDropdownExportVisible || isPopoverExportPngPresentModeVisible || isPopoverPresentMore) {
                isShowTool = true;
            }
            setIsShowClosePresent(isShowTool);
            setIsShowTopClosePresent(e.clientY <= TOP_OFFSET || !isCollapsePage || !isPopoverExportPngPresentModeVisible || !isPopoverExportPngFramePresentModeVisible);
            setIsShowBottomPresent(yBottom < 128);

            let isShowLeftMenu = isShowTool;
            if (APP_WEB) {
                if (!leftMenuRef.current.getCollapseStatus()) {
                    isShowLeftMenu = true;
                    setIsShowClosePresent(true);
                    setIsShowTopClosePresent(true);//顶栏也保持打开
                }
            }

            leftMenuRef?.current?.setOnShowOverlayStatus(isShowLeftMenu);

            if (isFramePresent) {
                postMessage(EVENT_FRAME_PAGE_DESC_VISIBLE, {isShowOverlay: isShowTool})
            }
        }

        // if (yBottom < 58 || e.clientY < 58){
        //     if (!isAppWebFullScreen){
        //         setIsShowOverlay(true);
        //         leftMenuRef.current.setOnShowOverlayStatus(true);
        //     }
        // }

        // setTimeout(()=>{
        //     if ((Date.now() - mMouseMovingTime) > 3000){
        //         if (isPopoverExportPngFramePresentModeVisible || isPopoverExportPngVisible)return;
        //         if (yBottom < 58 || e.clientY < 58) return;
        //
        //         setIsShowOverlay(false);
        //         leftMenuRef?.current?.setOnShowOverlayStatus(false);
        //     }
        // },3000);

        mMouseMovingTime = Date.now();

        //右边拖动。。。。。。。
        // console.log("e.buttons:"+e.buttons + "  mIsSliderDownPress:"+mIsSliderDownPress)
        if (e.buttons == 1 && mIsSliderDownPress) {
            let nMinWidth = e.clientX;
            if (e.clientX < 250) {
                nMinWidth = 250;
            }
            // console.log("nMinWidth:"+nMinWidth);
            let nWidth = document.body.clientWidth - nMinWidth;
            if (mSliderContainerType == "pdf") {
                if (nWidth < DEFAULT_SLIDER_PDF_WIDTH) {
                    nWidth = DEFAULT_SLIDER_PDF_WIDTH;
                }
            } else {
                if (nWidth < DEFAULT_SLIDER_WIDTH) {
                    nWidth = DEFAULT_SLIDER_WIDTH;
                }
            }
            setRightSliderWidth(nWidth);
            localStorage.setItem(KEY_SLIDER_RIGHT_WIDTH, nWidth + '');

            setIframePdfContainerPointerEvent('none');

            e.preventDefault();
            e.stopPropagation();
        } else {
            setIframePdfContainerPointerEvent('all');
        }
        //library的左右拖动
        if (e.buttons == 1 && mIsSliderLibraryDownPress) {
            let nMinWidth = e.clientX;
            if (e.clientX < 250) {
                nMinWidth = 250;
            }
            let nWidth = document.body.clientWidth - nMinWidth;
            if (nWidth < DEFAULT_SLIDER_LIBRARY_WIDTH) {
                nWidth = DEFAULT_SLIDER_LIBRARY_WIDTH;
            }
            setRightSliderLibraryWidth(nWidth);
            pageLibraryRef.current?.onSliderEvent(nWidth);
            pageHighlightRef.current?.onSliderEvent(nWidth);
            localStorage.setItem(KEY_SLIDER_RIGHT_LIBRARY_WIDTH, nWidth + '');

            setLibraryContainerPointerEvent('none')
        }else{
            setLibraryContainerPointerEvent('all')
        }

        //common窗口的左右拖动
        if (e.buttons == 1 && mIsSliderCommonDownPress) {
            let nMinWidth = e.clientX;
            if (e.clientX < 250) {
                nMinWidth = 250;
            }
            let nWidth = document.body.clientWidth - nMinWidth;
            if (nWidth < DEFAULT_SLIDER_COMMON_WIDTH) {
                nWidth = DEFAULT_SLIDER_COMMON_WIDTH;
            }
            setCommonSliderContainerWidth(nWidth);
            localStorage.setItem(KEY_SLIDER_RIGHT_LIBRARY_WIDTH, nWidth + '');

            sideProjectRef.current?.onResizeEvent(nWidth);

            setCommonContainerPointerEvent('none')
        }else{
            setCommonContainerPointerEvent('all')
        }

        //左边的拖动....
        if (e.buttons == 1 && mIsLeftMouseDownPressed.current){
            let nMinWidth = e.clientX - LEFT_MENU_WIDTH;
            if (nMinWidth < LEFT_MENU_WIDTH) {
                nMinWidth = LEFT_MENU_WIDTH;
            }
            setDrawLeftMenuWidth(nMinWidth);
            localStorage.setItem(KEY_DRAW_LEFT_MENU_WIDTH,nMinWidth+'');
        }
    }

    function onMouseDownListener(event){
        if (isInSidebar()){
            //执行相应的窗口外关闭操作
            if (global.g_showDialogs.dialogInfos){//当前打开的有info对话框
                return;
            }
            window.parent.closeUnpinDialogCard();
            window.parent.closeUnpinDialogPdf();
            window.parent.closeUnpinDialogVideos();
            // event.preventDefault();
            // event.stopPropagation();
        }
    }

    function onMouseUpListener(event) {
        // console.log('global mouse up.....')
        mIsSliderDownPress = false;
        mIsSliderLibraryDownPress = false;
        mIsSliderCommonDownPress = false;
        mIsLeftMouseDownPressed.current = false;
        excalidrawRef?.onUpdateElementForServer();
        if (isInSidebar()){
            //在内部的实时保存
            saveNotes().then(res=>{
                const leftBoard = leftMenuRef.current?.onGetSelectNode();
                sendMessageFromSliderDraw("SYNC_DRAW_BOARD",{id:mNoteData.current.id,board:jsonToStringReplaceIcon(leftBoard)})
            });
        }else{
            //如果侧栏有打开，并且项目是同一个，board不是同一个.
            if (sliderType == 'project' && sliderProjectData?.id == mNoteData.current?.id){
                saveNotes().then(res=>{
                    const leftBoard = leftMenuRef.current?.onGetSelectNode();
                    sendMessageFromDraw("SYNC_DRAW_BOARD",{id:mNoteData.current.id,board:jsonToStringReplaceIcon(leftBoard)})
                })
            }
        }
    }

    function onSizeChanged(event) {
        let nDocWidth = document.body.clientWidth
        if (nDocWidth < 900) {
            setIsToolbarVisible(false)
            setToolButtonItemStyle({margin:'0 1px',padding: '0px'})
        } else {
            setIsToolbarVisible(true)
            setToolButtonItemStyle(DEFAULT_TOOL_ITEM_STYLE);
        }
        //这里要调整右侧栏。。。
        if (rightSliderWidth > nDocWidth) {
            setRightSliderWidth(nDocWidth);
            localStorage.setItem(KEY_SLIDER_RIGHT_WIDTH, nDocWidth + '');
        }
        if (rightSliderLibraryWidth > nDocWidth){
            setRightSliderLibraryWidth(nDocWidth);
            localStorage.setItem(KEY_SLIDER_RIGHT_LIBRARY_WIDTH, nDocWidth + '');
        }
        //按窗口比例调整库大小
        // if (rightSliderWidth > 0){
        //
        // }
        // if (rightSliderLibraryWidth > 0){
        //     pageLibraryRef.current?.onSliderEvent(nWidth);
        // }

        setHeaderTitleWidth((document.body.clientWidth - homePaddingLeft - 400)/2 - 16)
    }

    /**
     * 只处理esc键
     */
    function onHandleKeyEscape(){
        if (window.hasDialogShow() && !isPresentMode)return;

        if (excalidrawRef.isImagePreviewVisible()) return;

        if (isShowCanvasConfig){
            setIsShowCanvasConfig(false);
            return;
        }

        if (window.cancelHeightbar){
            const bCancel = window.cancelHeightbar();
            if (bCancel){
                return;
            }
        }
        postMessage(EVENT_KEY_ESCAPSE);
        // postMessage(EVENT_KEY_ESCAPSE_ESC);
        closeAllPopoverOrDropdown();
        window.closeRightSlider();//关闭全局的，这里有可能是全局的那个右侧栏。。mindmap插入的card或者别的东西....

        //如果画布上有连线，关闭连线
        if (excalidrawRef.getApp()?.hiddenHoverModel()){
            return;
        }

        if (rightSliderLibraryWidth > 0 || rightSliderWidth >0 || commonSliderContainerWidth>0){
            drawIndexSliderHeaderAction("collapse");
            return;
        }

        //关闭库侧栏，如果打开的话
        if (rightSliderLibraryWidth > 0){
            setRightSliderLibraryWidth(0);
            return;
        }
        if (commonSliderContainerWidth > 0){
            setCommonSliderContainerWidth(0);
            return;
        }

        if (rightSliderWidth > 0){
            setRightSliderWidth(0);
            return;
        }

        if (drawPopoverOpen) {
            return;
        }
        if (activityTool == 'freedraw' || activityTool == 'highlighter' || activityTool == 'arrow') {
            var arrayNew = [...toolButtons];
            arrayNew.forEach(p => {
                p.isActive = false;
                if (p.id == 'selection') {
                    p.isActive = true;
                }
            });
            setActivityTool('selection');
            setToolButtons(arrayNew);
            excalidrawRef.onSetActiveTool('selection');
            return;
        }

        animateSliderFade()

        if (isSearchVisible) {
            setIsSearchVisible(false);
        }
        excalidrawRef?.onCloseContextMenu();

        if (excalidrawRef?.getAppState()?.activeTool.type == 'laser' || mIsShowLaser.current) {
            exitLaser();
            return;
        }
        if (APP_WEB) {
            //web端不做处理....
            setIsAppWebFullScreen(false);
            e.preventDefault();
            return;
        }

        if (isPresentMode) {
            onExitPresentMode();
            // if (excalidrawRef.getExcalidrawState().displayMode === "preview"){
            //     setTimeout(()=>{
            //         excalidrawRef.onSetDisplayMode("edit");
            //     },100);
            // }
        } else {
            //refresh tools
            closeAllPopoverOrDropdown();
        }
        if (showEditor) {
            window.GNoteSave(false, true)
        }

        //退出选中的element..
        setTimeout(()=>{
            excalidrawRef?.getExcalidrawApi()?.updateScene({ appState: { selectedElementIds: {} } });
        },10)
    }

    /*接收消息*/
    function onInvokeRecvMessage(event, args) {
        console.log(args);
        if (args.hasOwnProperty("action") && args['action'] == 'outOpenApp') {
            let szArgs = args["obj"];
            if (szArgs.endsWith(".pcanvas") || szArgs.endsWith(".pcanvasx")) {
                //打开文件？
                console.log('check-args');
                ipcInvoke("check-args", {filePath: szArgs}).then(args => {
                    if (args != undefined && args.hasOwnProperty("data")) {
                        saveNotes(false);
                        mNoteData.current = null;
                        mTitle.current = '';
                        //reopen
                        const importData = JSON.parse(args.data);
                        setTitle(importData.info.title);
                        leftMenuRef.current.setOutMenuData(importData);
                        mExportInfos = importData.info;
                        //是否只读
                        // excalidrawRef.onSetReadonlyStatus(params.state.usr.isReadOnlyState);
                        excalidrawRef.onSetReadonlyStatus(importData.info?.isReadOnlyStatus || false);

                        if (mExportInfos != undefined) {
                            if (mExportInfos?.isReadOnlyStatus) {
                                setPresentModeExitTip(t("to exit this project"))
                                onPresentClick(false);
                            }
                        }

                        if (importData != undefined && importData.pageSize != undefined) {
                            excalidrawRef.onSetPageSize(importData.pageSize);

                            nTimeoutId = setTimeout(() => {
                                setPageSizeNumber(1 + '/' + leftMenuRef?.current.getPagesCount());
                                mNoteData.current = null;
                                mTitle.current = '';
                            }, 200);
                            mArrayTimeoutIds.current.push(nTimeoutId);
                        }
                    }
                })
            }
        }
    }

    function onLoadingProgress(event: any) {
        if (APP_WEB_WWW) {
            if (event.lengthComputable) {
                const progress = Math.round((event.loaded / event.total) * 100);
                setProgressPercent(progress);
                setIsLoading(progress < 100);
            }
        }
    }

    function onFullScreenChange() {

        let isFullScreen = document.fullScreen || document.mozFullScreen || document.webkitIsFullScreen;
        if (isFullScreen) {

        } else {
            setIsAppWebFullScreen(false);
            if (!APP_WEB) {
                //非web......预览的.
                nTimeoutId = setTimeout(() => {
                    onExitPresentMode();
                }, 60);
                mArrayTimeoutIds.current.push(nTimeoutId);

                if (excalidrawRef.getExcalidrawState().displayMode === "preview") {
                    nTimeoutId = setTimeout(() => {
                        excalidrawRef.onSetDisplayMode("edit");
                    }, 100);
                    mArrayTimeoutIds.current.push(nTimeoutId);
                }
            }
        }
    }

    /**
     * 尝试保存一下....
     * @param e
     */
    function onBeforeUnload(e) {
        if (APP_WEB_WWW) {
            saveNotes();
        }
        console.log('beforeunload.....')
    }

    useLayoutEffect(() => {
        document.body.addEventListener('keydown', onKeydownListener)
        document.body.addEventListener('mousemove', onMouseMoveListener);
        document.body.addEventListener('mousedown', onMouseDownListener)
        document.body.addEventListener('mouseup', onMouseUpListener)
        document.body.addEventListener('fullscreenchange', onFullScreenChange);
        window.addEventListener('beforeunload', onBeforeUnload);
        window.addEventListener('resize', onSizeChanged);

        //进度条消息
        recvMessage(EVENT_UPDATE_PROGRESS, (msg, data) => {
            setProgressPercent(data.data.progress);
        })

        recvMessage(EVENT_TOOLBAR_LOCKED_CHANGED, (msg, data) => {
            setIsSelectElementLocked(data.data.locked);
        }, true);

        // recvMessage(EVENT_KEYDOWN,(msg,data)=>{
        //     onKeydownListener(data.data.event);
        // })

        //执行的escapse
        window.pageDrawIndexEscape = ()=>{
            onHandleKeyEscape();
        }

        return () => {
            document.body.removeEventListener('keydown', onKeydownListener);
            document.body.removeEventListener('mousemove', onMouseMoveListener);
            document.body.removeEventListener('mouseup', onMouseUpListener)
            document.body.removeEventListener('mousedown', onMouseDownListener)
            document.body.removeEventListener('fullscreenchange', onFullScreenChange);
            window.removeEventListener('beforeunload', onBeforeUnload);
            window.removeEventListener('resize', onSizeChanged);
            unSubscribe(EVENT_KEYDOWN);
            unSubscribe(EVENT_UPDATE_PROGRESS);
            unSubscribe(EVENT_TOOLBAR_LOCKED_CHANGED);
            delete window.pageDrawIndexEscape;
            if (window.refreshInfoInDraw){
                window.refreshInfoInDraw('',null);
            }
        }
    })

    //region **********协作部分*****************/
    /*
    useEffect(() => {
        if (!excalidrawAPI || (!isCollabDisabled && !collabAPI)) {
            return;
        }

        const loadImages = (
            data: ResolutionType<typeof initializeScene>,
            isInitialLoad = false,
        ) => {
            if (!data.scene) {
                return;
            }
            if (collabAPI?.isCollaborating()) {
                if (data.scene.elements) {
                    collabAPI
                        .fetchImageFilesFromFirebase({
                            elements: data.scene.elements,
                            forceFetchFiles: true,
                        })
                        .then(({ loadedFiles, erroredFiles }) => {
                            excalidrawAPI.addFiles(loadedFiles);
                            updateStaleImageStatuses({
                                excalidrawAPI,
                                erroredFiles,
                                elements: excalidrawAPI.getSceneElementsIncludingDeleted(),
                            });
                        });
                }
            } else {
                const fileIds =
                    data.scene.elements?.reduce((acc, element) => {
                        if (isInitializedImageElement(element)) {
                            return acc.concat(element.fileId);
                        }
                        return acc;
                    }, [] as FileId[]) || [];

                if (data.isExternalScene) {
                    loadFilesFromFirebase(
                        `${FIREBASE_STORAGE_PREFIXES.shareLinkFiles}/${data.id}`,
                        data.key,
                        fileIds,
                    ).then(({ loadedFiles, erroredFiles }) => {
                        excalidrawAPI.addFiles(loadedFiles);
                        updateStaleImageStatuses({
                            excalidrawAPI,
                            erroredFiles,
                            elements: excalidrawAPI.getSceneElementsIncludingDeleted(),
                        });
                    });
                } else if (isInitialLoad) {
                    if (fileIds.length) {
                        LocalData.fileStorage
                            .getFiles(fileIds)
                            .then(({ loadedFiles, erroredFiles }) => {
                                if (loadedFiles.length) {
                                    excalidrawAPI.addFiles(loadedFiles);
                                }
                                updateStaleImageStatuses({
                                    excalidrawAPI,
                                    erroredFiles,
                                    elements: excalidrawAPI.getSceneElementsIncludingDeleted(),
                                });
                            });
                    }
                    // on fresh load, clear unused files from IDB (from previous
                    // session)
                    LocalData.fileStorage.clearObsoleteFiles({ currentFileIds: fileIds });
                }
            }
        };

        initializeScene({ collabAPI, excalidrawAPI }).then(async (data) => {
            loadImages(data, /* isInitialLoad  true);
            initialStatePromiseRef.current.promise.resolve(data.scene);
        });

        const onHashChange = async (event: HashChangeEvent) => {
            event.preventDefault();
            const libraryUrlTokens = parseLibraryTokensFromUrl();
            if (!libraryUrlTokens) {
                if (
                    collabAPI?.isCollaborating() &&
                    !isCollaborationLink(window.location.href)
                ) {
                    collabAPI.stopCollaboration(false);
                }
                excalidrawAPI.updateScene({ appState: { isLoading: true } });

                initializeScene({ collabAPI, excalidrawAPI }).then((data) => {
                    loadImages(data);
                    if (data.scene) {
                        excalidrawAPI.updateScene({
                            ...data.scene,
                            ...restore(data.scene, null, null, { repairBindings: true }),
                            commitToHistory: true,
                        });
                    }
                });
            }
        };

        const titleTimeout = setTimeout(
            () => (document.title = APP_NAME),
            TITLE_TIMEOUT,
        );

        const syncData = debounce(() => {
            if (isTestEnv()) {
                return;
            }
            if (
                !document.hidden &&
                ((collabAPI && !collabAPI.isCollaborating()) || isCollabDisabled)
            ) {
                // don't sync if local state is newer or identical to browser state
                if (isBrowserStorageStateNewer(STORAGE_KEYS.VERSION_DATA_STATE)) {
                    const localDataState = importFromLocalStorage();
                    const username = importUsernameFromLocalStorage();
                    let langCode = languageDetector.detect() || defaultLang.code;
                    if (Array.isArray(langCode)) {
                        langCode = langCode[0];
                    }
                    setLangCode(langCode);
                    excalidrawAPI.updateScene({
                        ...localDataState,
                    });
                    excalidrawAPI.updateLibrary({
                        libraryItems: getLibraryItemsFromStorage(),
                    });
                    collabAPI?.setUsername(username || "");
                }

                if (isBrowserStorageStateNewer(STORAGE_KEYS.VERSION_FILES)) {
                    const elements = excalidrawAPI.getSceneElementsIncludingDeleted();
                    const currFiles = excalidrawAPI.getFiles();
                    const fileIds =
                        elements?.reduce((acc, element) => {
                            if (
                                isInitializedImageElement(element) &&
                                // only load and update images that aren't already loaded
                                !currFiles[element.fileId]
                            ) {
                                return acc.concat(element.fileId);
                            }
                            return acc;
                        }, [] as FileId[]) || [];
                    if (fileIds.length) {
                        LocalData.fileStorage
                            .getFiles(fileIds)
                            .then(({ loadedFiles, erroredFiles }) => {
                                if (loadedFiles.length) {
                                    excalidrawAPI.addFiles(loadedFiles);
                                }
                                updateStaleImageStatuses({
                                    excalidrawAPI,
                                    erroredFiles,
                                    elements: excalidrawAPI.getSceneElementsIncludingDeleted(),
                                });
                            });
                    }
                }
            }
        }, SYNC_BROWSER_TABS_TIMEOUT);

        const onUnload = () => {
            LocalData.flushSave();
        };

        const visibilityChange = (event: FocusEvent | Event) => {
            if (event.type === EVENT.BLUR || document.hidden) {
                LocalData.flushSave();
            }
            if (
                event.type === EVENT.VISIBILITY_CHANGE ||
                event.type === EVENT.FOCUS
            ) {
                syncData();
            }
        };

        window.addEventListener(EVENT.HASHCHANGE, onHashChange, false);
        window.addEventListener(EVENT.UNLOAD, onUnload, false);
        window.addEventListener(EVENT.BLUR, visibilityChange, false);
        document.addEventListener(EVENT.VISIBILITY_CHANGE, visibilityChange, false);
        window.addEventListener(EVENT.FOCUS, visibilityChange, false);
        return () => {
            window.removeEventListener(EVENT.HASHCHANGE, onHashChange, false);
            window.removeEventListener(EVENT.UNLOAD, onUnload, false);
            window.removeEventListener(EVENT.BLUR, visibilityChange, false);
            window.removeEventListener(EVENT.FOCUS, visibilityChange, false);
            document.removeEventListener(
                EVENT.VISIBILITY_CHANGE,
                visibilityChange,
                false,
            );
            clearTimeout(titleTimeout);
        };
    }, [isCollabDisabled, collabAPI, excalidrawAPI]);
    */

    //**********协作部分end*****************/

    //只进来一次的....
    useEffect(() => {
        mIsSaving = false;//要设置下。避免不确定的意外。。。
        onSizeChanged(null);
        window.title = t("AppName");
        global.g_isLoadingFinished = false;

        setCommonSliderContainerWidth(0);

        // resetRootPostionNormal();
        setRootPostionFixed();//这里跟mindmap中的富文本框冲突了，如果root设置成fix,那么，mindmap编辑后，带换行的多文本弹窗的工具栏显示就有问题。。。。

        let freeDrawStrokeWidth:any = localStorage.getItem(KEY_FREE_DRAW_STROKE_WIDTH) || "1";
        let nFreeDrawStrokeWidth = getSafeInt(freeDrawStrokeWidth);
        setDrawStrokeWidth(nFreeDrawStrokeWidth);

        // if (APP_WEB_WWW /*|| import.meta.env.DEV*/) {
        //     setArrayMenuMore(MENU_MORE_WEB);
        // }
        if (APP_WEB || isInSlider()){
            setHomePaddingLeft(0);
        }

        if (isInSidebar()){
            setIsCollapsePage(true);
            leftMenuRef?.current.setOnCollapseStatus(true);
        }

        window.globalBackspace = (() => {
            if (pdfFilePath) {
                animateSliderFade();
            }else{

            }
            onHandleKeyEscape();
        })
        //监听窗口关闭...
        ipcOn('close-window', (msg, data) => {
            saveNotes();
        })

        ipcOn('pdf-note-update',async (msg,data)=>{
            // 刷新这个注记----
            refreshPdfAnnoComment(data);
        })

        ipcOn('export-pcanvas-ok',(msg,data)=>{
            window.showProgress(t('Exporting'),null,false);
        })

        ipcOn('notify-main-draw-insert-card',async (msg,data)=>{
            if (data.projectId == PROJECT_ID && data.libraryId){
                const library = await getCardById(data.libraryId);
                if (library){
                    postMessage(EVENT_TEST_ONDRAG_NOTE,{...library})
                }
            }
        })

        //刷新pdfanno 的备注
        recvMessage(EVENT_REFRESH_PDF_ANNO_COMMENT,(msg,data)=>{
            refreshPdfAnnoComment(data.data);
        })

        recvMessage(EVENT_REFRESH_ANNO_NAME,(msg,data)=>{
            refreshAnnoName(data.data);
        })


        if (ipcRenderer != null) {
            ipcRenderer.on("save-canvas", (e: object, path: string) => {
                onSaveCanvasX(path);
            });

            ipcRenderer.on("open-canvas", (e: object, path: string) => {
                onReadCanvasX(path);
            })
        }

        //链接消息
        recvMessage(DRAW_LINK_CLICK, (msg, data) => {
            //当前选中的元素的URL
            const selectEle = excalidrawRef?.onGetCurrentSelectedElement();
            // if(selectEle?.type === "embeddable"){
            //     return;
            // }

            let linkInfo: any;
            if (selectEle != undefined) {
                if (!isStringNullOrEmpty(selectEle.link)) {
                    try {
                        linkInfo = JSON.parse(selectEle.link as string);
                        //查找标题...
                        if (linkInfo.type == LINK_INFO_TYPE_PAGE) {
                            const treeData = leftMenuRef?.current.onGetPageDataById(linkInfo.id);
                            if (treeData != undefined) {
                                linkInfo.url = treeData.title;
                            }
                        } else if (linkInfo.type == LINK_INFO_TYPE_NOTE) {
                            const treeData = leftMenuRef?.current.onGetNoteDataById(linkInfo.id);
                            if (treeData != undefined) {
                                linkInfo.url = treeData.title;
                            }
                        } else if (linkInfo.type == LINK_INFO_TYPE_FRAME) {
                            const treeData = leftMenuRef.current?.onGetPageDataById(linkInfo.pageId);
                            const arrayEles = treeData.drawJson.elements.filter(p => p.id == linkInfo.id);
                            if (arrayEles.length > 0) {
                                linkInfo.url = arrayEles[0].name;
                            }
                        }
                    } catch (e) {
                    }
                }

                setIsShowLinkDialog(true);
                if (currentSelectNode == null){
                    currentSelectNode = leftMenuRef.current?.onGetSelectNode();
                }
                currentSelectNode.drawJson = getExcalidrawJson();
                const nTimeoutId = setTimeout(()=>{
                    dialogLinkRef.current?.onSetTreeData(leftMenuRef.current?.getAllMenuData(), leftMenuRef.current?.getAllNoteData(), linkInfo || selectEle?.link, selectEle, leftMenuRef?.current.getSelectMenuKeys());
                },100)
                mArrayTimeoutIds.current.push(nTimeoutId);
            }

        });

        /**
         * link跳转消息
         */
        recvMessage(EVENT_NAVIGATE_DEEPLINK,(msg,data)=>{
            //关闭菜单
            const element = data.data.element;
            var linkInfo = {
                id:element.customData?.projectId,
                isCurrentProject:element.customData?.projectId == PROJECT_ID,
                pageId:element.customData?.boardId,
                type:element.customData?.boardId?'page':'project'
            };
            if (APP_WEB){
                linkInfo.isCurrentProject = true;
            }
            onLinkNav(linkInfo);

            setTimeout(()=>{
                excalidrawRef?.hidePopupMenu();
            },100)
        })

        //mindmap 添加链接
        recvMessage(EVENT_MINDMAP_ADD_LINK, (msg, data) => {
            setIsShowLinkDialog(true);
            let linkInfo: any;
            if (currentSelectNode == null){
                currentSelectNode = leftMenuRef.current?.onGetSelectNode();
            }
            currentSelectNode.drawJson = getExcalidrawJson();

            if (isDeepLink(data.data.linkInfo)){
                const nTimeoutId = setTimeout(()=>{
                    dialogLinkRef.current?.onShowDialog(data.data.linkInfo,'from_mindmap');
                },100)
                mArrayTimeoutIds.current.push(nTimeoutId);
            }else{
                if (isString(data.data.linkInfo) && !isStringNullOrEmpty(data.data.linkInfo)) {
                    try{
                        linkInfo = JSON.parse(data.data.linkInfo)
                    }catch (e){

                    }
                    if (!linkInfo){
                        const nTimeoutId = setTimeout(()=>{
                            dialogLinkRef.current?.onShowDialog(data.data.linkInfo,'from_mindmap');
                        },100);
                        mArrayTimeoutIds.current.push(nTimeoutId);
                        return;
                    }
                }

                const nTimeoutId = setTimeout(()=>{
                    dialogLinkRef.current?.onSetTreeData(leftMenuRef.current?.getAllMenuData(), leftMenuRef.current?.getAllNoteData(), linkInfo, null, leftMenuRef?.current.getSelectMenuKeys(),'from_mindmap');
                },100);
                mArrayTimeoutIds.current.push(nTimeoutId);
            }
        });
        recvMessage(EVENT_MINDMAP_LINE_COLOR, (msg, data) => {
            dialogColorChooseRef.current?.onShowDialog(data.data.color, excalidrawRef?.getAppState(), false, COLOR_CHOOSE_TYPE_MINDMAP_LINE_COLOR);
        })

        recvMessage(EVENT_UPDATE_FRAME_LIST, () => {
            leftMenuRef.current.setFrameElementList(excalidrawRef.getDrawJson().elements);
        });

        recvMessage(EVENT_CLEAR_CANVAS, (msg, data) => {
            dialogMessageBoxRef.current.onShowDialog(t("Clear canvas"), t("ClearReset"), t("Clear"), () => {
                excalidrawRef.newProject();
            })
        });

        recvMessage(EVENT_SHOW_FONT_CHOOSE, (msg, data) => {
            if (hasLicense() || hasDesktopBaseLicense()) {
                dialogFontChooseRef.current?.onShowDialog();
            } else {
                // showDesktopPro(DESKTOP_PRO_FROM_IMPORT_FONT);
                if (isZh()) {
                    ipcSend('open-url',import.meta.env.VITE_HTTP_PURCHASE_PRICE_ZH)
                }else {
                    ipcSend('open-url', import.meta.env.VITE_HTTP_PURCHASE_PRICE);
                }
            }
        });
        recvMessage(EVENT_SHOW_IMPORT_FILE_VIP, async (msg, data) => {
            // setIsShowDialogImportFileVip(true);
            // setTimeout(()=>{
            //     dialogImportFileVipRef?.current?.onShowDialog(t("Import file"),t("UpgradeToUseThisFeature"));
            // },100);

            // showDesktopPro(DESKTOP_PRO_FROM_IMPORT_FILE);
            //这里关闭一下。。
            // window.closeDialogFileImportLoading();

            let hasVideo = false;
            let hasPdf = false;
            for (let i = 0; i < data.data.files.length; i++) {
                const file = data.data.files[i];
                if (isVideo(file.path)){
                    hasVideo = true;
                }
                if (isPdf(file.path)){
                    hasPdf = true;
                }
            }
            const nVideoCount = await beyondFreeVideoLimit();
            if (!hasLicense() && !hasDesktopBaseLicense() && hasVideo &&  nVideoCount){
                window.showMessageBox(t("Upgrade required"), t("NeedUpgradeToImportVideoMore"), t("Cancel"), t("Learn more"), null, () => {
                    if (isZh()) {
                        ipcSend('open-url',import.meta.env.VITE_HTTP_PURCHASE_PRICE_ZH)
                    }else {
                        ipcSend('open-url', import.meta.env.VITE_HTTP_PURCHASE_PRICE);
                    }
                })
                window.closeDialogFileImportLoading();
                return;
            }

            const nPdfCount = await beyondFreePdfLimit();
            if (!hasLicense() && !hasDesktopBaseLicense() && hasPdf &&  nPdfCount){
                window.showMessageBox(t("Upgrade required"), t("NeedUpgradeToImportPDF"), t("Cancel"), t("Learn more"), null, () => {
                    if (isZh()) {
                        ipcSend('open-url',import.meta.env.VITE_HTTP_PURCHASE_PRICE_ZH)
                    }else {
                        ipcSend('open-url', import.meta.env.VITE_HTTP_PURCHASE_PRICE);
                    }
                })
                window.closeDialogFileImportLoading();
                return;
            }

            dialogMessageBoxRef.current.onShowDialogOkCancel(t("Tips"), t("FreeUsesCanImportDesc"), t("Import"), t("See plans"), async() => {
                for (let i = 0; i < data.data.files.length; i++) {
                    const file = data.data.files[i];
                    if (isImage(file.name)) {
                        // excalidrawRef.getApp()?.insertImgElement(file,false);
                    } else {
                        if (data.data.importFileMode == 'linkMode'){
                            //链接模式
                            window.closeDialogFileImportLoading();
                            excalidrawRef.insertFileElement(file.path, null, false, file, null, null,true,true);
                        }else{
                            if (data.data.files.length == 1){
                                const szExistFileName = await ipcInvoke('cmp-file-md5', {filePath:file.path});
                                if (szExistFileName){
                                    window.showMessageBox(t("DuplicateFileFound"),t("TheSameFileAlreadyExists"),t("CreateNewCopy"),t("Ok"),()=>{
                                        //create new copy
                                        ipcInvoke('copy-file', {filePath: file.path}).then(res => {
                                            //insert file type
                                            window.closeDialogFileImportLoading();
                                            excalidrawRef.insertFileElement(res, null, false, null);
                                        });
                                    },()=>{
                                        //use exist--得到文件名，创建一个新的...
                                        window.closeDialogFileImportLoading();
                                        // excalidrawRef.insertFileElement(szExistFileName, null, false, null);
                                        //use exist--得到文件名，创建一个新的...
                                        getLibraryByFileName(szExistFileName).then(library=>{
                                            excalidrawRef.insertFileElement(szExistFileName, library.id, false, file, null, null,false,false,library.name);
                                        });
                                    })
                                }else{
                                    ipcInvoke('copy-file', {filePath: file.path}).then(res => {
                                        //insert file type
                                        window.closeDialogFileImportLoading();
                                        excalidrawRef.insertFileElement(res, null, false, null);
                                    });
                                }
                            }else{
                                ipcInvoke('copy-file', {filePath: file.path}).then(res => {
                                    //insert file type
                                    window.closeDialogFileImportLoading();
                                    excalidrawRef.insertFileElement(res, null, false, null)
                                });
                            }
                        }

                    }
                }
            }, () => {
                if (isZh()) {
                    ipcSend('open-url',import.meta.env.VITE_HTTP_PURCHASE_PRICE_ZH)
                }else {
                    ipcSend('open-url', import.meta.env.VITE_HTTP_PURCHASE_PRICE);
                }
                return false;
            })


            // for (let i=0;i<data.data.files.length;i++){
            //     const file = data.data.files[i];
            //     if (isImage(file.name)){//image由app.tsx自动处理了。这里不用管了...
            //         // excalidrawRef.getApp()?.insertImgElement(file,false);
            //     }else{
            //         ipcInvoke('copy-file',{filePath:file.path}).then(res=>{
            //             //insert file type
            //             excalidrawRef.insertFileElement(res,null,false,null)
            //         });
            //     }
            // }

        }, true)
        // recvMessage(EVENT_SHOW_IMPORT_FONT_VIP,(msg,data)=>{
        //     showDesktopPro(DESKTOP_PRO_FROM_IMPORT_FONT);
        // },true)
        recvMessage(EVENT_FRAME_PAGES, (msg, data) => {
            setPageSizeNumber(data.data);
        }, true)
        recvMessage(EVENT_SHOW_PROGRESS, (msg, data) => {
            dialogProgressRef.current?.onShowDialog(data.data.tips);
            //随机s关闭
            //显示重命名对话框
            let random = new Random(Date.now());
            const ms = 600 + Math.floor(random.next() * 1000);
            nTimeoutId = setTimeout(() => {
                dialogProgressRef.current?.onCloseDialog();
                dialogRenameRef.current?.onShowDialog(data.data.id, data.data.fontName);
            }, ms);
            mArrayTimeoutIds.current.push(nTimeoutId);
        })
        recvMessage(EVENT_TOGGLE_THEME, (msg, data) => {
            const theme = localStorage.getItem(SYS_CONFIG_KEY_THEME);

            let item;
            if (theme == THEME_DARK) {
                item = arrayDarkMenu()[1];
            } else {
                item = arrayDarkMenu()[0];
            }
            // updateSysConfig(SYS_CONFIG_KEY_THEME,item.key);
            localStorage.setItem(SYS_CONFIG_KEY_THEME, item.key);
            global.g_isDarkMode = (item.key == THEME_DARK);
            const szThemeName = item.key + '-theme';
            let body = document.getElementsByTagName("body")[0];
            body.className = szThemeName;
            emitter.emit(EVENT_CHANGE_THEME, item.key);
            postMessage(EVENT_FORCE_UPDATE);
            window.globalRefreshList('updateTheme_')

            forceUpdate();

        }, true);

        recvMessage(EVENT_MAX_DRAG_IMAGE, (msg, data) => {
            dialogMessageBoxRef.current.onShowDialog(t("Tips"), t("YouCanUploadUp10").replace("10",20), '', () => {
                excalidrawRef.newProject();
            })
        }, true)

        recvMessage(EVENT_RICH_TEXT_SELECTED, (msg, data) => {
            if (data.data.hasSelection) {
                excalidrawRef?.showTextElementPopupMenu();
            } else {
                excalidrawRef?.hidePopupMenu();
            }

        }, true);

        /**
         * 右侧栏拖动过来的
         * 拖动拖动
         * 拖动来的
         * 插入来的
         * 插入
         * 元素
         * 元素插入
         * 拖动拖动拖动拖动拖动拖动拖动拖动拖动拖动拖动拖动拖动拖动拖动拖动拖动
         */
        recvMessage(EVENT_TEST_ONDRAG_NOTE, async (msg, data) => {
            if (global.g_isDragInCard){//防止一直是true...
                global.g_isDragInCard = false;
                return;
            }

            let {x, y} = viewportCoordsToSceneCoords({
                clientX: data.data.x,
                clientY: data.data.y
            }, excalidrawRef.getAppState());

            if (isNaN(x) || isNaN(y)){
                let sssssssss = excalidrawRef.getApp().getCurrentCenterPoint();
                x = sssssssss.x;
                y = sssssssss.y;
            }

            //判断当前鼠标的X,Y坐标是否在canvas内
            if (data.data.x >= (document.body.clientWidth - mSliderRightLibraryWidth)){
                return;
            }

            //不管插入下面哪个1s后刷新
            nTimeoutId = setTimeout(()=>{
                saveNotes();
            },1000);
            mArrayTimeoutIds.current.push(nTimeoutId);

            //判断是否存在...
            const arrayElements = excalidrawRef?.getApp()?.getSceneElements();
            if (mJsonDragPdfAnnotations) {
                // if (arrayElements.some(p => p.type == 'iframe' && p.customData?.generationData?.id == data.data.id && p.customData?.generationData?.type == 'pdfAnno')) {
                //     message.info(t("PdfAnnoExist"));
                //     return;
                // }
                //补充name
                //处理注记的插入
                excalidrawRef.onInsertPdfAnnotation0(mJsonDragPdfAnnotations, x, y,'pdfAnno').then(res=>{
                    //这里不获取 一下焦点的话，从iframe -pdf拖动过来的注记，第一次点击移动有点问题...
                    excalidrawRef?.onFocus();
                });
                mJsonDragPdfAnnotations = null;
                return;
            }

            if (data.data.type == 'card' || data.data.type == 'journal') {
                let card: any = await getCardById(data.data.id);
                if (card) {
                    let isNewInsert = false;
                    if (card.type == 'card'){
                        if (data.data.deeplink?.isNew){
                            //新插入---card
                            card.id = generateUUID2();
                            await updateCard(card);
                        }
                    }
                    //添加到左侧栏
                    leftMenuRef.current?.onAddOrUpdateDatas(card.id, card.name, card.doc);
                    excalidrawRef?.onInsertNoteData({
                        type:card.type,
                        id: card.id,
                        name: card.name,
                        doc: card.doc,
                        journalTime:card.journalTime,
                        libraryType:card.type
                    }, true, x - 100, y - 150,data.data.deeplink,true);

                }
            } else if (data.data.type == 'video' || data.data.type == 'pdf' || data.data.type == 'audio' || data.data.type == 'file') {
                // if (arrayElements.some(p => p.type == 'iframe' && p.customData?.generationData?.id == data.data.id && (p.customData?.generationData?.type == 'file' || p.customData?.generationData?.type == 'note'))) {
                //     message.info(t("CardIsAlreadOn").replace('{0}', t(firstLetterUpper(data.data.type == 'pdf' ? 'PDF' : data.data.type))));
                //     return;
                // }

                const card: any = await getCardById(data.data.id);
                if (card) {
                    excalidrawRef?.getApp().insertFileElement(card.fileName, card.id, {x, y},false,null,null,null,true,(card.isAbsolutePath || false),card.name,true,data.data.deeplink);
                }
            }else if (data.data.type == 'youtube' || data.data.type == 'bilibili' || isSupportVideoType(data.data.type)){
                //判断是否已添加过.
                // if (arrayElements.some(p => p.id == data.data.id)) {
                //     message.info(t("CardIsAlreadOn").replace("{0}",t("Video")));
                //     return;
                // }
                const card: any = await getCardById(data.data.id);
                excalidrawRef.insertEmbedElement(card.fileName,card.id,x,y,'page',data.data.deeplink);
            }
            else if (data.data.type == 'image') {
                const card: any = await getCardById(data.data.id);
                if (card) {
                    excalidrawRef?.getApp()?.insertLibrayImage(card, {x, y},true,data.data.deeplink)
                }
            }else if (data.data.type == 'videoAnno' || data.data.type == 'audioAnno'){
                //region 视频注记
                // if (arrayElements.some(p => p.type == 'iframe' && p.id == data.data.id && p.customData?.generationData?.type == 'videoAnno')) {
                //     message.info(t("VideoAnnoExist"));
                //     patchForModalClose();
                //     return;
                // }
                const videoAnno:any = await getCardById(data.data.id);
                if (!videoAnno){
                    message.error(t('HighlightNotFoundInLibrary'))
                    return;
                }
                if (videoAnno && !videoAnno.libraryId){
                    videoAnno.libraryId = data.data.libraryId;
                    updateCard(videoAnno);
                }
                let szName = data.data.name;
                if (!szName){
                    const library = await getCardById(videoAnno.libraryId);
                    if (library && library.name){
                        szName = library.name;
                    }else{
                        //去hight表找找看
                        const highlight = await dbGetHighlightByLibraryId(videoAnno.libraryId);
                        if (highlight && highlight.name){
                            szName = highlight.name;
                        }
                    }
                }
                //处理注记的插入
                excalidrawRef.onInsertVideoAnnotation(videoAnno.libraryId,videoAnno.fileName,videoAnno, x, y,szName,data.data.type).then(res=>{
                    patchForModalClose();
                });
                //endregion
            }else if (data.data.type == 'pdfAnno' || data.data.type == 'cardAnno'){
                //pdf注记拖动过来的.
                // if (arrayElements.some(p => p.type == 'iframe' && p.customData?.generationData?.id == data.data.id && p.customData?.generationData?.type == 'pdfAnno')) {
                //     let szMsg = t("CardAnnoExist");
                //     if (data.data.type == 'pdfAnno'){
                //         szMsg = t("PdfAnnoExist");
                //     }
                //     message.info(szMsg);
                //     return;
                // }
                const pdfAnno:any = await getCardById(data.data.id);
                const library:any = await getCardById(pdfAnno.libraryId);
                pdfAnno.pdfId = pdfAnno.libraryId;
                pdfAnno.type = 'highlight';
                //处理注记的插入
                excalidrawRef.onInsertPdfAnnotation({data:[pdfAnno],name:library?.name}, x, y,data.data.type,data.data.deeplink);
            }else if (data.data.type == 'webLink'){
                if (arrayElements.some(p => p.type == 'embeddable' && p.id == data.data.id)) {
                    message.info(t("Bookmark exist"));
                    patchForModalClose();
                    return;
                }
                const library = await getCardById(data.data.id);
                //插入bookmark
                excalidrawRef.insertEmbedElement(library.fileName,library.id,x,y,'text');
            }else if (data.data.type == 'board'){
                //直接要插入project-link
                // let xy = excalidrawAPI.getApp().getCurrentCenterPoint();
                let szId = PROJECT_ID;
                if (data.data.projectId){
                    szId = data.data.projectId;
                }
                excalidrawRef.getApp().insertProjectLink(x,y,szId,data.data.key || data.data.id,data.data.deeplink);
            }else if (data.data.type == 'project'){
                if (data.data.pageId){
                    //这是一个子画板.
                    excalidrawRef.getApp().insertProjectLink(x,y,data.data.id,data.data.pageId,data.data.deeplink);
                }else{
                    excalidrawRef.getApp().insertProjectLink(x,y,data.data.id,null,data.data.deeplink);
                }

            }
            else {
                const note = leftMenuRef.current?.getDragNoteInfo();
                if (note) {
                    if (!note.noteDataDoc){
                        note.noteDataDoc = await getCardDoc(note.key);
                    }
                    excalidrawRef?.onInsertNoteData({
                        id: note.key,
                        name: note.title,
                        doc: note.noteDataDoc
                    }, true, x, y);
                }
            }
        }, true);

        /**
         * 刷新视频注记
         */
        recvMessage(EVENT_REFRESH_VIDEO_ANNO_ELEMENT,async (msg,data)=>{
            const arrayElements:any = excalidrawRef.getApp()?.getSceneElements().filter(p=>p.customData?.generationData?.videoData?.id == data.data.id);
            arrayElements.forEach(async(element)=>{
                if (element){
                    const newCustom =  element.customData;
                    newCustom.generationData.videoData.title = data.data.title;
                    newCustom.generationData.videoData.content = data.data.content;
                    newCustom.generationData.videoData.time = data.data.time;
                    newCustom.generationData.videoData.thumbImage = data.data.thumbImage;
                    newCustom.generationData.videoData.loop = data.data.loop;
                    newCustom.generationData.videoData.endTime = data.data.endTime;
                    const nHeight = await calcVideoAnnoHeight({title:data.data.title,content:data.data.content,thumbImage:data.data.thumbImage},element.width);
                    mutateElement(element,{height:nHeight,customData:newCustom})
                }
            })

        })

        /**
         * 侧栏打开CARD
         * 右侧栏打开卡片
         * 右侧栏打开card
         */
        recvMessage(EVENT_NOTE_ON_SLIDER_RIGHT, async (msg, data) => {
            if (isInSlider()){
                sendMessageFromSliderDraw(EVENT_NOTE_ON_SLIDER_RIGHT,data)
                return;
            }
            //关闭全局的右侧栏。。
            window.closeRightSlider();

            //如果当前打开的是card,需要先保存之前的...
            const data0000 = await editorRef.current?.save?.();
            if (data0000) {
                postMessage(EVENT_UPDATE_NOTE, {data: data0000, isInsertCanvas: false});
            }

            mSliderCardId = data.data.data.id;
            mSliderContainerType = 'card';
            let nRightSliderW = rightSliderWidth;
            if (nRightSliderW == 0) {
                nRightSliderW = getIntValue(localStorage.getItem(KEY_SLIDER_RIGHT_WIDTH)) ?? DEFAULT_SLIDER_WIDTH;
            }
            //这里要调整右侧栏。。。
            const nDocWidth = document.body.clientWidth;
            if (nRightSliderW > nDocWidth) {
                nRightSliderW = nDocWidth;
            }

            setRightSliderWidth(nRightSliderW);

            // const szHtml = data.data.html;
            // setSliderContainerHtml(szHtml);
            //如果doc为空，使用本地的.
            if (!data.data.data.doc) {
                let note = await getCardById(data.data.data.id, true);
                if (note) {
                    data.data.data.name = note.name;
                    data.data.data.doc = note.doc;
                }
            }
            setSliderCardData(data.data.data);
            setPdfFileName(data.data.data.name);
            setPdfFilePath('');
            setPdfFileId('');
            const fScrollRate = data.data.scrollRate ?? 0;
            nTimeoutId = setTimeout(() => {
                const divEditContainer = document.getElementById('div-edit-container');
                if (divEditContainer) {
                    const nDivHeight = divEditContainer?.clientHeight;
                    divEditContainer.scrollTop = nDivHeight * fScrollRate;
                }
            }, 100);
            mArrayTimeoutIds.current.push(nTimeoutId);

            //关闭library
            setRightSliderLibraryWidth(0);
            setCommonSliderContainerWidth(0);

            //是否有导航菜单
            if (data.data.breadcrumb){
                setSliderHeaderVisible(true);
                setArrayBreadcrumb(data.data.breadcrumb);
            }else{
                setSliderHeaderVisible(false);
            }
            //一直有头部显示
            setSliderHeaderVisible(!global.g_isPresentMode);
            setSelectSliderRightMenu('library');

        }, true);

        recvMessage(EVENT_OPEN_NOTE, (msg, data) => {
            if (mSliderContainerType == 'card') {
                setRightSliderWidth(0);
                setSliderCardData(null);
            }
        }, true)

        recvMessage(EVENT_MINDMAP_REMOVE_ATTACH, (msg, data) => {
            let szMessage = t("DeleteTheCard");
            if (data.data.node.isRoot) {
                szMessage = t("DeleteTheMindmap");
            } else {
                const extra = data.data.node.getData().extra;
                if (extra.type == 'pdf') {
                    szMessage = t("DeleteThePDF");
                }
            }

            dialogMessageBoxRef?.current?.onShowDialog(t("Tips"), szMessage, t("Delete"), async () => {
                if (data.data.command == 'REMOVE_NODE') {
                    if (data.data.node.isRoot) {
                        //删除这个mindmap
                        // const elements = excalidrawRef?.getApp()?.getSceneElements();
                        excalidrawRef.getApp()?.removeElementById(data.data.node.uid);
                        excalidrawRef.hidePopupMenu();
                        mindMapCache.delete(data.data.node.uid);
                        patchForModalClose();
                    } else {
                        data.data.mindMap.execCommand('REMOVE_NODE', data.data.node)
                    }

                } else if (data.data.command == 'SET_NODE_IMAGE') {
                    data.data.mindMap.execCommand('SET_NODE_IMAGE', data.data.node, {url: null})
                }
            });
        }, true)

        recvMessage(EVENT_CHOOSE_INSERT_PDF_FILE, (msg, data) => {
            filePdfInputRef.current?.click();
        }, true)

        recvMessage(EVENT_CANVAS_REFRESH_ELEMENT_COUNT,(msg,data)=>{
            nTimeoutId = setTimeout(()=>{
                setHasElement(excalidrawRef?.getApp()?.getSceneElements()?.length > 0);
                //这里保存一下.
                saveNotes();
            },200);
            mArrayTimeoutIds.current.push(nTimeoutId);
        },true)

        //根据一个元素的ID，缩放到这个元素.......不认在哪个board
        recvMessage(EVENT_SELECT_ELEMENT_IN_CANVAS_BY_ELEID,(msg,data)=>{
            const id = data.data.id;
            const arrayBoards = leftMenuRef.current?.getAllMenuData();
            let szBoardId,szEleId;
            let bFinished = false;
            loopAllNode(arrayBoards,(board)=>{
                if (!bFinished && board.drawJson?.elements){
                    for (let j=0;j<board.drawJson.elements.length;j++){
                        const ele = board.drawJson.elements[j];
                        if (data.data.isCard){
                            if (!isNoteElement(ele))continue;
                        }
                        if (ele.id == id || ele.customData?.generationData?.id == id){
                            if (!szBoardId){
                                szBoardId = board.key;
                                szEleId = ele.id;
                            }else{
                                if (szBoardId && leftMenuRef.current?.onGetCurrentSelectKey() == board.key){
                                    szBoardId = board.key;
                                    szEleId = ele.id;
                                }
                            }
                            bFinished = true;
                        }
                    }
                }

            })

            /*
            for (let i=0;i<arrayBoards.length;i++){
                const board = arrayBoards[i];
                for (let j=0;j<board.drawJson.elements.length;j++){
                    const ele = board.drawJson.elements[j];
                    if (data.data.isCard){
                        if (!isNoteElement(ele))continue;
                    }
                    if (ele.id == id || ele.customData?.generationData?.id == id){
                        if (!szBoardId){
                            szBoardId = board.key;
                            szEleId = ele.id;
                        }else{
                            if (szBoardId && leftMenuRef.current?.onGetCurrentSelectKey() == board.key){
                                szBoardId = board.key;
                                szEleId = ele.id;
                            }
                        }
                        break;
                    }
                }
            }*/
            if (szBoardId && szEleId){
                onNavSub(szBoardId, szEleId);
            }
        })

        //主题刷新
        // recvMessage(EVENT_FORCE_UPDATE,(msg,data)=>{
        //     forceUpdate();
        //     excalidrawRef?.onUpdateTheme();
        // })

        recvMessage(EVENT_REFRESH_CURRENT_CANVAS,(msg,data)=>{
            getNoteById(PROJECT_ID).then(res=>{
                if (res){
                    params.state = {};
                    params.state.usr = {};
                    params.state.usr.noteData = res;
                    onLoadData();
                }
            })
        })

        //第一次初始化内置项目需要刷新的....
        recvMessage(EVENT_REFRESH_CANVAS,(msg,data)=>{
            params.state = {};
            params.state.usr = {};
            params.state.usr.noteData = data.data.note;
            onLoadData();
        })

        recvMessage(EVENT_REFRESH_FAVOR,(msg,data)=>{
            if (mNoteData.current && data.data.id == mNoteData.current?.id){
                mNoteData.current.isFavirated = data.data.isFavirated;
                mNoteData.current.favirateTime = data.data.favirateTime;
            }
        })

        recvMessage(EVENT_RENAME_LIBRARY_ITEM,(msg,data)=>{
            updateDrawElementName(data.data.id,data.data.name);
            if (data.data.type == 'pdf'){
                setPdfFileName(data.data.name)
            }
        })

        recvMessage(EVENT_REFRESH_SLIDER_INFO,(msg,data)=>{
            refreshInfo();
        })


        //分享的web参数
        //加载网页的数据
        //分享分享分享分享的加载
        // const szUrl = "https://muenzo.com/p/05a250ae-cf49-47fe-1b72-48f5a52cb057114";window.location.href;
        let szId: any = urlParams.id;//getUrlQueryParam(szUrl,'id');"05a250ae-cf49-47fe-1b72-48f5a52cb057114";
        let isTestShare = false;
        if (import.meta.env.DEV) {
            // szId = "e2652e388e3d45298d507bd0d03d6d97114";
            // isTestShare = true;
        }
        mProjId = szId;
        global.g_currentSharedProjectId = szId;

        let szLocalHref = window.location.href;
        if (APP_WEB && szLocalHref.indexOf('app.noteey.com') == -1){
            // szLocalHref = 'https://alextweets.noteey.com'
            //拿出这个2级域名.
            const results = szLocalHref.match(/(\w+\.\w+)/g);
            if (results && results.length > 0){
                if (results[0] != 'app.noteey'){
                    setIsLoading(true);
                    const szDomain = results[0].replace('.noteey','');
                    apiSecondLevelDomain(szDomain,()=>{
                        message.error(t("Operator fail"));
                    }).then(res=>{

                        if (res){
                            const szUrl = res['原始链接'];
                            const arraySplits = szUrl.split('/');
                            mProjId = arraySplits[arraySplits.length - 1];
                            global.g_currentSharedProjectId = mProjId;

                            setIsLoadingFramePresent(mProjId.indexOf(PUBLISH_FRAME_SUF) > 0);
                            excalidrawRef.setProjectId(mProjId);
                            setIsPresentMode(true);

                            loadWebShareProject(res,mProjId);
                        }
                    }).catch(err=>{
                        message.destroy();
                        message.error(t("Error"))
                    });
                }
            }
        }

        if ((APP_WEB || (szId && DEBUG && !isInSidebar())) && !isStringNullOrEmpty(szId) ) {
            //是否是正在loading frame
            setIsLoadingFramePresent(szId.indexOf(PUBLISH_FRAME_SUF) > 0);
            excalidrawRef.setProjectId(mProjId);

            setIsPresentMode(true);
            // message.open({
            //     type:'loading',
            //     content:'Loading...',
            //     duration:0
            // })
            setIsLoading(true);
            noteInfoById(szId, () => {
                message.destroy();
                message.error(t("Share not exist"))
            }).then(async (res) => {
                loadWebShareProject(res,szId);
            })
        }

        //test
        // loadNoteInfoByUrlParams();

        window.addEventListener('progress', onLoadingProgress);

        if (!APP_WEB && !APP_WEB_WWW) {
            // console.log('ipcOnce onInvokeRecvMessage.......')
            ipcOnce("message", onInvokeRecvMessage);

            // return()=>{
            //     console.log('useEffect return.......')
            //     ipcRemove("message",onInvokeRecvMessage);
            // }
        }

        //test
        if (import.meta.env.DEV) {
            // apiUpdateElement({id:'elementid',userId:114})
        }

        const link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = getCssPath('CardEdit.css');
        document.head.appendChild(link);

        /**
         * 获取本项目所有数据
         */
        window.onGetProjectData = async () => {
            return await getCanvasNoteDatas(false,false);
        }

        //本身就在内部的转到元素
        window.onNavDeepLink = (linkInfo)=>{
            if (linkInfo.pageId == leftMenuRef.current.onGetCurrentSelectKey()){
                let nLeftOffset = homePaddingLeft;
                if (!isCollapsePage) {
                    nLeftOffset += LEFT_MENU_WIDTH;
                }
                //同一个board....
                excalidrawRef?.onScrollToElement(linkInfo.elementId,linkInfo.nodeId,nLeftOffset,10);
            }else{
                onNavSub(linkInfo.pageId,linkInfo.elementId,linkInfo.nodeId)
            }
        }

        /**
         * 笔记插入画布
         */
        window.onInsertNote = (card:any)=>{
            excalidrawRef?.onInsertNoteData(card, true);
        }


        //刷新主题
        window.refreshList['updateTheme_drawIndex'] = ()=>{
            //直接清了shape
            ShapeCache.clear();

            forceUpdate();
            excalidrawRef?.onUpdateTheme();
            //更改背景色.
            saveNotes().then(res=>{
                const drawJson = excalidrawRef.getDrawJson();
                if (drawJson.appState.viewBackgroundColor == DEFAULT_CANVAS_BACKGROUND || drawJson.appState.viewBackgroundColor == DEFAULT_CANVAS_BACKGROUND_DARK){
                    excalidrawRef.onSetBackground(isDarkMode()?DEFAULT_CANVAS_BACKGROUND_DARK:DEFAULT_CANVAS_BACKGROUND);
                }
            })
        };

        //插入库中的数据到当前
        window.onInsertLibraryToCurrentBoard = (libraryData)=>{
            excalidrawRef.onInsertPdfAnnotation({data:[libraryData]},0, 0,libraryData.type);
        }


        return () => {
            ipcRemove("message", onInvokeRecvMessage);
            ipcRemoveThisAll('save-annotations')
            ipcRemoveThisAll('export-pcanvas-ok')
            window.removeEventListener('progress', onLoadingProgress);
            unSubscribe(EVENT_SHOW_IMPORT_FILE_VIP);
            unSubscribe(EVENT_NAVIGATE_DEEPLINK);
            unSubscribe(EVENT_MINDMAP_ADD_LINK);
            unSubscribe(EVENT_MINDMAP_LINE_COLOR);
            unSubscribe(EVENT_UPDATE_FRAME_LIST);
            unSubscribe(EVENT_CLEAR_CANVAS);
            unSubscribe(EVENT_SHOW_FONT_CHOOSE);
            unSubscribe(EVENT_FRAME_PAGES);
            unSubscribe(EVENT_SHOW_PROGRESS);
            unSubscribe(EVENT_TOGGLE_THEME);
            unSubscribe(EVENT_MAX_DRAG_IMAGE);
            unSubscribe(EVENT_RICH_TEXT_SELECTED);
            unSubscribe(EVENT_TEST_ONDRAG_NOTE);
            unSubscribe(EVENT_NOTE_ON_SLIDER_RIGHT);
            unSubscribe(EVENT_OPEN_NOTE);
            unSubscribe(EVENT_MINDMAP_REMOVE_ATTACH);
            unSubscribe(EVENT_CHOOSE_INSERT_PDF_FILE);
            unSubscribe(EVENT_CANVAS_REFRESH_ELEMENT_COUNT);
            unSubscribe(EVENT_SELECT_ELEMENT_IN_CANVAS_BY_ELEID);
            // unSubscribe(EVENT_FORCE_UPDATE);
            unSubscribe(EVENT_REFRESH_CURRENT_CANVAS);
            unSubscribe(EVENT_REFRESH_VIDEO_ANNO_ELEMENT);
            unSubscribe(EVENT_REFRESH_FAVOR);
            unSubscribe(EVENT_REFRESH_PDF_ANNO_COMMENT);
            unSubscribe(EVENT_REFRESH_ANNO_NAME);
            unSubscribe(EVENT_RENAME_LIBRARY_ITEM);
            unSubscribe(EVENT_REFRESH_SLIDER_INFO);
            unSubscribe(DRAW_LINK_CLICK);
            unSubscribe(EVENT_REFRESH_CANVAS);


            currentSelectNode = null;
            mapMenuKey_ExcalidrawState = [];
            excalidrawRef = null;
            excalidrawHiddenRef = null;

            // mTitle.current ='';
//分享ID，如果有保存过笔记，则为笔记的ID
            mIsPresentMode = false;
            mExportType = '';//导出类型
// let mCurrentSearchRange = 'currentPage';
            mInitDatas='';//初始的画布内容
            mFirstBase64Capture = '';//画布的第一页的缩略图
            mExportInfos = {};//导入的info信息
            mSvgPageNum = 1;
            mIsFirstHighlighterClicked = true;
            mIsSearchVisible = false;
            mMouseMovingTime=0;
            mPageSizeType : 'canvas';
            cachePageDatas = {};
            mAutosaveTimeId = 0;
            mSaveTimes = 0;
            mSliderX = 0;
            mIsSliderDownPress = false;
            mIsSliderLibraryDownPress = false;
            mIsSliderCommonDownPress = false;

            mSliderContainerType = '';
            mSliderCardId='';
            mIsFullScreen = false;//是否是全屏状态
            mIsCollapseLeft = false;//左边的状态，预览后用于还原。。。。
//拖动pdf注记的信息
            mJsonDragPdfAnnotations = null;
//当前打开的pdf的文件名称
            mOpenedPdfFileName = null;
//当前右侧打开的元素
            mSliderVideoNotes;
            mSliderRightLibraryWidth = 0;
            mViewTime = undefined;
            mBackupHomeLeftWidth = 0;
            mFileImportMode;
            mSavePromise;
            mIsSaving = false;
            mIsImagePopoverOpen = false;
//正在加载的项目的信息.
            mLoadProjectInfo = null;
            PROJECT_ID = "";

            delete window.onGetProjectData;
            // delete window.editorForMd;
            delete window.globalBackspace;
            delete window.onNavDeepLink;
            delete window.onInsertNote;
            delete window.refreshList['updateTheme_drawIndex'];
            delete window.onInsertLibraryToCurrentBoard;

            //卸载样式.
            // const arrayLinks = document.head.getElementsByTagName('style');
            // for (let i=0;i<arrayLinks.length;i++){
            //     const item = arrayLinks[i];
            //     if (item.dataset.viteDevId?.includes('CardEdit.css')){
            //         document.head.removeChild(item);
            //     }
            // }
            document.head.removeChild(link);

            resetRootPostionNormal();
        }
    }, []);

    useEffect(()=>{
        /**
         * 刷新PDF的高亮...
         */
        recvMessage(EVENT_REFRESH_PDF_HIGHLIGHT,(msg,data)=>{
            if (data.data.fileId != pdfFileId)return;
            var iframe = document.getElementById('pdf-iframe-slider');
            // iframe.contentWindow[0].location.reload();
            // var pdfNew = {...fileState};
            // setFileState(pdfNew);
            if (iframe){
                iframe.contentWindow?.postMessage(JSON.stringify({
                    fileId: data.data.fileId,
                    type: "refresh-annotations"
                }), {
                    targetOrigin: '*'
                })
            }
        })
        return ()=>{
            unSubscribe(EVENT_REFRESH_PDF_HIGHLIGHT);
        }
    },[pdfFileId])

    //每次都进来的.
    useEffect(() => {

        // 侧栏打开PDF
        recvMessage(EVENT_PDF_ON_SLIDER_RIGHT, async (msg, data) => {
            if (isInSlider()){
                //转发到上一层
                sendMessageFromSliderDraw(EVENT_PDF_ON_SLIDER_RIGHT,data);
                return;
            }
            //关闭全局的右侧栏。。
            window.closeRightSlider();

            //如果当前打开的是card,需要先保存之前的...
            const data0000 = await editorRef.current?.save?.();
            if (data0000) {
                postMessage(EVENT_UPDATE_NOTE, {data: data0000, isInsertCanvas: false});
            }

            let szOldPdfFileId = pdfFileId;
            let nOriginSliderWidth = rightSliderWidth;

            const library = await getCardById(data.data.fileId);
            //web端注意read.js中的。window.addEventListener("message", event => {  不能使用ipc调用。现在还在调用，要改....
            mSliderContainerType = 'pdf';
            setPdfFilePath(data.data.pdfPath);
            setPdfFileName(library?.name || data.data.fileName);
            setPdfFileId(data.data.fileId);
            mOpenedPdfFileName = data.data.pdfFileName;
            if (rightSliderWidth == 0) {
                setRightSliderWidth(getIntValue(localStorage.getItem(KEY_SLIDER_RIGHT_WIDTH),DEFAULT_SLIDER_PDF_WIDTH));
            }

            nTimeoutId = setTimeout(() => {
                const iframe = document.getElementById("pdf-iframe-slider") as HTMLIFrameElement;
                if (iframe) {
                    let nDelayTime = 10;
                    if (szOldPdfFileId != data.data.fileId) {
                        iframe.contentWindow?.postMessage(JSON.stringify({
                            path: data.data.pdfPath,
                            fileId: data.data.fileId,
                            type: "open-pdf",
                            theme:getTheme(),
                            isViewAllHighlight:data.data.isViewAllHighlight || false,
                            language:getLanguageCode(),
                            isWeb:APP_WEB,
                            isReadOnly:global.g_isPresentMode,
                            isInDrawRightSlider:true,
                            state:library?.state,
                            initialPage:library?.pageNumber || 1,
                        }), {
                            targetOrigin: '*'
                        })
                        nDelayTime = 1600;
                    }

                    if (library?.pageNumber > 1){
                        message.success(t("RestoreLastPdfReadPos"))
                    }

                    //打开高亮?---
                    for (let i=1;i<4;i++){
                        nTimeoutId = setTimeout(() => {
                            const pdfData = excalidrawRef.getNewestPdfAnno();
                            if (pdfData) {
                                iframe.contentWindow?.postMessage(JSON.stringify({
                                    type: 'highlights-location',
                                    id: pdfData.id,
                                    time: nDelayTime
                                }))

                                ipcInvoke('get-annotations',{fileId:data.data.fileId}).then(annos=>{
                                    if (annos){
                                        const anno = annos.find(p=>p.id == pdfData.id);
                                        if (!anno){
                                            message.error(t("CantFindPdfHighlight"))
                                        }
                                    }
                                })
                            }
                        }, 100*i*5);
                        mArrayTimeoutIds.current.push(nTimeoutId);
                    }


                    nTimeoutId = setTimeout(()=>{
                        // iframe.contentWindow._reader?._updateState({colorScheme: localStorage.getItem(SYS_CONFIG_KEY_THEME)??THEME_LIGHT})
                        if (data.data.isViewAllHighlight){
                            iframe.contentWindow?._reader.toggleSidebar(true)
                        }
                    },600);
                    mArrayTimeoutIds.current.push(nTimeoutId);
                }
            }, 1000);
            mArrayTimeoutIds.current.push(nTimeoutId);
            setSliderContainerHtml('');
            setSliderCardData(null);

            //关闭library
            setRightSliderLibraryWidth(0);
            setCommonSliderContainerWidth(0);

            //是否有导航菜单
            if (data.data.breadcrumb && !isPresentMode){//非演示模式
                setSliderHeaderVisible(true);
                setArrayBreadcrumb(data.data.breadcrumb);
                setSelectSliderRightMenu (data.data.breadcrumb[0].type);
            }else{
                setSliderHeaderVisible(false);
                setSelectSliderRightMenu('library');
            }


            // if (isPresentMode){
            //     setIframePdfContainerPointerEvent('none');
            //     setTimeout(()=>{
            //         // setIframePdfContainerPointerEvent('all');
            //     },600)
            // }

            // const szHtml = data.data.html;
            // setSliderContainerHtml(szHtml);
        });

        //侧栏打开视频...
        recvMessage(EVENT_VIDEO_ON_SLIDER_RIGHT,(msg,data)=>{
            if (isInSlider()){
                //转发到上一层
                pauseAllVideo(null);
                pauseAllAudio(null);
                sendMessageFromSliderDraw(EVENT_VIDEO_ON_SLIDER_RIGHT,data);
                return;
            }

            //关闭全局的右侧栏
            window.closeRightSlider();

            if (commonSliderContainerWidth == 0) {
                setCommonSliderContainerWidth(localStorage.getItem(KEY_SLIDER_RIGHT_WIDTH) ?? DEFAULT_SLIDER_PDF_WIDTH);
            }
            setSliderVideoNotes(data.data.videoNotes);
            setRightSliderLibraryWidth(0);
            setRightSliderWidth(0);
            setArrayCommonSliderMoreMenu(getVideoSliderMenu(data.data.videoNotes?.element?.link));
            setSliderType('video');

            //是否有导航菜单
            if (data.data.breadcrumb){
                setSelectSliderRightMenu(data.data.breadcrumb[0].type)
                setSliderHeaderVisible(true);
                setArrayBreadcrumb(data.data.breadcrumb)
            }else{
                setSliderHeaderVisible(false);
                setSelectSliderRightMenu('library');
            }

        });

        /**
         * 侧栏打开项目
         */
        recvMessage(EVENT_PROJECT_ON_SlIDER_RIGHT,(msg,data)=>{
            if (data.data.isDeleted || data.data.isBoardDeleted){
                message.error(t('Invalid link'));
                return;
            }
            if (isInSidebar()){
                saveNotes().then(res=>{
                    const leftBoard = leftMenuRef.current?.onGetSelectNode();
                    sendMessageFromSliderDraw(EVENT_PROJECT_ON_SlIDER_RIGHT,data);
                });
                return;
            }
            //关闭全局的右侧栏。。
            window.closeRightSlider();

            getNoteJsonById(data.data.id).then(res=>{
                setSliderHeaderVisible(true);
                setSelectSliderRightMenu('project');
                drawIndexSliderHeaderAction('project');
                loopAllNode(res.doc.canvas,(node)=>{
                    node.isSelected = false;
                })

                if (data.data.boardId){
                    loop(res.doc.canvas,data.data.boardId,(node, i, data0, parent)=>{
                        node.isSelected = true;
                        node.elementId = data.data.elementId;
                        node.nodeId = data.data.nodeId;
                    })
                    // for (let i=0;i<res.doc.canvas.length;i++){
                    //     if (res.doc.canvas[i].key == data.data.boardId){
                    //         res.doc.canvas[i].isSelected = true;
                    //         res.doc.canvas[i].elementId = data.data.elementId;
                    //         res.doc.canvas[i].nodeId = data.data.nodeId;
                    //     }
                    // }
                }

                setSliderProjectData(res);
            })
        })

        /**
         * 侧栏打开webview
         */
        recvMessage(EVENT_WEBLINK_ON_SLIDER_RIGHT,(msg,data)=>{
            setSliderHeaderVisible(true);
            setSelectSliderRightMenu('webview');
            drawIndexSliderHeaderAction('webview');
            if (commonSliderContainerWidth == 0) {
                setCommonSliderContainerWidth(localStorage.getItem(KEY_SLIDER_RIGHT_WIDTH) ?? DEFAULT_SLIDER_PDF_WIDTH);
            }
            setRightSliderLibraryWidth(0);
            setRightSliderWidth(0);
            const ele = {link:data.data.link}
            if (ele.link.includes('?')){
                ele.link = ele.link + '&t='+Date.now();
            }else{
                ele.link = ele.link + '?t='+Date.now();
            }
            setSliderWebviewItem(ele)
        })

        //从pdf弹窗中删除了
        recvMessage(EVENT_DELETE_PDF_FROM_DIALOG,(msg,data)=>{
            if (pdfFileId == data.data.fileId){
                setRightSliderWidth(0);
                setPdfFilePath('');
            }
        });

        recvMessage(EVENT_REFRESH_DRAW_FAVOR,(msg,data)=>{
            refreshMenuMore();
        })

        //监听iframe dialogdrawindex发送的消息....
        window.addEventListener('message', windowMessageEvent);

        //关闭侧栏.
        window.closeSliderBar = ()=>{
            setRightSliderWidth(0);
            setRightSliderLibraryWidth(0);
            setCommonSliderContainerWidth(0);
        }

        //刷新右侧栏的标题，重命名的地方太多....
        window.refreshSlideRightBreadcrumb = (item)=>{
            if (selectSliderRightMenu == 'library'){
                if (sliderVideoNotes?.element?.id == item.id || pdfFileId == item.id){
                    setArrayBreadcrumb(createBreadcrumb('library',item.name))
                }
            }else if (selectSliderRightMenu == 'highlight'){
                if (sliderVideoNotes?.element?.id == item.id || pdfFileId == item.id){
                    setArrayBreadcrumb(createBreadcrumb('highlight',item.name))
                }
            }
        }

        /**
         * 重命名画布
         * @param szElementId
         * @param szName
         */
        window.renameElement = (szElementId,szName) =>{
            excalidrawRef.getApp().renameElement(szElementId,szName).then(res=>{

            });
        }

        /**
         * 删除画布
         * @param szElementId
         */
        window.deleteElement = (szElementId,isRemoveFromLibrary)=>{
            if (isRemoveFromLibrary){
                excalidrawRef.onDeleteElementFromLibrary(szElementId);
            }else{
                excalidrawRef.onDeleteElement(szElementId);
            }
        }

        /**
         * 是否正在加载项目
         */
        window.isLoadingProject = ()=>{
            return isSaving;
        }

        return () => {
            window.removeEventListener('message', windowMessageEvent);
            unSubscribe(EVENT_PDF_ON_SLIDER_RIGHT);
            unSubscribe(EVENT_VIDEO_ON_SLIDER_RIGHT);
            unSubscribe(EVENT_DELETE_PDF_FROM_DIALOG);
            unSubscribe(EVENT_PROJECT_ON_SlIDER_RIGHT);
            unSubscribe(EVENT_REFRESH_DRAW_FAVOR);
            unSubscribe(EVENT_WEBLINK_ON_SLIDER_RIGHT);
            delete window.closeSliderBar;
            delete window.refreshSlideRightBreadcrumb;
            delete window.renameElement;
            delete window.deleteElement;
            delete  window.isLoadingProject;
        }
    })

    useEffect(() => {
        leftMenuRef?.current.onPresentMode(isPresentMode);
    }, [isPresentMode])

    useEffect(() => {
        mIsSearchVisible = isSearchVisible;
    }, [isSearchVisible])

    useEffect(() => {
        onSearchElement();
    }, [searchKey])

    useEffect(()=>{
        if (params.state?.usr?.searchKey){
            setTimeout(()=>{
                setSearchKey(params.state?.usr?.searchKey);
            },500)
            //选择all board
            setDefaultSearch('wholeProject');
        }
    },[params.state?.usr?.time])

    useEffect(() => {
        postMessage(EVENT_FRAME_PAGE_DESC_VISIBLE, {isShowOverlay: isShowOverlay})
    }, [isShowOverlay])

    // useEffect(() => {
    //     document.title = title;
    //     if (isStringNullOrEmpty(title)) {
    //         // document.title = t("New project")
    //     }
    //     mTitle.current = title;
    // }, [title])

    useEffect(() => {
        if (isFullScreen == null) return;

        onFullScreen(isFullScreen);
    }, [isFullScreen])

    useEffect(() => {
        leftMenuRef.current.onIsFramePresent(isFramePresent)
    }, [isFramePresent])

    /**
     * !!!!!当打开视频弹窗时，这个拖动一个注记到画布-点击一次mask 无法关闭，需要再次才能关闭。。解决这个问题.!!!
     */
    const patchForModalClose = ()=>{
        nTimeoutId = setTimeout(()=>{
            const div = document.getElementsByClassName('blank-nothing-for-click');
            if (div && div.length > 0){
                div[0].click();
            }
        },200);
        mArrayTimeoutIds.current.push(nTimeoutId);
    }

    const patchMenuFavor = ()=>{
        setTimeout(()=>{
            const arrayMenus = document.getElementsByClassName('ant-dropdown-menu-submenu-title');
            for (let i=0;i<arrayMenus.length;i++){
                const item = arrayMenus[i];
                if (item.dataset?.menuId?.endsWith('-favor')){
                    item.onclick = async function (event:any){

                        if (mNoteData.current == null) {
                            await saveNotes(false);
                        }
                        if (mNoteData.current.isFavirated === 1) {
                            mNoteData.current.isFavirated = 0;
                        } else {
                            mNoteData.current.isFavirated = 1;
                        }
                        mNoteData.current.favirateTime = new Date().getTime();
                        mNoteData.current.sort = 0;
                        updateNote(mNoteData.current).then(res=>{
                            postMessage(EVENT_FAVIRIATE_CHANGE);
                        });
                        setIsFavored(mNoteData.current.isFavirated === 1);
                        refreshMenuMore();

                        setIsShowMenuMore(false);
                        setIsShowMenuMore1(false);
                    }
                }
            }
        },100)
    }

    /**
     * 刷新pdf备注
     * @param data
     */
    const refreshPdfAnnoComment = async (data:any)=>{
        if (!excalidrawRef)return;

        const arrayElements = excalidrawRef.getApp()?.getSceneElements();
        for (let i=0;i<arrayElements.length;i++){
            const element = arrayElements[i];
            if (element.customData?.generationData?.id == data.fileId){
                for (let j=0;j<data.annotations.length;j++){
                    const anno = data.annotations[j];
                    if (anno.id ==element.customData?.generationData?.pdfData?.id){
                        const customData = {...element.customData};
                        customData.generationData.pdfData.comment = anno.comment;
                        customData.generationData.pdfData.color = anno.color;
                        const pdfData = customData.generationData.pdfData;

                        // const szHtml = createPdfAnnoTextElement(pdfData);
                        // let height = 210;
                        // let elementHeight = height;
                        // if (pdfData.type == 'image' || pdfData.annoType == 'image'){
                        //     let size;
                        //
                        //     let szBase64Image = pdfData.image;
                        //     const filePath = localStorage.getItem(KEY_FILE_DIR)+pdfData.id+'.png';
                        //     size = mMapImageSize[filePath]
                        //     if (!size){
                        //         if (pdfData.image){
                        //             szBase64Image = pdfData.image;
                        //         }else{
                        //             szBase64Image = 'data:image/png;base64,' + await ipcInvoke('read-file-base64',{filePath:filePath});
                        //         }
                        //
                        //         size = await getBase64ImageSize(szBase64Image);
                        //         if (size && size.with > 0){
                        //             mMapImageSize[filePath] = {...size};
                        //         }
                        //     }
                        //
                        //     height = (size.height/size.width) * (element.width) + 28;
                        //     elementHeight = height;//不包含注记的高度
                        //     height += calcTextAreaHeight((element.width - (2 + 8 + 6)*2),pdfData.comment);
                        // }else{
                        //     //文本，计算下高度.
                        //     const hhhhhhiiiigggggg = calcTextHeight((element.width - (8 + 8 + 6) * 2), szHtml);
                        //     const nCommentHeight = calcTextAreaHeight((element.width - (2 + 8 + 6)*2),pdfData.comment);
                        //     height = hhhhhhiiiigggggg  + nCommentHeight;//(2 + 8 + 6)这个是所有的padding.
                        //     elementHeight = height;//不包含注记的高度.
                        // }

                        //更新这个元素
                        excalidrawRef.getApp()?.onUpdateElement(element,{customData:customData})
                        //触发该元素的自动更新
                        //tododododododododo 触发一次onchange事件
                        nTimeoutId = setTimeout(()=>{
                            let input = document.getElementById('pdf-anno-'+pdfData.id);
                            if (input){
                                let event1 = new InputEvent('input',{bubbles:true});
                                event1.isManualUpdate = true
                                input.dispatchEvent(event1);
                            }
                        },100);
                        mArrayTimeoutIds.current.push(nTimeoutId);
                        break;
                    }
                }

            }
        }
    }

    /**
     * 只刷新名称
     * @param library
     */
    const refreshAnnoName = (library:any)=>{
        const arrayElements = excalidrawRef.getApp()?.getSceneElements();
        for (let i=0;i<arrayElements.length;i++) {
            const element = arrayElements[i];
            if (isPdfAnnoElement(element) && (element.customData?.generationData?.id == library.libraryId || element.id == library.id)) {
                const customData = {...element.customData};
                customData.generationData.name = library.name;
                customData.generationData.pdfData!.name = library.name;
                //更新这个元素
                excalidrawRef.getApp()?.onUpdateElement(element, {customData: customData,name:library.name})
            }else if (isVideoAnnoElement(element) || isAudioAnnoElement(element)){
                const customData = {...element.customData};
                customData.generationData.videoName = library.name;
                //更新这个元素
                excalidrawRef.getApp()?.onUpdateElement(element, {customData: customData,name:library.name})
            }
        }
    }

    /**
     * 配置一些切换项目的参数。。。。。
     */
    const resetSomeInfo = ()=>{
        // mPublishId = '';//重置。。。。
        // PROJECT_ID = localStorage.getItem(KEY_NEW_PROJECT_ID) ?? generateUUID2();
        // mPublishId = PROJECT_ID;//localStorage.getItem(KEY_NEW_PROJECT_ID)??generateUUID2();

        if (params.state?.usr?.noteData || params.state?.usr?.importNoteData) {

        }else{
            setHasElement(false);//打开的....
        }
        if (props.projectId){
            if (!params.state){
                params.state = {};
            }
            if (!params.state.usr){
                params.state.usr = {};
            }
            params.state.usr.projectId = props.projectId;
        }
        if (params.state?.usr?.projectId){
            mPublishId = PROJECT_ID = params.state?.usr?.projectId;
        }
        //切换了项目了，当前选择的要置空!
        currentSelectNode = null;
        setIsSearchVisible(false);
        setSelectBoard(null);
        mTitle.current = '';
        setTitle('');
        mIsFirstHighlighterClicked = true;
        mAutosaveTimeId = 0;
        mFirstBase64Capture = '';
        mIsPresentMode = false;
        mNoteData.current = null;
        global.g_isPresentMode = false;
        global.g_arrayRemovedFromLibraryIds.length = 0;
        window.refreshEditCardList = {};//重置....
        setIsTitleDisabled(KEY_DEFAULT_PROJECT_ID == props.projectId || PROJECT_ID == KEY_DEFAULT_PROJECT_ID)

        excalidrawRef?.createFistHistory(currentSelectNode?.key);
    }

    /**
     * 主参数修改时 重新加载数据
     */
    const loadDataParamsChanged = async ()=>{
        //这里参数更改，要刷新界面
        mSavePromise = null;

        if (getExcalidrawAPI()){
            if (mIsSaving)return;

            mIsSaving = true;
            if (!global.g_isAutoRestore){
                setIsSaving(true);
            }

            //表示已经是打开的项目了，保存上一个更改.
            // console.log('1.开始加载....')
            saveNotes(false).then(async (res)=>{
                // console.log('2.保存完成....开始初始化相应数据')
                resetSomeInfo();
                //保存完了加载新的...
                //预防后退过来的数据。这里需要从数据库取一下project......
                if (params.state?.usr?.projectId){
                    const res = await getNoteById(params.state?.usr?.projectId);
                    if (res){
                        const noteData = res;
                        params.state.usr.noteData = noteData;
                        await onExcalidrawInitComplete(null);
                        mIsSaving = false;
                    }else{
                        newProject();
                        await onExcalidrawInitComplete(null);
                        mIsSaving = false;
                    }
                }else{
                    await onExcalidrawInitComplete(null);
                    mIsSaving = false;
                }
                refreshMenuMore();
            });
        }else{
            resetSomeInfo();
            if (params.state?.usr?.projectId){
                if (!global.g_isAutoRestore){
                    setIsSaving(params.state?.usr?.projectId == KEY_DEFAULT_PROJECT_ID);
                }

                getNoteById(params.state?.usr?.projectId).then(async (res)=>{
                    if(res){
                        const noteData = res;
                        params.state.usr.noteData = noteData;
                        await onExcalidrawInitComplete(null);
                        mIsSaving = false;
                    }
                    setIsSaving(false);
                    refreshMenuMore();
                })
            }
        }
    }

    useEffect(() => {
        if (mSavePromise){
            mSavePromise.then(res=>{
                loadDataParamsChanged();
            })
        }else{
            loadDataParamsChanged();
        }

        //这里clear一下缓存，用户从文件目录手动去删除一个文件，再次进来立即刷新这个视频地址。
        // ipcInvoke('clear-cache')

        window.insertItemToThisProject = async (project:any,arraySelectItems:any)=>{
            if (!project.key || project.key == leftMenuRef.current.onGetCurrentSelectKey()){
                for (let i=0;i<arraySelectItems.length;i++){
                    postMessage(EVENT_TEST_ONDRAG_NOTE,{...arraySelectItems[i]})
                }

            }else{

                let firstCanvas:any = null;

                const menuData = [...leftMenuRef.current.getAllMenuData()]
                loopAllNode(menuData,(node)=>{
                    if (!firstCanvas && node.drawJson?.elements){
                        if (project.id != project.key){
                            //选中的是一个board
                            if (node.key == project.key){
                                firstCanvas = node;
                            }
                        }else{
                            firstCanvas = node;
                        }
                    }
                })

                if (firstCanvas == null){
                    firstCanvas = menuData[0];
                }

                if (firstCanvas.key == leftMenuRef.current.onGetCurrentSelectKey()){
                    for (let i=0;i<arraySelectItems.length;i++){
                        postMessage(EVENT_TEST_ONDRAG_NOTE,{...arraySelectItems[i]})
                    }
                    return;
                }

                //region xxxxxxx
                for (let i=0;i<arraySelectItems.length;i++) {
                    const item = arraySelectItems[i];
                    //插入到画布
                    let ptX = (document.body.clientHeight)*0.5;
                    let ptY = 210;
                    //第1个画布，如果存在就继续下一个....
                    //todo...

                    if (item.type == 'card' || item.type == 'journal') {
                        //region 添加到该项目的card
                        const itemNew =  {
                            title:item.name,
                            editValue:item.name,
                            key:item.id,
                            icon:'',
                            isFolder:false,
                            isEditable:false,
                            noteDataDoc:'',
                            hasUpdate:true,
                            createTime:Date.now(),
                            updateTime:Date.now()
                        };
                        // if(!jsonDoc.notes){
                        //     jsonDoc.notes = [];
                        // }
                        // if (!jsonDoc.notes.some(p=>p.key == item.id)){
                        //     jsonDoc.notes.push(itemNew);
                        // }

                        let w = DEFAULT_NOTE_WIDTH,h = DEFAULT_NOTE_HEIGHT;
                        ptX += w;

                        const szDefaultStyle = localStorage.getItem(KEY_CARD_ELEMENT_DEFAULT_STYLE);
                        let defaultStyle = {strokeWidth:2,strokeColor:'transparent',backgroundColor:getNoteElementBackgroundColor()};
                        if (szDefaultStyle){
                            const jsonDefaultStyle = JSON.parse(szDefaultStyle);

                            if (jsonDefaultStyle.backgroundColor){
                                defaultStyle.backgroundColor = jsonDefaultStyle.backgroundColor;
                            }
                            if (jsonDefaultStyle.strokeWidth){
                                defaultStyle.strokeWidth = jsonDefaultStyle.strokeWidth;
                            }
                            if (jsonDefaultStyle.strokeColor){
                                defaultStyle.strokeColor = jsonDefaultStyle.strokeColor;
                            }
                        }

                        let element = {
                            type: "iframe",
                            version: 1,
                            isDeleted: false,
                            id: generateUUID2(),
                            strokeWidth: item.strokeWidth || defaultStyle.strokeWidth,
                            strokeStyle: "solid",
                            roughness:0,
                            roundness: {
                                type:ROUNDNESS.ADAPTIVE_RADIUS,
                                value:8
                            },
                            opacity: 100,
                            angle: 0,
                            locked:false,
                            x: ptX,
                            y: ptY,
                            backgroundColor:item.backgroundColor || defaultStyle.backgroundColor,//getNoteElementBackgroundColor(),
                            strokeColor:item.strokeColor || defaultStyle.strokeColor,//getNoteElementStrokeColor(),
                            fillStyle:'solid',
                            width: w,
                            height: h,
                            groupIds: [],
                            customData: {
                                generationData: {
                                    status: 'done',
                                    html: '',
                                    name:'',
                                    type:item.type == 'card'?'note':'journal',
                                    libraryType:item.type == 'card'?'note':'journal',
                                    formatDate:item.formatDate,
                                    id:item.id,
                                    isEditable:true,
                                    isExpand:true,
                                    isFixedSize:true,
                                }
                            }
                        }
                        //添加到第一个board
                        firstCanvas.drawJson.elements.push(element);
                        //endregion
                    }else if (item.type == 'image') {
                        //region 以图片的方式插入....
                        let ptX = (document.body.clientHeight - 280)*0.5;
                        let ptY = 210;

                        let isSvgExt = isSvg(item.fileName);
                        let szBase64 = await ipcInvoke('read-file-base64',{filePath:(localStorage.getItem(KEY_FILE_DIR)+item.fileName)});
                        szBase64 = `data:image/${isSvgExt?'svg+xml':getFileNameExt(item.fileName)};base64,`+szBase64
                        let w = 280,h = 210;
                        const imgSize = await getBase64ImageSize(szBase64);
                        w = DEFAULT_NOTE_WIDTH;
                        h = w*imgSize?.height/imgSize?.width;
                        if (!h){
                            h = w*1.4;
                        }
                        ptX += w;
                        let element = {
                            type: "image",
                            version: 1,
                            isDeleted: false,
                            id: generateUUID2(),//这里使用新的ID，原始ID保存到customData里面,
                            fileId:getFileNameWithoutExt(item.fileName),
                            strokeWidth: 0.0000001,
                            strokeStyle: "solid",
                            roughness:0,
                            roundness: {
                                type:ROUNDNESS.ADAPTIVE_RADIUS,
                                value:12
                            },
                            opacity: 100,
                            angle: 0,
                            locked:false,
                            x: ptX-130,
                            y: ptY-h/2,
                            strokeColor: "white",
                            backgroundColor: "white",
                            fillStyle:'solid',
                            width: w,
                            height: h,
                            groupIds: [],
                            isLockRatio:true,
                            isHidden:false,
                            customData:{
                                generationData:{
                                    id:item.id,
                                    name:item.name
                                }
                            }
                        }
                        //添加到第一个board
                        firstCanvas.drawJson.elements.push(element);
                        if(!firstCanvas.drawJson.files || isArray(firstCanvas.drawJson.files)) {
                            firstCanvas.drawJson.files = {};
                        }

                        var newFile = {
                            mimeType: isSvgExt?'image/svg+xml':`image/${getFileNameExt(item.fileName)}`,
                            id: element.fileId,
                            dataURL: isSvgExt?szBase64:'',
                            created: Date.now(),
                            lastRetrieved: Date.now(),
                            fullPath:item.isAbsolutePath?item.fileName:''
                        }

                        firstCanvas.drawJson.files[newFile.id] = (newFile)
                        //endregion
                    }else if (item.type == 'pdfAnno' || item.type == 'cardAnno'){
                        //region pdfanno
                        const szHtml = createPdfAnnoTextElement(item);
                        let height = 210;
                        let elementHeight = height;
                        if (item.type == 'image' || item.annoType == 'image'){
                            let szBase64Image = item.image;
                            if (!item.image && item.thumbImage){
                                const filePath = localStorage.getItem(KEY_FILE_DIR)+item.id+'.png';
                                szBase64Image = 'data:image/png;base64,' + await ipcInvoke('read-file-base64',{filePath:filePath});
                            }
                            const size = await getBase64ImageSize(szBase64Image,);
                            height = (size.height/size.width) * (DEFAULT_NOTE_WIDTH - 24) + 28;
                            elementHeight = height;//不包含注记的高度
                            height += calcTextAreaHeight((DEFAULT_NOTE_WIDTH - (2 + 8 + 6)*2),item.comment);
                        }else{
                            //文本，计算下高度.
                            const hhhhhhiiiigggggg = calcTextHeight((DEFAULT_NOTE_WIDTH - (8 + 8 + 6) * 2), szHtml);
                            const nCommentHeight = calcTextAreaHeight((DEFAULT_NOTE_WIDTH - (2 + 8 + 6)*2),item.comment);
                            height = hhhhhhiiiigggggg  + nCommentHeight;//(2 + 8 + 6)这个是所有的padding.
                            elementHeight = height;//不包含注记的高度.
                        }
                        let fileName = item?.name.replace('.pdf','')+'.pdf';
                        if (item.type == 'cardAnno'){
                            fileName = '';
                        }

                        var element = {
                            type: "iframe",
                            version: 1,
                            isDeleted: false,
                            id: generateUUID2(),
                            strokeWidth: 1,
                            strokeStyle: "solid",
                            roughness:0,
                            roundness: {
                                type:ROUNDNESS.ADAPTIVE_RADIUS,
                                value:8
                            },
                            opacity: 100,
                            angle: 0,
                            locked:false,
                            x: ptX,
                            y: ptY,
                            backgroundColor:getNoteElementBackgroundColor(),
                            strokeColor:getNoteElementStrokeColor(),
                            fillStyle:'solid',
                            width: DEFAULT_NOTE_WIDTH,
                            height: height,
                            groupIds: [],
                            customData: {
                                generationData: {
                                    annoHeight:elementHeight,//注记本身高度
                                    status: 'done',
                                    html: szHtml,
                                    type:item.type,
                                    id:item.libraryId,
                                    pdfData:item,
                                    fileName:fileName
                                }
                            }
                        }
                        firstCanvas.drawJson.elements.push(element);
                        //endregion
                    }else if (item.type == 'videoAnno' || item.type == 'audioAnno'){
                        //region videoAnno audioAnno
                        let height = await calcVideoAnnoHeight(item,DEFAULT_NOTE_WIDTH);
                        var element = {
                            type: "iframe",
                            version: 1,
                            isDeleted: false,
                            id: generateUUID2(),
                            strokeWidth: 1,
                            strokeStyle: "solid",
                            roughness:0,
                            roundness: {
                                type:ROUNDNESS.ADAPTIVE_RADIUS,
                                value:8
                            },
                            opacity: 100,
                            angle: 0,
                            locked:false,
                            x: ptX,
                            y: ptY,
                            backgroundColor:getNoteElementBackgroundColor(),
                            strokeColor:getNoteElementStrokeColor(),
                            fillStyle:'solid',
                            width: DEFAULT_NOTE_WIDTH,
                            height: height,
                            groupIds: [],
                            customData: {
                                generationData: {
                                    // annoHeight:elementHeight,//注记本身高度
                                    status: 'done',
                                    html: '',//szHtml,
                                    type: item.type,
                                    id:item.libraryId,
                                    videoData:item,
                                    videoName:item.name
                                }
                            }
                        }
                        firstCanvas.drawJson.elements.push(element);
                        //endregion
                    }else if (item.type == 'youtube' || item.type == 'bilibili' || item.type == 'webLink' || item.type == 'baidu'){

                        var element = {
                            type: "embeddable",
                            version: 1,
                            isDeleted: false,
                            id: generateUUID2(),
                            strokeWidth: 1,
                            strokeStyle: "solid",
                            roughness:0,
                            roundness: {
                                type:ROUNDNESS.ADAPTIVE_RADIUS,
                                value:12
                            },
                            customData:{
                                generationData:{
                                    id:item.id,
                                    type:item.type
                                }
                            },
                            link:item.fileName,
                            opacity: 100,
                            angle: 0,
                            x: ptX,
                            y: ptY,
                            strokeColor: "#F0EFF5",
                            backgroundColor: "white",
                            fillStyle:'solid',
                            width: 380,
                            height: DEFAULT_EMBEDABLE_ELEMENT_HEIGHT,
                            locked:false,
                            groupIds: []
                        }
                        if (item.type == 'webLink'){
                            element.embedType = 'text';
                            element.height = DEFAULT_EMBEDABLE_BOOKMARK_HEIGHT;
                        }
                        firstCanvas.drawJson.elements.push(element);
                    }
                    else {
                        //region 以文件的方式插入....
                        let ptX = (document.body.clientHeight - 280)*0.5;
                        let ptY = 210;

                        let w = 280,h = 210;
                        if (isVideo(item.fileName)){
                            const wh = await getVideoScale(getLocalFilePath(item.fileName,item.isAbsolutePath));
                            w = 400;
                            h = w*wh.videoHeight/wh.videoWidth;
                        }else if (isPdf(item.fileName)){
                            const imgSize = await getBase64ImageSize(item.thumbImage);
                            // console.log('get pdf thumb.....end...')
                            w = 200;
                            h = w*imgSize?.height/imgSize?.width;
                            if (!h){
                                h = w*1.4;
                            }
                        }else if (isAudio(item.fileName)){
                            //音频
                            w = DEFAULT_AUDIO_WIDTH;
                            h = DEFAULT_AUDIO_HEIGHT;
                        }

                        ptX += w;
                        const id = generateUUID2();

                        let element = {
                            type: "iframe",
                            version: 1,
                            isDeleted: false,
                            id: id,//这里使用新的ID，原始ID保存到customData里面
                            strokeWidth: 0.0000001,
                            strokeStyle: "solid",
                            roughness:0,
                            roundness: {
                                type:ROUNDNESS.ADAPTIVE_RADIUS,
                                value:8
                            },
                            opacity: 100,
                            angle: 0,
                            locked:false,
                            x: ptX-130,
                            y: ptY-h/2,
                            strokeColor: "white",
                            backgroundColor: "white",
                            fillStyle:'solid',
                            width: w,
                            height: h,
                            groupIds: [],
                            isLockRatio:true,
                            isHidden:false,
                            customData: {
                                generationData: {
                                    status: 'done',
                                    id:item.id,
                                    html: createFileElementHtml(id,item.fileName,getFileNameWithoutExt(item.fileName),item.thumbImage),
                                    type:'file',
                                    fileName:item.fileName,
                                    name:item.name,
                                    showName:item.name,
                                }
                            }
                        }
                        //添加到第一个board
                        firstCanvas.drawJson.elements.push(element);
                        //endregion
                    }
                }
                //endregion

                leftMenuRef.current.updateMenuData1(menuData);
            }

        }

        return ()=>{
            excalidrawRef?.getApp()?.simpleRelease();
            // excalidrawRef?.getApp()?.releaseCanvas(false);
            mArrayTimeoutIds.current.forEach(p=>{
                clearTimeout(p);
            });
            QuillCache.clear();
            StickyNoteTiptapCache.clear();
        }

    }, [params]);

    useEffect(() => {
        global.g_isLoadingFinished = !isSaving;
    }, [isSaving]);

    useLayoutEffect(()=>{
        window.saveNotes = async ()=>{
            return await saveNotes();
        }
        window.onUpdateTag = (item)=>{
            if (mNoteData.current){
                if (mNoteData.current.id == item.id){
                    mNoteData.current.tags = item.tags;
                }
            }
        }
        window.onUpdateInfoNotes = (item)=>{
            if (mNoteData.current){
                mNoteData.current.infoNotes = item.infoNotes;
                mNoteData.current.infoUrl = item.infoUrl;
            }
        }
        //这里能保存回调同步执行，别的函数的组件引用为不null!!  useeffect 中的 return 回调是异步的，不能保证。
        return ()=>{
            console.log('useLayoutEffect---useLayoutEffect----savenotes')
            mSavePromise = saveNotes(false);
            global.g_isPresentMode = false;//关闭..
            delete window.saveNotes;
            mInitDatas = '';
            // mNoteData.current = null;
            Global.g_currentPageData = {};
            setCommonSliderContainerWidth(0);

            delete window.onUpdateTag;
            delete window.onUpdateInfoNotes;

            //记录下时间....
            ipcInvoke('update-backup-time');

            //gc........
            // ipcInvoke('gc-collection');
        }
    },[])

    /**
     * 加载分享的项目
     * @param res
     */
    const loadWebShareProject = async (res:any,szId:any)=>{
        if (!res.published) {
            // message.error(t("Share not exist"))
            message.error(t('ThisShareNoAvailable'));
            return;
        }

        const pageCache = await getPageCacheById(szId);
        let originPageJson = {};
        if (pageCache != undefined && pageCache != null) {
            originPageJson = (pageCache.pages);
        }
        const szRealId = replaceLast(szId,res.userId+'','');

        if (res.content?.includes('{type:"card"')){
            // if (!res.published){
            //     message.error(t('ThisShareNoAvailable'));
            //     return;
            // }
            //表示分享的是单独的card....
            getS3CardData(szId).then(async (res)=>{
                //保存到card表
                // const card = {
                //     id:szId,
                //     doc:res,
                //     name:document.title,
                //     isDeleted:0,
                //     thumbUrl:'',
                //     type:'card',
                //     createTime:Date.now(),
                //     updateTime:Date.now()
                // }
                const card = JSON.parse(res);
                if (card.arrayLibrarys){
                    //全部保存.
                    for (let i=0;i<card.arrayLibrarys.length;i++){
                        const item = card.arrayLibrarys[i];
                        if (item.type == 'project'){
                            await updateProject(item);
                        }else{
                            await updateCard(item);
                        }
                    }
                }

                document.title = document.body.title = card.name;
                setTitle(card.name);

                await updateCard(card);
                setIsShareCardPage(true);
                nTimeoutId = setTimeout(() => {
                    setIsLoading(false);
                }, 200);
            })
            return;
        }

        getS3DataNew(szId, originPageJson).then(async (res) => {
            // mInitDatas = JSON.stringify(res);
            cachePageDatas = res;//保存缓存...
            await addPageToCache(szId, res);
            //直接保存一份到project...

            const project = {
                id:szRealId,
                name:document.title,
                doc: cachePageDatas,
                createTime:Date.now(),
                updateTime:Date.now(),
            }
            await updateNote(project);

            //适配当前分辨率
            justfiyCurrentResolution(res);

            //这里处理一遍res.canvas,不可见的canvas删除掉;
            const arrayCanvas:any = filterPublishCheckedTreeData(res.canvas);
            res.canvas = arrayCanvas;

            const jsonObj: any = res;//JSON.parse(res);
            //将库的数据全部保存.
            batchUpdateCard(jsonObj.arrayLibrarys);

            replaceWebImgSrcPath(jsonObj);
            global.g_projId = mProjId;
            global.g_isWebDarkMode = global.g_isDarkMode = (jsonObj.info.isDarkMode || false);

            if (global.g_isWebDarkMode){
                const szThemeName = 'dark' + '-theme';
                let body = document.getElementsByTagName("body")[0];
                body.className = szThemeName;
                emitter.emit(EVENT_CHANGE_THEME,'dark');
                postMessage(EVENT_FORCE_UPDATE);
                window.globalRefreshList('updateTheme_')
            }

            if (szId.indexOf(PUBLISH_FRAME_SUF) > 0) {
                var arrayNewCanvas:any = [];
                //移除没有frame的page
                loopAllNode(jsonObj.canvas,(item)=>{
                    if (item.drawJson?.elements){
                        if (item.drawJson.elements.some(p => p.type == 'frame')) {
                            arrayNewCanvas.push(item);
                        }
                    }
                })

                jsonObj.canvas = arrayNewCanvas;
            }

            leftMenuRef.current.setOutMenuData(jsonObj);
            //是否只读
            excalidrawRef.onSetReadonlyStatus(true);
            mIsPresentMode = true;
            if (szId.indexOf(PUBLISH_FRAME_SUF) > 0) {
                setIsPresentMode(false);
                nTimeoutId = setTimeout(() => {
                    setIsFramePresent(true);
                    onPresentFrameClick()
                }, 100);
                mArrayTimeoutIds.current.push(nTimeoutId);
            } else {
                setIsPresentMode(true);

                nTimeoutId = setTimeout(() => {
                    setPageSizeNumber(1 + '/' + leftMenuRef?.current.getPagesCount())
                }, 200);
                mArrayTimeoutIds.current.push(nTimeoutId);
            }

            if (jsonObj.hasOwnProperty('info')) {
                setIsShowPageTree(jsonObj.info.showPageList);
                setIsEnableNavKey(jsonObj.info.enableNavKeys);
                if (jsonObj.info.enableNavKeys) {
                    setIsShowOverlay(true);
                }
                leftMenuRef.current.setOnHasPageList(jsonObj.info.showPageList);
            }

            nTimeoutId = setTimeout(() => {
                setIsLoading(false);
            }, 200);
            mArrayTimeoutIds.current.push(nTimeoutId);

            message.destroy();
        })
    }

    /**
     * 接收iframe的消息.....
     * @param event
     */
    const windowMessageEvent = async(event: any) => {

        if (event?.data?.type == 'drag-annotations' && isArray(event?.data?.data?.annotations)) {
            //pdf注记拖动...
            mJsonDragPdfAnnotations = {};//JSON.parse(event.data);
            mJsonDragPdfAnnotations.data = event.data.data.annotations;//JSON.parse(mJsonDragPdfAnnotations.data);
            mJsonDragPdfAnnotations.data[0].pdfId = event.data.data.fileId;
            //下面这个属性不能用。---使用点太奇葩了，库里打开，浮窗，然后打开画布，把浮窗的注记拖动过来.!
            mJsonDragPdfAnnotations.data[0].name = pdfFileName;
            mJsonDragPdfAnnotations.data[0].fileName = getFileName(mOpenedPdfFileName);
            //test insert
        }
        else {
            if (mIsDialogDrawIndex && event?.data) {
                if (event.data.action == 'setDrawJson') {
                    //设置数据并显示...
                    setIsShowSmallLoading(true);
                    onLoadData(true, event.data.linkInfo).then(res => {
                        setIsShowSmallLoading(false);
                    })
                } else if (event.data.action == 'isFullScreen') {
                    setIsDialogDrawIndexFullScreen(event.data.isFullScreen)
                } else if (event.data.action == 'clearData') {
                    //清空数据...
                    newProject();
                }
            }
        }

        if (event?.data){
            if (event.data.action == 'selectBoard' && sliderProjectData){
                //20250610-更改了右侧栏显示leftmenu 这里不需要设置了。。。
                // const newData = {...sliderProjectData};
                // let doc = newData.doc;
                // if (doc && isString(doc)){
                //     doc = JSON.parse(doc);
                // }
                // newData.doc = doc;
                // for (let i=0;i<doc.canvas.length;i++){
                //     doc.canvas[i].isSelected = false;
                //     if (doc.canvas[i].key == event.data.data){
                //         doc.canvas[i].isSelected = true;
                //     }
                // }
                // setSliderProjectData(newData);
            }else if (event.data.action == 'switchBoardSelect'){
                //slider 给 draw发消息，切换board...
                const selectBoard = event.data.data;
                leftMenuRef.current?.onNavSelectedItem(selectBoard.key);
            }else if (event.data.action == EVENT_PDF_ON_SLIDER_RIGHT){
                //slider->draw 打开PDF
                //这里要重新处理pdfPath
                const library:any = await getCardById(event.data.data.data.fileId);
                if (library){
                    let szFilePath = '';
                    if (library.isAbsolutePath){
                        szFilePath = library.fileName;
                    }else{
                        szFilePath = localStorage.getItem(KEY_FILE_DIR)+library.fileName;
                    }
                    ipcInvoke('read-file-absolute-path', {filePath: szFilePath}).then(res => {
                        const blob = new Blob([res]);
                        const url = URL.createObjectURL(blob);
                        event.data.data.data.pdfPath = url;
                        postMessage(EVENT_PDF_ON_SLIDER_RIGHT,event.data.data.data)
                    });
                }else{
                    message.error('open failed.');
                }
            }else if (event.data.action == EVENT_NOTE_ON_SLIDER_RIGHT){
                postMessage(EVENT_NOTE_ON_SLIDER_RIGHT,event.data.data.data)
            }else if (event.data.action == EVENT_VIDEO_ON_SLIDER_RIGHT){
                postMessage(EVENT_VIDEO_ON_SLIDER_RIGHT,event.data.data.data)
            }else if (event.data.action == "UPDATE_CARD_FROM_DRAW"){
                //draw-->to sidebar更新card...
                excalidrawRef.onUpdateCardElement(event.data.data);
            }else if (event.data.action == 'SYNC_DRAW_BOARD'){
                //sidebar --> draw  同步board...
                if (mNoteData.current?.id == event.data.data.id){
                    //同一个项目..
                    const currentBoard = leftMenuRef.current?.onGetSelectNode();
                    const sidebarBoard = JSON.parse(event.data.data.board);
                    sidebarBoard.icon = <IconBoard/>
                    if (currentBoard.key != sidebarBoard.key){
                        //不是同一个board...更新board.
                        leftMenuRef.current?.onUpdateBoard(sidebarBoard);
                    }
                }
            }else if (event.data.action == 'MOUSE_UP'){
                //关闭board弹窗，如果有的话...
                setIsShowPopupBoard(false);
            }else if (event.data.action == EVENT_PROJECT_ON_SlIDER_RIGHT){
                //link-project右侧栏中的project继续在右侧栏打开的跳转
                postMessage(EVENT_PROJECT_ON_SlIDER_RIGHT,event.data.data.data);
            }else if (event.data.action == 'saveNotes'){
                saveNotes();
            }else if (event.data.action == 'toggleLeftMenu'){
                //打开或关闭左侧栏
                setHomePaddingLeft(0);
                setIsCollapsePage(!isCollapsePage);
                leftMenuRef?.current.setOnCollapseStatus(!isCollapsePage);
            }else if (event.data.action == 'setCtrlPressed'){
                global.g_isCtrlPressed = event.data.isPressed;
            }else if (event.data.action == 'refresh-canvas-card'){
                //刷新画布上的card...
                const data = event.data.data;
                data.customData = {generationData:{...data,html:data.doc}}
                postMessage(EVENT_UPDATE_FORCE_CARD_IIIINNNNNFFFFOOOOOO,data)
            }else if (event.data.action == 'sendMessage-refreshContent' || event.data.action == 'draw2Slider-sendMessage-refreshContent'){
                //slider draw -->draw...
                //刷新画布上的
                window.globalRefreshList('embedProject_');
                if(window.onRefreshContentElement){
                    window.onRefreshContentElement();
                }
            }else if (event.data.action == 'refresh-project-name'){
                //slider draw --->draw.
                if (sliderProjectData){
                    const newSliderProjectData = {...sliderProjectData};
                    newSliderProjectData.name = event.data.data.name;
                    setSliderProjectData(newSliderProjectData);
                }
                if (event.data.data.id == PROJECT_ID){
                    if (mNoteData.current){
                        inputTitleRef.current.value = event.data.data.name;
                        mTitle.current = event.data.data.name;
                        refreshTitleBoardPath();
                    }
                }
            }
        }
    }

    /**
     * sliderDraw 给draw 发送消息
     * @param szAction
     * @param data
     */
    const sendMessageFromSliderDraw = (szAction,data)=>{
        window.parent.postMessage({action:szAction,data:data})
    }

    /**
     * draw 给 sliderDraw发消息
     * @param szAction
     * @param data
     */
    const sendMessageFromDraw = (szAction,data)=>{
        const iframe = document.getElementById('iframe-slider-drawindex-container');
        if (iframe){
            iframe.contentWindow.postMessage({action:szAction,data:data})
        }
    }


    //test 测试....
    const loadNoteInfoByUrlParams = async () => {
        if (!urlParams.hasOwnProperty("id")) return;

        let note = await getNoteById(urlParams.id);
        const jsonData = JSON.parse(note.doc);
        leftMenuRef.current.setOutMenuData(jsonData);
        //是否只读
        excalidrawRef.onSetReadonlyStatus(true);
        setIsPresentMode(true);
    }
    /**
     * 转到子页面-或子笔记
     */
    const onNavSub = (szBoardId: string, szElementId: string,szNodeId:any = null) => {
        if (!szBoardId) {
            setTimeout(()=>{
                refreshInfo();
            },100)
            return
        };

        leftMenuRef?.current.onNavSelectedItem(szBoardId, szElementId).then(res => {
            if (szElementId) {
                let nLeftOffset = homePaddingLeft;
                if (!isCollapsePage) {
                    nLeftOffset += LEFT_MENU_WIDTH;
                }
                excalidrawRef.onScrollToElement(szElementId,szNodeId,nLeftOffset);
                setTimeout(()=>{
                    refreshInfo();
                },100)
            }
        });
        // setTimeout(()=>{
        //
        // },100);

        // if ("p" === szSubPath){
        //     setTimeout(()=>{
        //         leftMenuRef?.current.onNavSelectedItem(szSubId);
        //     },100);
        //
        // }else if ("n" === szSubPath){
        //     //open note
        //     leftMenuRef?.current.onEditNoteDataByNoteId(szSubId);
        // }
    }

    /**
     * 替换web iframe的路径
     * @param jsonObj
     */
    const replaceWebImgSrcPath = (jsonObj: any) => {
        let canvas = jsonObj.canvas;
        loopAllNode(canvas,(board)=>{
            if (board.drawJson?.elements){
                for (let j = 0; j < board.drawJson.elements.length; j++) {
                    const element = board.drawJson.elements[j];
                    if (isFileElement(element)) {
                        if (isFileVideoElement(element)) {
                            element.customData.generationData.html = createVideoFileElementHtmlFromWeb(getShareDataUrl() + mProjId + "/notesfile/" + element.customData.generationData.fileName);
                        }else if (isPdfFileElement(element)){
                            element.customData.generationData.html = createPdfFileElementHtmlFromWeb(getShareDataUrl() + mProjId + "/notesfile/" + element.customData.generationData.id+".png");
                        }
                        else {
                            element.customData.generationData.html = element.customData.generationData.html.replaceAll("src='./imgs", "src='/imgs");
                        }
                    }
                }
            }
        })
        // for (let i = 0; i < canvas.length; i++) {
        //     for (let j = 0; j < canvas[i].drawJson.elements.length; j++) {
        //         const element = canvas[i].drawJson.elements[j];
        //         if (isFileElement(element)) {
        //             if (isFileVideoElement(element)) {
        //                 element.customData.generationData.html = createVideoFileElementHtmlFromWeb(AWS_S3_PRE_DATA_URL + mProjId + "/notesfile/" + element.customData.generationData.fileName);
        //             }else if (isPdfFileElement(element)){
        //                 element.customData.generationData.html = createPdfFileElementHtmlFromWeb(AWS_S3_PRE_DATA_URL + mProjId + "/notesfile/" + element.customData.generationData.id+".png");
        //             }
        //             else {
        //                 element.customData.generationData.html = element.customData.generationData.html.replaceAll("src='./imgs", "src='/imgs");
        //             }
        //         }
        //     }
        // }
    }

    /**
     * 导入
     * @param item
     */
    const onMoreMenuEvent = (item: any) => {
        if ('import-pcanvas' == item) {
            ipcInvoke("openFile", {filters: [{name: 'Canvas', extensions: ['pcanvas']}]}).then(data => {
                onReadCanvasNew(data);
            })
            // ipcRenderer.send('openFile',[{name: 'Canvas', extensions: ['pcanvas']}]);
            // ipcRenderer.once("openFileResult",(event:any,args:any)=>{
            //     onReadCanvasX(args);
            // })
        } else if ('import-pcanvasx' == item) {
            ipcInvoke("openFile", {filters: [{name: 'Canvas', extensions: ['pcanvasx']}]}).then(data => {
                onReadCanvasNew(data);
            })
            // ipcRenderer.send('openFile',[{name: 'Canvas', extensions: ['pcanvasx']}]);
            // ipcRenderer.once("openFileResult",(event:any,args:any)=>{
            //     onReadCanvasX(args);
            // })
        }
    }

    const onExportPngPopover = async (exportType: any) => {
        if (isPresentMode) {
            setIsPopoverExportPngPresentModeVisible(true)
        } else {
            setIsPopoverExportPngVisible(true);
        }

        if (mNoteData.current != null) {
            mPublishId = mNoteData.current.id;
        } else if (isStringNullOrEmpty(mPublishId)) {
            mPublishId = await generateShortUUID();
        }
        nTimeoutId = setTimeout(() => {
            if (isPresentMode) {
                popoverExportPresentModeRef.current.onDialogShow(mPublishId, leftMenuRef.current?.getAllMenuData(), leftMenuRef?.current.getSelectMenuKeys(), exportType);
            } else {
                popoverExportRef.current.onDialogShow(mPublishId, leftMenuRef.current?.getAllMenuData(), leftMenuRef?.current.getSelectMenuKeys(), exportType);
            }
        }, 150);
        mArrayTimeoutIds.current.push(nTimeoutId);
    }

    /**
     * 导出frame的弹窗
     * @param exportType
     */
    const onExportFramePngPopover = (exportType: any) => {
        mExportType = exportType;
        setIsPopoverExportPngFramePresentModeVisible(true);
    }

    /**
     * new project
     */
    const newProject = () => {
        mNoteData.current = null;
        mPublishId = '';
        excalidrawRef.newProject();
        leftMenuRef.current?.newProject();
    }

    /**
     * 分享的导出菜单
     * @param item
     */
    const onShareMenuEvent = async (item: any, arraySelectMenuData: any = [], extra: any) => {
        mExportType = item;
        const importData = params.state?.usr?.importNoteData;
        const info = importData?.info;
        if ('exportCanvas' == item) {
            if (isDevMode()) {
                //填写基本信息
                setIsShowDialogExportInfo(true);
                dialogExportInfoRef?.current.onSetExportInfo(info, mTitle.current, t("Output pcanvas"));
            } else {
                onExportEventWithInfo({title: mTitle.current, isFrame: extra?.isFrame});
            }

            // const szData = getCanvasNoteDatas();
            // ipcSend("saveFile", {filters: [{name: 'Canvas', extensions: ['pcanvas']}], stream: szData});

            // ipcRenderer.send('saveFile', [{ name: 'Canvas', extensions: ['pcanvas'] }]);
            // ipcRenderer.once("saveFileResult", (event: any, args: any) => {
            //     onSaveCanvasX(args);
            // })
        } else if ('exportCanvasx' == item) {
            if (isDevMode()) {
                //填写基本信息
                setIsShowDialogExportInfo(true);
                dialogExportInfoRef?.current.onSetExportInfo(info, mTitle.current, t("Output pcanvasx"));
            } else {
                onExportEventWithInfo({title: mTitle.current});
            }

            // const szData = getCanvasNoteDatas();
            // ipcSend("saveFile", {filters: [{name: 'Canvas', extensions: ['pcanvasx']}], stream: szData});

            // ipcRenderer.send('saveFile', [{ name: 'Canvas', extensions: ['pcanvasx'] }]);
            // ipcRenderer.once("saveFileResult", (event: any, args: any) => {
            //     onSaveCanvasX(args);
            // })
        } else if ('exportPng' == item || 'exportPdf' == item) {
            /*
            const imgBlob = await excalidrawRef.getPngData();
            //xian qi piao piao的使用...
            let reader = new FileReader();
            reader.readAsArrayBuffer(imgBlob);
            reader.onload = () => {
                // let buf = new Buffer(reader.result);
                ipcSend("saveFile", {
                    filters: [{name: 'Canvas', extensions: ['png']}],
                    stream: reader.result,
                    streamType: 'image'
                });
            }
             */
            setIsShowSmallLoading(true);

            if (arraySelectMenuData.length == 0) return;
            let arrayPngDatas = [];

            if (arraySelectMenuData.length == 1 && global.g_currentBoardId == arraySelectMenuData[0].key){
                //只有一个，并且是选中的这个。。
                const imgBlob = await excalidrawRef.getPngData();
                const data = await readerBuffer(imgBlob);
                arrayPngDatas.push({
                    title: arraySelectMenuData[0].title,
                    stream: data
                });
            }else{
                const currentDrawJson = excalidrawRef.getDrawJson("0");
                const appStates = excalidrawRef.getExcalidrawState();
                //如果选择的有当前画布，保存下当前画布内容
                const arraySelectKeys = leftMenuRef.current.getSelectMenuKeys();
                let selectKey = "";
                if (arraySelectKeys.length > 0) {
                    selectKey = arraySelectKeys[0];
                }

                for (let i = 0; i < arraySelectMenuData.length; i++) {
                    var item = arraySelectMenuData[i];
                    if (selectKey === item.key) {
                        item.drawJson = currentDrawJson;
                    }
                    try {
                        await excalidrawRef.setDrawJson(0, item.drawJson, null);
                        const imgBlob = await excalidrawRef.getPngData();
                        const data = await readerBuffer(imgBlob);
                        arrayPngDatas.push({
                            title: item.title,
                            stream: data
                        });
                    } catch (e) {
                        console.log(e);
                    }
                }
                //还原
                excalidrawRef.setDrawJson("0", currentDrawJson, appStates);
            }

            setIsShowSmallLoading(false);

            const isPdf = ('exportPdf' == mExportType);
            if (arrayPngDatas.length == 1) {

                if (APP_WEB || APP_WEB_WWW) {
                    const blob = new Blob([new Uint8Array(arrayPngDatas[0].stream, 0, arrayPngDatas[0].stream.length)]);
                    if ('exportPng' == mExportType) {
                        saveAs(blob, arrayPngDatas[0].title + '.png');
                    } else {
                        let pdf = new jsPDF('p', 'pt', 'a4');
                        const szDataURL = await blobToBase64(blob);

                        const imgProps = pdf.getImageProperties(szDataURL);
                        const nPdfWidth = pdf.internal.pageSize.getWidth() - 20;
                        const nPageHeight = pdf.internal.pageSize.getHeight();
                        const nPdfHeight = (imgProps.height * nPdfWidth) / imgProps.width;

                        pdf.addImage(szDataURL, 'png', 10, (nPageHeight - nPdfHeight) / 2, nPdfWidth, nPdfHeight);
                        pdf.save(arrayPngDatas[0].title + '.pdf');
                    }
                } else {
                    ipcSend("saveFile", {
                        filters: [{name: 'Canvas', extensions: [('exportPng' == mExportType) ? 'png' : 'pdf']}],
                        stream: isPdf ? arrayPngDatas : arrayPngDatas[0].stream,
                        fileName: arrayPngDatas[0].title,
                        streamType: ('exportPng' == mExportType) ? 'image' : "pdf"
                    })
                }
            } else {
                if (APP_WEB || APP_WEB_WWW) {
                    if ('exportPng' == mExportType) {
                        let zip = new JSZip();
                        for (let i = 0; i < arrayPngDatas.length; i++) {
                            const item = arrayPngDatas[i];
                            const base64 = btoa(String.fromCharCode.apply(null, new Uint8Array(item.stream)));
                            zip.file(item.title + '.png', base64, {base64: true});
                        }
                        zip.generateAsync({type: "blob"}).then(function (content) {
                            saveAs(content, title + '.zip');
                        });
                    } else {
                        let pdf = new jsPDF('p', 'pt', 'a4');
                        for (let i = 0; i < arrayPngDatas.length; i++) {
                            const blob = new Blob([new Uint8Array(arrayPngDatas[i].stream, 0, arrayPngDatas[i].stream.length)]);
                            const szDataURL = await blobToBase64(blob);
                            const imgProps = pdf.getImageProperties(szDataURL);
                            const nPdfWidth = pdf.internal.pageSize.getWidth() - 40;
                            const nPageHeight = pdf.internal.pageSize.getHeight();
                            const nPdfHeight = (imgProps.height * nPdfWidth) / imgProps.width;
                            pdf.addImage(szDataURL, 'png', 20, (nPageHeight - nPdfHeight) / 2, nPdfWidth, nPdfHeight);
                            if (i != arrayPngDatas.length - 1) {
                                pdf.addPage();
                            }
                        }
                        pdf.save(arrayPngDatas[0].title + '.pdf');
                    }
                } else {
                    ipcSend("saveFile", {
                        filters: [{name: isPdf ? 'pdf' : 'Zip', extensions: [isPdf ? 'pdf' : 'zip']}],
                        stream: arrayPngDatas,
                        fileName: inputTitleRef.current.value,
                        streamType: isPdf ? 'pdf' : 'zip'
                    })
                }
            }

        } else if ('exportWeb' == item) {
            //更新当前画布的数据....
            if (currentSelectNode != null) {
                currentSelectNode.drawJson = getExcalidrawJson();
                //更新那个对象...
                leftMenuRef.current.updateMenuData(currentSelectNode.key, currentSelectNode.drawJson);
            }
            message.open({
                type: 'loading',
                content: t("Publishing"),
                duration: 0
            })
            const jsonResult = await getCanvasNoteDatas(false,true);
            jsonResult.info.showPageList = extra?.showPageList;
            jsonResult.info.enableNavKeys = extra?.enableNavKeys;
            jsonResult.info.isDarkMode = isDarkMode();

            const arrayTiptapImages:any = [];
            //记录每个画板的排序.
            const arrayLinkCards:any = [];
            await loopAllNodeAsync(jsonResult.canvas,async (board)=>{
                if (board.drawJson?.elements){
                    const arrayFrames = await sortFramePresent(board.key,board.drawJson.elements.filter(p=>isFrameElement(p)));
                    board.sortFrames = arrayFrames;
                    for (let i=0;i<board.drawJson.elements.length;i++){
                        const element = board.drawJson.elements[i];
                        if (element.link){
                            if (isDeepLink(element.link)){
                                const deeplink = decodeDeeplink(element.link);
                                if (deeplink.type == 'library'){
                                    const card = await getCardById(deeplink.id);
                                    if (card?.type == 'card'){
                                        arrayLinkCards.push(card);
                                    }
                                }
                            }
                        }
                        if (isTextElement(element) || isStickyNotesElement(element)){
                            const tiptapDoc = await getTiptapDoc(element.id);
                            const arrayImgs = imgServer.getImageListFromHtml(tiptapDoc?.doc);
                            arrayTiptapImages.push(...arrayImgs);
                        }
                    }
                }
            })

            //将所有的链接加入到这个...
            jsonResult.notes.push(...arrayLinkCards);

            //待导出的笔记的图片
            const notesImage = await getNotesImageForExport(jsonResult.notes);
            notesImage.push(...arrayTiptapImages);
            const arrayFiles = await getFileBase64ForExport(jsonResult.canvas);

            // clearMenuDataIcon(jsonResult.canvas);
            // clearMenuDataIcon(jsonResult.notes);
            const szJson = JSON.stringify(jsonResult, replaceIcon);
            //重新还原
            // setMenuPageDataIcon(jsonResult.canvas);
            // setMenuNoteDataIcon(jsonResult.notes);

            if (mNoteData.current != null) {
                mPublishId = mNoteData.current.id;
            } else if (isStringNullOrEmpty(mPublishId)) {
                mPublishId = await generateShortUUID();
            }
            //frame规则 id+前缀+用户id
            shareProjectData(mPublishId + (isFramePresent ? PUBLISH_FRAME_SUF : "") + Global.g_userInfo.id, szJson, notesImage, arrayFiles);
        }
    }

    /**
     * frame的分享....
     * 分享数据
     * 分享画板
     * 分享项目
     * @param szExportType
     * @param szPageType
     */
    const onShareMenuFrameEvent = async (szExportType: string, szPageType: string) => {
        const currentDrawJson = excalidrawRef.getDrawJson("0");
        const appStates = excalidrawRef.getExcalidrawState();
        //如果选择的有当前画布，保存下当前画布内容
        const arraySelectKeys = leftMenuRef.current.getSelectMenuKeys();
        let selectKey = "";
        if (arraySelectKeys.length > 0) {
            selectKey = arraySelectKeys[0];
        }
        let arrayPngDatas = [];

        if (szPageType == 'current') {
            for (let i = 0; i < currentDrawJson.elements.length; i++) {
                const frame = currentDrawJson.elements[i];
                if (frame.type == 'frame') {
                    const imgBlob = await excalidrawRef.getFramePngData(frame.id);
                    const data = await readerBuffer(imgBlob);
                    arrayPngDatas.push({
                        title: frame.name,
                        stream: data
                    });
                }
            }
        } else {
            const arrayPages = leftMenuRef.current.getAllPages();
            for (let i = 0; i < arrayPages.length; i++) {
                var item = arrayPages[i];
                if (selectKey === item.key) {
                    item.drawJson = currentDrawJson;
                }
                await excalidrawRef.setDrawJson(0, item.drawJson, null);
                for (let i = 0; i < item.drawJson.elements.length; i++) {
                    const frame = item.drawJson.elements[i];
                    if (frame.type == 'frame') {
                        const imgBlob = await excalidrawRef.getFramePngData(frame.id);
                        const data = await readerBuffer(imgBlob);
                        arrayPngDatas.push({
                            title: item.title + '-' + frame.name,
                            stream: data
                        });
                    }
                }
            }

            //还原
            excalidrawRef.setDrawJson("0", currentDrawJson, appStates);
        }
        const isPdf = ('exportPdf' == mExportType);
        if (arrayPngDatas.length == 1) {
            ipcSend("saveFile", {
                filters: [{name: 'Canvas', extensions: [('exportPng' == mExportType) ? 'png' : 'pdf']}],
                stream: isPdf ? arrayPngDatas : arrayPngDatas[0].stream,
                fileName: arrayPngDatas[0].title,
                streamType: ('exportPng' == mExportType) ? 'image' : "pdf"
            })
        } else {
            ipcSend("saveFile", {
                filters: [{name: isPdf ? 'pdf' : 'Zip', extensions: [isPdf ? 'pdf' : 'zip']}],
                stream: arrayPngDatas,
                fileName: mTitle.current,
                streamType: isPdf ? 'pdf' : 'zip'
            })
        }
    }

    const readerBuffer = (imgBlob) => {
        return new Promise((resolve, reject) => {
            let reader = new FileReader();
            reader.readAsArrayBuffer(imgBlob);
            reader.onload = () => {
                resolve(reader.result);
            }
        })
    }

    /**
     * 分享网页
     * 分享到网页
     * 网页分享
     * @param szProjId
     * @param szJson
     * @param arrayNotesImage
     * @param arrayFiles
     */
    const shareProjectData = async (szProjId: string, szJson: any, arrayNotesImage: any, arrayFiles: any) => {
        if (Global.g_userInfo?.id == undefined) {
            message.error(t("Please login first"));
            return;
        }

        //非publish的证书...
        //也就是只有desktop license的证书..
        let publishNoteInfo: any = null;

        try {//e x 因为有2级域名的关系，后台又是全部改的。这里要先查询一下。
            publishNoteInfo = await noteInfoById(szProjId, () => {

            }, false);
        } catch (e) {

        }
        if (!hasPublishLicense() && !hasDesktopLicense() && !hasPremiumLicense()) {
            //判断这个有没有发布过...
            if (!publishNoteInfo || !publishNoteInfo?.published) {
                //不能超过20个项目. -- 2024-12-05取消发布数量的限制
                // if (Global.g_userInfo.noteCount > 20 && !DEBUG) {
                //     dialogPublishToWebRef.current?.onCloseIndicator();
                //     message.error(t("PublishMaxCount").replace('{0}', '20'));
                //     return;
                // }
            }

            //计算大小..
            const projectInfo = await staticProject(mNoteData.current);
            if (projectInfo.size > 20 * 1024 * 1024) {
                dialogPublishToWebRef.current?.onCloseIndicator();
                //20mb
                message.error(t("PublishMaxSize").replace('{0}', SHARE_LIMIT_SIZE + 'Mb'));
                return;
            }
            //上传的文件只能是PDF和视频...
            if (projectInfo.audios > 0 || projectInfo.files > 0) {
                dialogPublishToWebRef.current?.onCloseIndicator();
                message.error(t("OnlySupportPdfVideo"));
                return;
            }
        }


        //这里处理需要上传的数据....待更新的？？？
        const szProjectSize = await uploadS3New(szProjId, szJson, mInitDatas, arrayNotesImage, arrayFiles);
        let level2Domain = '';
        if (publishNoteInfo){
            level2Domain = publishNoteInfo['二级域名链接'] || ''
        }
        const data = {
            id: szProjId,
            userId: Global.g_userInfo.id,
            title: inputTitleRef.current.value,
            publishedTitle: inputTitleRef.current.value,
            published: true,
            publishedContent: getShareDataUrl() + szProjId,
            content: getShareDataUrl() + szProjId,
        };
        //分享
        /*
        shareCanvas(data).then(res => {
            message.destroy();
            if (res.code == 0) {
                const szUrl = 'http://106.75.20.145:8809/#draw/' + szProjId;
                if (dialogShareRef != null) {
                    dialogShareRef.current.onShareWebFinished(szUrl);
                }
                // clipboard.write(szUrl);
                // message.info("分享地址已复制到剪切板")
            }
        });*/

        const publishNote = await getPublishNoteById(szProjId);
        const isUpdate = (publishNote != null);
        const isDialogVisible = dialogPublishToWebRef.current?.onIsDialogVisible();
        if (isUpdate && isDialogVisible) {
            message.info(t("Published"));
            // message.info(t("上行流量: "+size));
        }

        //如果是2次改变的。。这个就不重要了。。。
        notePublish(data, () => {
            if (!isUpdate) {
                message.destroy();
                message.error(t("Operator fail"));
            }
        }).then(res => {
            console.log(res);
            let szUrl = res['原始链接'].replace("https://noteey", "https://app.noteey");
            if (isAliOss()){
                szUrl = szUrl.replace('/p/','/cn/p/')
            }
            if (dialogPublishToWebRef != null) {
                dialogPublishToWebRef.current?.onShareWebFinished(szUrl);
            }
            // clipboard.write(szUrl);
            if (!isUpdate && isDialogVisible) {
                message.destroy();
                message.info(t("Published"));
                // message.info(t("上行流量: "+size));
            }

            //更新当前所有标示为已更新..
            leftMenuRef.current?.updateAllPageHasUpdateSign();

            //发布数量上本地+1
            if (!Global.g_userInfo.noteCount) {
                Global.g_userInfo.noteCount = 0;
            }
            Global.g_userInfo.noteCount = (Global.g_userInfo.noteCount + 1);

        })
    }

    /**
     * 保存数据
     * @param szFilePath
     */
    const onSaveCanvasX = async (szFilePath: string) => {
        //更新当前画布的数据....
        if (currentSelectNode != null) {
            currentSelectNode.drawJson = getExcalidrawJson();
            //更新那个对象...
            leftMenuRef.current.updateMenuData(currentSelectNode.key, currentSelectNode.drawJson);
        }

        const jsonResult = leftMenuRef.current?.getAllMenuData();
        if (jsonResult){
            clearMenuDataIcon(jsonResult);
            const szJson = JSON.stringify(jsonResult);
            // let buf = new Buffer(szJson);
            fs.writeFile(szFilePath, szJson, () => {

            })
        }
    }

    /**
     * 保存png
     * @param szFilePath
     */
    const onSaveCanvasPng = async (szFilePath: string) => {
        // excalidrawRef.snapCapture(szFilePath);
        const imgBlob = await excalidrawRef.getPngData();
        //xian qi piao piao的使用...
        let reader = new FileReader();
        reader.readAsArrayBuffer(imgBlob);
        reader.onload = () => {
            // @ts-ignore
            let buf = new Buffer(reader.result);
            fs.writeFile(szFilePath, buf, (err: any) => {

            })
        }
    }

    /**
     * 读取数据
     * @param szFilePath
     */
    const onReadCanvasX = async (szFilePath: string) => {
        fs.readFile(szFilePath, "utf-8", (err: object, data: object) => {
            if (err) throw err;
            const jsonObj = JSON.parse(data.toString());
            leftMenuRef.current.setOutMenuData(jsonObj);
            //是否只读
            excalidrawRef.onSetReadonlyStatus(szFilePath.endsWith('pcanvas'));
        });
    }

    /**
     * 显示数据
     * @param szJsonData
     */
    const onReadCanvasNew = (szJsonData) => {
        const jsonObj = JSON.parse(szJsonData);
        leftMenuRef.current.setOutMenuData(jsonObj);
        //是否只读
        excalidrawRef.onSetReadonlyStatus(szFilePath.endsWith('pcanvas'));
    }

    /**
     * 清空tree菜单的图标
     * @param jsonResult
     */
    function clearMenuDataIcon(jsonResult: any) {
        for (var i = 0; i < jsonResult.length; i++) {
            var item = jsonResult[i];
            item.icon = "";
            if (item.isFolder) {
                clearMenuDataIcon(item.children);
            }
        }
    }

    /**
     * 设置tree菜单的图标
     * @param jsonResult
     */
    function setMenuPageDataIcon(jsonResult: any) {
        for (var i = 0; i < jsonResult.length; i++) {
            var item = jsonResult[i];
            if (item.isFolder) {
                item.icon = <IconTreeFolder/>;
                setMenuPageDataIcon(item.children);
            } else {
                item.icon = <IconBoard/>;
            }
        }
    }

    /**
     * 设置note菜单的图标
     * @param jsonResult
     */
    function setMenuNoteDataIcon(jsonResult: any) {
        for (var i = 0; i < jsonResult.length; i++) {
            var item = jsonResult[i];
            if (item.isFolder) {
                item.icon = <IconTreeFolder/>;
                setMenuNoteDataIcon(item.children);
            } else {
                item.icon = <IconNote/>;
            }
        }
    }

    function setFirstItem(selectNode: any) {
        currentSelectNode = selectNode;
    }

    /**
     * 切到第一个，并且缓存缩略图....
     */
    async function updateFirstThumb() {
        // setIsSaving(true);
        excalidrawRef?.hidePopupMenu();
        const allPages = leftMenuRef.current?.getAllPages();
        if (allPages.length > 1) {
            await leftMenuRef.current.onNavSelectedItem(allPages[0].key);
        }

        return new Promise((resolve, reject) => {
            nTimeoutId = setTimeout(async () => {
                // if (mExportInfos?.isFrame){
                //     mFirstBase64Capture = await excalidrawRef?.getFirstFrameBase64Data();
                // }else{
                //     mFirstBase64Capture = await excalidrawRef?.getPngBase64Data();
                // }
                // resolve(0);
                //直接使用屏幕截图....
                mFirstBase64Capture = await ipcInvoke('get-capture', {});
                resolve(0);
            }, 100);
            mArrayTimeoutIds.current.push(nTimeoutId);
        })
    }

    /**
     * 菜单点击
     * @param mSelectNode
     */
    async function leftMenuItemClicked(selectNode: any, menuNewData: any) {
        let nTime = Date.now();
        if (selectNode?.key == currentSelectNode?.key)return;
        mIsLoading = true;

        if (APP_WEB){
            //分享来的.
            if (selectNode.sortFrames){
                excalidrawRef.onUpdateAppStates({
                    sortArrayFrames:selectNode.sortFrames
                })
            }
        }

        let nZoom = selectNode.drawJson.appState?.zoom?.value;
        if (!nZoom){
            nZoom = getExcalidrawAPI()?.getApp()?.state?.value || 1.0;
        }
        setInputZoom(Math.floor(nZoom*100) + '%');
        //保存上一个画布的数据.
        if (!isSaving && currentSelectNode != null && (!isPresentMode || isStringNullOrEmpty(mFirstBase64Capture))) {
            const drawNewJson = getExcalidrawJson();
            if (JSON.stringify(drawNewJson) != JSON.stringify(currentSelectNode.drawJson)) {
                currentSelectNode.updateTime = Date.now();
                currentSelectNode.hasUpdate = true;
            }
            if (!isPresentMode) {
                currentSelectNode.drawJson = drawNewJson;
            }
            mapMenuKey_ExcalidrawState[currentSelectNode.key] = getExcalidrawState();
            //更新那个对象...
            leftMenuRef.current.updateMenuData(currentSelectNode.key, currentSelectNode.drawJson, menuNewData);

            //缓存第一个的base64截图
            /*
            if (menuNewData != null){
                for (var i=0;i<menuNewData.length;i++){
                    var item = menuNewData[i];
                    if (!item.isFolder){
                        if (currentSelectNode.key === item.key){
                            if (mExportInfos?.isFrame){
                                // mFirstBase64Capture = await excalidrawRef?.getFirstFrameBase64Data();
                                excalidrawRef?.getFirstFrameBase64Data().then(res=>{
                                    mFirstBase64Capture = res;
                                })
                            }else{
                                // mFirstBase64Capture = await excalidrawRef?.getPngBase64Data();
                                excalidrawRef?.getPngBase64Data().then(res=>{
                                    mFirstBase64Capture = res;
                                })
                            }
                        }
                    }else{
                        for (var j=0;j<item.children.length;j++){
                            if (currentSelectNode.key === item.children[j].key){
                                if (mExportInfos?.isFrame){
                                    // mFirstBase64Capture = await excalidrawRef?.getFirstFrameBase64Data();
                                    excalidrawRef?.getFirstFrameBase64Data().then(res=>{
                                        mFirstBase64Capture = res;
                                    })
                                }else{
                                    // mFirstBase64Capture = await excalidrawRef?.getPngBase64Data();
                                    excalidrawRef?.getPngBase64Data().then(res=>{
                                        mFirstBase64Capture = res;
                                    })
                                }
                            }
                            break;
                        }
                    }
                    break;
                }
            }
            */
        }

        //这里释放一下draw....
        excalidrawRef.getApp()?.releaseCanvas(false);

        // console.log('drawIndex-leftMenuItemClicked:',(Date.now() - nTime));

        currentSelectNode = (selectNode);
        await excalidrawRef.setDrawJson(selectNode.key, selectNode.drawJson, mapMenuKey_ExcalidrawState[selectNode.key]);
        excalidrawRef.onAutoFocus();

        // console.log('drawIndex-leftMenuItemClicked-down:',(Date.now() - nTime));

        if (APP_WEB/*|| import.meta.env.DEV*/) {
            //region app_web--
            var files = excalidrawRef.getApp()?.files;

            for (let i = 0; i < selectNode.drawJson.elements.length; i++) {
                const item = selectNode.drawJson.elements[i];
                if (item.type == 'image') {
                    if (!files[item.fileId]) {
                        //to download....
                        const szFolderKey = leftMenuRef.current.getParentNodeKey(item.key);
                        downloadFileDataURL(mProjId, szFolderKey, selectNode.key, item.fileId).then(async (res) => {
                            const szStr = await res.Body.transformToString();
                            const jObj = JSON.parse(szStr);

                            var newFile = {
                                mimeType: jObj.mimeType,
                                id: item.fileId,
                                dataURL: jObj.dataURL,
                                created: Date.now(),
                                lastRetrieved: Date.now()
                            }

                            //保存到这个集合，存储到缓存...
                            if (selectNode.drawJson.files[item.fileId]) {
                                selectNode.drawJson.files[item.fileId].dataURL = jObj.dataURL;
                            }

                            excalidrawRef.getApp().addFiles([newFile]);
                            //更新
                            nTimeoutId = setTimeout(() => {
                                excalidrawRef?.getApp()?.refreshElement(item, {fileId: item.fileId});
                            }, 100);
                            mArrayTimeoutIds.current.push(nTimeoutId);

                            //真是神奇的一些东西。。。不这样转一下保存不了，。。。。。
                            const s = JSON.stringify(cachePageDatas);
                            addPageToCache(mProjId, JSON.parse(s));
                        });
                    }
                }
            }
            //endregion
        }
        if (isFramePresent) {
            setDisplayMode('edit');
            nTimeoutId = setTimeout(() => {
                // excalidrawRef?.onSetDisplayMode("preview");
                onPresentFrameClick();
            }, 130);
            mArrayTimeoutIds.current.push(nTimeoutId);
        }
        if (isPresentMode) {
            nTimeoutId = setTimeout(() => {
                setPageSizeNumber(leftMenuRef.current.getPageSizeDesc());
            }, 100);
            mArrayTimeoutIds.current.push(nTimeoutId);
        }


        excalidrawRef?.onSetReadonlyStatus(isPresentMode);

        //发送个消息.
        if (window.location.href.includes('sliderDraw')){
            let szKey = selectNode.key;
            if (urlParams.boardId){
                szKey = urlParams.boardId
            }
            urlParams.boardId = '';
            sendMessageFromSliderDraw("selectBoard",szKey);
        }

        //连续不停点击？!
        nLastDelayIndicatorTimeoutId = setTimeout(()=>{
            if (!mIsLoading){
                setIsSaving(false);
            }
        },100)
        mIsLoading = false;
    }

    /**
     * 获取当前--上一次的绘制对象....
     */
    function getExcalidrawJson() {
        if (excalidrawRef != null) {
            return excalidrawRef.getDrawJson(currentSelectNode?.key);
        } else {
            // window.location.reload();
            // message.error('excalidrawRef is null');
            console.log('excalidrawRef is null')
        }
    }

    /**
     * 插入笔记内容到画布
     * @param noteData
     */
    function onInsertNoteData(noteData, isAutoInsert) {
        excalidrawRef?.onInsertNoteData(noteData, isAutoInsert);
    }

    /**
     * 编辑笔记
     * @param element
     */
    async function onEditNoteData(element: any, isReadOnlyMode: boolean = false, openType: string | 'slider' | 'dialog',bClearSelectElement=true,isIngoreTypeChange=true) {
        if (!isNoteElement(element) && !isCardAnnoElement(element))return;

        if (isIngoreTypeChange){
            if (rightSliderWidth > 0 || APP_WEB || isPresentMode) {//分享的侧栏打开...
                openType = 'slider';
            }
            if (isPresentMode){
                if (localStorage.getItem(KEY_GLOBAL_CARD_DISPLAY_MODE) == 'popupWindow'){
                    openType = 'dialog';
                }
            }
        }

        if (openType == 'dialog') {
            leftMenuRef.current.onEditNoteData(element, isReadOnlyMode);
            if (isSearchVisible) {
                nTimeoutId = setTimeout(() => {
                    window.GSearchOpen(searchKey);
                }, 200);
                mArrayTimeoutIds.current.push(nTimeoutId);
            }
        } else if (openType == 'slider') {
            if (window.closeGlobalRightSide){
                window.closeGlobalRightSide();
            }

            let cardData: any;
            if (APP_WEB) {
                cardData = leftMenuRef.current.onGetNoteDataById(element.id, element.customData?.generationData?.id) ?? {};
                cardData.id = cardData.key;
                cardData.name = cardData.title;
                cardData.doc = cardData.noteDataDoc;
            } else {
                cardData = await getCardById(element.customData?.generationData?.id);//leftMenuRef.current.onGetNoteDataById(element.id);
            }

            const newData = {
                ...cardData,
                id: cardData.id,
                name: cardData.name,
                doc: cardData.doc,
            }
            //打开注记
            if (isCardAnnoElement(element)){
                newData.annoId = element.customData?.generationData?.pdfData?.id//element.id;
            }

            postMessage(EVENT_NOTE_ON_SLIDER_RIGHT, {data: newData, scrollRate: 0});
            if (bClearSelectElement){
                excalidrawRef.clearSelectElements();
            }
        }
    }

    function getExcalidrawState() {
        if (excalidrawRef != null) {
            return Object.assign({}, excalidrawRef.getExcalidrawState());
        } else {
            message.error('excalidrawRef is null');
        }
    }

    /**
     * 添加字体....
     * @param fontInfo
     */
    function createFontFamily(fontInfo: any) {
        var style = document.createElement('style');
        style.type = 'text/css';
        var cssContent = document.createTextNode('@font-face { font-family: "' + fontInfo.fontName + '"; src: url("localfont://' + fontInfo.fontPath + '"); }');
        style.appendChild(cssContent);
        document.head.appendChild(style);
        global.g_arrayFonts.splice(0, 0, fontInfo);
    }

    /**动态组件部分暂不用**/
    // function createDynamicComponent(componentName: any) {
    //     const DynamicComponent = () => (
    //         <>
    //             {React.createElement(componentName)}
    //         </>
    //     );
    //     return DynamicComponent;
    // }

    //显示激活的画布---
    //react 不支持状态保存。。。没必要这种搞了。。。。
    // function ShowActivieDraw() {
    //     let Excalidraw = null;
    //     if (currentSelectNode != null) {
    //         Excalidraw = currentSelectNode.excalidraw;
    //     } else {
    //         Excalidraw = createDynamicComponent(MyExcalidraw);
    //     }
    //     return (
    //         <>
    //             <Excalidraw/>
    //         </>
    //     )
    // }

    /**动态组件部分暂不用--end**/

    /**
     * 适配当前分辨率大小
     * @param jsonData
     */
    const justfiyCurrentResolution = (jsonData: any) => {
        if (!('info' in jsonData)) return;
        if (!('screen' in jsonData.info)) return;
        const canvasScreen = jsonData.info.screen;
        const fRateW = screen.width / canvasScreen.width;
        const fRateH = screen.height / canvasScreen.height;

        let fMin = Math.max(fRateW, fRateH);
        if (fRateW > 1 && fRateH > 1) {
            fMin = Math.min(fRateW, fRateH);
        }
        if (fMin == 1) return;

        //调整元素的位置和大小
        for (let i = 0; i < jsonData.canvas.length; i++) {
            const item = jsonData.canvas[i];
            if (item.isFolder) {
                for (let k = 0; k < item.children.length; k++) {
                    const subItem = item.children[k];
                    for (let j = 0; j < subItem.drawJson.elements.length; j++) {
                        resetElementAttr(subItem.drawJson.elements[j], fMin);
                    }
                }
            } else {
                for (let j = 0; j < item.drawJson.elements.length; j++) {
                    resetElementAttr(item.drawJson.elements[j], fMin);
                }
            }
        }
    }

    /**
     * 重置元素的位置和大小
     * @param element
     * @param fRate
     */
    const resetElementAttr = (element: any, fRate: number) => {
        element.x *= fRate;
        element.y *= fRate;
        element.width *= fRate;
        element.height *= fRate;
        element.strokeWidth *= fRate;
        if (element.type === 'text') {
            element.fontSize *= fRate;
        } else if (element.type == 'freedraw') {
            for (let i = 0; i < element.points.length; i++) {
                let array = element.points[i];
                array[0] = array[0] * fRate;
                array[1] = array[1] * fRate;
            }
        }
    }

    let drawJson = [];
    if (currentSelectNode != null) {
        drawJson = currentSelectNode.drawJson;
    }

    /**
     * 只选中工具栏。
     * @param szAction
     */
    const onCheckToolbar = (szAction: string) => {
        var arrayNew = [...toolButtons];
        arrayNew.forEach(p => {
            if (szAction == p.id) {
                p.isActive = true;
            } else {
                p.isActive = false;
            }
        });
        setActivityTool(szAction);
        setToolButtons(arrayNew);

    }

    //工具栏点击
    const toolsClicked = async (e: any) => {
        excalidrawRef?.hidePopupMenu();

        if (drawPopoverOpen) {
            setDrawPopoverOpen(false);
        }
        if (elementPopoverOpen) {
            setElementPopoverOpen(false);
        }
        if (embedPopoverOpen) {
            setEmbedPopoverOpen(false);
        }
        if (filePopoverOpen) {
            setFilePopoverOpen(false);
        }
        if (isFramePopoverOpen) {
            setIsFramePopoverOpen(false);
            return;
        }
        if (isImagePopoverOpen) {
            setIsImagePopoverOpen(false);
        }
        var szId = e.currentTarget.dataset.id;

        if (szId == 'text' || szId == 'card'){
            if (await hasBeyondTextLimit())return;
        }

        if ('library' == szId) {
            if (rightSliderLibraryWidth != 0) {
                setRightSliderLibraryWidth(0);
                return;
            }
            let nWidth = getIntValue(localStorage.getItem(KEY_SLIDER_RIGHT_LIBRARY_WIDTH),DEFAULT_SLIDER_PDF_WIDTH);
            setRightSliderLibraryWidth(nWidth);
            //关闭card..pdf
            setRightSliderWidth(0);
            nTimeoutId = setTimeout(() => {
                pageLibraryRef.current?.onSliderEvent(nWidth);
            }, 100);
            mArrayTimeoutIds.current.push(nTimeoutId);

            return;
        }

        var arrayNew = [...toolButtons];
        const szActiveTool = excalidrawRef?.onGetActiveTool();

        arrayNew.forEach(p => {
            if (szId == p.id && 'image' != szId) {
                p.isActive = true;
            } else {
                p.isActive = false;
            }
        });
        setToolButtons(arrayNew);
        if ('style' === szId) return;

        if ('element' == szId) {
            setElementPopoverOpen(!elementPopoverOpen);
            setSvgSearchKey('');
            setArraySvgData([...Global.g_arraySvg.slice(0, PAGE_SIZE)]);
        } else if ("draw" == szId) {
            if (szActiveTool == 'highlighter' || szActiveTool == 'eraser') {

            } else {
                excalidrawRef.onSetActiveTool('freedraw');
                setFreeDrawToolName('freedraw');
                setDrawStrokeColor(excalidrawRef.getAppState()?.currentItemDrawStrokeColor);
            }
        } else if ('frame' == szId) {
            excalidrawRef?.onSetFrameSize({
                type: "preset",
                width: 16,
                height: 9,
            });
            excalidrawRef.onSetActiveTool("frame");
            setIsFramePopoverOpen(true)
        } else if ('file' == szId){
            mFileImportMode = '';
            //file的点击次数，如果是第一次就显示这个弹窗，后面就不再显示了.
            const isFirst = localStorage.getItem(KEY_IS_FIRST_CLICK_FILE_MODE) != 'false';
            const fileMode = getFileImportMode();
            if (!isFirst && fileMode != 'askMe'){
                setFilePopoverOpen(false);
                fileImportInputRef.current?.click();
            }
            localStorage.setItem(KEY_IS_FIRST_CLICK_FILE_MODE,'false');
        }else if ('stickyNotes' == szId){
            localStorage.setItem('stickyColor',DEFAULT_STICKYNOTE_BACKGROUND_COLOR);
            excalidrawRef.onSetActiveTool('stickyNotes');
            const canvas = document.getElementById('canvas');
            if (canvas) {
                setCursor(canvas, `url(${getImagePath('sticky_notes_1')}) 22 22, auto`)
            }
        }
        else {
            if (szId == 'selection' && szActiveTool === 'selection') {
                //换成pan
                szId = "hand";
                //取消选中
                arrayNew.forEach(p => {
                    p.isActive = false;
                });
                setToolButtons(arrayNew);
            }

            if ("embeddable-1" === szId || 'file' == szId) {
                szId = "selection";//换成选择工具....

                nTimeoutId = setTimeout(()=>{
                    inputEmbedUrl.current?.focus();
                },100);
                mArrayTimeoutIds.current.push(nTimeoutId);
            }

            excalidrawRef.onSetActiveTool(szId);
        }
        nTimeoutId = setTimeout(() => {
            setActivityTool(excalidrawRef.getAppState()?.activeTool?.type);
        }, 100);
        mArrayTimeoutIds.current.push(nTimeoutId);
    }

    /**
     * 选中工具栏的某一个.
     * @param szId
     */
    function onSelectTool(szId: string) {
        var arrayTool = [...toolButtons];
        arrayTool.forEach(p => {
            p.isActive = (p.id == szId);
        })
        setToolButtons(arrayTool);
        setActivityTool(szId);
        excalidrawRef.onSetActiveTool(szId);
    }

    async function onElementClickEvent(e: any) {
        var szId = e.currentTarget.dataset.id;
        setElementPopoverOpen(false);
        if (szId == 'line'){
            global.g_forceStraight = true;
        }else if (isShape(szId)){
            if (await hasBeyondTextLimit())return;
        }

        excalidrawRef.onSetActiveTool(szId);
    }

    /*图标点击*/
    function onElementIconClickEvent(e) {
        //插入图片
        excalidrawRef?.onInsertElementIcon(imgPathPerfix() + e.currentTarget.dataset.path);
        setElementPopoverOpen(false);
    }

    /*绘制点击*/
    function onDrawIconClickEvent(szId: string) {
        if (mIsFirstHighlighterClicked && 'highlighter' === szId) {
            excalidrawRef.setFirstHighlight();
            mIsFirstHighlighterClicked = false;
        }
        if ('freedraw' == szId || 'eraser' == szId) {
            setDrawStrokeColor(excalidrawRef?.getAppState()?.currentItemDrawStrokeColor);
            setDrawTransparent(hexToRgba(excalidrawRef?.getAppState()?.currentItemDrawStrokeColor).a * 100);
            setDrawStrokeWidth(excalidrawRef?.getAppState()?.currentItemDrawStrokeWidth);
        } else if ('highlighter' == szId) {
            setDrawStrokeColor(excalidrawRef?.getAppState()?.currentItemHighlightStrokeColor);
            setDrawTransparent(hexToRgba(excalidrawRef?.getAppState()?.currentItemHighlightStrokeColor).a * 100)
            setDrawStrokeWidth(excalidrawRef?.getAppState()?.currentItemHighlightStrokeWidth);
        }
        // setDrawPopoverOpen(false);
        excalidrawRef.onSetActiveTool(szId);
        setFreeDrawToolName(szId);
        setActivityTool(szId);
    }

    //frame点击
    const onFrameToolsClick = (p: {
        id: string;
        title: string;
        isActive: boolean;
        pageSize?: number[] | null;
    }) => {
        setIsFramePopoverOpen(false);
        if (!p.pageSize) {
            mPageSizeType = "frame";
            dialogPageSizeRef.current.onShowDialog('', '');
            return;
        }
        excalidrawRef?.onSetFrameSize({
            type: "preset",
            width: p.pageSize[0],
            height: p.pageSize[1],
        });
        excalidrawRef.onSetActiveTool("frame");
    };

    /**
     * 分页元素列表
     */
    function paginationElementSvg(szKey) {
        var arrayNew: any = [];
        if (mSvgPageNum > 1) {
            arrayNew.push(...arraySvgData)
        }
        const nStart = (mSvgPageNum - 1) * PAGE_SIZE;
        var arrayNewItems = [];
        if (!isStringNullOrEmpty(szKey)) {
            arrayNewItems = Global.g_arraySvg.filter(p => p.searchName.toLowerCase().indexOf(szKey) != -1);
        } else {
            arrayNewItems = [...Global.g_arraySvg];
        }
        var arrayNextPage = arrayNewItems.slice(nStart, nStart + PAGE_SIZE)
        arrayNew.push(...arrayNextPage);

        setArraySvgData(arrayNew);
    }


    function renderToolElementShape() {
        const ARRAY_SHAPE_ELEMENT = [
            {
                id: 'rectangle',
                key: 'rectangle',
                imageName: 'element_shape_jx_no_corner.png',
                title: t('Rectangle'),
                isActive: false
            },
            {
                id: 'roundedRectangle',
                key: 'roundedRectangle',
                imageName: 'element_shape_jx.png',
                title: t('Rectangle'),
                isActive: false
            },
            {
                id: 'diamond',
                key: 'diamond',
                imageName: 'element_shape_lx.png',
                title: t('Diamond'),
                isActive: false
            },
            {
                id: 'ellipse',
                key: 'ellipse',
                imageName: 'element_shape_ty.png',
                title: t('Ellipse'),
                isActive: false
            },
            {
                id: 'triangle',
                key: 'triangle',
                imageName: 'element_shape_sanjiaoxing.png',
                title: t('Line'),
                isActive: false
            },
            {
                id: 'line',
                key: 'line',
                imageName: 'element_shape_line.png',
                title: t('Line'),
                isActive: false
            },
            // {
            //     id: 'arrow',
            //     key: 'arrow',
            //     imageName: 'element_shape_jiantou.png',
            //     title: t('Arrow'),
            //     isActive: false
            // },
            {
                id: 'bubble',
                key: 'bubble',
                imageName: 'element_shape_chat.png',
                title: t('Line'),
                isActive: false
            },
            {
                id: 'pentagram',
                key: 'pentagram',
                imageName: 'element_shape_star.png',
                title: t('Line'),
                isActive: false
            },
            {
                id: 'parallelogram',
                key: 'parallelogram',
                imageName: 'element_shape_pingxingsibianxing.png',
                title: t('Line'),
                isActive: false
            },
            {
                id: 'thickArrow',
                key: 'thickArrow',
                imageName: 'element_shape_way.png',
                title: t('Line'),
                isActive: false
            }
        ];

        var arrayHtmls = [];
        for (var i = 0; i < ARRAY_SHAPE_ELEMENT.length; i++) {
            var item = ARRAY_SHAPE_ELEMENT[i];
            arrayHtmls.push(
                <img key={item.id} data-id={item.id} onClick={(e) => onElementClickEvent(e)}
                     src={imgPathPerfix() + item.imageName}/>
            )
        }

        return (
            <List
                grid={{gutter: 16, column: 5}}
                dataSource={ARRAY_SHAPE_ELEMENT}
                renderItem={(item) => (
                    <List.Item>
                        <div className='flex-center hovered'
                             style={{marginLeft: '-16px', height: '20px', width: '20px'}}>
                            <img key={item.id} style={{
                                width: '20px',
                                height: '20px',
                                filter: isDarkMode() ? 'brightness(100)' : 'none'
                            }} data-id={item.id} onClick={(e) => onElementClickEvent(e)}
                                 src={imgPathPerfix() + item.imageName}/>
                        </div>

                    </List.Item>
                )}

            />
        )
    }

    /*svg图标....*/
    function renderToolElmentIcon(szKey) {
        // let arrayItems;
        // if (!isStringNullOrEmpty(szKey)){
        //     arrayItems = Global.g_arraySvg.filter(p=>p.key.indexOf(szKey) != -1);
        // }else{
        //     arrayItems = [...Global.g_arraySvg];//elementIcons()[elementIconType];
        // }

        // var arrayHtmls = [];
        // for (var i = 0; i < arrayItems.length; i++) {
        //     var item = arrayItems[i];
        //     arrayHtmls.push(
        //         <img key={item.id} data-id={item.id} onClick={(e) => onElementClickEvent(e)}
        //              src={imgPathPerfix() + item.imageName}/>
        //     )
        // }

        return (
            <div style={{display: 'flex', flexDirection: 'column', overflow: 'hidden'}}>
                <Input variant={"borderless"} className={'input-border'}
                       style={{marginTop: '-0px', height: '32px', flexShrink: '0'}} prefix={<IconSearch/>}
                       value={svgSearchKey} placeholder={t("Search")} onChange={(e) => {
                    setSvgSearchKey(e.currentTarget.value);
                    let szValue = e.currentTarget.value.toLowerCase();
                    // let arrayItems = Global.g_arraySvg.filter(p=>p.key.indexOf(szValue) != -1);
                    // setArraySvgData(arrayItems);
                    // divElementSvgContainerRef?.current?.scrollTop = 0;
                    mSvgPageNum = 1;
                    paginationElementSvg(szValue);
                }}/>
                <div ref={divElementSvgContainerRef} style={{overflowX: 'hidden', overflowY: 'auto', marginTop: '10px'}}
                     onScroll={(e) => {
                         let he = e.currentTarget.scrollHeight - e.currentTarget.clientHeight - e.currentTarget.scrollTop
                         // console.log(he);
                         if (he >= 50) {
                         } else {
                             mSvgPageNum++;
                             paginationElementSvg(svgSearchKey);
                         }
                     }}>
                    <List
                        grid={{gutter: 16, column: 5}}
                        dataSource={arraySvgData}
                        renderItem={(item) => (
                            <List.Item>
                                <div key={item.id} className='flex-center hovered'
                                     style={{marginLeft: '-16px', height: '20px', width: '20px'}}>
                                    <img key={item.id} style={{width: '20px', height: '20px'}} data-id={item.id}
                                         data-path={item.imageName} onClick={(e) => onElementIconClickEvent(e)}
                                         src={imgPathPerfix() + item.imageName}/>
                                </div>

                            </List.Item>
                        )}
                    />
                </div>

            </div>

        )
    }

    /**
     * element工具左侧菜单点击
     * @param szType
     */
    function onElementLeftClicked(szType) {
        let arrayNewEleMenus = [...ARRAY_ELEMENT_LEFT_MENU];
        for (var i = 0; i < arrayNewEleMenus.length; i++) {
            var item = arrayNewEleMenus[i];
            if (item.id == szType) {
                item.isChecked = true;
            } else {
                item.isChecked = false;
            }
        }
        setArrayElementLeftMenu(arrayNewEleMenus);

        setElementType(szType);
    }

    function renderElementRigthContainer() {
        if ('shape' == elementType) {
            return renderToolElementShape();
        } else {
            return renderToolElmentIcon('');
        }
    }

    const ARRAY_ELEMENT_LEFT_MENU = [
        {
            id: 'shape',
            name: 'Shapes',
            isChecked: true
        },
        {
            id: 'icons',
            name: 'Icons',
            isChecked: false
        }
        // {
        //     id: 'social',
        //     name: 'Social',
        //     isChecked: false
        // },
        // {
        //     id: 'movie',
        //     name: t("Movie"),
        //     isChecked: false
        // },
        // {
        //     id: 'editor',
        //     name: t("Editor"),
        //     isChecked: false
        // },
        // {
        //     id: 'action',
        //     name: t("Action"),
        //     isChecked: false
        // },
        // {
        //     id: 'navi',
        //     name: "Navi",
        //     isChecked: false
        // },
        // {
        //     id: 'other',
        //     name: t("Other"),
        //     isChecked: false
        // }
    ]
    const [arrayElementLeftMenu, setArrayElementLeftMenu] = useState(ARRAY_ELEMENT_LEFT_MENU);

    /**
     * 当前白板视频数量
     */
    const getCurrentVideoElementCount = ()=>{
        const arrayElements = excalidrawRef?.onGetAllElements();
        return arrayElements.filter(p=>isFileVideoElement(p)).length;
    }

    /**
     * 超过免费视频限制
     */
    const beyondFreeVideoLimit = async ()=>{
        const nCount:any = await getLibraryVideoCount();
        return (nCount >= 3);
        // return getCurrentVideoElementCount() >= 3;
    }


    const handleImportFileByMode = async (file:any,fileImportMode:any,bCheckFile=true)=>{
        let importFileMode = fileImportMode || getFileImportMode(file.size);
        //如果是md文件，使用链接模式
        // if (isMd(file.path)){
        //     importFileMode = IMPORT_FILE_MODE_LINKMODE;
        // }
        if (importFileMode == IMPORT_FILE_MODE_ASKME){
            //使用高级选项 还是有机会 会到这里
            window.showDialogFileImportDrag(async (szAction:any)=>{
                if (szAction == IMPORT_FILE_MODE_IMPORTMODE){
                    window.showDialogFileImportLoading(szAction);
                    //检测文件md5
                    let szExistFileName = '';
                    if (bCheckFile){
                        szExistFileName = await ipcInvoke('cmp-file-md5', {filePath:file.path});
                    }
                    if (szExistFileName){
                        window.closeDialogFileImportLoading();
                        window.showMessageBox(t("DuplicateFileFound"),t("TheSameFileAlreadyExists"),t("CreateNewCopy"),t("Ok"),()=>{
                            //create new copy
                            ipcInvoke('copy-file', {filePath: file.path}).then(res => {
                                //insert file type
                                excalidrawRef.insertFileElement(res, null, false, file, null, null);
                            });
                        },()=>{
                            //use exist--得到文件名，创建一个新的...
                            // excalidrawRef.insertFileElement(szExistFileName, null, false, file, null, null,false);
                            //use exist--得到文件名，创建一个新的...
                            getLibraryByFileName(szExistFileName).then(library=>{
                                excalidrawRef.insertFileElement(szExistFileName, library.id, false, file, null, null,false,false,library.name);
                            });
                        })
                    }else{
                        ipcInvoke('copy-file', {filePath: file.path}).then(res => {
                            //insert file type
                            excalidrawRef.insertFileElement(res, null, false, file, null, null);
                            window.closeDialogFileImportLoading();
                        });
                    }
                }else{
                    //不需要复制文件.....
                    window.showDialogFileImportLoading(szAction);
                    excalidrawRef.insertFileElement(file.path, null, false, file, null, null,true,true);
                    window.closeDialogFileImportLoading();
                }
            });
        }else if (importFileMode == IMPORT_FILE_MODE_IMPORTMODE){
            window.showDialogFileImportLoading(importFileMode);
            //检测文件md5
            let szExistFileName = '';
            if (bCheckFile){
                szExistFileName = await ipcInvoke('cmp-file-md5', {filePath:file.path});
            }
            if (szExistFileName){
                window.closeDialogFileImportLoading();
                window.showMessageBox(t("DuplicateFileFound"),t("TheSameFileAlreadyExists"),t("CreateNewCopy"),t("Ok"),()=>{
                    //create new copy
                    ipcInvoke('copy-file', {filePath: file.path}).then(res => {
                        //insert file type
                        excalidrawRef.insertFileElement(res, null, false, file, null, null);
                    });
                },()=>{
                    //use exist--得到文件名，创建一个新的...
                    getLibraryByFileName(szExistFileName).then(library=>{
                        excalidrawRef.insertFileElement(szExistFileName, library.id, false, file, null, null,false,false,library.name);
                    });
                })
            }else{
                ipcInvoke('copy-file', {filePath: file.path}).then(res => {
                    window.closeDialogFileImportLoading();
                    //insert file type
                    excalidrawRef.insertFileElement(res, null, false, file, null, null);
                });
            }
        }else if (importFileMode == IMPORT_FILE_MODE_LINKMODE){
            //不需要复制文件.....
            window.showDialogFileImportLoading(importFileMode);
            nTimeoutId = setTimeout(()=>{
                window.closeDialogFileImportLoading();
                excalidrawRef.insertFileElement(file.path, null, false, file, null, null,true,true);
            },1000);
            mArrayTimeoutIds.current.push(nTimeoutId);
        }
    }

    /**
     * 处理导入的文件
     * @param file
     */
    const handleImportFile = async (file:any,fileImportMode:any,bCheckFile=true)=>{
        if (file.size > MAX_SIZE) {
            message.error(t("The maximum file").replace('500MB','2G'));
            return Upload.LIST_IGNORE;
        }
        // let reader = new FileReader();
        // reader.onload = function (e){
        // setIsVisible(false);
        // props.onImportNoteData(e.target.result as string,file.path);
        // }
        // reader.readAsText(file,"utf-8");
        setFilePopoverOpen(false);
        if (isImage(file.name)) {
            excalidrawRef.getApp()?.insertImgElement(file,true,fileImportMode);
        } else {
            if (isWebApp()) {
                window.showProgress();
                let elementId = generateRandomPageKey();
                uploadS3File(elementId, file, 'file').then(res => {
                    window.closeProgress();
                    excalidrawRef.insertFileElement(file.name, null, false, file, elementId, res).then(element => {

                    })
                })
            } else {
                if (!hasLicense() && !hasDesktopBaseLicense()) {
                    let nVideoCount = await beyondFreeVideoLimit();
                    let nPdfCount = await beyondFreePdfLimit();
                    if (isVideo(file.path) && nVideoCount) {
                        window.showMessageBox(t("Upgrade required"), t("NeedUpgradeToImportVideoMore"), t("Cancel"), t("Learn more"), ()=>{
                            window.closeDialogFileImportLoading();
                        }, () => {
                            window.closeDialogFileImportLoading();
                            if (isZh()) {
                                ipcSend('open-url',import.meta.env.VITE_HTTP_PURCHASE_PRICE_ZH)
                            }else {
                                ipcSend('open-url', import.meta.env.VITE_HTTP_PURCHASE_PRICE);
                            }
                        })
                    }else if (isPdf(file.path) && nPdfCount){
                        window.showMessageBox(t("Upgrade required"), t("NeedUpgradeToImportPDF"), t("Cancel"), t("Learn more"), ()=>{
                            window.closeDialogFileImportLoading();
                        }, () => {
                            window.closeDialogFileImportLoading();
                            if (isZh()) {
                                ipcSend('open-url',import.meta.env.VITE_HTTP_PURCHASE_PRICE_ZH)
                            }else {
                                ipcSend('open-url', import.meta.env.VITE_HTTP_PURCHASE_PRICE);
                            }
                        })
                    }
                    else {
                        await handleImportFileByMode(file,fileImportMode,bCheckFile);
                    }
                } else {
                    await handleImportFileByMode(file,fileImportMode,bCheckFile);
                }
            }
        }

        let arrayTools = [...toolButtons];
        arrayTools.forEach((p) => {
            p.isActive = p.id === 'selection';
        })
        setToolButtons(arrayTools);
        excalidrawRef.onSetActiveTool("selection");
        setHasElement(true);
    }

    /**
     * 文件选择
     */
    const uploadProps: { beforeUpload: (file: any) => string } = {
        beforeUpload: (file) => {
            handleImportFile(file);
            return Upload.LIST_IGNORE
        }
    }

    /**
     * element工具弹出左侧菜单
     */
    function renderPopoverElementLeftMenu() {
        let arrayHtmls = [];
        for (var i = 0; i < arrayElementLeftMenu.length; i++) {
            var item = arrayElementLeftMenu[i];
            arrayHtmls.push(
                <span key={item.id} data-id={item.id}
                      style={{color: item.isChecked ? 'white' : 'var(--item-no-select-color)'}}
                      className={item.isChecked ? 'popover-tool-element-container-left-actived' : 'popover-tool-element-container-left-normal'}
                      onClick={(e) => onElementLeftClicked(e.currentTarget.dataset.id)}>{t(item.name)}</span>
            )
        }
        return (
            arrayHtmls
        )
    }

    /**
     * 工具栏的元素
     */
    function renderToolPopoverElements() {
        return (
            <div className='popover-tool-element-container'>
                <div className='popover-tool-element-container-left'>
                    {renderPopoverElementLeftMenu()}
                </div>
                <div className='popover-tool-element-container-right'>
                    {renderElementRigthContainer()}
                </div>
            </div>
        )
    }

    /**
     * embed元素
     */
    function renderEmbedPopoverElements() {
        const arrayIcons = [
            {
                label: 'Youtube',
                icon: 'embed_1',
                whiteIcon: 'embed_1_white.png'
            },
            {
                label: 'Tiktok',
                icon: 'embed_tiktok',
                whiteIcon: 'embed_tiktok_white.png'
            },
            {
                label: '　X　',
                icon: 'embed_2',
                whiteIcon: 'embed_2_white.png'
            },
            {
                label: 'Vimeo',
                icon: 'embed_vimeo'
            },
            {
                label: 'Google Drive',
                icon: 'embed_3'
            },
            {
                label: 'Google Docs',
                icon: 'embed_4'
            },
            {
                label: 'Google Slides',
                icon: 'embed_5'
            },
            {
                label: 'Google Sheets',
                icon: 'embed_6'
            },
            {
                label: 'Figma',
                icon: 'embed_7'
            },
            {
                label: 'Miro',
                icon: 'embed_8'
            },
            {
                label: 'Mural',
                icon: 'embed_mural',
                whiteIcon: 'embed_mural_white.png'
            },
            {
                label: 'Loom',
                icon: 'embed_9'
            },
            {
                label: 'Spotify',
                icon: 'embed_spotify'
            },
            {
                label: 'Soundcloud',
                icon: 'embed_soundcloud'
            },
            {
                label: 'Typeform',
                icon: 'embed_typeform',
                whiteIcon: 'embed_typeform_white.png'
            },
            {
                label: 'Airtable',
                icon: 'embed_10'
            }
        ];

        return (
            <div className='flex-col font-size-12' style={{width: '376px', height: '306px', padding: '6px'}}>
                <div className='flex-row-vertical-center'>
                    <span className='dialog-title'
                          style={{marginTop: '0px', fontSize: '14px'}}>{t("Embed code")}</span>
                    <img className='img-14 ml-6 cursor-pointer' src={getImagePathWithTheme('embed_helper')}
                         onClick={() => {
                             ipcSend('open-url', import.meta.env.VITE_HTTP_EMBED_HELPER_URL);
                         }}/>
                </div>
                <div className='line-e4' style={{margin: '12px -18px'}}></div>

                <div className='flex-row-vertical-center mt-12'>
                    <Input ref={inputEmbedUrl} variant={"borderless"} autoFocus={true} className='input-border' placeholder=''
                           value={embedUrl} onChange={(e) => {
                        setEmbedUrl(e.currentTarget.value);
                    }}/>

                </div>

                {/*<span className='mb-4 font-weight-500' style={{marginTop: '-2px'}}>{t("Can embed mul page")}</span>*/}
                <span className='mt-26'>{t("Supported products")}</span>
                <div className='flex-row-vertical-center'
                     style={{margin: '6px -8px', flexWrap: 'wrap', justifyContent: 'space-between'}}>
                    {
                        arrayIcons.map(p =>
                            <div key={p.label} className='flex-column-center'
                                 style={{margin: '10px 10px'}}>
                                <Tooltip placement="bottom" fresh={true} onOpenChange={(e) => {
                                    if (e) {
                                        let arrayTooltips = document.body.getElementsByClassName('ant-tooltip-arrow');
                                        for (let i = 0; i < arrayTooltips.length; i++) {
                                            arrayTooltips[i].style.top = '1px';
                                        }
                                    }
                                }} color='#808080' overlayClassName='font-size-12' title={p.label} arrow={true}>
                                    <img className='img-24' src={getImagePathWithTheme(p.icon)}/>
                                </Tooltip>
                                {/*<span style={{*/}
                                {/*    fontSize: '11px',*/}
                                {/*    marginTop: '2px',*/}
                                {/*    textAlign: 'center',*/}
                                {/*    width: '100%',*/}
                                {/*    whiteSpace: 'nowrap'*/}
                                {/*}}>{p.label}</span>*/}
                            </div>
                        )
                    }
                </div>

                <div className='flex-center'
                     style={{position: 'absolute', bottom: '20px', left: '50%', transform: 'translateX(-50%)'}}>
                    <Button disabled={!isValidUrl(embedUrl)} className='button-solid-style'
                            style={{height: '38px', width: '164px'}} type={"primary"} onClick={() => {
                        excalidrawRef?.insertEmbedElement(embedUrl);
                        setEmbedPopoverOpen(false);
                        setEmbedUrl('');
                    }}>{t("Confirm")}</Button>
                </div>

                {/*<img style={{position:'absolute',top:'16px',right:'16px'}} className='img-small hovered-circle' src={imgPathPerfix()+"close_circle.png"} onClick={()=>setEmbedPopoverOpen(false)}/>*/}
            </div>
        )
    }

    /**
     * 选择文件
     */
    function renderFileChoose() {
        return (
            <div className='font-size-12' style={{
                width: '500px',
                margin: '-12px',
                padding: '16px',
                display: 'flex',
                overflow:'hidden',
                flexDirection: 'column',
                alignItems: 'center'
            }}>
                <div style={{
                    backgroundColor: 'var(--drag-file-background-color)',
                    height: '170px',
                    width: '100%',
                    borderRadius: '8px'
                }} onClick={() => {
                    setFilePopoverOpen(false);
                }}>
                    <Dragger /*disabled={!hasLicense()}*/ {...uploadProps} accept={"*"}
                                                          style={{outline: 'none', border: '0px'}}>
                        <p className="ant-upload-text">
                            <img style={{width: '78px', height: '78px'}} src={imgPathPerfix() + "drag_file.png"}/>
                        </p>
                        <p className='font-family-semi-bold font-size-14'
                           style={{color: 'var(--drag-file-desc-color)'}}>{t("Click here or drag")}</p>
                    </Dragger>
                </div>

                <span style={{
                    color: 'var(--text-color-66666)',
                    marginTop: '12px',
                    lineHeight: '24px',
                    textAlign: 'center'
                }}>{t("Support all file")}</span>
                {
                    !hasLicense() && !hasDesktopBaseLicense() &&
                    <>
                        <div style={{width: '110%', margin: '16px -16px'}} className={'line'}></div>
                        <div style={{display: 'flex', flexDirection: 'column', width: '100%'}}>
                            <span className={'dialog-title'}>{t("Tips")}</span>
                            <span className={'text-color-666'}
                                  style={{marginTop: '6px'}}>{t("ExportProjectTips")}</span>
                            <div className='flex-center button-solid-style'
                                 style={{
                                     width: '164px',
                                     height: '38px',
                                     marginTop: '20px',
                                     alignSelf: 'center',
                                     marginBottom: '6px'
                                 }} onClick={() => {
                                if (!hasLicense() && !hasDesktopBaseLicense()) {
                                    if (isZh()) {
                                        ipcSend('open-url',import.meta.env.VITE_HTTP_PURCHASE_PRICE_ZH)
                                    }else {
                                        ipcSend('open-url', import.meta.env.VITE_HTTP_PURCHASE_PRICE);
                                    }
                                }
                            }}>
                                {/*<img className='img-18' src={imgPathPerfix() + 'vip_white.png'}/>*/}
                                <span className='ml-6 font-family-medium'>{t("See plans")}</span>
                            </div>
                        </div>

                    </>
                }

            </div>
        )
    }

    /**
     * 新的文件选择弹窗.
     */
    function renderFileChooseNew(){
        return <FileImportMode onCallback={(action:any)=>{
            setFilePopoverOpen(false);
            mFileImportMode = '';
            if (action == 'showDialogSetting'){
                window.showSettingDialog('importFile');
            }else if (action == 'importMode'){
                mFileImportMode = action;
                fileImportInputRef.current?.click();
            }else if (action == 'linkMode'){
                mFileImportMode = action;
                fileImportInputRef.current?.click();
            }
        }}/>
    }

    /**
     * 渲染style
     */
    function renderStylePopover() {
        return (
            <div className='div-tool-style font-size-12'>
                <div className='flex-row-vertical-center' onClick={() => onToolStyleEvent("pageColor")}>
                    <img className='img-mini-small' src={imgPathPerfix() + "menu_page_color.png"}/>
                    <span>{t("Page color")}</span>
                </div>
                {/*画布大小的下一层级*/}
                <Popover
                    onOpenChange={(e) => setStylePageSizePopoverOpen(e)}
                    open={stylePageSizePopoverOpen}
                    placement={"rightBottom"}
                    arrow={false}
                    content={renderStylePageSizeMenu()}
                    trigger={['click', "hover"]}>
                    <div className='flex-row-vertical-center' onClick={() => onToolStyleEvent("pageSize")}>
                        <img className='img-mini-small' src={imgPathPerfix() + "menu_page_size.png"}/>
                        <span>{t("Page size")}</span>
                    </div>
                </Popover>

                <div className='flex-row-vertical-center' onClick={() => onToolStyleEvent("showGrid")}>
                    <img className='img-mini-small' src={imgPathPerfix() + "menu_page_grid.png"}/>
                    <span style={{flexGrow: '1'}}>{t("Show grid")}</span>
                    {
                        excalidrawRef?.iShowGrid() &&
                        <img className='img-mini-small' src={imgPathPerfix() + "draw_checked.png"}/>
                    }
                </div>
            </div>
        )
    }

    /**
     * 渲染pagesize的下一层级
     */
    function renderStylePageSizeMenu() {
        return (
            <div className='div-tool-style' style={{minWidth: '292px'}}>
                {
                    arrayPageSizeMenu.map(p => (
                        <div data-id={p.label} key={p.label} className='flex-row-vertical-center'
                             onMouseEnter={(e) => {
                                 var arrayNew = [...ARRAY_PAGE_SIZE_MUNE];
                                 arrayNew.forEach(p => {
                                     p.isHover = (p.label === e.currentTarget.dataset.id);
                                 })
                                 setArrayPageSizeMenu(arrayNew);
                             }}
                             onMouseLeave={(e) => {
                                 var arrayNew = [...ARRAY_PAGE_SIZE_MUNE];
                                 arrayNew.forEach(p => {
                                     p.isHover = false;
                                 })
                                 setArrayPageSizeMenu(arrayNew);
                             }}
                             onClick={(e) => onToolStylePageSizeMenuEvent(e)}>
                            <img className='img-mini-small' src={imgPathPerfix() + p.icon}/>
                            <span>{p.label}</span>
                            {
                                p.isHover &&
                                <span style={{
                                    marginLeft: '6px',
                                    fontSize: '10px',
                                    color: 'var(--text-color)'
                                }}>{p.size}</span>
                            }

                            <span style={{flexGrow: '1'}}></span>

                            {
                                excalidrawRef?.onGetPageSize()?.id == p.id &&
                                <img className='img-mini-small' src={imgPathPerfix() + "draw_checked.png"}/>
                            }
                        </div>
                    ))
                }
            </div>
        )
    }

    /**
     * 渲染绘制
     *
     */
    function renderDrawPopover() {
        return (
            <div className='div-tool-style font-size-12'>
                <div className='flex-row-vertical-center hovered-filter-img'
                     onClick={() => onDrawIconClickEvent("freedraw")}>
                    <img className='img-16' color={DEFAULT_IMAGE_COLOR}
                         src={imgPathPerfix() + "tool_draw_freedraw.png"}/>
                    <span style={{flexGrow: '1'}}>{t("Pen")}</span>
                    {
                        (excalidrawRef?.getAppState()?.activeTool.type === 'freedraw'
                            || (excalidrawRef?.getAppState()?.activeTool.type !== 'highlighter' && excalidrawRef?.getAppState()?.activeTool.type !== 'eraser')) &&
                        <img className='img-mini-small' src={imgPathPerfix() + "draw_checked.png"}/>
                    }
                </div>
                <div className='flex-row-vertical-center hovered-filter-img'
                     onClick={() => onDrawIconClickEvent("highlighter")}>
                    <img className='img-16' src={imgPathPerfix() + "tool_draw_highdraw.png"}/>
                    <span style={{flexGrow: '1'}}>{t("Highlight")}</span>
                    {
                        excalidrawRef?.getAppState()?.activeTool.type === 'highlighter' &&
                        <img className='img-mini-small' src={imgPathPerfix() + "draw_checked.png"}/>
                    }
                </div>
                <div className='flex-row-vertical-center hovered-filter-img'
                     onClick={() => onDrawIconClickEvent("eraser")}>
                    <img className='img-16' src={imgPathPerfix() + "tool_draw_erase.png"}/>
                    <span style={{flexGrow: '1'}}>{t("Eraser")}</span>
                    {
                        excalidrawRef?.getAppState()?.activeTool.type === 'eraser' &&
                        <img className='img-mini-small' src={imgPathPerfix() + "draw_checked.png"}/>
                    }
                </div>
            </div>
        )
    }

    /**
     * 绘制的style
     */
    function renderDrawStrokeStyle() {
        return (
            <div ref={divPopoverStyleRef} id='popoverDrawStyle'>
                {/*weight*/}
                <div style={{margin: '-12px', padding: '16px 16px', width: '254px'}}>
                    <div style={{display: 'flex', justifyContent: 'space-between'}}>
                        <div className='font-size-12' style={{flexShrink: '0'}}>{t("Weight")}</div>

                        <div style={{display: 'flex', alignItems: 'center'}}>
                            <input className={'input-border'}
                                   style={{
                                       width: '36px',
                                       height: '24px',
                                       // border: '1px solid #DBDBDB',
                                       borderRadius: '8px',
                                       marginLeft: '2px',
                                       textAlign: 'center',
                                       fontSize: '12px',
                                   }}
                                   value={drawStrokeWidth}
                                   onFocus={(e) => {
                                       e.currentTarget.select();
                                   }}
                                   onChange={(event) => {
                                       setDrawStrokeWidth(event.currentTarget.value);
                                       const nWidth = parseInt(event.currentTarget.value);
                                       if (isNumber(nWidth)) {
                                           let itemStrokeWidth: any = {
                                               currentItemDrawStrokeWidth: nWidth,
                                           }
                                           if (excalidrawRef?.getAppState()?.activeTool?.type == 'highlighter') {
                                               itemStrokeWidth = {
                                                   currentItemHighlightStrokeWidth: nWidth
                                               };
                                           }else {
                                               //画笔，保存当前设置的值
                                               localStorage.setItem(KEY_FREE_DRAW_STROKE_WIDTH,nWidth);
                                           }
                                           excalidrawRef?.getApp()?.updateScene({
                                               appState: {
                                                   ...excalidrawRef?.getAppState(),
                                                   ...itemStrokeWidth
                                               }
                                           })
                                       }
                                   }}
                            />
                        </div>
                    </div>

                    <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        flexGrow: '1',
                        marginLeft: '-4px',
                        marginTop: '-2px',
                        width: '100%'
                    }}>
                        <Slider style={{width: '100%', marginRight: '-6px'}} tooltip={{open: false}} min={1} max={20}
                                value={drawStrokeWidth} onChange={(value) => {
                            setDrawStrokeWidth(value);

                            let itemStrokeWidth: any = {
                                currentItemDrawStrokeWidth: value,
                            }
                            if (excalidrawRef?.getAppState()?.activeTool?.type == 'highlighter') {
                                itemStrokeWidth = {
                                    currentItemHighlightStrokeWidth: value
                                };
                            }else {
                                //画笔，保存当前设置的值
                                localStorage.setItem(KEY_FREE_DRAW_STROKE_WIDTH,value);
                            }

                            excalidrawRef?.getApp()?.updateScene({
                                appState: {
                                    ...excalidrawRef?.getAppState(),
                                    ...itemStrokeWidth
                                }
                            })
                        }}/>
                    </div>
                </div>

                {/*transparent*/}
                <div style={{margin: '-12px', padding: '16px 16px', width: '254px'}}>
                    <div style={{display: 'flex', justifyContent: 'space-between'}}>
                        <div className='font-size-12' style={{flexShrink: '0'}}>{t("Transparency")}</div>

                        <div style={{display: 'flex', alignItems: 'center'}}>
                            <input className={'input-border flex-center'}
                                   style={{
                                       width: '36px',
                                       height: '24px',
                                       // border: '1px solid #DBDBDB',
                                       borderRadius: '8px',
                                       marginLeft: '2px',
                                       textAlign: 'center',
                                       fontSize: '12px'
                                   }}
                                   value={drawTransparent}
                                   onFocus={(e) => {
                                       e.currentTarget.select();
                                   }}
                                   onChange={(event) => {
                                       setDrawTransparent(event.currentTarget.value);
                                       const nAlpha = parseInt(event.currentTarget.value);

                                       if (isNumber(nAlpha)) {
                                           const rgba = hexToRgba(excalidrawRef?.getAppState()?.currentItemStrokeColor)
                                           rgba.a = nAlpha / 100;
                                           const szNewHex = rgbaToHexa(rgba);
                                           setDrawStrokeColor(szNewHex);
                                           setDrawTransparent(nAlpha);

                                           let itemStrokeColor: any = {
                                               currentItemDrawStrokeColor: szNewHex
                                           }
                                           if (excalidrawRef?.getAppState()?.activeTool?.type == 'highlighter') {
                                               itemStrokeColor = {
                                                   currentItemHighlightStrokeColor: szNewHex
                                               };
                                           }

                                           excalidrawRef?.getApp()?.updateScene({
                                               appState: {
                                                   ...excalidrawRef?.getAppState(),
                                                   ...itemStrokeColor
                                               }
                                           })
                                       } else {
                                           if (isStringNullOrEmpty(event.currentTarget.value)) {
                                               setDrawTransparent(0);
                                           } else {
                                               setDrawTransparent(100);
                                           }
                                       }
                                   }}
                            />
                        </div>
                    </div>

                    <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        flexGrow: '1',
                        marginLeft: '-4px',
                        marginTop: '-2px',
                        width: '100%'
                    }}>
                        <Slider style={{width: '100%', marginRight: '-6px'}} tooltip={{open: false}}
                                value={drawTransparent}
                                onChange={(value) => {
                                    setDrawTransparent(value);

                                    const rgba = hexToRgba(excalidrawRef?.getAppState()?.currentItemStrokeColor)
                                    rgba.a = value / 100;
                                    const szNewHex = rgbaToHexa(rgba)
                                    setDrawStrokeColor(szNewHex);

                                    let itemStrokeColor: any = {
                                        currentItemDrawStrokeColor: szNewHex
                                    }
                                    if (excalidrawRef?.getAppState()?.activeTool?.type == 'highlighter') {
                                        itemStrokeColor = {
                                            currentItemHighlightStrokeColor: szNewHex
                                        };
                                    }

                                    excalidrawRef?.getApp()?.updateScene({
                                        appState: {
                                            ...excalidrawRef?.getAppState(),
                                            ...itemStrokeColor
                                        }
                                    })
                                }}/>
                    </div>
                </div>
            </div>
        )
    }


    /**
     * New 绘制
     */
    function renderDrawPopoverNew() {
        return (
            <div className='flex-row-vertical-center tool-draw'>
                <Tooltip arrow={false} title={<div>{t("Pen")}<span
                    className={'tooltip-shortcut-key'}>{'P'}</span></div>}>
                    <div onClick={() => {
                        onDrawIconClickEvent("freedraw");
                        setDrawStrokeColor(excalidrawRef?.getAppState()?.currentItemDrawStrokeColor);
                        setDrawStrokeWidth(excalidrawRef?.getAppState()?.currentItemDrawStrokeWidth);
                        const rgba = hexToRgba(excalidrawRef?.getAppState()?.currentItemDrawStrokeColor)
                        setDrawTransparent(Math.floor(rgba.a * 100));
                    }} style={{background: (freeDrawToolName == 'freedraw') ? COLOR_E5E5E5() : COLOR_TRANSPARENT}}>
                        <img className='img-20' color={DEFAULT_IMAGE_COLOR}
                             src={getImagePathWithTheme('tool_draw_freedraw_1')}/>
                    </div>
                </Tooltip>

                <Tooltip arrow={false} title={<div>{t("Highlighter")}<span
                    className={'tooltip-shortcut-key'}>{getCtrlOrAltCmd('Ctrl+P')}</span></div>}>
                    <div onClick={() => {
                        onDrawIconClickEvent("highlighter")
                        setDrawStrokeColor(excalidrawRef?.getAppState()?.currentItemHighlightStrokeColor);
                        setDrawStrokeWidth(excalidrawRef?.getAppState()?.currentItemHighlightStrokeWidth);
                        const rgba = hexToRgba(excalidrawRef?.getAppState()?.currentItemHighlightStrokeColor)
                        setDrawTransparent(Math.floor(rgba.a * 100));
                    }} style={{background: (freeDrawToolName === 'highlighter') ? COLOR_E5E5E5() : COLOR_TRANSPARENT}}>
                        <img className='img-20' style={{width: '21px', height: '21px'}} color={DEFAULT_IMAGE_COLOR}
                             src={getImagePathWithTheme('tool_draw_highdraw_1')}/>
                    </div>
                </Tooltip>

                <Tooltip arrow={false} title={<div>{t("Eraser")}<span
                    className={'tooltip-shortcut-key'}>{getCtrlOrAltCmd('Ctrl+R')}</span></div>}>
                    <div onClick={() => {
                        onDrawIconClickEvent("eraser")
                    }} style={{background: (freeDrawToolName === 'eraser') ? COLOR_E5E5E5() : COLOR_TRANSPARENT}}>
                        <img className='img-20' color={DEFAULT_IMAGE_COLOR}
                             src={getImagePathWithTheme('tool_draw_erase_1')}/>
                    </div>
                </Tooltip>

                {/*绘制颜色*/}
                <Popover trigger={"click"} placement={"bottom"}
                         arrow={false}
                         forceRender={true}
                         overlayStyle={{top: '116px'}}
                         open={isShowDrawStrokeColor}
                         onOpenChange={(e) => setIsShowDrawStrokeColor(e)}
                         content={<ColorChoose onColorClicked={(szHexColor: string, isClosePopover: boolean) => {
                             if (isClosePopover) {
                                 setIsShowDrawStrokeColor(false);
                             }
                             setDrawStrokeColor(szHexColor);

                             let itemStrokeColor: any = {
                                 currentItemDrawStrokeColor: szHexColor
                             }
                             if (excalidrawRef?.getAppState()?.activeTool?.type == 'highlighter') {
                                 itemStrokeColor = {
                                     currentItemHighlightStrokeColor: szHexColor
                                 };
                             }

                             excalidrawRef?.getApp()?.updateScene({
                                 appState: {
                                     ...excalidrawRef?.getAppState(),
                                     ...itemStrokeColor
                                 }
                             })
                         }}/>}>
                    <div>
                        <div style={{
                            width: '20px',
                            height: '20px',
                            marginLeft: '3px',
                            background: drawStrokeColor,
                            borderRadius: '3px'
                        }}></div>
                    </div>
                </Popover>

                {/*绘制边框样式*/}
                <Popover trigger={"click"} placement={"bottom"}
                         arrow={false}
                         forceRender={true}
                         open={isShowDrawStyle}
                         overlayStyle={{top: '104px'}}
                         onOpenChange={(e) => setIsShowDrawStyle(e)} content={renderDrawStrokeStyle()}>
                    <div>
                        <img className='img-30' src={getImagePathWithTheme('tool_stroke_style')}/>
                    </div>
                </Popover>

            </div>
        )
    }

    /**
     * 渲染iframe的弹出菜单
     */
    function renderFramePopover() {
        return (
            <div className='div-tool-style font-size-12'>
                {
                    ARRAY_IFRAME_SIZE.map(p => (
                        <div key={p.id} data-id={p.id} className='flex-row-vertical-center hovered-filter-img'
                             onClick={() => onFrameToolsClick(p)}>
                            <img className='img-16' src={getImagePathWithTheme(p.imageName.replaceAll(".png", ""))}/>
                            <span style={{flexGrow: '1'}}>{p.id == 'Custom Size'?t("Custom Size"):p.title}</span>
                        </div>
                    ))
                }
            </div>
        )
    }

    /**
     * 渲染image的弹出
     */
    function renderImagePopover() {
        return (
            <ChooseImage onOkClicked={(obj: any) => {
                if (mIsImagePopoverOpen){
                    setIsImagePopoverOpen(false);
                    const fileImportMode = getFileImportMode();
                    global.g_insertMode = fileImportMode;

                    if (fileImportMode == IMPORT_FILE_MODE_ASKME) {
                        window.showDialogFileImportDrag((szAction) => {
                            global.g_insertMode = szAction;
                            if (obj.action == 'uploadImage') {
                                excalidrawRef.onSetActiveTool('image');
                                setActivityTool('image');
                            } else if (obj.action == 'base64') {
                                excalidrawRef?.getApp()?.insertBase64ImageElement(obj.base64Image);
                            } else if (obj.action == 'file') {
                                // excalidrawRef.getApp().insertImageElementWithCursor(obj.file);

                                let reader = new FileReader();
                                reader.onload = (e => {
                                    excalidrawRef?.getApp()?.insertBase64ImageElement(e.target?.result,szAction,obj.file.path);
                                })
                                reader.readAsDataURL(obj.file)
                            }
                        })
                    }else{
                        if (obj.action == 'uploadImage') {
                            excalidrawRef.onSetActiveTool('image');
                            setActivityTool('image');
                        } else if (obj.action == 'base64') {
                            excalidrawRef?.getApp()?.insertBase64ImageElement(obj.base64Image);
                        } else if (obj.action == 'file') {
                            // excalidrawRef.getApp().insertImageElementWithCursor(obj.file);

                            let reader = new FileReader();
                            reader.onload = (e => {
                                excalidrawRef?.getApp()?.insertBase64ImageElement(e.target?.result,IMPORT_FILE_MODE_IMPORTMODE,obj.file.path);
                            })
                            reader.readAsDataURL(obj.file)
                        }
                    }
                }

            }} onCancelClicked={() => {
            }}/>
        )
    }

    function renderStickyNotes(){
        const arrayStickNotes = [
            {
                id:'stickyNotes1',
                image:'sticky_notes_1',
                color:'#FDF59D'//'#FCF9BC'
            },
            {
                id:'stickyNotes2',
                image:'sticky_notes_2',
                color:'#FDE76D'//'#FFDA00'
            },
            {
                id:'stickyNotes3',
                image:'sticky_notes_3',
                color:'#FFB271'//'#FFDFBD'
            },
            {
                id:'stickyNotes4',
                image:'sticky_notes_4',
                color:'#FF9898'//'#FFC8C7'
            },
            {
                id:'stickyNotes5',
                image:'sticky_notes_5',
                color:'#FFD2F2'//'#DC8989'
            },
            {
                id:'stickyNotes6',
                image:'sticky_notes_6',
                color:'#D1F09F'//'#CCF0CC'
            },
            {
                id:'stickyNotes7',
                image:'sticky_notes_7',
                color:'#B2D0FE'//'#CADFFF'
            },
            {
                id:'stickyNotes8',
                image:'sticky_notes_8',
                color:'#B4A7FB'//'#F6E9FC'
            },
            {
                id:'stickyNotes9',
                image:'sticky_notes_9',
                color:'#D8D8D8'
            },
            {
                id:'stickyNotes10',
                image:'sticky_notes_10',
                color:'#FFFFFF'
            }
        ]
        return(
            <div style={{display: 'grid', gridTemplateColumns: 'repeat(5,1fr)', gap: '23px 8px',paddingTop:'12px'}}>
                {
                    arrayStickNotes.map(p => {
                        return (
                            <div key={p.id} className={'flex-center cursor-pointer'} onClick={()=>{
                                setIsStickyNotesOpen(false);
                                localStorage.setItem('stickyColor',p.color);
                                localStorage.setItem(KEY_DEFAULT_STICKYNOTE_BACKGROUND_COLOR,p.color);
                                excalidrawRef.onSetActiveTool('stickyNotes');
                                const canvas = document.getElementById('canvas');
                                if (canvas) {
                                    setCursor(canvas, `url(${getImagePath(p.image)}) 22 22, auto`)
                                }
                            }}>
                                <img style={{width: '40px', height: '40px'}} src={getImagePath(p.image)}/>
                            </div>
                        )
                    })
                }
            </div>
        )
    }


    //渲染工具栏
    function renderToolButtons() {
        var arrayNew = [];
        for (var i = 0; i < toolButtons.length; i++) {
            var p = toolButtons[i];
            if (p.id == 'element') {
                arrayNew.push(
                    <Popover
                        key={p.id}
                        placement={"bottom"}
                        overlayStyle={{top: DRAW_TOOLS_HEIGHT}}
                        content={renderToolPopoverElements()}
                        title=""
                        arrow={true}
                        showArrow={true}
                        trigger="click"
                        onOpenChange={(e) => {
                            setElementPopoverOpen(e);
                            if (e) {
                                mSvgPageNum = 1;
                                setSvgSearchKey('');
                                setArraySvgData([...Global.g_arraySvg.slice(0, PAGE_SIZE)]);
                            }
                        }}
                        open={elementPopoverOpen}>
                        <div data-id={p.id}
                             style={toolButtonItemStyle}
                             className={p.isActive ? 'tool-button-active' : 'tool-button' + " default-font-size"}
                             onClick={toolsClicked}>

                            <Tooltip placement="bottom" overlayClassName='font-size-12' title={p.title} arrow={true}>
                                <img className='img-32' src={getImagePathWithTheme(p.imageName)}/>
                            </Tooltip>
                            {/*<span>{p.title}</span>*/}
                        </div>
                    </Popover>
                )
            } else if (p.id === 'embeddable-1') {
                arrayNew.push(
                    <Popover key={p.id}
                             arrow={true}
                             placement={"bottom"}
                             overlayStyle={{top: DRAW_TOOLS_HEIGHT}}
                             trigger='click'
                             onOpenChange={(e) => setEmbedPopoverOpen(e)}
                             open={embedPopoverOpen}
                             content={renderEmbedPopoverElements()}
                    >
                        <div data-id={p.id}
                             style={toolButtonItemStyle}
                             className={p.isActive ? 'tool-button-active' : 'tool-button'}
                             onClick={toolsClicked}>
                            <Tooltip placement="bottom" overlayClassName='font-size-12' title={p.title} arrow={true}>
                                <img className='img-32' src={getImagePathWithTheme(p.imageName)}/>
                            </Tooltip>
                            {/*<span>{p.title}</span>*/}
                        </div>
                    </Popover>
                )
            } else if (p.id === 'style') {
                arrayNew.push(
                    <Popover key={p.id}
                             arrow={true}
                             placement={"bottom"}
                             overlayStyle={{top: DRAW_TOOLS_HEIGHT}}
                             onOpenChange={(e) => setStylePopoverOpen(e)}
                             open={stylePopoverOpen}
                             trigger={'click'}
                             content={renderStylePopover()}
                    >
                        <div data-id={p.id}
                             style={toolButtonItemStyle}
                             className={p.isActive ? 'tool-button-active' : 'tool-button'}
                             onClick={toolsClicked}>
                            <Tooltip placement="bottom" overlayClassName='font-size-12' title={p.title} arrow={true}>
                                <img className='img-32' src={getImagePathWithTheme(p.imageName)}/>
                            </Tooltip>
                            {/*<span>{p.title}</span>*/}
                        </div>
                    </Popover>
                )
            } else if (p.id === 'draw') {
                arrayNew.push(
                    <Popover key={p.id}
                             arrow={true}
                             placement={"bottom"}
                             overlayStyle={{top: DRAW_TOOLS_HEIGHT}}
                             onOpenChange={(e) => setDrawPopoverOpen(e)}
                             open={drawPopoverOpen}
                             trigger={'click'}
                             content={renderDrawPopoverNew()}
                    >
                        <div data-id={p.id}
                             style={toolButtonItemStyle}
                             className={p.isActive ? 'tool-button-active' : 'tool-button'}
                             onClick={toolsClicked}>
                            <Tooltip placement="bottom" overlayClassName='font-size-12' title={<div>{p.title}<span className={'tooltip-shortcut-key'}>{getCtrlOrAlt("P")}</span></div>}
                                     arrow={true}>
                                <img className='img-32' src={getImagePathWithTheme(p.imageName)}/>
                            </Tooltip>
                            {/*<span>{p.title}</span>*/}
                        </div>
                    </Popover>
                )
            } else if (p.id == 'frame') {
                arrayNew.push(
                    <Popover key={p.id}
                             arrow={true}
                             placement={"bottom"}
                             overlayStyle={{top: DRAW_TOOLS_HEIGHT}}
                             onOpenChange={(e) => setIsFramePopoverOpen(e)}
                             open={isFramePopoverOpen}
                             trigger={'click'}
                             content={renderFramePopover()}
                    >
                        <div data-id={p.id}
                             style={toolButtonItemStyle}
                             className={p.isActive ? 'tool-button-active' : 'tool-button'}
                             onClick={toolsClicked}>
                            <Tooltip placement="bottom" overlayClassName='font-size-12' title={<div>{p.title}<span
                                className={'tooltip-shortcut-key'}>{getCtrlOrAlt("F")}</span></div>}
                                     arrow={true}>
                                <img className='img-32' src={getImagePathWithTheme(p.imageName)}/>
                            </Tooltip>
                            {/*<span>{p.title}</span>*/}
                        </div>
                    </Popover>
                )
            } else if (p.id == 'file') {
                arrayNew.push(
                    <Popover key={p.id}
                             arrow={true}
                             placement={"bottom"}
                             overlayStyle={{top: DRAW_TOOLS_HEIGHT}}
                             trigger='click'
                             onOpenChange={(e) => {
                                 // if (!hasLicense()) {
                                 //     showDesktopPro(DESKTOP_PRO_FROM_IMPORT_FILE);
                                 // }else {
                                 //     setFilePopoverOpen(e)
                                 // }
                                 setFilePopoverOpen(e)
                             }}
                             open={filePopoverOpen}
                             content={renderFileChooseNew()}
                    >
                        <div data-id={p.id}
                             style={toolButtonItemStyle}
                             className={p.isActive ? 'tool-button-active' : 'tool-button'}
                             onClick={(event)=>{
                                 if (isWeb()) {
                                     setFilePopoverOpen(false);
                                     window.showTipNotSupportWebOfflineVersion();
                                     return;
                                 }
                                 toolsClicked(event);
                             }}>
                            <Tooltip placement="bottom" overlayClassName='font-size-12' title={p.title} arrow={true}>
                                <div className='flex-center' style={{height: '100%', position: 'relative'}}>
                                    <img className='img-32' src={getImagePathWithTheme(p.imageName)}/>
                                    {
                                        // !hasLicense() &&
                                        // <img style={{
                                        //     position: "absolute",
                                        //     right: '-8px',
                                        //     top: '-8px',
                                        //     pointerEvents: 'none',
                                        //     background:'transparent'
                                        // }} className='img-18' src={imgPathPerfix() + "vip.png"}/>
                                    }

                                </div>

                            </Tooltip>
                            {/*<span>{p.title}</span>*/}
                        </div>
                    </Popover>
                )
            } else if (p.id == 'image') {
                arrayNew.push(
                    <Popover key={p.id}
                             arrow={true}
                             placement={"bottom"}
                             overlayStyle={{top: DRAW_TOOLS_HEIGHT, width: '334px'}}
                             overlayInnerStyle={{height: '266px',padding: '0px'}}
                             onOpenChange={(e) => setIsImagePopoverOpen(e)}
                             open={isImagePopoverOpen}
                             trigger={'click'}
                             content={renderImagePopover()}
                    >
                        <div data-id={p.id}
                             style={toolButtonItemStyle}
                             className={p.isActive ? 'tool-button-active' : 'tool-button'}>
                            <Tooltip placement="bottom" overlayClassName='font-size-12' title={p.title} arrow={true}>
                                <img className='img-32' src={getImagePathWithTheme(p.imageName)}/>
                            </Tooltip>
                        </div>
                    </Popover>
                )
            } else if (p.id == 'stickyNotes'){
                arrayNew.push(
                    <Popover key={p.id}
                             arrow={true}
                             placement={"bottom"}
                             overlayStyle={{top: DRAW_TOOLS_HEIGHT, width: '340px'}}
                             overlayInnerStyle={{height: '148px',}}
                             onOpenChange={(e) => setIsStickyNotesOpen(e)}
                             open={isStickyNotesOpen}
                             trigger={'click'}
                             content={renderStickyNotes()}
                    >
                        <div data-id={p.id}
                             style={toolButtonItemStyle}
                             className={p.isActive ? 'tool-button-active' : 'tool-button'}>
                            <Tooltip placement="bottom" overlayClassName='font-size-12' title={<div>{p.title}<span
                                className={'tooltip-shortcut-key'}>{getCtrlOrAlt("S")}</span></div>} arrow={true}>
                                <img className='img-32' data-id={p.id} src={getImagePathWithTheme(p.imageName)} onClick={async (e)=>{
                                    const hasBeyond = await hasBeyondTextLimit();
                                    if (hasBeyond) {
                                        e.stopPropagation();
                                        setIsStickyNotesOpen(false);
                                        return;
                                    }
                                    toolsClicked({currentTarget:{dataset:{id:'stickyNotes'}}});
                                }}/>
                            </Tooltip>
                        </div>
                    </Popover>
                )
            }
            else {
                arrayNew.push(<div key={p.id} data-id={p.id}
                                   style={toolButtonItemStyle}
                                   className={p.isActive ? 'tool-button-active' : 'tool-button' + " default-font-size"}
                                   onClick={toolsClicked}>
                    <Tooltip placement="bottom" overlayClassName='font-size-12' title={<div>{p.title}<span style={{marginLeft:p.shortcut?'10px':'0px'}} className={'tooltip-shortcut-key'}>{getCtrlOrAlt(p.shortcut || '')}</span></div>} arrow={true}>
                        <img className='img-32' src={getImagePathWithTheme(p.imageName)}/>
                    </Tooltip>
                    {/*<span>{p.title}</span>*/}
                </div>)
            }
        }
        return (
            <>
                <ConfigProvider
                    theme={{
                        components: {
                            Button: {
                                /* 这里是你的组件 token */
                            },
                        },
                    }}
                >
                    {arrayNew}
                </ConfigProvider>

            </>
        )
    }

    /**
     * Style工具点击
     * @param szMenu
     */
    function onToolStyleEvent(szMenu) {
        var arrayNew = [...toolButtons];
        arrayNew.forEach(p => {
            p.isActive = false;
        });
        setToolButtons(arrayNew);

        if ("pageColor" == szMenu) {
            setStylePopoverOpen(false);
            dialogColorChooseRef.current?.onShowDialog(excalidrawRef?.getAppState()?.viewBackgroundColor, excalidrawRef?.getAppState());
        } else if ("pageSize" == szMenu) {

        } else if ("showGrid" == szMenu) {
            setStylePopoverOpen(false);
            excalidrawRef.showGrid(!excalidrawRef.iShowGrid());
        }
    }

    /**
     * pagesize工具
     * @param szMenu
     */
    function onToolStylePageSizeMenuEvent(e) {
        var szId = e.currentTarget.dataset.id;
        var item = arrayPageSizeMenu.filter(p => p.label === szId)[0];
        setStylePageSizePopoverOpen(false)

        nTimeoutId = setTimeout(() => {
            setStylePopoverOpen(false);
        }, 100);
        mArrayTimeoutIds.current.push(nTimeoutId);

        if (item.id === 'custom') {
            const pageSize = excalidrawRef?.getAppState()?.pageSizeValues;
            mPageSizeType = "canvas";
            dialogPageSizeRef?.current.onShowDialog(pageSize?.width, pageSize?.height);
        } else if (item.id === 'whiteboard') {
            excalidrawRef.onSetPageSize({type: 'infinite', id: 'whiteboard'})
        } else {
            let w = 0, h = 0;
            if (item.id === 'a4') {
                //210 297
                h = 1920;
                w = h / 297 * 210;
            } else if (item.id == 'letter') {
                //216 280
                h = 1920;
                w = h / 280 * 216;
            } else {
                const arraySizes = item.size.replace("px", '').split('*');
                if (arraySizes.length == 2) {
                    w = arraySizes[0];
                    h = arraySizes[1];
                }
            }

            if (w > 0 && h > 0) {
                excalidrawRef.onSetPageSize({type: "custom", width: w, height: h, id: item.id})
            }
        }
    }

    function onCustomPageSize(width: number, height: number) {
        if (mPageSizeType == "canvas") {
            excalidrawRef.onSetPageSize({type: "custom", width: width, height: height, id: 'custom'});
        } else {
            excalidrawRef.onSetFrameSize({type: "custom", width: width, height: height});
            excalidrawRef.onSetActiveTool("frame");
        }
    }

    //设置背景色
    function setCanvasBackgroundColor(value: any, hex: string, isAllPage: boolean) {
        excalidrawRef?.onSetBackground(hex);
        setCanvasBackground(hex);
        if (isAllPage) {//all page backgroundcolor
            mAllCanvasBackground = hex;
        }
        //设置别的页面的background
        leftMenuRef.current.onUpdateAllCanvasBackground(hex, isAllPage);
    }

    //设置展示模式
    function setDisplayMode(displayMode: DisplayMode) {
        if (displayMode === "preview") {
            onUpdatePresentUIElement();
            if (excalidrawRef.getApp().getFrameElementCount() == 0) {
                message.info('No frame exists')
                return;
            }
            setIsPresentMode(true);
            nTimeoutId = setTimeout(() => {
                excalidrawRef?.onSetDisplayMode("preview");
                excalidrawRef?.onUpdateDisplaySize(isFullScreen);
            }, 100);
            mArrayTimeoutIds.current.push(nTimeoutId);
        } else {
            Global.g_isPresentMode = false;
            excalidrawRef.onSetDisplayMode("edit");
        }
    }

    /**
     * 本地加载
     */
    async function onOpenFromLocalfile() {
        // const file = await fileOpen({
        //     description: "Muenzo file",
        //     extensions: Object.keys(
        //         IMAGE_MIME_TYPES,
        //     ) as (keyof typeof IMAGE_MIME_TYPES)[],
        // });
        // var fileReader = new FileReader();
        // fileReader.onload = (e)=>{
        //     const szJsonStr:string = (e.target.result);
        //     params.state.usr = {};
        //     params.state.usr.importNoteData = JSON.parse(szJsonStr);
        //     onLoadData(false);
        //     //要保存一次..
        //     setTimeout(()=>{
        //         saveNotes();
        //     },2000);
        // }
        // fileReader.readAsText(file,'utf-8');

        openPcanvasFile();
    }

    //undo
    function undo() {
        // document.getElementById("undo")?.click();
        // excalidrawRef.getApp()?.getHistory().undoOnce();
        excalidrawRef.onUndo();
    }

    //redo
    function redo() {
        // document.getElementById("redo")?.click();
        excalidrawRef.onRedo();
    }

    function zoomSize(isAdd: any, fPercent: any = 0) {
        setIsPopoverZoomVisible(false)
        const fZoomValue = excalidrawRef.zoomFix(isAdd, fPercent);
        setInputZoom(Math.floor(fZoomValue * 100) + '%')
        global.g_canvasZoomValue = fZoomValue;
    }

    /**
     * 从card library中替换notes.
     * @param pageData
     */
    const replaceNotesFromLibrary = async (pageData: any) => {
        if (!pageData.notes) return;

        for (let i = 0; i < pageData.notes.length; i++) {
            const card = await getCardById(pageData.notes[i].key);
            if (card) {
                pageData.notes[i].title = card.name;
                pageData.notes[i].editValue = card.name;
                pageData.notes[i].noteDataDoc = card.doc;
            }
        }
    }

    /**
     * 旧的导入图片，以文件方式保存在本地
     * @param pageDatas
     */
    const saveOldImportImageToLocalFile = async (pageDatas:any)=>{
        for (let i=0;i<pageDatas.canvas.length;i++){
            const item = pageDatas.canvas[i];
            if (!item.drawJson)continue;
            const files = item.drawJson.files;
            if (!files)continue;
            const arrayFiles = Object.values(files);
            for (let j=0;j<arrayFiles.length;j++){
                const value:any = arrayFiles[j];
                if(value.dataURL && !isSvg(value.mimeType)){
                    const szFileName = value.id + "."+extFromMineType(value.mimeType);
                    const arraySplits = value.dataURL.split(',');
                    if (arraySplits.length > 1){
                        const arrayFiles = [{fileName:szFileName,data:arraySplits[1]}]
                        await ipcInvoke('write-base64-files',JSON.stringify(arrayFiles));
                    }
                    value.dataURL = '';//置空.
                }
            }
        }
    }

    /**
     * 从集合中找一个...
     */
    const getLibraryItem = (arrayLibrarys,id)=>{
        return arrayLibrarys.find(p=>p?.id == id);
    }

    const bulkGetLibrary = (arrayLibraryIds,arrayNoteIds)=>{
        const promises = [getCardByIds(arrayLibraryIds),getCardDocByIds(arrayNoteIds)]
        return Promise.all(promises);
    }

    const arrayDistinct = (arrayStrs)=>{
        return [...new Set(arrayStrs)]; // 或 Array.from(new Set(arr))
    }

    /**
     * 加载笔记元素
     * @param pageData
     */
    const loadNotesElement = async (pageData: any,isImport=false) => {
        let nTime = Date.now();

        // await replaceNotesFromLibrary(pageData);
        if (!isArray(pageData.notes)){
            pageData.notes = [];
        }
        const arrayAllElements:any = [];
        const arrayLibraryIds:any = [];
        loopAllNode(pageData.canvas,(item)=>{
            if (!item.isFolder && item.drawJson?.elements){
                arrayAllElements.push(...item.drawJson.elements);

                //如果画布上有，但是notes没有，反向存过来..
                for (let j=0;j<item.drawJson.elements.length;j++){
                    const element = item.drawJson.elements[j];

                    //将所有涉及到的library的id加进来
                    if (element.customData?.generationData?.pdfData?.id){//pdf-card 注记
                        arrayLibraryIds.push(element.customData?.generationData?.pdfData?.id);
                    }
                    if (element.customData?.generationData?.id){//正常的 file/card/video/audio/pdf
                        arrayLibraryIds.push(element.customData?.generationData?.id);
                    }
                    if (element.customData?.generationData?.videoData?.id){//正常的 file/card/video/audio/pdf
                        arrayLibraryIds.push(element.customData?.generationData?.videoData?.id);
                    }
                    //end.....

                    if (isNoteElement(element)){
                        //这里直接替换掉原来的边框宽度，换来换去的，又兼容来兼容去的，搞不了这种判断.
                        if (element.strokeColor == '#EFEFEF' && element.strokeWidth == 1){
                            element.strokeWidth = 2.2;
                        }
                        if (!pageData.notes.some(p=>p.key == element.id || p.key == element.customData?.generationData?.id)){
                            //画布上有，但是notes列表不存在...重新加进来
                            const itemNew = {
                                title:element.customData?.generationData?.name || '',
                                editValue:element.customData?.generationData?.name || '',
                                key:element.customData?.generationData?.id || element.id,
                                icon:'',
                                isFolder:false,
                                isEditable:false,
                                children:[]
                            }
                            pageData.notes.push(itemNew);
                        }
                    }
                }
            }
        })

        /*
        for (let i = 0; i < pageData.canvas.length; i++) {
            const item = pageData.canvas[i];
            if (item.drawJson.elements){
                arrayAllElements.push(...item.drawJson.elements);

                //如果画布上有，但是notes没有，反向存过来..
                for (let j=0;j<item.drawJson.elements.length;j++){
                    const element = item.drawJson.elements[j];

                    //将所有涉及到的library的id加进来
                    if (element.customData?.generationData?.pdfData?.id){//pdf-card 注记
                        arrayLibraryIds.push(element.customData?.generationData?.pdfData?.id);
                    }else if (element.customData?.generationData?.id){//正常的 file/card/video/audio/pdf
                        arrayLibraryIds.push(element.customData?.generationData?.id);
                    }
                    //end.....

                    if (isNoteElement(element)){
                        if (!pageData.notes.some(p=>p.key == element.id || p.key == element.customData?.generationData?.id)){
                            //画布上有，但是notes列表不存在...重新加进来
                            const itemNew = {
                                title:element.customData?.generationData?.name || '',
                                editValue:element.customData?.generationData?.name || '',
                                key:element.customData?.generationData?.id || element.id,
                                icon:'',
                                isFolder:false,
                                isEditable:false,
                                children:[]
                            }
                            pageData.notes.push(itemNew);
                        }
                    }
                }
            }
        }
         */


        const arrayNoteIds = [];
        for (let i=0;i<pageData.notes.length;i++){
            arrayNoteIds.push(pageData.notes[i].key);
        }
        // const arrayLibrarys = await getCardByIds(arrayLibraryIds);
        // const arrayCardDocs = await getCardDocByIds(arrayNoteIds);
        const arrayResults = await bulkGetLibrary(arrayDistinct(arrayLibraryIds),arrayDistinct(arrayNoteIds));
        const arrayLibrarys = arrayResults[0];
        const arrayCardDocs = arrayResults[1];

        // console.log('loadNotesElement-bulkGet:',(Date.now() - nTime));

        //这里删除，空白的卡片...
        if (isArray(pageData.notes)){
            //去重.
            const arrayNewNotes = [];
            for (let n = 0;n<pageData.notes.length;n++){
                if (!arrayNewNotes.some(p=>p.key == pageData.notes[n].key)){
                    arrayNewNotes.push(pageData.notes[n]);
                }
            }

            pageData.notes = arrayNewNotes;

            for (let k=(pageData.notes.length-1);k>=0;k--){
                // const card = await getCardById(pageData.notes[k].key);
                const card = arrayLibrarys.find(p=>p?.id == pageData.notes[k].key)//await getCardById(pageData.notes[k].key);
                const isInCard = arrayAllElements.some(p=>p.id == card?.id || p.customData?.generationData?.id == card?.id)
                if (card){
                    pageData.notes[k].title = card.name;
                    pageData.notes[k].editValue = card.name;
                    // pageData.notes[i].noteDataDoc = card.doc;

                    if (card.type != 'card' || card.isDeleted == 1 || (isCardEmptyCard(card) && !isInCard)){
                        pageData.notes.splice(k,1);
                    }
                }
            }
        }

        // console.log('loadNotesElement-clear-test:',(Date.now() - nTime));

        await loopAllNodeAsync(pageData.canvas, (async (item)=>{
            if (item.drawJson?.elements){
                await loadElementNotes(item.drawJson.elements, pageData.notes,arrayLibrarys,arrayCardDocs, isImport);
            }
            if (isArray(item.subNotes)){
                item.subNotes.forEach(p=>{
                    p.noteDataDoc = '';
                })
            }
        }))

        // for (let i = 0; i < pageData.canvas.length; i++) {
        //     const item = pageData.canvas[i];
        //
        //     if (item.isFolder) {
        //         for (let j = 0; j < item.children.length; j++) {
        //             const subItem = item.children[j];
        //             await loadElementNotes(subItem.drawJson.elements, pageData.notes,arrayLibrarys,arrayCardDocs, isImport);
        //         }
        //     } else {
        //         await loadElementNotes(item.drawJson.elements, pageData.notes,arrayLibrarys,arrayCardDocs, isImport);
        //     }
        //     if (isArray(item.subNotes)){
        //         item.subNotes.forEach(p=>{
        //             p.noteDataDoc = '';
        //         })
        //     }
        // }
        // console.log('loadNotesElement-end:',(Date.now() - nTime));
        return 'ok'
    }

    /**
     * 加载元素中的笔记
     * @param elements
     * @param notes
     */
    const loadElementNotes = async (elements: any, notes: any,arrayLibrarys:any,arrayCardDocs:any, isImport=false) => {
        if (!elements) return;
        for (let i = 0; i < elements.length; i++) {
            let item = elements[i];
            if (item.x == undefined || item.x == null || item.y == undefined || item.y == null){
                item.isDeleted = true;
            }

            if ((item.type == 'iframe' || (item.type == 'embeddable' && item.embedType == 'text') || item.type == 'image') && ('customData' in item)) {
                if (item.type == 'image'){
                    item.status = '';//这里，是为了显示名称，新插入的图片会保持status = pending....   兼容旧的要消除这个状态
                }
                if (item.customData?.generationData?.type == 'pdfAnno'  || isCardAnnoElement(item)) {
                    //去library查看有没有
                    const pdfAnno = arrayLibrarys.find(p=>p?.id == item.customData.generationData.pdfData.id);//await getCardById(item.customData.generationData.pdfData.id);
                    if (pdfAnno){
                        item.customData.generationData.pdfData.comment = pdfAnno.comment;
                        if (item.customData.generationData.pdfData.type == 'image'){
                            item.customData.generationData.pdfData.image = pdfAnno.thumbImage;
                        }
                        if (isCardAnnoElement(item)){
                            item.customData.generationData.pdfData = pdfAnno;
                        }

                        if (pdfAnno.isDeleted == 1){
                            item.isDeleted = true;
                        }
                    }else{
                        //库里没有了。删除.
                        item.isDeleted = true;
                    }
                    //pdf注记
                    if (isPdfAnnoElement(item)){
                        item.customData.generationData.html = createPdfAnnoTextElement(item.customData.generationData.pdfData);
                    }
                }
                else {
                    if (isFileElement(item)){
                        //文件...判断文件是否存在
                        const library = arrayLibrarys.find(p=>p?.id == item.customData.generationData.id);//await getCardById(item.customData?.generationData?.id);
                        if (library){
                            item.customData.generationData.fileName = library.fileName;
                            if (isSupportVideoAnnoUrl(library.fileName)){
                                //视频被换成了在线的所支持的视频？？？？乱换--各种都能换.
                                item.type = 'embeddable';
                                item.link = library.fileName;
                            }
                            item.customData.generationData.type = library.type;
                        }
                        if (item.customData.generationData?.isAbsolutePath){
                            item.customData.generationData.isFileExist = await ipcInvoke('is-file-exist',{filePath:item.customData.generationData.fileName})
                        }
                    }

                    if (isAudioFileElement(item)){
                        //音频重新调整下大小
                        const fRate = item.width/item.height;
                        const fRate1 = DEFAULT_AUDIO_WIDTH/DEFAULT_AUDIO_HEIGHT;
                        if (fRate.toFixed(1) != fRate1.toFixed(1)){
                            item.width = DEFAULT_AUDIO_WIDTH;
                            item.height = DEFAULT_AUDIO_HEIGHT;
                            item.roundness =  {
                                type:ROUNDNESS.ADAPTIVE_RADIUS,
                                value:8
                            };
                        }
                    }

                    if (isVideoAnnoElement(item) || isAudioAnnoElement(item)){
                        const lib = arrayLibrarys.find(p=>p?.id == item.customData.generationData?.videoData?.id);
                        if (lib){
                            if (lib.isDeleted == 1){
                                item.isDeleted = 1;
                            }
                        }
                    }

                    // const card: any = await getCardById(item.customData.generationData.id);
                    const card: any = arrayLibrarys.find(p=>p?.id == item.customData?.generationData?.id);//await getCardById(item.customData.generationData.id);
                    if (card) {
                        if (card.isDeleted == 1){
                            //已经被删除，标记删除...--注记元素除外。。注记取的是library的实体...
                            if (!isAnnoElement(item)){
                                item.isDeleted = true;
                            }
                        }

                        //region card
                        item.customData.generationData.id = card.id;
                        if (!isCardAnnoElement(item) && (card.type == 'card' || card.type == 'journal')) {
                            const cardDoc = arrayCardDocs.find(p=>p?.id == card.id);
                            if (cardDoc){
                                card.doc = cardDoc.doc;
                            }

                            item.customData.generationData.name = card.name;
                            // const arrayImgs = await imgServer.getImgFromSystem(card.doc);
                            item.customData.generationData.html = card.doc;//createNoteElementByNote(card.name,card.doc);
                            item.customData.generationData.type = 'note';
                            item.customData.generationData.isEditable = false;
                            item.customData.generationData.isHidden = card.isHidden;
                            item.customData.generationData.journalTime = card.journalTime;
                            item.customData.generationData.libraryType = card.type;
                            //重新调整卡片的最大高度-，调整原来的...
                            if (!item.customData.generationData.isFixedSize && item.height >= MAX_AUTO_CARD_EDIT_HEIGHT){
                                item.height = MAX_AUTO_CARD_EDIT_HEIGHT;
                            }
                            if (isDefaultBackgroundColor(item.backgroundColor)) {
                                item.backgroundColor = getNoteElementBackgroundColor()
                            }
                            if (card.isDeleted /*|| isCardEmptyCard(card)*/) {
                                //卡片删除，删除左侧
                                item.isDeleted = true;
                                for (let j = 0; j < notes.length; j++) {
                                    const note = notes[j];
                                    if (note.key == item.id || note.key == item.customData.generationData.id) {
                                        notes.splice(j, 1);
                                        break;
                                    }
                                }
                            }
                        } else {
                            if (isVideoAnnoElement(item) || isAudioAnnoElement(item)){
                                //从pdfhightlight 中更新这个notes
                                item.customData.generationData.videoName = card.name;
                            }else{
                                item.customData.generationData.name = card.name;
                                item.customData.generationData.fileName = card.fileName;
                                item.customData.generationData.html = createFileElementHtml(card.id, card.fileName, card.name, card.thumbImage);
                                item.customData.generationData.type = 'file';
                            }
                            //--文件类型的.给予名称
                            item.name = card.name;

                            if (isDefaultBackgroundColor(item.backgroundColor)) {
                                item.backgroundColor = getNoteElementBackgroundColor()
                            }
                            if (isFileVideoElement(item)){
                                if (isImport){
                                    //是导入的，
                                    if (item.videoNotes){
                                        //保存到数据库
                                        const highlight = {
                                            id:item.customData.generationData.id,
                                            type:'video',
                                            libraryId:item.customData?.generationData?.id,
                                            name:item.customData?.generationData?.showName,
                                            fileName:item.customData?.generationData?.fileName,
                                            data:item.videoNotes
                                        }
                                        updateHighlight(highlight);
                                    }
                                }else{
                                    //从数据库读取videoNotes
                                    // let highlight = await dbGetHighlight(item.id);
                                    // if (!highlight){
                                    //     highlight = await dbGetHighlight(item.customData?.generationData?.id);
                                    // }
                                    let highlight = arrayLibrarys.find(p=>p?.id == item.customData?.generationData?.id);
                                    if (!highlight){
                                        highlight = await dbGetHighlight(item.id);
                                    }

                                    if (highlight){
                                        item.videoNotes = highlight.data;
                                        videoCache.set(item.id,highlight.data);
                                    }else{
                                        //没有highlight...但是文件上带...
                                        if (item.videoNotes){
                                            //保存到数据库
                                            const highlight = {
                                                id:item.customData.generationData.id,
                                                type:'video',
                                                libraryId:item.customData?.generationData?.id,
                                                name:item.customData?.generationData?.showName,
                                                fileName:item.customData?.generationData?.fileName,
                                                data:item.videoNotes
                                            }
                                            updateHighlight(highlight);
                                        }
                                    }
                                }
                            }
                        }
                        //endregion
                    } else {
                        //没有card
                        if (isNoteElement(item)) {
                            for (let j = 0; j < notes.length; j++) {
                                const note = notes[j];
                                if (note.key == item.id || note.key == item.customData.generationData.id) {
                                    notes.splice(j, 1);
                                    break;
                                }
                            }
                            //element 也标记为删除
                            item.isDeleted = true;
                        }else if (isImageElement(item)){
                            if (item.customData?.generationData?.id){
                                //也标记为删除
                                item.isDeleted = true;
                            }
                        }
                    }
                }
            }else if (isEmbeddableElement(item) && isSupportVideoAnnoUrl(item.link)){
                if (isImport) {
                    //是导入的，

                    if (item.videoNotes) {
                        const src = getEmbedLink(toValidURL(item.link || ""));
                        //保存到数据库
                        const highlight = {
                            id:item.id,
                            url:item.link,
                            name:item.name || '',
                            data:item.videoNotes,
                            type:'youtube',
                            thumbImage:isYoutubeUrl(item.link)?getYoutubeThumbUrl(src?.videoId):''
                        }
                        updateHighlight(highlight);
                    }
                }else{
                    //从数据库读取videoNotes
                    // let highlight = await dbGetHighlight(item.id);
                    // if (!highlight){
                    //     highlight = await dbGetHighlight(item.customData?.generationData?.id);
                    // }
                    let highlight = arrayLibrarys.find(p=>p?.id == item.customData?.generationData?.id);
                    if (!highlight){
                        highlight = await dbGetHighlight(item.id);
                    }

                    if (highlight){
                        item.videoNotes = highlight.data;
                        videoCache.set(item.id,highlight.data);
                        if (highlight.isDeleted == 1){
                            item.isDeleted = true;
                        }
                    }else{
                        if (item.videoNotes) {
                            const src = getEmbedLink(toValidURL(item.link || ""));
                            //保存到数据库
                            const highlight = {
                                id:item.id,
                                url:item.link,
                                name:item.name || '',
                                data:item.videoNotes,
                                type:'youtube',
                                thumbImage:isYoutubeUrl(item.link)?getYoutubeThumbUrl(src?.videoId):''
                            }
                            updateHighlight(highlight);
                        }
                    }
                }
            }else if(isImageElement(item)){
                const library = await getCardById(item.customData?.generationData?.id);
                if (library){
                    item.name = library.name;
                    item.customData.generationData.originName = library.name;
                }
                item.status = '';
            }else if (isStickyNotesElement(item)){
                //重新读取html
                const tiptapDoc = await getTiptapDoc(item.id);
                if (tiptapDoc){
                    item.value = tiptapDoc.doc;
                }
                delete item.containerId;
            }else if (isTextElement(item)){
                //重新读取html
                const tiptapDoc = await getTiptapDoc(item.id);
                if (tiptapDoc){
                    item.value = tiptapDoc.doc;
                }
            }
        }
    }

    /**
     * 获取根据元素ID获取笔记
     * @param id
     * @param notes
     */
    const getElementNoteById = (id, notes) => {
        for (let i = 0; i < notes.length; i++) {
            const item = notes[i];
            if (item.isFolder) {
                for (let j = 0; j < item.children.length; j++) {
                    const subItem = item.children[j];
                    if (subItem.key == id) {
                        return subItem;
                    }
                }
            } else {
                if (item.key == id) {
                    return item;
                }
            }
        }
        return null;
    }


    /**
     * web的最近打开
     * @param arrayNotes
     */
    const refreshRecentlyMoreMenu = async (arrayNotes: any = undefined) => {
        if (arrayNotes == undefined) {
            arrayNotes = await getNoteList();
            arrayNotes.sort((a, b) => {
                return b.updateTime - a.updateTime;
            })
        }
        var arrayNewMenu = [...MENU_MORE_WEB];
        for (let i = 0; i < arrayNewMenu.length; i++) {
            let item = arrayNewMenu[i];
            if (item.key == 'openRecent') {
                let nCount = arrayNotes.length;
                if (nCount > 6) {
                    nCount = 6;
                }
                var arrayChildren = [];
                for (let j = 0; j < nCount; j++) {
                    let board = arrayNotes[j];
                    mTitle.current = board.name;
                    var newItem = getItem(board.name, board.id, null, null, undefined, (e) => {
                        if (params.state.usr == undefined) {
                            params.state.usr = {};
                        }
                        params.state.usr.noteData = {id: e.key};
                        onLoadData(false).then((res) => {
                            nTimeoutId = setTimeout(() => {
                                //保存一下
                                saveNotes(false, mTitle.current).then(async (r) => {
                                    nTimeoutId = setTimeout(() => {
                                        //刷新最近菜单....
                                        refreshRecentlyMoreMenu();
                                    }, 1000);
                                    mArrayTimeoutIds.current.push(nTimeoutId);
                                });
                            }, 1000);
                            mArrayTimeoutIds.current.push(nTimeoutId);
                        });
                    });
                    arrayChildren.push(newItem);
                }
                item.children = arrayChildren;
                arrayNewMenu.splice(i, 1, item);
                nTimeoutId = setTimeout(() => {
                    setArrayMenuMore(arrayNewMenu);
                }, 100);
                mArrayTimeoutIds.current.push(nTimeoutId);

                break;
            }
        }
    }

    /**
     * 这玩意不能写到 util里面》》》》》》
     * @param arrayElements
     */
    const s3ImageToLocalFile = async (arrayElements: any) => {
        const arrayImageElements = arrayElements.filter(p => p.type == 'image' && !p.extra?.svg);
        let arrayFiles = await downloadS3ImageToBase64(arrayImageElements);

        const arraySvgElements = arrayElements.filter(p => p.type == 'image' && p.extra?.svg);
        for (let i = 0; i < arraySvgElements.length; i++) {
            const element = arraySvgElements[i];
            const imageFile = new Blob([element.extra.svgText], {type: MIME_TYPES.svg});
            const szBase64 = await fileToBase64(imageFile);
            arrayFiles[element.fileId] = {
                mimeType: 'image/svg+xml',
                id: element.fileId,
                dataURL: szBase64,
                created: Date.now(),
                lastRetrieved: Date.now()
            }
        }

        return arrayFiles;
    }

    /**
     * 更新内部的URL链接....
     */
    const getLinkInfo = (linkInfo,pageDatas)=>{
        if (!linkInfo) {
            linkInfo = (params.state?.usr?.linkInfo);
        }
        if (!linkInfo && !urlParams.boardId && !params.state?.usr?.cardId){
            //不能是这些地方进来的...才能设置默认的.
            if (pageDatas?.info?.selectedBoardKey){
                linkInfo = {pageId:pageDatas.info.selectedBoardKey}
            }
        }

        //默认最后一个的...
        if (linkInfo && !linkInfo.pageId){
            linkInfo.pageId = pageDatas.info.selectedBoardKey;
        }

        //不是第一个board并且element为空可以再加载一次
        if (pageDatas && isArray(pageDatas.canvas) && pageDatas.canvas?.length > 0 && !params?.state?.usr?.forceRefresh){
            if (!linkInfo?.isLink && linkInfo?.pageId == pageDatas?.canvas[0].key && !linkInfo?.elementId){//linkInfo.isLink 这里跳转的链接不能置空
                linkInfo =null;
            }
        }
        if (!linkInfo){
            if (urlParams.boardId){//这个是前提...
                linkInfo = {};
                linkInfo.pageId = urlParams.boardId;

            }
            if (urlParams.elementId){
                linkInfo.elementId = urlParams.elementId;
            }
            if (urlParams.nodeId){
                linkInfo.nodeId = urlParams.nodeId;
            }
        }
        if (linkInfo){
            //这里额外处理，如果是文件夹的ID自动切换到该文件夹下的第一个board，如果文件夹下没有自动切换到第一个.
            loop(pageDatas.canvas,linkInfo.pageId,(node, i, data, parent)=>{
                if (node.isFolder){
                    if (node.children?.length > 0){
                        linkInfo.pageId = node.children[0].key;
                    }else{
                        //取第一个.
                        let isOk = false;
                        loopAllNode(pageDatas.canvas,(item)=>{
                            if (!isOk && item.drawJson?.elements){
                                linkInfo.pageId = item.key;
                                isOk = true;
                            }
                        })
                    }
                }
            })

            if (params.state?.usr?.searchKey){
                //如果带搜索进来的，禁止跳转
                // linkInfo.pageId = '';
            }
        }
        return linkInfo;
    }

    /**
     * @param isAutoLoading true表示自动从数据库加载...  否则不用
     */
    const onLoadData = async (isAutoLoading = true, linkInfo: any = null) => {
        let lTime = Date.now();
        console.log('3.onloadData....***********');
        if (!leftMenuRef.current)return;
        mNoteData.current = null;
        mExportInfos = undefined;
        mFirstBase64Capture = '';
        mInitDatas = '';
        mSaveTimes = 0;
        mThumbUrl = '';
        mAllCanvasBackground = DEFAULT_CANVAS_BACKGROUND;
        Global.g_currentPageData = {};
        let pageDatas:any;
        mViewTime = undefined;
        //WEB的---离线画布这个不能要。。。。是全量的。不是只一个画布!!!!  20250115
        // if (APP_WEB_WWW && isAutoLoading && !import.meta.env.DEV) {
        //     const arrayNotes: any = await getNoteList();
        //     setIsWebAlphaVisible(arrayNotes.length == 0);
        //     if (arrayNotes.length > 0) {
        //         //desc... get last one
        //         arrayNotes.sort((a, b) => {
        //             return b.updateTime - a.updateTime;
        //         })
        //
        //         refreshRecentlyMoreMenu(arrayNotes);
        //
        //         if (!params.state.usr) {
        //             params.state.usr = {};
        //         }
        //         //use last one....
        //         params.state.usr.noteData = arrayNotes[0];
        //     }
        // }
        ///////end***********

        if (params.state?.usr?.linkInfo){
            linkInfo = params.state?.usr.linkInfo;
        }

        if (localStorage.getItem('times') == undefined) {
            // window.location.reload();
            localStorage.setItem('times', 'ok');
        }

        if ((urlParams.id && !APP_WEB) || linkInfo) {//有id并且非分享...
            let szProjectId = urlParams.id ?? linkInfo.id;
            if (szProjectId){
                let szOriginUsr = params.state?.usr || {};
                params.state = {};
                params.state.usr = szOriginUsr;
                const noteData = await getNoteById(szProjectId);
                params.state.usr.noteData = noteData;
                params.state.usr.linkInfo = linkInfo;
            }
        }

        let promiseSetOutData: any;
        mLoadProjectInfo = null;


        //打开编辑的数据....
        if (params.state != undefined && params.state.usr != null) {
            if (params.state?.usr?.noteData) {
                //region
                mNoteData.current = params.state.usr.noteData;

                mPublishId = mNoteData.current.id;
                // localStorage.setItem(KEY_NEW_PROJECT_ID,mNoteData.current.id);
                global.g_projectId = PROJECT_ID = mNoteData.current.id;
                mThumbUrl = mNoteData.current.thumbUrl;

                mLoadProjectInfo = {id:PROJECT_ID,isFinished:false}

                global.g_currentRecentId = mPublishId;
                //更新Viewtime
                updateProjectViewTime(mPublishId).then(res=>{
                    postMessage(EVENT_REFRESH_RECENTS);
                })

                if (isWebApp()) {
                    //region webapp
                    let webJsonDoc: any = {
                        annotations: [],
                        canvas: [],
                        info: {},
                        notes: [],
                        pageSize: {
                            type: 'infinite',
                            id: 'whiteboard'
                        }
                    };
                    const retBoard = await apiProjectListBoardNotes(mNoteData.current.id);
                    //默认暂时先取第一个。。。
                    if (retBoard.code == 0) {
                        retBoard.data.arrayLibrarys.forEach(p => {
                            webJsonDoc.notes.push(
                                {
                                    ...p,
                                    title: p.name,
                                    editValue: p.name,
                                    key: p.id,
                                    noteDataDoc: p.doc
                                }
                            )
                        });
                        if (retBoard.data.arrayBoards.length > 0) {
                            //重新组合一下key.由于mysql 关键字问题--后端存储的为keyId
                            retBoard.data.arrayBoards.forEach(p => {
                                p.key = p.keyId;
                                const appState = p.appState;
                                delete p.appState;

                                webJsonDoc.canvas.push({
                                    drawJson: {
                                        appState: appState,
                                        elements: [],
                                        files: {},
                                        type: 'excalidraw',
                                        version: 2,
                                        source: 'http://localhost:3000'
                                    },
                                    ...p,
                                    editValue: p.title
                                })
                            });
                            const retElement = await apiElementByBoardKey(retBoard.data.arrayBoards[0].key);
                            if (retElement.code == 0) {
                                // webJsonDoc.canvas[0].appState = appState;
                                //把这个的所有elements加入到已处理...
                                retElement.data.forEach(p => {
                                    excalidrawRef?.setUpdateElementId(p.id);
                                })

                                webJsonDoc.canvas[0].drawJson.elements = retElement.data;
                                //处理这一页的图片....
                                webJsonDoc.canvas[0].drawJson.files = await s3ImageToLocalFile(webJsonDoc.canvas[0].drawJson.elements);
                            }
                        }
                    }

                    mNoteData.current.doc = JSON.stringify(webJsonDoc);

                    //endregion
                } else {
                    // console.log('onloadData-time-....***********',(Date.now() - lTime));
                    const dbData = await getJsonNoteById(mNoteData.current.id);
                    if (dbData){
                        mNoteData.current = dbData;
                    }
                    // console.log('onloadData-time-....***********',(Date.now() - lTime));
                }

                if (!mNoteData.current.doc){
                    return;
                }

                let jsonObj:any = null; //JSON.parse(mNoteData.current.doc);
                if (isString(mNoteData.current.doc)){
                    jsonObj = JSON.parse(mNoteData.current.doc);
                }else{
                    jsonObj = mNoteData.current.doc;
                }

                mExportInfos = jsonObj.info;
                pageDatas = jsonObj;

                //兼容旧的数据--图片以文件方式保存 20241119---
                if (!isWeb()){
                    await saveOldImportImageToLocalFile(pageDatas)
                }

                // console.log('onloadData-loadNotesElement---start....***********',(Date.now() - lTime));

                await loadNotesElement(pageDatas);

                // console.log('onloadData-loadNotesElement---end....***********',(Date.now() - lTime));

                //*********对跳转的处理******************!!!!
                linkInfo = getLinkInfo(linkInfo,pageDatas)
                //*********对跳转的处理******************end!!!!

                //必须有这个设置，不然进入的时候偶尔会有 设置不上数据的情况.....
                promiseSetOutData = leftMenuRef.current?.setOutMenuData(jsonObj,linkInfo);
                // nTimeoutId = setTimeout(() => {
                //     promiseSetOutData = leftMenuRef.current.setOutMenuData(jsonObj,linkInfo);
                // }, 50);
                // mArrayTimeoutIds.current.push(nTimeoutId);

                //检查设置的数据与当前是否一致？、？？？？
                // setTimeout(()=>{
                //     const arraySettttttData = leftMenuRef.current.getAllMenuData();
                //     if(jsonObj.canvas != arraySettttttData){
                //         console.log('no treedata fail.............re set ......');
                //         leftMenuRef.current.setOutMenuData(jsonObj);
                //     }
                // },1500);
                //--
                mInitDatas = JSON.stringify(jsonObj);//初始数据
                mTitle.current = mNoteData.current.name;
                mSaveTimes = (mNoteData.current.saveTimes ?? 0);//已保存的次数....
                setTitle(mNoteData.current.name);
                excalidrawRef?.onSetReadonlyStatus(false);
                mNoteData.current.viewTime = Date.now();

                updateNoteLastView(mNoteData.current).then(res=>{
                    console.log('update-last-view')
                })

                //endregion
            } else if (params.state.usr.hasOwnProperty("importNoteData")) {
                //region 生成新的id
                global.g_projectId = PROJECT_ID = generateUUID2();
                localStorage.setItem(KEY_NEW_PROJECT_ID, PROJECT_ID)
                mPublishId = PROJECT_ID;
                mViewTime = Date.now();

                mLoadProjectInfo = {id:PROJECT_ID,isFinished:false}

                let importData = params.state.usr.importNoteData;
                //查找所有元素-修改内部的链接
                if (importData.info.originProjectId){
                    let szNewImportData = JSON.stringify(importData);
                    szNewImportData = szNewImportData.replaceAll(importData.info.originProjectId,PROJECT_ID);
                    importData = JSON.parse(szNewImportData);
                }

                importData.info.isImport = true;//标记为import
                pageDatas = importData;

                //缩略图...导出用...
                mThumbUrl = importData.info.thumbUrl;

                //保存笔记的图片到本地...
                await ipcInvoke('save-image-to-local', JSON.stringify(pageDatas.notesImage));
                //保存插入的文件到本地
                if (pageDatas.files && pageDatas.files.length > 0) {
                    await ipcInvoke('write-base64-files', JSON.stringify(pageDatas.files))
                }

                //兼容旧的数据--图片以文件方式保存 20241119
                await saveOldImportImageToLocalFile(pageDatas)

                //分离数据到library....
                await updateCanvasToLibrary(pageDatas, false, (fProgress: any) => {
                    setLoadingTips(Math.round(fProgress * 100) + '%')
                });

                //加载笔记，文件===
                await loadNotesElement(pageDatas,true);

                //add update time
                const dtNow = Date.now();
                for (let i = 0; i < pageDatas.canvas.length; i++) {
                    const item = pageDatas.canvas[i];
                    item.updateTime = dtNow;
                    item.hasUpdate = true;
                    if (item.isFolder) {
                        for (let j = 0; j < item.children.length; j++) {
                            item.children[j].updateTime = dtNow;
                        }
                    }
                }
                for (let i = 0; i < pageDatas.notes.length; i++) {
                    const item = pageDatas.notes[i];
                    item.updateTime = dtNow;
                    item.hasUpdate = true;
                    if (item.isFolder) {
                        for (let j = 0; j < item.children.length; j++) {
                            item.children[j].updateTime = dtNow;
                        }
                    }
                }
                mTitle.current = importData.info.title;
                setTitle(importData.info.title);

                if (APP_WEB_WWW) {
                    //网页版--替换笔记的路径为base64
                    replaceImageUrlToBase64(pageDatas.notes, pageDatas.notesImage);
                }

                //这里先保存一下。以免有些东西找不到。。。
                let nIndex:any = getIntValue(localStorage.getItem(KEY_PROJECT_THUMB_INDEX), 0);
                if (nIndex < 0 || nIndex >= ARRAY_DEFAULT_PROJECT_ITEM_THUMB_BIG.length) {
                    nIndex = 0;
                }
                const lTime = Date.now();
                const szTitle = mTitle.current;
                const project = {
                    createTime: lTime,
                    deleteTime: 0,
                    doc: {canvas:importData.canvas},
                    favirateTime: 0,
                    id: PROJECT_ID,
                    isDeleted: 0,
                    isFavirated: 0,
                    name: szTitle,
                    searchName: szTitle,
                    showName: szTitle,
                    updateTime: lTime,
                    viewTime: mViewTime || lTime,
                    thumbUrl: ARRAY_DEFAULT_PROJECT_ITEM_THUMB_BIG[nIndex],
                }
                localStorage.setItem(KEY_PROJECT_THUMB_INDEX, (nIndex+1) % ARRAY_DEFAULT_PROJECT_ITEM_THUMB_BIG.length + '');
                project.saveTimes = 0;
                project.name = project.showName = project.searchName = szTitle;
                project.updateTime =  lTime;
                await updateNote(project);

                //*********对跳转的处理******************!!!!
                linkInfo = getLinkInfo(linkInfo,pageDatas)
                //*********对跳转的处理******************end!!!!

                //这里先保存一下。以免有些东西找不到。。。END
                promiseSetOutData = leftMenuRef.current?.setOutMenuData(importData,linkInfo);
                mExportInfos = importData.info;
                // mInitDatas = JSON.stringify(pageDatas);//初始数据
                //是否只读
                // excalidrawRef.onSetReadonlyStatus(params.state.usr.isReadOnlyState);
                nTimeoutId = setTimeout(() => {//shit.不能及时更新数据真是。。
                    excalidrawRef?.onSetReadonlyStatus(importData.info?.isReadOnlyStatus || false);
                }, 500);
                mArrayTimeoutIds.current.push(nTimeoutId);

                //保存注记---文件
                if (importData.annotations) {
                    for (let i = 0; i < importData.annotations.length; i++) {
                        const item = importData.annotations[i];
                        ipcInvoke('save-annotations', {fileId: item.id, annotations: item.anno});
                    }
                }

                setLoadingTips('');

                //endregion
            }


            if (mExportInfos != undefined) {
                if (mExportInfos?.isReadOnlyStatus) {
                    setPresentModeExitTip(t("to exit this project"))
                    if (mExportInfos?.isFrame) {
                        nTimeoutId = setTimeout(() => {
                            onPresentFrameClick();
                        }, 150);
                        mArrayTimeoutIds.current.push(nTimeoutId);

                    } else {
                        onPresentClick(false);
                    }
                }
                mAllCanvasBackground = mExportInfos.viewBackgroundColor;
                if (isStringNullOrEmpty(mAllCanvasBackground)) {
                    mAllCanvasBackground = DEFAULT_CANVAS_BACKGROUND;
                }
            }

            //可能是点进来立即就点出去了。。
            if (!excalidrawRef)return;

            excalidrawRef.setProjectId(mProjId);
            if (pageDatas?.canvas.length > 0){
                setHasElement(pageDatas.canvas[0].drawJson?.elements?.length > 0);
            }

            if (pageDatas != undefined && pageDatas.pageSize != undefined) {
                // excalidrawRef.onSetPageSize(pageDatas.pageSize);

                nTimeoutId = setTimeout(() => {
                    setPageSizeNumber(1 + '/' + leftMenuRef.current?.getPagesCount())
                }, 200);
                mArrayTimeoutIds.current.push(nTimeoutId);

                loopAllNode(pageDatas.canvas,(item)=>{
                    if (item.drawJson?.elements){
                        excalidrawRef.lazyLoadImage(item.drawJson.elements, item.drawJson.files);
                    }
                })

                console.log('loopAllNodeAsync-ok')

                Global.g_currentPageData = pageDatas;
            } else {
                //new project
                // setTimeout(()=>{
                //     excalidrawRef.initFirstBlankProject();
                // },10);
            }
        }else{
            //new project
            mTitle.current = '';
            setTitle('')
            newProject();
        }

        setIsTitleDisabled(KEY_DEFAULT_PROJECT_ID == props.projectId || PROJECT_ID == KEY_DEFAULT_PROJECT_ID)

        //菜单
        refreshMenuMore();


        //转到子页面，如果有的话.....
        if (promiseSetOutData) {
            // console.log('onloadData-time-promiseSetOutData....***********',(Date.now() - lTime));
            promiseSetOutData.then(res => {
                // console.log('onloadData-time-promiseSetOutData-end....***********',(Date.now() - lTime));
                setTimeout(()=>{
                    //这里还必须要延迟,leftmenu数据还没有更新。!!!!
                    if (linkInfo) {
                        onNavSub(linkInfo.pageId, linkInfo.elementId,linkInfo.nodeId);
                    } else {
                        let szBoardId =urlParams.boardId;
                        let szElementId = urlParams.elementId;
                        if (params.state?.usr?.cardId){
                            //找board 和  card
                            const jsonObj = JSON.parse(mNoteData.current.doc);
                            for (let i = 0; i < jsonObj.canvas.length; i++) {
                                const elements = jsonObj.canvas[i].drawJson.elements;
                                for (let j = 0; j < elements.length; j++) {
                                    let item = elements[j];
                                    if (item.id == params.state?.usr?.cardId || item.customData?.generationData?.id == params.state?.usr?.cardId){
                                        szBoardId = jsonObj.canvas[i].key;
                                        szElementId = item.id;
                                    }
                                }
                            }
                        }
                        onNavSub(szBoardId, szElementId);
                    }
                },100)

                //到这里才算是加载一个项目结束....
                mLoadProjectInfo = null;

                // console.log('promiseSetOutData-time-end....***********',(Date.now() - lTime));
            })
        } else {
            if (linkInfo) {
                onNavSub(linkInfo.pageId, linkInfo.elementId);
            } else {
                onNavSub(urlParams.boardId, urlParams.elementId);
            }
            //到这里才算是加载一个项目结束....
            mLoadProjectInfo = null;
        }
        nTimeoutId = setTimeout(() => {

        }, 10);
        mArrayTimeoutIds.current.push(nTimeoutId);

        nTimeoutId = setTimeout(()=>{
            //以防万一，给10s的时间。项目不可能一直加载不完...******
            // 一直在没法保存......到这里才算是加载一个项目结束....
            mLoadProjectInfo = null;
        },10000);
        mArrayTimeoutIds.current.push(nTimeoutId);

        // console.log('onloadData-time-end....***********',(Date.now() - lTime));
    }

    /**
     * 替换图片的URL为BASE64图片
     */
    const replaceImageUrlToBase64 = (notes: any, notesImage: any) => {
        if (!notesImage) return;
        for (let i = 0; i < notes.length; i++) {
            let note = notes[i];
            for (let j = 0; j < notesImage.length; j++) {
                let jsonImg = notesImage[j];
                note.noteDataDoc = note.noteDataDoc.replace('atom://' + jsonImg.id + '.' + jsonImg.ext, 'data:image/' + jsonImg.ext + ';base64,' + jsonImg.data);
            }
        }
    }

    /**
     * 画布界面初始化完成
     */
    async function onExcalidrawInitComplete(api:any) {
        // if (api){
        //     setExcalidrawRefCallback(api);
        // }
        if (!global.g_isAutoRestore){//非全局恢复的时候才关闭。。
            window.closeIndicator();//关闭全局的这个

            if (!APP_WEB){
                setIsSaving(true);
            }
        }

        if (params.state?.usr?.noteData || params.state?.usr?.importNoteData) {
            await onLoadData();
        } else {
            if (params.state?.usr?.projectId != KEY_DEFAULT_PROJECT_ID){
                await onLoadData();
            }
        }

        //等待3s关闭。别的地方加载成功也有关闭，这里如果太着急关闭，会留出一个短暂的空白，此时切换board会覆盖.
        // nTimeoutId = setTimeout(async () => {
        //     setIsSaving(false);
        // }, 30000);
        // mArrayTimeoutIds.current.push(nTimeoutId);

    }


    /**
     * 刷新收藏
     */
    function refreshMenuMore() {
        if (APP_WEB_WWW || APP_WEB) return;
        if (mNoteData.current != null) {
            let arrayNewMoreMenus = [...MENU_MORE()];
            arrayNewMoreMenus.forEach((p: any) => {
                if (p.key == 'favor') {
                    if (mNoteData.current.isFavirated) {
                        p.label = t("Cancel favor");
                        p.icon = <IconRemoveFavor/>
                    } else {
                        p.label = t("Add to Favorites");
                        p.icon = <IconAddToFavor/>
                    }
                }
            })

            setArrayMenuMore(arrayNewMoreMenus);
        }else{
            setArrayMenuMore(MENU_MORE());
        }
    }

    function setTitle(szText:any) {
        if (inputTitleRef.current){
            inputTitleRef.current.value = szText;
        }
    }

    function getExcalidrawAPI(){
        return excalidrawRef?.getExcalidrawApi();
    }

    /**
     * 刷新是否有元素
     */
    function refreshHasElement(){
        nTimeoutId = setTimeout(()=>{
            if (getExcalidrawAPI()){
                setHasElement(getExcalidrawAPI()?.getSceneElements().length > 0);
            }
        },100);
        mArrayTimeoutIds.current.push(nTimeoutId);
    }

    /**
     * 根据链接转到相应的page OR
     * 链接点击
     * 链接打开
     * 打开链接
     * 跳转链接
     * @param linkInfo
     */
    function onLinkNav(linkInfo: any,isBack = false,isForward = false,isPop = false) {
        if (linkInfo.isCurrentProject == undefined || linkInfo.isCurrentProject == true) {
            //添加到栈，返回的时候使用..
            if (!isPop){
                if (isBack){
                    //添加到前进列表
                    mStackForward.current.push(linkInfo);
                }else{
                    //返回....
                    mStackHistory.current.push({...linkInfo,pageId:leftMenuRef?.current.onGetCurrentSelectKey()});
                }

                if (isForward){
                    mStackHistory.current.push({...linkInfo,pageId:leftMenuRef?.current.onGetCurrentSelectKey()});
                }else{
                    mStackForward.current.push(linkInfo);
                }
            }


            leftMenuRef?.current.onNavMenuItemClickByLinkInfo(linkInfo);
            //切换底部的页面
            nTimeoutId = setTimeout(() => {
                const szDesc = leftMenuRef?.current.getBottomDesc(linkInfo.id);
                setPageSizeNumber(szDesc);
            }, 100);
            mArrayTimeoutIds.current.push(nTimeoutId);

        } else {
            //打开一个新的project   -- dialog.....
            // setIsShowDialogDrawIndex(true);
            // setLinkInfo(linkInfo);
            setIsDialogDrawIndexFullScreen(false);
            postMessage(EVENT_SHOW_DIALOG_DRAWINDEX, {linkInfo})
        }
    }

    /**
     * 获取本画布的所有数据
     */
    async function getCanvasNoteDatas(bClearIcon = true,bHasPdfAnnos = false) {
        //更新当前画布的数据....
        if (currentSelectNode == null){
            currentSelectNode = leftMenuRef.current?.onGetSelectNode();
        }

        if (currentSelectNode != null) {
            const drawNewJson = getExcalidrawJson();
            // if (JSON.stringify(drawNewJson) != JSON.stringify(currentSelectNode.drawJson)) {
            //     currentSelectNode.updateTime = Date.now();
            //     currentSelectNode.hasUpdate = true;
            // }
            currentSelectNode.updateTime = Date.now();
            currentSelectNode.hasUpdate = true;
            currentSelectNode.drawJson = drawNewJson;
            //更新那个对象...
            leftMenuRef.current?.updateMenuData(currentSelectNode.key, currentSelectNode.drawJson);
        }
        let jsonResult = leftMenuRef.current?.getAllMenuData();
        if (!jsonResult){
            //todo  error
        }
        if (bClearIcon) {
            clearMenuDataIcon(jsonResult);
        }

        const jsonNote = leftMenuRef.current?.getAllNoteData();
        //这里要补充jsonNote的doc...
        var newJsonResult = {
            canvas: jsonResult,
            notes: jsonNote
        }
        if (mExportInfos != undefined) {
            newJsonResult.info = mExportInfos;
        } else {
            newJsonResult.info = {};
        }
        newJsonResult.info.screen = {
            width: screen.width,
            height: screen.height
        }
        //device-id
        newJsonResult.info.deviceId = localStorage.getItem(KEY_MACHINEID);
        newJsonResult.info.selectedBoardKey = leftMenuRef.current.onGetCurrentSelectKey();
        newJsonResult.pageSize = excalidrawRef?.getAppState()?.pageSizeValues;

        //增加pdf注记信息--如果有的话..
        if (bHasPdfAnnos){
            let arrayAnnotations: any = [];
            for (let i = 0; i < jsonResult.length; i++) {
                const canvas = jsonResult[i];
                for (let j = 0; j < canvas.drawJson?.elements?.length; j++) {
                    const element = canvas.drawJson.elements[j];
                    if (isPdfFileElement(element)) {
                        const annos = await ipcInvoke('get-annotations', {fileId: element.id});
                        arrayAnnotations.push({
                            id: element.id,
                            anno: annos
                        })
                    } else if (isMindmapElement(element)) {
                        //mindmap里面有 pdf 有 anno
                        await recursionMindmapData(element.data, async (data: any) => {
                            if (data.extra && data.extra.type == 'pdf') {
                                const annos = await ipcInvoke('get-annotations', {fileId: data.extra.id});
                                arrayAnnotations.push({
                                    id: data.extra.id,
                                    anno: annos
                                })
                            }
                        })
                    }
                }
            }
            newJsonResult.annotations = arrayAnnotations;
        }


        //子画布
        return newJsonResult;
    }

    /**
     * 笔记内容选中
     * @param treeNoteData
     */
    function onSubNoteClick(treeNoteData) {
        excalidrawRef.onScrollToElementNoDelay(treeNoteData.key);
    }

    /**
     * 关闭所有的弹窗
     */
    function closeAllPopoverOrDropdown() {

        if (elementPopoverOpen) {
            setElementPopoverOpen(false);
        }
        if (stylePopoverOpen) {
            setStylePopoverOpen(false);
        }
        if (embedPopoverOpen) {
            setEmbedPopoverOpen(false);
        }
        if (stylePageSizePopoverOpen) {
            setStylePageSizePopoverOpen(false);
        }

        if (isFramePopoverOpen) {
            setIsFramePopoverOpen(false);
        }
        if (isPopoverExportPngVisible) {
            setIsPopoverExportPngVisible(false)
        }
        if (isPopoverExportPngFramePresentModeVisible) {
            setIsPopoverExportPngFramePresentModeVisible(false);
        }

        //预览弹出
        if (isPopoverPresentModeVisible) {
            setIsPopoverPresentModeVisible(false);
        }
        if (isPopoverZoomVisible) {
            setIsPopoverZoomVisible(false);
        }

        if (filePopoverOpen) {
            setFilePopoverOpen(false);
        }

        if (drawPopoverOpen) {
            setIsShowDrawStyle(false);
            setIsShowDrawStrokeColor(false);

            nTimeoutId = setTimeout(() => {
                setDrawPopoverOpen(false);
            }, 50);
            mArrayTimeoutIds.current.push(nTimeoutId);
        }

        hiddenToolbar();

        nTimeoutId = setTimeout(()=>{
            const nElements:any = excalidrawRef.getDrawJson().elements.length || 0;
            setHasElement(nElements > 0);
        },200);
        mArrayTimeoutIds.current.push(nTimeoutId);
    }

    /**
     * 直接返回
     */
    async function onBack() {
        const objCanvasJson = await getCanvasNoteDatas(false,false);
        try {
            const szCanvasJson = JSON.stringify(objCanvasJson);
            if (mInitDatas != szCanvasJson) {
                Modal.confirm({
                    centered: true,
                    content: t("No save exit"),
                    onOk() {
                        onBackImme();
                    }
                })
            } else {
                onBackImme();
            }
        } catch (e) {
            onBackImme();
        }
    }

    /*不保存直接退出*/
    function onBackImme() {
        var szFolderId = params.state?.usr?.folderId;
        if (mNoteData.current != null) {
            szFolderId = mNoteData.current.folderId;
        }
        navigate('/home', {state: {folderId: szFolderId}})
    }

    function replaceIcon(key, value) {
        if (key === 'icon') {
            return '';
        } else if (key == 'html' && !isFileHtml(value)) {
            return '';//笔记的html也不存。读取的时候重新加载...
        }
        return value;
    }

    function replaceIconAndHasUpdate(key, value) {
        if (key === 'icon') {
            if (isObject(value)){
                return '';
            }
        } else if (key == 'html' && !isFileHtml(value)) {
            return '';//笔记的html也不存。读取的时候重新加载...
        } else if (key == 'hasUpdate') {
            return true;
        }
        return value;
    }

    async function screenshot() {
        // 获取屏幕流
        const displayMediaOptions = {
            video: {
                cursor: "always"
            }
        };
        const stream = await navigator.mediaDevices.getDisplayMedia(displayMediaOptions);

        // 创建一个video元素来播放屏幕流
        const video = document.createElement('video');
        video.srcObject = stream;
        await video.play();

        // 创建一个canvas元素来截屏
        const canvas = document.createElement('canvas');
        canvas.width = video.videoWidth;
        canvas.height = video.videoHeight;

        // 将视频播放的内容绘制到canvas上
        const context = canvas.getContext('2d');
        context.drawImage(video, 0, 0, canvas.width, canvas.height);

        // 将canvas内容转换为base64
        const base64 = canvas.toDataURL();

        // 关闭视频流
        video.srcObject.getTracks().forEach((track) => track.stop());

        return base64;
    }

    /**
     * 保存保存保存保存保存保存保存保存保存保存保存保存保存保存保存保存
     * 保存笔记
     */
    async function saveNotes(toHome: boolean = false, szDefaultTitle = '', bShowSaving: boolean = false,szLinkNewProjectId = '') {
        // message.loading(t("Saving"));

        if (mIsPresentMode && !toHome) {
            //展示模式，不要保存....
            return;
        }

        if (global.g_isRestoreData){
            global.g_isRestoreData = false;
            return;
        }

        if (mLoadProjectInfo && mLoadProjectInfo.id == PROJECT_ID && !mLoadProjectInfo.isFinished){
            //有项目，项目ID相同并且还未加载完成...不用保存
            return;
        }

        if (isSaving){
            //正在加载的时候退出
            console.log('isSaving....return.....');
            return;
        }

        //显示的查看不保存
        if (mIsDialogDrawIndex) {
            return;
        }

        if (bShowSaving) {//网页版自动保存不显示保存中....
            setIsSaving(true);
        }

        let szTitle = inputTitleRef.current?.value;//这个title为什么总是为空？？？？？？SHIT！;
        if (!szTitle) {
            szTitle = t("Untitled");
            if (!isStringNullOrEmpty(szDefaultTitle)) {
                szTitle = szDefaultTitle;
            }
        }

        if (excalidrawRef == null) {
            if (DEBUG) {
                return;
            }
            // message.error('save error...');
            console.log('excalidrawRef is null save fail....');
            navigate('/home/project');
            return;
        }

        const objCanvasJson = await getCanvasNoteDatas(false,false);
        objCanvasJson.canvas.forEach(p=>{
            p.subNotes = [];
        })
        // mFirstBase64Capture = await ipcInvoke('get-capture', {});

        objCanvasJson.info.viewBackgroundColor = mAllCanvasBackground;//保存应用到所有页面的背景
        if (objCanvasJson.canvas.length == 0/* !objCanvasJson.canvas[0].drawJson*/){//换成文件夹，不能用后面这种方式判断了。
            //这里什么问题。改的出这种问题.
            return;
        }
        if (DEBUG) {
            // console.log("savenotes.****");
            // console.log(objCanvasJson);
        }
        if (!APP_WEB && !APP_WEB_WWW) {
            // if (objCanvasJson.canvas.length == 1 && objCanvasJson.canvas[0].drawJson.elements?.length === 0 && isStringNullOrEmpty(title) && objCanvasJson.notes.length == 0) {
            //     setIsSaving(false);
            //     if (toHome) {
            //         message.info(t("Cant save blank note"))
            //         navigate('/home');
            //         return;
            //     } else {
            //         // return;
            //     }
            // }
        }
        if (!objCanvasJson.canvas[0].isFolder && !objCanvasJson.canvas[0].drawJson){
            return;
        }

        const szCanvasJson = JSON.stringify(objCanvasJson, replaceIcon);
        let szBase64;
        if (!isStringNullOrEmpty(mFirstBase64Capture)) {
            // szBase64 = mFirstBase64Capture;
        } else {
            if (APP_WEB_SITE) {
                //web app
                if (mExportInfos?.isFrame) {
                    szBase64 = await excalidrawRef.getFirstFrameBase64Data();
                } else {
                    szBase64 = await excalidrawRef.getPngBase64Data();
                }
            }
            // if (mExportInfos?.isFrame){
            //     szBase64 = await excalidrawRef.getFirstFrameBase64Data();
            // }else{
            //     szBase64 = await excalidrawRef.getPngBase64Data();
            // }

            // if (toHome){
            //     //返回的界面
            //     szBase64 = await ipcInvoke('get-capture');
            // }
        }
        //缩略图搞小点
        if (!isStringNullOrEmpty(szBase64)) {
            try {
                let file = new File([base64ToBlob(szBase64)], 'preview', {type: MIME_TYPES.png});
                const newImageFile = await resizeImageFile(file,
                    {
                        outputType: MIME_TYPES.jpg,
                        maxWidthOrHeight: 400,
                    });
                szBase64 = await fileToBase64(newImageFile);
            } catch (e) {
                console.log('thumb resize err...' + e);
            }
        }

        // if (mExportInfos != undefined && mExportInfos != null){
        //     if (!isStringNullOrEmpty(mExportInfos.cover)){
        //         szBase64 = mExportInfos.cover;
        //     }
        // }

        const lTime = new Date().getTime();
        const jsonDoc = JSON.parse(szCanvasJson);

        if (mNoteData.current == null) {
            let id = '';
            if (!isStringNullOrEmpty(mPublishId)) {
                id = mPublishId;
            } else {
                id = await generateShortUUID();
            }
            global.g_projectId = PROJECT_ID = mPublishId = id;
            let nIndex:any = getIntValue(localStorage.getItem(KEY_PROJECT_THUMB_INDEX), 0);
            if (nIndex < 0 || nIndex > ARRAY_DEFAULT_PROJECT_ITEM_THUMB_BIG.length) {
                nIndex = 0;
            }
            mNoteData.current = {
                createTime: lTime,
                deleteTime: 0,
                // doc: JSON.parse(szCanvasJson),
                favirateTime: 0,
                id: id,
                isDeleted: 0,
                isFavirated: 0,
                name: szTitle,
                searchName: szTitle,
                showName: szTitle,
                updateTime: lTime,
                viewTime: mViewTime || lTime,
                thumbUrl: ARRAY_DEFAULT_PROJECT_ITEM_THUMB_BIG[nIndex],
            }
            if (mThumbUrl){
                mNoteData.current.thumbUrl = mThumbUrl;
            }
            localStorage.setItem(KEY_PROJECT_THUMB_INDEX, (nIndex+1) % ARRAY_DEFAULT_PROJECT_ITEM_THUMB_BIG.length + '')
        }
        if (!isStringNullOrEmpty(szBase64)) {
            mNoteData.current.img = szBase64;
        }

        if (szLinkNewProjectId){
            //这里换本项目中的，被移走的画布 新项目的ID
            await loopAllNodeAsync(jsonDoc.canvas,async(canvas)=>{
                if (canvas.drawJson?.elements){
                    for (let ii=0;ii<canvas.drawJson.elements.length;ii++){
                        const ele = canvas.drawJson.elements[ii];
                        if (isProjectLinkElement(ele)){
                            if (ele.customData.projectId == PROJECT_ID){
                                ele.customData.projectId = szLinkNewProjectId;
                            }
                        }
                    }
                }
            })
        }
        if (!mNoteData.current.thumbUrl){
            mNoteData.current.thumbUrl = ARRAY_DEFAULT_PROJECT_ITEM_THUMB_BIG[0];
        }
        mNoteData.current.saveTimes = mSaveTimes;
        mNoteData.current.doc = jsonDoc;
        mNoteData.current.name = mNoteData.current.showName = mNoteData.current.searchName = szTitle;
        mNoteData.current.updateTime =  lTime;
        mNoteData.current.viewTime = lTime;
        var szFolderId = params.state?.usr?.folderId;
        if (szFolderId != undefined && szFolderId != '-2') {
            mNoteData.current.folderId = szFolderId;
        }

        if (mNoteData.current.id == KEY_DEFAULT_PROJECT_ID){
            mNoteData.current.isDefaultProject = true;
            mNoteData.current.name = t("Home");
            //home取第一个.
            if (!mNoteData.current.thumbUrl || mNoteData.current.thumbUrl?.includes('icon_')){
                mNoteData.current.thumbUrl = ARRAY_DEFAULT_PROJECT_ITEM_THUMB_BIG[0];
            }
        }

        // message.destroy();
        // showLoad('')
        // updateNote(mNoteData.current, '', false).then(res => {
        //     console.log('***save note finished....');
        //     // setIsSaving(false);
        //     // if (toHome) {
        //     //     // hideLoad();
        //     //     // navigate('/home',{state:{folderId:mNoteData.current.folderId}})
        //     //     navigate('/home');
        //     // }
        // });

        await updateNote(mNoteData.current,'',false);

        if (DEBUG){
            console.log('******savenotes******')
        }

        //恢复一下数据....
        if (mNoteData.current){
            mNoteData.current.doc = szCanvasJson;
        }

        global.g_currentRecentId = mNoteData.current.id;

        postMessage(EVENT_FAVIRIATE_CHANGE);
        postMessage(EVENT_REFRESH_RECENTS,{projectId:mNoteData.current.id});
        postMessage(EVENT_NOTE_CHANGED)

        setIsSaving(false);

        // console.log('***save note finished....');

        if (toHome) {
            // hideLoad();
            // navigate('/home',{state:{folderId:mNoteData.current.folderId}})
            window.closePopupCardList();
            // navigate('/home');
            window.navPage('recent');
            localStorage.removeItem('times');
            //保存到服务端
            if (isWebApp()) {
                var serverProject = {...mNoteData.current};
                //上传图片
                const szImageThumbUrl = await uploadS3ImageThumb(mNoteData.current.id, mNoteData.current.img);

                delete serverProject.doc;
                serverProject.img = szImageThumbUrl;
                // apiUpdateProject(serverProject).then(res=>{
                //     postMessage(EVENT_NOTE_CHANGED)
                // });
                var arrayBoards: any = [];
                var arrayElements: any = [];
                for (let i = 0; i < objCanvasJson.canvas.length; i++) {
                    var canvas = objCanvasJson.canvas[i];
                    arrayBoards.push({
                        projectId: serverProject.id,
                        title: canvas.title,
                        keyId: canvas.key,
                        isFolder: canvas.isFolder,
                        updateTime: canvas.updateTime,
                        hasUpdate: canvas.hasUpdate,
                        appState: canvas.drawJson.appState,
                        sort: i
                    })

                    //已更新过的元素。。。。
                    const arrayUpdatedElementIds = excalidrawRef.getNormalUpdateElementIds();
                    for (let j = 0; j < canvas.drawJson.elements.length; j++) {
                        if (arrayUpdatedElementIds[canvas.drawJson.elements[j].id] && !isMindmapElement(canvas.drawJson.elements[j])) continue;

                        arrayElements.push({
                            ...canvas.drawJson.elements[j],
                            boardKeyId: canvas.key
                        })
                    }
                }
                apiUpdateProjectAll(serverProject, arrayBoards, arrayElements).then(res => {
                    postMessage(EVENT_NOTE_CHANGED)
                })
            }
        }

        nTimeoutId = setTimeout(() => {
            setIsAutoSaving(false);
        }, 1000);
        mArrayTimeoutIds.current.push(nTimeoutId);
    }

    /**
     * 分享点击
     */
    const onShareClick = async () => {
        setIsShowShareDialog(true);
        if (mNoteData.current != null) {
            mPublishId = mNoteData.current.id;
        } else if (isStringNullOrEmpty(mPublishId)) {
            mPublishId = await generateShortUUID();
        }
        dialogShareRef.current.onDialogShow(mPublishId, leftMenuRef.current?.getAllMenuData(), leftMenuRef?.current.getSelectMenuKeys());
    }

    /**
     * 展示--全屏
     */
    const onPresentClick = async (isNeedUpdateCurrentPage = true) => {
        mBackupHomeLeftWidth = homePaddingLeft;
        setHomePaddingLeft(0);//隐藏左侧边栏

        mIsCollapseLeft = isCollapsePage;
        //更新下当前页面的内容....
        if (isNeedUpdateCurrentPage) {
            if (currentSelectNode != null) {
                currentSelectNode.drawJson = getExcalidrawJson();
                //更新那个对象...
                leftMenuRef.current.updateMenuData(currentSelectNode.key, currentSelectNode.drawJson);
            }
        }
        setIsFramePresent(false);
        setIsShowOverlay(false);
        onUpdatePresentUIElement();
        //全屏..
        if (!APP_WEB) {
            mIsFullScreen = await ipcInvoke('is-full-screen');
            setIsFullScreen(true);
        }
        setPageSizeNumber(leftMenuRef?.current.getPageSizeDesc());
        updateMindmapMode("readonly");
        //修改.excalidraw__embeddable-container  zindex为1，不然影响激光笔的层次，会在card,视频的下层.
        const arrayContainer:any = document.getElementsByClassName('excalidraw__embeddable-container');
        for (let i=0;i<arrayContainer.length;i++){
            arrayContainer[i].style.zIndex = '1';
        }
        const arraySticky:any = document.getElementsByClassName('excalidraw__mindmap-container');
        for (let i=0;i<arraySticky.length;i++){
            const item = arraySticky[i];
            if (item.dataset.type == 'stickynotes'){
                arraySticky[i].style.zIndex = '1';
            }
        }

        nTimeoutId = setTimeout(() => {
            setIsShowExitPresent(true);
        }, 50);
        mArrayTimeoutIds.current.push(nTimeoutId);

        nTimeoutId = setTimeout(() => {
            focus();
        }, 3000);
        mArrayTimeoutIds.current.push(nTimeoutId);

        nTimeoutId = setTimeout(() => {
            setIsShowExitPresent(false);
        }, 4000);
        mArrayTimeoutIds.current.push(nTimeoutId);
    }

    /**
     * 预览frame
     */
    const onPresentFrameClick = async () => {
        mBackupHomeLeftWidth = homePaddingLeft;
        setHomePaddingLeft(0);
        setIsShowOverlay(false);
        if (!APP_WEB) {
            mIsFullScreen = await ipcInvoke('is-full-screen');
            setIsFullScreen(true)
        }
        setIsPopoverPresentModeVisible(false);
        setIsFramePresent(true);
        leftMenuRef.current.onIsFramePresent(true);
        setDisplayMode("preview");
        nTimeoutId = setTimeout(() => {
            setPageSizeNumber(leftMenuRef?.current.getPageSizeDesc())
        }, 100);
        mArrayTimeoutIds.current.push(nTimeoutId);
        //只读
        updateMindmapMode('readonly');
    }

    /**
     * 全屏
     */
    const onFullScreen = (isFullScreen: boolean = true) => {
        if (import.meta.env.DEV) return;

        if (APP_WEB_WWW || APP_WEB) {
            onFullScreenByWeb(isFullScreen);
        } else {
            if (mIsFullScreen) {
                // ipcInvoke("full-screen",{isFullScreen:isFullScreen});
            } else {
                ipcInvoke("full-screen", {isFullScreen: isFullScreen});
            }
        }
        postMessage(EVENT_WINDOW_BAR_VISIBLE, {isWindowBarVisible: !isFullScreen})
    }

    /**
     * 直接WEB端的全屏...不通过客户端
     */
    const onFullScreenByWeb = (bIsFullScreen: boolean) => {
        if (bIsFullScreen) {
            var ele = document.body;
            if (ele.requestFullscreen) {
                ele.requestFullscreen();
            } else if (ele.mozRequestFullScreen) {
                ele.mozRequestFullScreen();
            } else if (ele.webkitRequestFullscreen) {
                ele.webkitRequestFullscreen();
            } else if (ele.msRequestFullscreen) {
                ele.msRequestFullscreen();
            }
            setIsAppWebFullScreen(true);
            setIsShowOverlay(false);
        } else {
            if (document.exitFullScreen) {
                document.exitFullScreen();
            } else if (document.mozCancelFullScreen) {
                document.mozCancelFullScreen();
            } else if (document.webkitExitFullscreen) {
                document.webkitExitFullscreen();
            } else if (document.msExitFullscreen) {
                document.msExitFullscreen();
            }
            setIsAppWebFullScreen(false);
        }
    }

    const onUpdatePresentUIElement = () => {
        setIsSearchVisible(false);
        setIsPresentMode(true);
        setIsCollapsePage(true);
        mIsPresentMode = true;
        excalidrawRef?.onSetReadonlyStatus(true);
        leftMenuRef?.current.onPresentMode(true);
    }

    /**
     * 显示桌面的pro...
     * @param szFrom
     */
    const showDesktopPro = (szFrom: string) => {
        setIsShowDialogDesktopPro(true);
        nTimeoutId = setTimeout(() => {
            dialogDesktopProRef.current?.onShowDialog(szFrom)
        }, 100);
        mArrayTimeoutIds.current.push(nTimeoutId);
    }

    /**
     * 退出全屏展示
     */
    const onExitPresentMode = () => {
        setHomePaddingLeft(mBackupHomeLeftWidth);
        setIsShowBottomPresent(false);

        //修改.excalidraw__embeddable-container  zindex为1，不然影响激光笔的层次，会在card,视频的下层.--还原回来.
        const arrayContainer:any = document.getElementsByClassName('excalidraw__embeddable-container');
        for (let i=0;i<arrayContainer.length;i++){
            arrayContainer[i].style.zIndex = '3';//必须要大于mindmap,不然在mindmap下层的话就不能移动了。
        }
        const arraySticky:any = document.getElementsByClassName('excalidraw__mindmap-container');
        for (let i=0;i<arraySticky.length;i++){
            arraySticky[i].style.zIndex = '2';
        }

        if (mExportInfos?.isReadOnlyStatus) {
            //只读模式的，退出工程，回首页
            dialogMessageBoxRef?.current?.onShowDialog(t("Tips"), t("Sure to exit this project"), t("Ok"), async () => {
                if (APP_WEB_WWW) {
                    mIsPresentMode = false;
                    setIsPresentMode(false);
                    setIsShowExitPresent(false);
                    excalidrawRef?.onSetReadonlyStatus(false);
                    leftMenuRef?.current.onPresentMode(false);
                    setIsCollapsePage(false);
                    leftMenuRef?.current.setOnCollapseStatus(false);
                    //web端打开预览了。退出到正常状态....
                    saveNotes(false).then(res => {
                        nTimeoutId = setTimeout(() => {
                            newProject();
                            setIsWebAlphaVisible(true);
                        }, 100);
                        mArrayTimeoutIds.current.push(nTimeoutId);
                    })
                } else {
                    // setIsShowClosePresent(false);
                    // if (excalidrawRef.getAppState()?.displayMode == 'preview'){
                    //     setIsFramePresent(false);
                    //     setDisplayMode('edit');
                    //     leftMenuRef.current.onIsFramePresent(false);
                    // }
                    //
                    // if (mIsPresentMode){
                    //     excalidrawRef.onRestoreActiveTool();
                    // }else{
                    //     //高亮selection
                    //     var arrayTools = [...toolButtons];
                    //     arrayTools.forEach((p)=>{
                    //         p.isActive = p.id === 'selection';
                    //     })
                    //     setToolButtons(arrayTools);
                    //     excalidrawRef.onSetActiveTool("selection");
                    // }
                    setIsShowExitPresent(false);
                    nTimeoutId = setTimeout(async () => {
                        //截屏保存....
                        // if (mSaveTimes % 5 == 0) {
                        //     await updateFirstThumb();
                        // }
                        // mSaveTimes++;

                        await updateFirstThumb();
                        saveNotes(true);
                    }, 300);
                    mArrayTimeoutIds.current.push(nTimeoutId);
                    ipcInvoke("full-screen", {isFullScreen: false});
                }
            })
        } else {
            setIsShowClosePresent(false);
            if (excalidrawRef.getAppState()?.displayMode == 'preview') {
                setIsFramePresent(false);
                setDisplayMode('edit');

                leftMenuRef.current.onIsFramePresent(false);

                nTimeoutId = setTimeout(() => {
                    //重新读取.....
                    const jsonObj = JSON.parse(mNoteData.current.doc);
                    loadNotesElement(jsonObj).then(res => {
                        const currentBoard = leftMenuRef.current.onGetSelectNode();
                        const linkInfo = {pageId:currentBoard?.key};
                        leftMenuRef.current.setOutMenuData(jsonObj,linkInfo);

                        //强制刷新一下...!!!
                        excalidrawRef.getApp().onRefreshResize();
                    });
                }, 200);
                mArrayTimeoutIds.current.push(nTimeoutId);
            }

            if (mIsPresentMode) {
                excalidrawRef.onRestoreActiveTool();
            } else {
                //高亮selection
                var arrayTools = [...toolButtons];
                arrayTools.forEach((p) => {
                    p.isActive = p.id === 'selection';
                })
                setToolButtons(arrayTools);
                excalidrawRef.onSetActiveTool("selection");
            }

            mIsPresentMode = false;
            setIsPresentMode(false);
            setIsShowExitPresent(false);
            excalidrawRef?.onSetReadonlyStatus(false);
            leftMenuRef?.current.onPresentMode(false);

            //还原一下左边栏之前的状态.....
            setIsCollapsePage(mIsCollapseLeft);
            leftMenuRef?.current.setOnCollapseStatus(mIsCollapseLeft);

            //这里不要处理，不然退出的时候会自动关闭侧栏。让它保持原样
            // setRightSliderWidth(0);
            // setRightSliderLibraryWidth(0);
            // setCommonSliderContainerWidth(0);

            setIsFullScreen(false);
            updateMindmapMode('edit');

            setTimeout(()=>{
                //强制刷新一下...!!!
                excalidrawRef.getApp().onRefreshResize();
            },100)
        }
    }

    /**
     * 插入链接....
     * @param linkInfo
     */
    const onInsertLink = (linkInfo) => {
        excalidrawRef?.onUpdateLink(linkInfo);
    }

    const getImageItemToMap = (szHtml: any) => {
        let noteImage = {};
        var szReg = /<img src=\"atom:\/\/.*\" /g;
        var reg = new RegExp(szReg);
        var arrayMatchs = [...szHtml.matchAll(reg)];
        if (arrayMatchs && arrayMatchs.length > 0) {

        }
    }

    const getNotesImageForExport = async (notes: any) => {
        let notesImg = [];
        for (let i = 0; i < notes.length; i++) {
            const item = notes[i];

            if (item.isFolder) {
                for (let j = 0; j < item.children.length; j++) {
                    let doc = item.children[j].noteDataDoc;
                    if (!doc){
                        doc = await getCardDoc(item.children[j].key || item.id);
                    }
                    let imgs = await imgServer.getImgFromSystem(doc);
                    notesImg.push(...imgs);
                }
            } else {
                let doc = item.noteDatadoc;
                if (!doc){
                    doc = await getCardDoc(item.key || item.id);
                }
                let imgs = await imgServer.getImgFromSystem(doc);
                notesImg.push(...imgs);
            }
        }
        return notesImg;
    }

    const isFileElement = (element) => {
        return element?.type == 'iframe' && element?.customData?.generationData?.type == 'file';
    }

    const getFileBase64 = (szFilePath: string) => {
        return new Promise((resolve, reject) => {
            ipcInvoke("read-file-base64", {filePath: szFilePath}).then(res => {
                resolve(res);
            })
        })
    }

    const getFileBase64ForExport = async (canvas: any) => {
        let arrayFiles: any = [];
        await loopAllNodeAsync(canvas,async (canvas)=>{
            if (canvas.drawJson?.elements){
                for (let j = 0; j < canvas.drawJson.elements.length; j++) {
                    const element = canvas.drawJson.elements[j];
                    if (isFileElement(element)) {
                        if (element.customData?.generationData?.isAbsolutePath)continue;//使用绝对路径的不添加....

                        const data = await getFileBase64(localStorage.getItem(KEY_FILE_DIR) + element?.customData?.generationData?.fileName);
                        if (data){
                            arrayFiles.push({
                                id: element.id,
                                data: data,
                                fileName: element?.customData?.generationData?.fileName,
                                ext: getFileNameExt(element?.customData?.generationData?.fileName)
                            });
                        }

                        //缩略图
                        if (isPdfFileElement(element)){
                            const data = await getFileBase64(localStorage.getItem(KEY_FILE_DIR) + element?.customData?.generationData?.id+".png");
                            if (data){
                                arrayFiles.push({
                                    id: element?.customData?.generationData?.id,
                                    data: data,
                                    fileName: element?.customData?.generationData?.id+".png",
                                    ext: 'png'
                                });
                            }

                        }
                    } else if (isMindmapElement(element)) {
                        const arrayMindmapFiles = await getMindmapFiles(element.data);
                        for (let k = 0; k < arrayMindmapFiles.length; k++) {
                            const item = arrayMindmapFiles[k];
                            const data = await getFileBase64(localStorage.getItem(KEY_FILE_DIR) + item.fileName);
                            if (data){
                                arrayFiles.push({
                                    id: item.id,
                                    data: data,
                                    fileName: item.fileName,
                                    ext: getFileNameExt(item.fileName)
                                })
                            }
                        }
                    }else{
                        //所有的链接。。。。
                        if (element.link){

                        }
                    }
                }
            }
        })
        for (let i = 0; i < canvas.length; i++) {

        }
        return arrayFiles;
    }

    /**
     * 导出时用，本项目所涉及的library
     * --暂时只记录mindmap中的card.
     * @param canvas
     */
    const getCanvasRefLibrary = async (objData: any) => {
        const canvas = objData.canvas;
        let arrayLibrary: any = [];
        let arrayPdfFileHighlights: any = [];
        let arrayVideoHighlights: any = [];
        let arrayAudioHighlights: any = [];
        let arrayCardHighlights:any = [];
        let arrayBoards:any = [];
        let arrayTranscripts:any = [];
        let arrayTiptapElements:any = [];
        await loopAllNodeAsync(canvas,async (node)=>{
            const board = await getBoardById(node.key);
            if (board){
                arrayBoards.push(board);
            }

            if (node.drawJson?.elements){
                for (let j = 0; j < node.drawJson.elements.length; j++) {
                    const element = node.drawJson.elements[j];
                    if (element.link){
                        //导出这个link
                        if (isDeepLink(element.link)){
                            const deeplink = decodeDeeplink(element.link);
                            if (deeplink.type == 'library'){
                                const library = await getCardById(deeplink.id);
                                arrayLibrary.push(library);
                            }
                        }
                    }
                    if (isMindmapElement(element)) {
                        await recursionMindmapData(element.data, async (data: any) => {

                            let szDeeplink = '';
                            if (data.extra) {
                                if (data.extra.type == 'card') {
                                    const card = await getCardById(data.extra.id);
                                    if (card) {
                                        arrayLibrary.push(card);
                                    }
                                }else if (data.extra.type == 'pdf'){
                                    //放到下面去处理....
                                    szDeeplink = createCopyLinkByLibraryItem(data.extra,false);
                                }
                            }

                            if (data.attachmentUrl || data.hyperlink){
                                if (isString(data.attachmentUrl)){
                                    if (isDeepLink(data.attachmentUrl)){
                                        szDeeplink = data.attachmentUrl;
                                    }
                                }else if (data.attachmentUrl?.url){
                                    szDeeplink = data.attachmentUrl.url;
                                }
                                if (data.hyperlink){
                                    szDeeplink = data.hyperlink;
                                }
                            }

                            if (szDeeplink){
                                const deeplink = decodeDeeplink(szDeeplink);
                                if (deeplink.type == 'library'){
                                    //只处理library中的数据.
                                    const card = await getCardById(deeplink.id);
                                    if (card){
                                        if (!arrayLibrary.some(p=>p.id == card.id)){
                                            arrayLibrary.push(card);

                                            const szLibraryId = card.id;

                                            if (card.type == 'pdf'){
                                                //装注记文件.
                                                const pdfAnnos = await ipcInvoke('get-annotations',{fileId:card.id});
                                                if (pdfAnnos){
                                                    arrayPdfFileHighlights.push({id:card.id,annotations:pdfAnnos});
                                                }
                                            }else if (card.type == 'video'){
                                                const highlight = await dbGetHighlightByLibraryId(szLibraryId);
                                                if (highlight){
                                                    arrayVideoHighlights.push(highlight)
                                                }
                                                const transcript = await getTransctiptById(szLibraryId);
                                                if (!arrayTranscripts.some(p=>p.id == transcript.id)){
                                                    arrayTranscripts.push(transcript)
                                                }
                                            }else if (card.type == 'audio'){
                                                const highlight = await dbGetHighlightByLibraryId(szLibraryId);
                                                if (highlight){
                                                    arrayAudioHighlights.push(highlight)
                                                }
                                                const transcript = await getTransctiptById(szLibraryId);
                                                if (!arrayTranscripts.some(p=>p.id == transcript.id)){
                                                    arrayTranscripts.push(transcript)
                                                }
                                            }else if (card.type == 'card'){
                                                const arrayCardHighs = await getCardListByLibraryId(szLibraryId);
                                                for (let k=0;k<arrayCardHighs.length;k++){
                                                    const item = arrayCardHighs[k];
                                                    if (!arrayCardHighlights.some(p=>p.id == item.id)){
                                                        arrayCardHighlights.push(item);
                                                    }
                                                }
                                            }else if (isLiveVideoType(card.type)){
                                                //在线视频类的...
                                                const highlight = await dbGetHighlightByLibraryId(szLibraryId);
                                                if (highlight){
                                                    arrayVideoHighlights.push(highlight)
                                                }
                                                const transcript = await getTransctiptById(szLibraryId);
                                                if (!arrayTranscripts.some(p=>p.id == transcript.id)){
                                                    arrayTranscripts.push(transcript)
                                                }
                                            }

                                        }
                                    }
                                }
                            }
                        })
                    }else if (isPdfAnnoElement(element) || isPdfFileElement(element)){
                        //pdf及标注
                        let szLibraryId = element.customData.generationData.id;
                        if (isPdfAnnoElement(element)){
                            szLibraryId = element.customData.generationData.id;
                        }
                        //这里实际取的是注记的主文件.
                        const card = await getCardById(szLibraryId);
                        if (card){
                            if (!arrayLibrary.some(p=>p.id == card.id)){
                                arrayLibrary.push(card);

                                //装注记文件.
                                const pdfAnnos = await ipcInvoke('get-annotations',{fileId:card.id});
                                if (pdfAnnos){
                                    arrayPdfFileHighlights.push({id:card.id,annotations:pdfAnnos});
                                }
                            }
                        }
                    }else if (isVideoAnnoElement(element) || isFileVideoElement(element) || isLiveVideoElement(element)){
                        //视频及标注
                        let szLibraryId = element.customData.generationData.id;
                        if (isVideoAnnoElement(element)){
                            szLibraryId = element.customData.generationData.id;
                        }
                        const card = await getCardById(szLibraryId);
                        if (card){
                            if (!arrayLibrary.some(p=>p.id == card.id)){
                                arrayLibrary.push(card);

                                //装注记文件.
                                const highlight = await dbGetHighlightByLibraryId(szLibraryId);
                                if (highlight){
                                    arrayVideoHighlights.push(highlight)
                                }
                            }
                        }

                        const transcript = await getTransctiptById(szLibraryId);
                        if (transcript){
                            if (!arrayTranscripts.some(p=>p.id == transcript.id)){
                                arrayTranscripts.push(transcript)
                            }
                        }
                    }else if (isAudioAnnoElement(element) || isAudioFileElement(element)){
                        //音频及标注
                        let szLibraryId = element.customData.generationData.id;
                        if (isAudioAnnoElement(element)){
                            szLibraryId = element.customData.generationData.id;
                        }
                        const card = await getCardById(szLibraryId);
                        if (card){
                            if (!arrayLibrary.some(p=>p.id == card.id)){
                                arrayLibrary.push(card);

                                //装注记文件.
                                const highlight = await dbGetHighlightByLibraryId(szLibraryId);
                                if (highlight){
                                    arrayAudioHighlights.push(highlight)
                                }
                            }
                        }
                        const transcript = await getTransctiptById(szLibraryId);
                        if (transcript){
                            if (!arrayTranscripts.some(p=>p.id == transcript.id)){
                                arrayTranscripts.push(transcript)
                            }
                        }
                    }else if (isCardAnnoElement(element) || isNoteElement(element)){
                        let szLibraryId = element.customData.generationData.id;
                        if (isCardAnnoElement(element)){
                            szLibraryId = element.customData.generationData.id;
                        }
                        const card = await getCardById(szLibraryId);
                        if (card){
                            if (!arrayLibrary.some(p=>p.id == card.id)) {
                                arrayLibrary.push(card);
                            }
                        }
                        //取所有的注记
                        const arrayCardHighs = await getCardListByLibraryId(szLibraryId);
                        for (let k=0;k<arrayCardHighs.length;k++){
                            const item = arrayCardHighs[k];
                            if (!arrayCardHighlights.some(p=>p.id == item.id)){
                                arrayCardHighlights.push(item);
                            }
                        }
                    }else if (isImageElement(element) || isEmbeddableElement(element)){
                        const card = await getCardById(element.customData?.generationData?.id || element.id);
                        if (card){
                            if (!arrayLibrary.some(p=>p.id == card.id)) {
                                arrayLibrary.push(card);
                            }
                        }
                    }else if (isTextElement(element) || isStickyNotesElement(element)){
                        arrayTiptapElements.push(element);
                    }
                }
            }
        })

        //notes----
        for (let j=0;j<objData.notes.length;j++){
            const item = objData.notes[j];
            //保存卡片本身..
            if (!arrayLibrary.some(p=>p?.id == item.key)){
                const card = await getCardById(item.key);
                if (card){
                    arrayLibrary.push(card);
                }
            }

            var arrayLinks:any = [];
            await statCardLink({...item,id:item.key},arrayLinks,null);
            arrayLibrary.push(...arrayLinks);

            //所有注记也保存一下，有的不在画布的element区域
            const arrayCardHighs = await getCardListByLibraryId(item.key);
            for (let k=0;k<arrayCardHighs.length;k++){
                const item = arrayCardHighs[k];
                if (!arrayCardHighlights.some(p=>p.id == item.id)){
                    arrayCardHighlights.push(item);
                }
            }
        }

        return [arrayLibrary,arrayPdfFileHighlights,arrayVideoHighlights,arrayAudioHighlights,arrayCardHighlights,arrayBoards,arrayTranscripts,arrayTiptapElements];
    }

    /**
     * 高亮数据
     * @param arrayLibrary
     */
    const getCanvasRefHighlight = async (arrayLibrary:any)=>{
        let arrayHighlight: any = [];
        for (let i = 0; i < arrayLibrary.length; i++) {
            const highlight = await dbGetHighlightByLibraryId(arrayLibrary[i].id);
            if (highlight){
                arrayHighlight.push(highlight);
            }
        }
        return arrayHighlight;
    }

    /**
     * pdf文件的高亮
     * @param arrayLibrary
     */
    const getCanvasPdfFileHighlight = async (arrayLibrary:any)=>{
        let arrayPdfs:any = [];
        for (let i = 0; i < arrayLibrary.length; i++) {
            const item = arrayLibrary[i];
            if (item.type == 'pdf'){
                const pdfAnnos = await ipcInvoke('get-annotations',{fileId:item.id});
                if (pdfAnnos){
                    arrayPdfs.push(pdfAnnos);
                }
            }
        }
        return arrayPdfs;
    }

    /**
     * 找 card 的链接....
     * @param card
     */
    async function statCardLink(card:any,arrayLinkNodes:any,childNode:any){
        if (!card.doc){
            card.doc = await getCardDoc(card.id);
        }
        let pattern = /<deeplink(.*?)<\/deeplink>/g;
        let results = card.doc.match(pattern);
        if (results){
            const parser = new DOMParser();
            for (let i=0;i<results.length;i++){
                //获取标题和链接
                const szStr = results[i];
                const xmlDoc = parser.parseFromString(szStr,'text/xml');
                const deeplinkTag = xmlDoc.getElementsByTagName('deeplink')[0];
                if (deeplinkTag){
                    const szName = deeplinkTag.getAttribute('text');
                    const szHref:any = deeplinkTag.getAttribute('href');

                    const deeplink = decodeDeeplink(szHref);
                    if (deeplink.childType == 'card'){
                        const dbCard:any = await getCardById(deeplink.id,true);
                        if (dbCard){
                            if (arrayLinkNodes){
                                arrayLinkNodes.push(dbCard);
                            }else{
                                childNode.children.push(dbCard);
                            }
                            //找下一级
                            await statCardLink(dbCard,arrayLinkNodes,null)
                        }
                    }
                }
            }
        }
    }

    /**
     * 带基本信息导出
     * @param info
     */
    const onExportEventWithInfo = async (info: any) => {
        const objData = await getCanvasNoteDatas(false,true);
        //如果element中带有file,禁止导出
        if (!hasLicense() && !hasDesktopBaseLicense()) {
            let isContainFile = false;
            for (let i = 0; i < objData.canvas.length; i++) {
                for (let j = 0; j < objData.canvas[i].drawJson.elements.length; j++) {
                    const element = objData.canvas[i].drawJson.elements[j];
                    if (isFileElement(element)) {
                        isContainFile = true;
                        break;
                    }
                }
                if (isContainFile) {
                    break;
                }
            }
            if (isContainFile) {
                // dialogMessageBoxRef.current.onShowDialogOkCancel(t("Tips"),t("FreeUsesCanImportDesc"),t("Cancel"),t("See plans"),()=>{
                //
                // },()=>{
                //     ipcSend('open-url',import.meta.env.VITE_HTTP_PURCHASE_PRICE);
                // })
                setIsShowDialogExportTips(true);
                nTimeoutId = setTimeout(() => {
                    dialogExportTipsRef.current?.onShowDialog(() => {
                        info.isBackupMode = true;
                        onExportPcanvas_x(objData, info);
                    });
                }, 100);
                mArrayTimeoutIds.current.push(nTimeoutId);

                return;
            }
        }

        onExportPcanvas_x(objData, info);
    }

    function chunkStringify(obj: any) {
        const chunkSize = 100 * 1024 * 1024; // 设置块的大小
        const chunks = [];
        let start = 0;
        let end = 0;
        while (start < obj.length) {
            end = start + chunkSize;
            const chunk = JSON.stringify(obj.slice(start, end), replaceIconAndHasUpdate);
            chunks.push(chunk);
            start += chunkSize;
        }
        return chunks.join('');
    }

    /**
     * 开始导出......
     * @param objData
     * @param info
     */
    const onExportPcanvas_x = async (objData: any, info: any) => {
        onExportPcanvas_x_zip(objData, info);

        return;

        // clearMenuDataIcon(objData.canvas);
        // clearMenuDataIcon(objData.notes);
        //增加一个属性notesimage
        /*之前的导出--直接导出一个json文件 -- 20240902  大文件有问题....
        objData.notesImage = await getNotesImageForExport(objData.notes);
        objData.files = await getFileBase64ForExport(objData.canvas);
        objData.librarys = await getCanvasRefLibrary(objData.canvas) ;//这里暂时只处理mindmap的card部分.....
        info.isReadOnlyStatus = mExportType === 'exportCanvas';
        info.deviceId = localStorage.getItem(KEY_MACHINEID);
        objData.info = info;
        const szData = JSON.stringify(objData,replaceIconAndHasUpdate);
        if (APP_WEB || APP_WEB_WWW){
            let fileName = info.title + '.' +(('exportCanvas' == mExportType)?'pcanvas':'pcanvasx');
            let blob = new Blob([szData]);
            saveAs(blob,fileName);
            return;
        }

        if ('exportCanvas' == mExportType) {
            ipcSend("saveFile", {filters: [{name: 'Canvas', extensions: ['pcanvas']}], stream: szData,fileName:info.title});
        } else if ('exportCanvasx' == mExportType) {
            ipcSend("saveFile", {filters: [{name: 'Canvas', extensions: ['pcanvasx']}], stream: szData,fileName:info.title});
        }
         */

        // setMenuPageDataIcon(objData.canvas);
        // setMenuNoteDataIcon(objData.notes);
    }


    //region 这里是使用jszip--前端压缩
    /**
     * 开始导出......
     * @param objData
     * @param info
     */
    const onExportPcanvas_x_zip_web = async (objData: any, info: any) => {
        setIsShowSmallLoading(true);

        // var blob = new Blob(['hhhh'],{type:'text/plain'});
        // saveAs(blob,'xxxxxx.txt');

        let zip = new JSZip();
        //增加一个属性notesimage
        // try {
        objData.notesImage = await getNotesImageForExport(objData.notes);
        objData.files = [];//await getFileBase64ForExport(objData.canvas);
        const arrayLibAndPdf = await getCanvasRefLibrary(objData);//这里暂时只处理mindmap的card部分和引用中的card.....
        objData.librarys = arrayLibAndPdf[0];
        objData.pdfAnnos = arrayLibAndPdf[1];
        objData.videoHighlights = arrayLibAndPdf[2];
        objData.audioHighlights = arrayLibAndPdf[3];
        objData.cardHighlights = arrayLibAndPdf[4];
        objData.boards = arrayLibAndPdf[5];
        objData.transcripts = arrayLibAndPdf[6];
        const arrayTiptapElements = arrayLibAndPdf[7];//tiptap-doc的
        //导出所有自定义属性。。。导入的时候根据需要
        const arrayProperties = await getPropertyList();
        objData.properties = arrayProperties.filter(p=>p.groupName != 'default');
        //tags也全部带上，
        objData.tags = await getTagList();
        //views也带上。
        objData.propertyViews = await getAllViewList();

        for (let i=0;i<objData.librarys.length;i++){
            const item = objData.librarys[i];
            if (item.type == 'card'){
                const arrayNotesImages = await getNotesImageForExport([item]);
                arrayNotesImages.forEach(p=>{
                    if (!objData.notesImage.some(pp=>pp.id == p.id)){
                        objData.notesImage.push(p);
                    }
                })
            }
        }



        info.isReadOnlyStatus = mExportType === 'exportCanvas';
        info.deviceId = localStorage.getItem(KEY_MACHINEID);
        info.originProjectId = mNoteData.current?.id;

        objData.info = info;
        if (mThumbUrl){
            info.thumbUrl = mThumbUrl;
            //这个需要导出
            const fileName = mThumbUrl.replace('localfile://','');
            if (mThumbUrl.startsWith('localfile://')){
                const data = await ipcInvoke('read-file-absolute-path', {filePath: localStorage.getItem(KEY_FILE_DIR) + fileName});
                if (data){
                    zip.file(fileName, data);
                }
            }
        }

        const szData = JSON.stringify(objData, replaceIconAndHasUpdate);
        zip.file(ZIP_DATA_DB_NAME, szData);

        //加入objData.notesImage
        for (let i=0;i<objData.notesImage.length;i++){
            const noteImage = objData.notesImage[i];
            const fileName = noteImage.id + '.'+noteImage.ext;
            const data = await ipcInvoke('read-file-absolute-path', {filePath: localStorage.getItem(KEY_FILE_DIR) + fileName});
            if (data){
                zip.file(fileName, data);
            }
        }

        //加入tiptapText/stickynotes
        for (let i=0;i<arrayTiptapElements.length;i++){
            const tiptapItem = await getTiptapDoc(arrayTiptapElements[i].id);
            if (tiptapItem?.doc){
                const arrayImgs = imgServer.getImageListFromHtml(tiptapItem.doc);
                for (let j=0;j<arrayImgs.length;j++){
                    const noteImage = arrayImgs[j];
                    const fileName = noteImage.id + '.'+noteImage.ext;
                    const data = await ipcInvoke('read-file-absolute-path', {filePath: localStorage.getItem(KEY_FILE_DIR) + fileName});
                    if (data){
                        zip.file(fileName, data);
                    }
                }
            }

        }

        //加入pdf注记中的图片.
        for (let i=0;i<objData.pdfAnnos.length;i++){
            const pdfAnno = objData.pdfAnnos[i];
            for (let j=0;j<pdfAnno.annotations.length;j++){
                const item = pdfAnno.annotations[j];
                if (item.type == 'image'){
                    const fileName = item.id + '.png';
                    const data = await ipcInvoke('read-file-absolute-path', {filePath: localStorage.getItem(KEY_FILE_DIR) + fileName});
                    if (data){
                        zip.file(fileName, data);
                    }
                }
            }
        }

        //加入视频注记中的图片。。。
        for (let i=0;i<objData.videoHighlights.length;i++){
            const videoAnno = objData.videoHighlights[i];
            for (let j=0;j<videoAnno.data.length;j++){
                const item = videoAnno.data[j];
                if (item.thumbImage){
                    const fileName = getFileName(item.thumbImage);
                    const data = await ipcInvoke('read-file-absolute-path', {filePath: localStorage.getItem(KEY_FILE_DIR) + fileName});
                    if (data){
                        zip.file(fileName, data);
                    }
                }
            }
        }

        //加入board中的图片
        for (let i=0;i<objData.boards.length;i++){
            const item = objData.boards[i];
            if (item.thumbUrl){
                const fileName = getFileName(item.thumbUrl);
                const data = await ipcInvoke('read-file-absolute-path', {filePath: localStorage.getItem(KEY_FILE_DIR) + fileName});
                if (data){
                    zip.file(fileName, data);
                }
            }
        }

        await zipProjectFileForExport_web(objData.canvas, zip);
        zip.generateAsync({type: 'blob'}).then(function (content) {
            let fileName = (info.title ? info.title : t("Untitled")) + '.' + (('exportCanvas' == mExportType) ? 'pcanvas' : 'pcanvasx');
            setIsShowSmallLoading(false);
            saveAs(content, fileName)
        })
        // } catch (e) {
        //     logger('onExportPcanvas_x_zip error:' + e);
        // }
    }

    /**
     * project的file压缩成zip
     * @param canvas
     * @param zip
     */
    const zipProjectFileForExport_web = async (canvas: any, zip: any) => {
        let arrayFiles: any = [];
        const mapZip:any = {};
        await loopAllNodeAsync(canvas,async (node)=>{
            if (node.drawJson?.elements){
                for (let j = 0; j < node.drawJson.elements.length; j++) {
                    const element = node.drawJson.elements[j];
                    if (isFileElement(element)) {
                        let data = await ipcInvoke('read-file-absolute-path', {filePath: localStorage.getItem(KEY_FILE_DIR) + element?.customData?.generationData?.fileName});
                        if (data){
                            if (!mapZip[element?.customData?.generationData?.fileName]){
                                zip.file(element?.customData?.generationData?.fileName, data);
                                mapZip[element?.customData?.generationData?.fileName] = true;
                            }
                        }
                        //附带的缩略图
                        let szThumbName = element.customData?.generationData?.id+".png";
                        data = await ipcInvoke('read-file-absolute-path', {filePath: localStorage.getItem(KEY_FILE_DIR) + szThumbName});
                        if (data){
                            if (!mapZip[szThumbName]){
                                zip.file(szThumbName, data);
                                mapZip[szThumbName] = true;
                            }
                        }
                    } else if (isMindmapElement(element)) {
                        const arrayMindmapFiles = await getMindmapFiles0(element.data);
                        for (let k = 0; k < arrayMindmapFiles.length; k++) {
                            const item = arrayMindmapFiles[k];
                            const data = await ipcInvoke('read-file-absolute-path', {filePath: localStorage.getItem(KEY_FILE_DIR) + item.fileName});
                            if (data){
                                if (!mapZip[item.fileName]) {
                                    zip.file(item.fileName, data);
                                    mapZip[item.fileName] = true;
                                }
                            }
                        }
                    }else if (isVideoAnnoElement(element)){
                        const library = await getCardById(element.customData.generationData.id);
                        if (library){
                            let data = await ipcInvoke('read-file-absolute-path', {filePath: localStorage.getItem(KEY_FILE_DIR) + library.fileName});
                            if (data){
                                if (!mapZip[library.fileName]){
                                    zip.file(library.fileName, data);
                                    mapZip[library.fileName] = true;
                                }
                            }
                        }
                    }else if (isPdfAnnoElement(element)){
                        //自己的缩略图
                        let szThumbName = element.id+".png";
                        if (!mapZip[szThumbName]){
                            let thumbData =  await ipcInvoke('read-file-absolute-path', {filePath: localStorage.getItem(KEY_FILE_DIR) + szThumbName});
                            if (thumbData){
                                zip.file(szThumbName, thumbData);
                                mapZip[szThumbName] = true;
                            }
                        }

                        const library = await getCardById(element.customData.generationData.id);
                        if (library){
                            let data = await ipcInvoke('read-file-absolute-path', {filePath: localStorage.getItem(KEY_FILE_DIR) + library.fileName});
                            if (data){
                                if (!mapZip[library.fileName]){
                                    zip.file(library.fileName, data);
                                    mapZip[library.fileName] = true;

                                    //文件的缩略图
                                    szThumbName = library.id+".png";
                                    data = await ipcInvoke('read-file-absolute-path', {filePath: localStorage.getItem(KEY_FILE_DIR) + szThumbName});
                                    if (data){
                                        zip.file(szThumbName, data);
                                        mapZip[szThumbName] = true;
                                    }
                                }
                            }
                        }
                    }else if (isProjectLinkElement(element)){
                        if (element.customData.thumbImage){
                            const szThumbName = getFileName(element.customData.thumbImage)
                            let szFilePath = localStorage.getItem(KEY_FILE_DIR) + szThumbName;
                            const data = await ipcInvoke('read-file-absolute-path', {filePath:szFilePath});
                            if (data){
                                zip.file(szThumbName, data);
                                mapZip[szThumbName] = true;
                            }
                        }
                    }
                }

                //图片文件...
                const arrayFiles = Object.values(node.drawJson.files);
                for (let j=0;j<arrayFiles.length;j++){
                    const file = arrayFiles[j];
                    const szFileName = file.id+'.'+extFromMineType(file.mimeType);
                    const data = await ipcInvoke('read-file-absolute-path', {filePath: localStorage.getItem(KEY_FILE_DIR) + szFileName});
                    if (data){
                        zip.file(szFileName, data);
                    }
                }
            }
        })

        return arrayFiles;
    }

    //endregion  使用前端压缩结束-----

    /**
     * 使用electron压缩大文件..
     * @param objData
     * @param info
     */
    /**
     * 开始导出......
     * @param objData
     * @param info
     */
    const onExportPcanvas_x_zip = async (objData: any, info: any) => {

        // setIsShowSmallLoading(true);

        // var blob = new Blob(['hhhh'],{type:'text/plain'});
        // saveAs(blob,'xxxxxx.txt');

        const arrayDatas:any = [];
        //增加一个属性notesimage
        // try {
        objData.notesImage = await getNotesImageForExport(objData.notes);
        objData.files = [];//await getFileBase64ForExport(objData.canvas);
        const arrayLibAndPdf = await getCanvasRefLibrary(objData);//这里暂时只处理mindmap的card部分和引用中的card.....
        objData.librarys = arrayLibAndPdf[0];
        objData.pdfAnnos = arrayLibAndPdf[1];
        objData.videoHighlights = arrayLibAndPdf[2];
        objData.audioHighlights = arrayLibAndPdf[3];
        objData.cardHighlights = arrayLibAndPdf[4];
        objData.boards = arrayLibAndPdf[5];
        objData.transcripts = arrayLibAndPdf[6];
        const arrayTiptapElements = arrayLibAndPdf[7];//tiptap-doc的
        //导出所有自定义属性。。。导入的时候根据需要
        const arrayProperties = await getPropertyList();
        objData.properties = arrayProperties.filter(p=>p.groupName != 'default');
        //tags也全部带上，
        objData.tags = await getTagList();
        //views也带上。
        objData.propertyViews = await getAllViewList();

        for (let i=0;i<objData.librarys.length;i++){
            const item = objData.librarys[i];
            if (item.type == 'card'){
                const arrayNotesImages = await getNotesImageForExport([item]);
                arrayNotesImages.forEach(p=>{
                    if (!objData.notesImage.some(pp=>pp.id == p.id)){
                        objData.notesImage.push(p);
                    }
                })
            }
        }


        info.isReadOnlyStatus = mExportType === 'exportCanvas';
        info.deviceId = localStorage.getItem(KEY_MACHINEID);
        info.originProjectId = mNoteData.current?.id;

        objData.info = info;
        if (mThumbUrl){
            info.thumbUrl = mThumbUrl;
            //这个需要导出
            const fileName = mThumbUrl.replace('localfile://','');
            if (mThumbUrl.startsWith('localfile://')){
                // const data = await ipcInvoke('read-file-absolute-path', {filePath: localStorage.getItem(KEY_FILE_DIR) + fileName});
                // if (data){
                //     zip.file(fileName, data);
                // }
                arrayDatas.push({
                    fileName:fileName,
                })
            }
        }

        const szData = JSON.stringify(objData, replaceIconAndHasUpdate);
        // zip.file(ZIP_DATA_DB_NAME, szData);
        arrayDatas.push({
            fileName:ZIP_DATA_DB_NAME,
            data:szData
        })


        //加入objData.notesImage
        for (let i=0;i<objData.notesImage.length;i++){
            const noteImage = objData.notesImage[i];
            const fileName = noteImage.id + '.'+noteImage.ext;
            // const data = await ipcInvoke('read-file-absolute-path', {filePath: localStorage.getItem(KEY_FILE_DIR) + fileName});
            // if (data){
            //     zip.file(fileName, data);
            // }
            arrayDatas.push({
                fileName:fileName,
            })
        }

        //加入tiptapText/stickynotes
        for (let i=0;i<arrayTiptapElements.length;i++){
            const tiptapItem = await getTiptapDoc(arrayTiptapElements[i].id);
            if (tiptapItem?.doc){
                const arrayImgs = imgServer.getImageListFromHtml(tiptapItem.doc);
                for (let j=0;j<arrayImgs.length;j++){
                    const noteImage = arrayImgs[j];
                    const fileName = noteImage.id + '.'+noteImage.ext;
                    // const data = await ipcInvoke('read-file-absolute-path', {filePath: localStorage.getItem(KEY_FILE_DIR) + fileName});
                    // if (data){
                    //     zip.file(fileName, data);
                    // }
                    arrayDatas.push({
                        fileName:fileName,
                    })
                }
            }

        }

        //加入pdf注记中的图片.
        for (let i=0;i<objData.pdfAnnos.length;i++){
            const pdfAnno = objData.pdfAnnos[i];
            for (let j=0;j<pdfAnno.annotations.length;j++){
                const item = pdfAnno.annotations[j];
                if (item.type == 'image'){
                    const fileName = item.id + '.png';
                    // const data = await ipcInvoke('read-file-absolute-path', {filePath: localStorage.getItem(KEY_FILE_DIR) + fileName});
                    // if (data){
                    //     zip.file(fileName, data);
                    // }
                    arrayDatas.push({
                        fileName:fileName,
                    })
                }
            }
        }

        //加入视频注记中的图片。。。
        for (let i=0;i<objData.videoHighlights.length;i++){
            const videoAnno = objData.videoHighlights[i];
            for (let j=0;j<videoAnno.data.length;j++){
                const item = videoAnno.data[j];
                if (item.thumbImage){
                    const fileName = getFileName(item.thumbImage);
                    // const data = await ipcInvoke('read-file-absolute-path', {filePath: localStorage.getItem(KEY_FILE_DIR) + fileName});
                    // if (data){
                    //     zip.file(fileName, data);
                    // }
                    arrayDatas.push({
                        fileName:fileName,
                    })
                }
            }
        }

        //加入board中的图片
        for (let i=0;i<objData.boards.length;i++){
            const item = objData.boards[i];
            if (item.thumbUrl){
                const fileName = getFileName(item.thumbUrl);
                // const data = await ipcInvoke('read-file-absolute-path', {filePath: localStorage.getItem(KEY_FILE_DIR) + fileName});
                // if (data){
                //     zip.file(fileName, data);
                // }
                arrayDatas.push({
                    fileName:fileName,
                })
            }
        }

        await zipProjectFileForExport(objData.canvas, arrayDatas);
        let fileName = (info.title ? info.title : t("Untitled")) + '.' + (('exportCanvas' == mExportType) ? 'pcanvas' : 'pcanvasx');
        ipcInvoke('export-pcanvasx',{name:fileName,arrayFiles:arrayDatas}).then(res=>{
            setIsShowSmallLoading(false);
            window.closeProgress();
            if (res == 'ok'){
                message.success(t('ExportProjectSuccess'));
            }else if (res == 'error'){
                message.error(t('ExportProjectFail'));
            }
        })
        // zip.generateAsync({type: 'blob'}).then(function (content) {
        //     let fileName = (info.title ? info.title : t("Untitled")) + '.' + (('exportCanvas' == mExportType) ? 'pcanvas' : 'pcanvasx');
        //     setIsShowSmallLoading(false);
        //     saveAs(content, fileName)
        // })
    }

    /**
     * project的file压缩成zip
     * @param canvas
     * @param zip
     */
    const zipProjectFileForExport = async (canvas: any, arrayDatas: any) => {
        let arrayFiles: any = [];
        const mapZip:any = {};
        await loopAllNodeAsync(canvas,async (node)=>{
            if (node.drawJson?.elements){
                for (let j = 0; j < node.drawJson.elements.length; j++) {
                    const element = node.drawJson.elements[j];
                    if (isFileElement(element)) {
                        if (!mapZip[element?.customData?.generationData?.fileName]){
                            // zip.file(element?.customData?.generationData?.fileName, data);
                            mapZip[element?.customData?.generationData?.fileName] = true;
                            arrayDatas.push({
                                fileName:element?.customData?.generationData?.fileName
                            })
                        }
                        //附带的缩略图
                        let szThumbName = element.customData?.generationData?.id+".png";
                        if (!mapZip[szThumbName]){
                            mapZip[szThumbName] = true;
                            arrayDatas.push({
                                fileName:szThumbName
                            })
                        }
                        // data = await ipcInvoke('read-file-absolute-path', {filePath: localStorage.getItem(KEY_FILE_DIR) + szThumbName});
                        // if (data){
                        //     if (!mapZip[szThumbName]){
                        //         zip.file(szThumbName, data);
                        //         mapZip[szThumbName] = true;
                        //     }
                        // }
                    } else if (isMindmapElement(element)) {
                        const arrayMindmapFiles = await getMindmapFiles0(element.data);
                        for (let k = 0; k < arrayMindmapFiles.length; k++) {
                            const item = arrayMindmapFiles[k];
                            if (!mapZip[item.fileName]) {
                                mapZip[item.fileName] = true;
                                arrayDatas.push({
                                    fileName:item.fileName
                                })
                            }
                            // const data = await ipcInvoke('read-file-absolute-path', {filePath: localStorage.getItem(KEY_FILE_DIR) + item.fileName});
                            // if (data){
                            //     if (!mapZip[item.fileName]) {
                            //         zip.file(item.fileName, data);
                            //         mapZip[item.fileName] = true;
                            //     }
                            // }
                        }
                    }else if (isVideoAnnoElement(element)){
                        const library = await getCardById(element.customData.generationData.id);
                        if (library){
                            if (!mapZip[library.fileName]){
                                mapZip[library.fileName] = true;
                                arrayDatas.push({
                                    fileName:library.fileName
                                })
                            }
                            // let data = await ipcInvoke('read-file-absolute-path', {filePath: localStorage.getItem(KEY_FILE_DIR) + library.fileName});
                            // if (data){
                            //     if (!mapZip[library.fileName]){
                            //         zip.file(library.fileName, data);
                            //         mapZip[library.fileName];
                            //     }
                            // }
                        }
                    }else if (isPdfAnnoElement(element)){
                        //自己的缩略图
                        let szThumbName = element.id+".png";
                        if (!mapZip[szThumbName]){
                            arrayDatas.push({
                                fileName:szThumbName
                            })
                            mapZip[szThumbName] = true;

                            // let thumbData =  await ipcInvoke('read-file-absolute-path', {filePath: localStorage.getItem(KEY_FILE_DIR) + szThumbName});
                            // if (thumbData){
                            //     zip.file(szThumbName, thumbData);
                            //     mapZip[szThumbName] = true;
                            // }
                        }

                        const library = await getCardById(element.customData.generationData.id);
                        if (library){
                            if (!mapZip[library.fileName]){
                                mapZip[library.fileName] = true;
                                arrayDatas.push({
                                    fileName:library.fileName
                                })

                                //文件的缩略图
                                szThumbName = library.id+".png";
                                arrayDatas.push({
                                    fileName:szThumbName
                                })
                                mapZip[szThumbName] = true;
                            }

                            // let data = await ipcInvoke('read-file-absolute-path', {filePath: localStorage.getItem(KEY_FILE_DIR) + library.fileName});
                            // if (data){
                            //     if (!mapZip[library.fileName]){
                            //         zip.file(library.fileName, data);
                            //         mapZip[library.fileName] = true;
                            //
                            //         //文件的缩略图
                            //         szThumbName = library.id+".png";
                            //         data = await ipcInvoke('read-file-absolute-path', {filePath: localStorage.getItem(KEY_FILE_DIR) + szThumbName});
                            //         if (data){
                            //             zip.file(szThumbName, data);
                            //             mapZip[szThumbName] = true;
                            //         }
                            //     }
                            // }
                        }
                    }else if (isProjectLinkElement(element)){
                        if (element.customData.thumbImage){
                            const szThumbName = getFileName(element.customData.thumbImage)

                            if (!mapZip[library.fileName]){
                                mapZip[library.fileName] = true;
                                arrayDatas.push({
                                    fileName:library.fileName
                                })
                            }
                            // let szFilePath = localStorage.getItem(KEY_FILE_DIR) + szThumbName;
                            // const data = await ipcInvoke('read-file-absolute-path', {filePath:szFilePath});
                            // if (data){
                            //     zip.file(szThumbName, data);
                            //     mapZip[szThumbName] = true;
                            // }
                        }
                    }
                }

                //图片文件...
                const arrayFiles = Object.values(node.drawJson.files);
                for (let j=0;j<arrayFiles.length;j++){
                    const file = arrayFiles[j];
                    const szFileName = file.id+'.'+extFromMineType(file.mimeType);
                    arrayDatas.push({
                        fileName:szFileName
                    })
                    // const data = await ipcInvoke('read-file-absolute-path', {filePath: localStorage.getItem(KEY_FILE_DIR) + szFileName});
                    // if (data){
                    //     zip.file(szFileName, data);
                    // }
                }
            }
        })

        return arrayFiles;
    }

    /*关闭搜索*/
    const onCloseSearch = () => {
        setIsSearchVisible(false);
        setSearchKey('');
    }
    /**
     * 当前page 整个项目选择
     * @param e
     */
    const onSearchOptionChange = (key) => {
        if ("currentPage" === key) {
            //当前页
        } else {
            //all
        }
        // mCurrentSearchRange = key;
        setDefaultSearch(key);
        onSearchElement(key);
    }


    /**
     * 搜索上一个或者下一个
     * 搜索下一个
     * 搜索上一个
     * @param nValue
     */
    const onSearchNextOrPre = (nValue) => {
        if (mIsLoading) {
            console.log('isLoading.....')
            return;
        };
        if (arraySearchResult.length == 0) return;
        var nIndex = 0;
        if (-1 === nValue) {
            //上一个
            var nPreIndex = currentSearchIndex - 1;
            if (nPreIndex < 0) {
                nPreIndex = arraySearchResult.length - 1;
            }
            setCurrentSearchIndex(nPreIndex);
            nIndex = nPreIndex;
        } else {
            //下一个...
            var nNextIndex = currentSearchIndex + 1;
            if (nNextIndex >= arraySearchResult.length) {
                nNextIndex = 0;
            }
            setCurrentSearchIndex(nNextIndex);
            nIndex = nNextIndex;
        }
        //选中
        //是否是同一个画布
        var searchItem:any = arraySearchResult[nIndex];
        if (searchItem.type == 'page') {
            if (leftMenuRef.current.onGetCurrentSelectKey() != arraySearchResult[nIndex].key) {
                leftMenuRef.current.onNavSelectedItem(arraySearchResult[nIndex].key);
                nTimeoutId = setTimeout(() => {
                    excalidrawRef?.onScrollToElementFromElement(arraySearchResult[nIndex].element);
                }, 300);
                mArrayTimeoutIds.current.push(nTimeoutId);
            } else {
                nTimeoutId = setTimeout(() => {
                    excalidrawRef?.onScrollToElementFromElement(arraySearchResult[nIndex].element);
                }, 300);
                mArrayTimeoutIds.current.push(nTimeoutId);
            }
        }else if (searchItem.type == 'mindmap'){
            clearMindmapActiveNode();

            if (searchItem.key != leftMenuRef.current.onGetCurrentSelectKey()) {
                leftMenuRef.current.onNavSelectedItem(searchItem.key);
                nTimeoutId = setTimeout(() => {
                    excalidrawRef?.onScrollToElementNoSelected(searchItem.element);

                    const currentMindMap = mindMapCache.get(searchItem.element.id);
                    // @ts-ignore
                    currentMindMap.renderer.expandToNodeUid(searchItem.uid, () => {
                        setTimeout(() => {
                            // @ts-ignore
                            const node = currentMindMap.renderer.findNodeByUid(searchItem.uid);
                            node.active();
                        }, 200);
                    });
                    // const node = currentMindMap.renderer.findNodeByUid(searchItem.uid);
                    // node?.active();
                }, 300);
                mArrayTimeoutIds.current.push(nTimeoutId);
            } else {
                nTimeoutId = setTimeout(() => {
                    excalidrawRef?.onScrollToElementNoSelected(searchItem.element);

                    const currentMindMap = mindMapCache.get(searchItem.element.id);
                    // @ts-ignore
                    currentMindMap.renderer.expandToNodeUid(searchItem.uid, () => {
                        setTimeout(() => {
                            // @ts-ignore
                            const node = currentMindMap.renderer.findNodeByUid(searchItem.uid);
                            node.active();
                        }, 200);
                    });
                    // const node = currentMindMap.renderer.findNodeByUid(searchItem.uid);
                    // node?.active();

                }, 300);
                mArrayTimeoutIds.current.push(nTimeoutId);
            }
        }
        else {
            leftMenuRef.current.onSelectNoteByKey(searchItem.key, searchItem.parentKey);
        }
    }

    /**
     * 搜索结果中是否已包含了note
     * @param arraySearchs
     * @param szId
     */
    const isContainNote = (arraySearchs:any,szId:any)=>{
        return arraySearchs.some(p=>p.type == 'page' && (p.element?.id == szId || p.element?.customData?.generationData?.id == szId));
    }


    const getMindmapStringData = (data,jsonText)=>{
        jsonText.text += removeHtmlTags(data.data.text);
        if (isArray(data.children)){
            for (let i=0;i<data.children.length;i++){
                const item = data.children[i];
                getMindmapStringData(item,jsonText)
            }
        }
    }
    /**
     * mindmap 是否包含
     * @param data
     * @param searchKey
     */
    const isContainMindmapData = (data,searchKey)=>{
        if (!data)return false;
        const jsonText = {text:''};
        getMindmapStringData(data,jsonText);
        return (jsonText.text.toLowerCase().includes(searchKey))
    }

    /**
     * 搜索-和笔记
     * 搜索画布
     * 搜索 搜索 搜索 搜索
     */
    const onSearchElement = async (key = undefined,searchBoardKey = undefined) => {
        if (isStringNullOrEmpty(searchKey)) {
            setArraySearchResult([]);
            return;
        }
        const newJsonResult = await getCanvasNoteDatas(false,false);
        if (newJsonResult?.canvas?.length == 0)return;

        var arrayDatas = newJsonResult.canvas;//leftMenuRef.current.getAllMenuData();
        var arraySearchs:any = [];
        var isCurrentPage = ('currentPage' === defaultSearch);
        if (key != undefined) {
            isCurrentPage = 'currentPage' == key;
        }
        let szSearchKey = searchKey?.toLowerCase();
        let currentSelectKey = leftMenuRef.current.onGetCurrentSelectKey();
        if (searchBoardKey){
            currentSelectKey = searchBoardKey;
        }
        await loopAllNodeAsync(arrayDatas,async (item)=>{
            if (isCurrentPage){
                if (item.key != currentSelectKey)return;
            }

            if (item.drawJson && item.drawJson.elements) {
                for (var j = 0; j < item.drawJson.elements.length; j++) {
                    var ele = item.drawJson.elements[j];
                    if (ele.name && ele.name.toLowerCase().includes(szSearchKey)){
                        arraySearchs.push({key: item.key, element: ele, type: 'page'});
                        continue;
                    }
                    if (ele.customData?.generationData?.infoNotes?.toLowerCase()?.includes(szSearchKey)){
                        arraySearchs.push({key: item.key, element: ele, type: 'page'});
                        continue;
                    }
                    if (ele.type === 'text') {
                        let szTxt = ele.text || '';
                        if (szTxt.replaceAll('\r','').replaceAll('\n','').toLowerCase().indexOf(szSearchKey) != -1 || removeHtmlTags(ele.value).toLowerCase().includes(szSearchKey)) {
                            arraySearchs.push({key: item.key, element: ele, type: 'page'});
                        }
                    } else if (ele.type == 'iframe') {
                        var szHtml = ele.customData?.generationData?.html;
                        if (ele.customData?.generationData?.name && ele.customData?.generationData?.name?.toLowerCase()?.indexOf(szSearchKey) != -1) {
                            arraySearchs.push({key: item.key, element: ele, type: 'page'});
                        }
                        else {
                            if (isPdfAnnoElement(ele) || isCardAnnoElement(ele)){
                                //pdf注记
                                const pdfData = ele.customData.generationData.pdfData;
                                if (pdfData?.name?.toLowerCase()?.includes(szSearchKey) || pdfData?.text?.toLowerCase()?.includes(szSearchKey) || pdfData?.comment?.toLowerCase()?.includes(szSearchKey)){
                                    arraySearchs.push({key: item.key, element: ele, type: 'page'});
                                }
                            }else if (isVideoAnnoElement(ele) || isAudioAnnoElement(ele)){
                                const videoData = ele.customData.generationData.videoData;
                                if (videoData?.title?.toLowerCase()?.includes(szSearchKey) || videoData?.content?.toLowerCase()?.includes(szSearchKey) || videoData?.comment?.toLowerCase()?.includes(szSearchKey)){
                                    arraySearchs.push({key: item.key, element: ele, type: 'page'});
                                }
                            }
                            else if(!isStringNullOrEmpty(szHtml)) {
                                var szTxt = removeHtmlTags(szHtml);
                                if (szTxt.toLowerCase().indexOf(szSearchKey) != -1) {
                                    arraySearchs.push({key: item.key, element: ele, type: 'page'});
                                }
                            }
                        }
                    }else if (isMindmapElement(ele)){
                        const mindmapData = ele.data;
                        await recursionMindmapData(mindmapData,(mindmapData:any)=>{
                            const szTxt = removeHtmlTags(mindmapData.text);
                            if (szTxt.toLowerCase().includes(szSearchKey)){
                                arraySearchs.push({key: item.key, element: ele, type: 'mindmap',uid:mindmapData.uid});
                            }
                        })
                        // if (isContainMindmapData(mindmapData,szSearchKey)){
                        //     arraySearchs.push({key: item.key, element: ele, type: 'page'});
                        // }
                    }else if (isStickyNotesElement(ele)){
                        if (ele.value && ele.value.toLowerCase().includes(szSearchKey)){
                            arraySearchs.push({key: item.key, element: ele, type: 'page'});
                        }
                    }
                }
            }
        })

        // for (var i = 0; i < arrayDatas.length; i++) {
        //     var item = arrayDatas[i];
        //     if (isCurrentPage) {
        //         if (item.key != currentSelectKey) continue;
        //     }
        //
        // }

        var arrayNotes = leftMenuRef.current?.getAllNoteData();
        for (var i = 0; i < arrayNotes.length; i++) {
            var item = arrayNotes[i];
            if (item.title.toLowerCase().indexOf(szSearchKey) != -1) {
                if (!isContainNote(arraySearchs,item.key)){
                    arraySearchs.push({key: item.key, type: 'note'});
                }
            }
            if (item.isFolder) {
                for (var j = 0; j < item.children.length; j++) {
                    var note = item.children[j];
                    if (note.title.toLowerCase().indexOf(szSearchKey) != -1) {
                        arraySearchs.push({key: note.key, parentKey: item.key, type: 'note'});
                    } else {
                        var szTxt = removeHtmlTags(note.noteDataDoc);
                        if (szTxt.toLowerCase().indexOf(szSearchKey) != -1) {
                            arraySearchs.push({key: note.key, parentKey: item.key, type: 'note'});
                        }
                    }
                }
            }
        }

        setCurrentSearchIndex(0);
        setArraySearchResult(arraySearchs);
        if (arraySearchs.length > 0) {
            var item = arraySearchs[0];
            //转到当前这个页面....
            if (params?.state?.usr?.linkInfo?.pageId){
                const nIndex = arraySearchs.findIndex(p=>p.key == params?.state?.usr?.linkInfo?.pageId);
                if (nIndex != -1){
                    setCurrentSearchIndex(nIndex);
                    item = arraySearchs[nIndex];
                }
            }

            if (item.type === 'page') {
                if (item.key != leftMenuRef.current.onGetCurrentSelectKey()) {
                    leftMenuRef.current.onNavSelectedItem(item.key);

                    nTimeoutId = setTimeout(() => {
                        excalidrawRef?.onScrollToElementFromElement(item.element);
                    }, 300);
                    mArrayTimeoutIds.current.push(nTimeoutId);
                } else {
                    nTimeoutId = setTimeout(() => {
                        excalidrawRef?.onScrollToElementFromElement(item.element);
                    }, 300);
                    mArrayTimeoutIds.current.push(nTimeoutId);
                }
            } else if (item.type == 'mindmap'){
                clearMindmapActiveNode();

                if (item.key != leftMenuRef.current.onGetCurrentSelectKey()) {
                    leftMenuRef.current.onNavSelectedItem(item.key);
                    nTimeoutId = setTimeout(() => {
                        excalidrawRef?.onScrollToElementNoSelected(item.element);

                        const currentMindMap = mindMapCache.get(item.element.id);
                        // @ts-ignore
                        currentMindMap.renderer.expandToNodeUid(item.uid, () => {
                            setTimeout(() => {
                                // @ts-ignore
                                const node = currentMindMap.renderer.findNodeByUid(item.uid);
                                node.active();

                                setTimeout(()=>{
                                    inputSearchRef.current?.focus();
                                })

                            }, 200);
                        });
                        // const node = currentMindMap.renderer.findNodeByUid(item.uid);
                        // node?.active();

                    }, 300);
                    mArrayTimeoutIds.current.push(nTimeoutId);
                } else {
                    nTimeoutId = setTimeout(() => {
                        excalidrawRef?.onScrollToElementNoSelected(item.element);

                        const currentMindMap = mindMapCache.get(item.element.id);
                        // @ts-ignore
                        currentMindMap.renderer.expandToNodeUid(item.uid, () => {
                            setTimeout(() => {
                                // @ts-ignore
                                const node = currentMindMap.renderer.findNodeByUid(item.uid);
                                node.active();

                                setTimeout(()=>{
                                    inputSearchRef.current?.focus();
                                },10)

                            }, 200);
                        });
                        // const node = currentMindMap.renderer.findNodeByUid(item.uid);
                        // node?.active();

                    }, 300);
                    mArrayTimeoutIds.current.push(nTimeoutId);
                }
            }
            else {
                leftMenuRef.current.onSelectNoteByKey(item.key, item.parentKey);
            }
        }else{
            //没有搜索结果，但是又是从搜索进来的，直接转到这个画板...
            // if (searchBoardKey){
            //     onNavSub(searchBoardKey)
            // }
        }
    }

    const onMessageBoxClickEvent = () => {

    }

    /**
     * 更新frame 列表
     */
    const onUpdateFrameList = () => {
        const szActiveTool = excalidrawRef.onGetActiveTool();
        if (szActiveTool == 'frame') {
            const elements = excalidrawRef.getDrawJson().elements;
            leftMenuRef.current.setFrameElementList(elements);
        }
    }

    /**
     * 最近颜色
     */
    const getLastestColors = () => {
        let arrayColors = [];
        const colors = localStorage.getItem("lastestCanvasColor");
        if (colors != null && colors !== '') {
            arrayColors = JSON.parse(colors);
        }
        return arrayColors;
    }
    //保存最近的颜色
    const setLastestColors = (szNewHexColor: string) => {
        let arrayColors = getLastestColors();
        //remove 重复的...
        for (let i = arrayColors.length - 1; i >= 0; i--) {
            if (arrayColors[i].toLowerCase() === szNewHexColor.toLowerCase()) {
                arrayColors.splice(i, 1);
            }
        }
        let maxCount = arrayColors.length;
        if (maxCount > 17) {
            maxCount = 17;
        }
        let arrayNewColors = [szNewHexColor];
        for (let i = 0; i < maxCount; i++) {
            arrayNewColors.push(arrayColors[i]);
        }
        localStorage.setItem("lastestCanvasColor", JSON.stringify(arrayNewColors));
    }


    /**
     * 文件选择更改...
     * @param event
     */
    const handleFileChange = (event: any) => {
        const selectedFile = event.target.files[0];
        var fileReader = new FileReader();
        fileReader.onload = (e) => {
            const szJsonStr: string = (e.target.result);
            params.state.usr = {};
            params.state.usr.importNoteData = JSON.parse(szJsonStr);
            onLoadData(false).then(res => {
                setIsWebAlphaVisible(false);

                nTimeoutId = setTimeout(() => {
                    saveNotes().then(async (r) => {
                        setTimeout(async () => {
                            //刷新列表
                            const arrayNotes: any = await getNoteList();
                            arrayNotes.sort((a, b) => {
                                return b.updateTime - a.updateTime;
                            })
                            refreshRecentlyMoreMenu(arrayNotes);
                        }, 2000);
                    });
                }, 1000);
                mArrayTimeoutIds.current.push(nTimeoutId);
            });

        }
        fileReader.readAsText(selectedFile, 'utf-8');
    };

    async function resizeBase64ImageSize(szImgBase64: any) {
        try {
            let file = new File([base64ToBlob(szImgBase64)], 'preview', {type: MIME_TYPES.png});
            const newImageFile = await resizeImageFile(file,
                {
                    outputType: MIME_TYPES.jpg,
                    maxWidthOrHeight: 600,
                });
            szImgBase64 = await fileToBase64(newImageFile);
        } catch (e) {
            console.log('thumb resize err...' + e);
        }
        return szImgBase64;
    }

    /**
     * 选择PDF文件
     * @param event
     */
    const handlePdfFileChange = (event: any) => {
        const selectedFile = event.target.files[0];
        ipcInvoke('copy-file', {filePath: selectedFile.path}).then(async (res) => {
            if (window.eventAddChoosePdf) {
                let szImgBase64 = await getPdfImageThumb('localfile://' + res);
                szImgBase64 = await resizeBase64ImageSize(szImgBase64);
                var item = {
                    id: generateUUID2(),
                    type: 'pdf',
                    fileName: res,
                    name: getFileNameWithoutExt(res),
                    isSingle: true,
                    thumbImage: szImgBase64
                }
                window.eventAddChoosePdf(item);
                //保存到card
                await updateCard(item);
                delete window.eventAddChoosePdf;
            }
            // insert file type --这里插入的pdf默认隐藏....
            // excalidrawRef.insertFileElement(res,true).then(element=>{
            //     if(window.eventAddChoosePdf){
            //         window.eventAddChoosePdf({
            //             id:element.id,
            //             type:'pdf',
            //             fileName:element.customData.generationData.fileName,
            //             showName:element.customData.generationData.showName
            //         })
            //         delete window.eventAddChoosePdf;
            //     }
            // });
        });
    }

    /**
     * 选择pcanvas*文件
     */
    const openPcanvasFile = () => {
        fileInputRef.current?.click();
    }

    /**
     * 是否显示左侧 右边线条
     */
    const isShowLeftMenuRightBorder = () => {
        // (!isCollapsePage && !isFramePresent && !APP_WEB)
        if (isCollapsePage) return false;
        if (isPresentMode) return false;
        return true;
    }

    /**
     * 右侧PDF更多
     */
    const getSliderMoreItems = () => {
        if (mSliderContainerType == "pdf") {
            return [
                getItem(t("Open in popup"), 'openPdfInPopup', <IconOpenInPopup/>, undefined, undefined, () => {
                    onSliderClickMenu('openPdfInPopup')
                }),
                getItem(t("Open in fullscreen"), 'openPdfInFullScreen', <IconOpenInFullscreen/>, undefined, undefined, () => {
                    onSliderClickMenu('openPdfInFullScreen')
                }),

                getItem(t("Export as Pdf"), 'pdfExport', <IconMenuExportItem/>, undefined, undefined, () => {
                    onSliderClickMenu('pdfExport')
                }),
                getItem(MENU_SEPARATOR, generateUUID2(), null, undefined, 'divider', () => {

                }),
                getItem(t("Rename"), 'pdfRename', <IconRename/>, undefined, undefined, () => {
                    onSliderClickMenu('pdfRename')
                }),
                getItem(t("Search"), 'pdfSearch', <IconSearch/>, undefined, undefined, () => {
                    onSliderClickMenu('pdfSearch')
                }),
                getItem(t("View all highlights"), 'pdfViewHighlights', <IconViewAllHighlight/>, undefined, undefined, () => {
                    onSliderClickMenu('pdfViewHighlights')
                }),
                getItem(t("Show info"), 'showInfo', <IconInfoMenu/>, undefined, undefined, () => {
                    onSliderClickMenu('showInfo-pdf')
                }),
                getItem(MENU_SEPARATOR, generateUUID2(), null, undefined, 'divider', () => {

                }),
                getItem(t("Copy link"), 'copyLink', <IconCopyLink/>, undefined, undefined, () => {
                    onSliderClickMenu('copyLink-pdf')
                }),
                getItem(t("Manage tags"), 'manageTags', <IconManagerTags/>, undefined, undefined, () => {
                    onSliderClickMenu('manageTags-pdf')
                }),
                getItem(t("Add to project"), 'addToProject', <IconAddToProject/>, undefined, undefined, () => {
                    onSliderClickMenu('addToProject-pdf')
                }),
                getItem(t("Delete"), 'pdfDelete', <IconDelete/>, undefined, undefined, () => {
                    onSliderClickMenu('pdfDelete')
                }),
            ]
        } else if (mSliderContainerType == 'card') {
            const MENU_MORE: MenuItem[] = [
                getItem(t("Open in popup"), 'openInPopup', <IconOpenInPopup/>, undefined, undefined, () => {
                    onSliderClickMenu('openInPopup')
                }),
                getItem(t("Open in fullscreen"), 'openInFullScreen', <IconOpenInFullscreen/>, undefined, undefined, () => {
                    onSliderClickMenu('openInFullScreen')
                }),
                getItem(t("ExportPDF"), 'exportPdf', <IconMenuExportItem/>, undefined, undefined, async () => {
                    onSliderClickMenu('exportPdf')
                }),
                getItem(t("ExportMarkdown"), 'exportMarkdown', <IconMenuExportItem/>, undefined, undefined, () => {
                    onSliderClickMenu('exportMarkdown')
                }),
                getItem(MENU_SEPARATOR, generateUUID2(), null, undefined, 'divider', () => {

                }),
                // getItem(t("ShowInfo"), 'showInfo', null, undefined, undefined, () => {
                //   window.GOpenCountWords();
                // }),
                getItem(t("Rename"), 'rename', <IconRename/>, undefined, undefined, () => {
                    // @ts-ignore
                    onSliderClickMenu('rename')
                }),
                getItem(sliderCardData?.isFavirated === 1?t('Cancel favor'):t("Add to Favorites"), 'favor', sliderCardData?.isFavirated === 1?<IconRemoveFavor/>:<IconAddToFavor/>, undefined, undefined, async () => {
                    const ccccccc = await editorRef.current?.save?.();
                    await updateCard({
                        ...ccccccc,
                        type: 'card',
                        isFavirated: (sliderCardData?.isFavirated == 1) ? 0 : 1
                    }).then(res=>{
                        postMessage(EVENT_FAVIRIATE_CHANGE);
                    });
                    const card:any = await getCardById(sliderCardData?.id, true);
                    setSliderCardData(card);
                }),
                getItem(t("Generic copy"), 'makeCopy', <IconMakeCopy/>, undefined, undefined, async () => {
                    onSliderClickMenu("makeACopy")
                }),
                getItem(t("Search"), 'search', <IconSearch/>, undefined, undefined, () => {
                    onSliderClickMenu('search');
                }),
                getItem(t("Show info"), 'showInfo', <IconInfoMenu/>, undefined, undefined, async () => {
                    const saveData: any = await editorRef.current?.getSaveData();
                    const cardData:any = {...sliderCardData};
                    cardData.doc = saveData.doc;
                    cardData.name = saveData.name;
                    cardData.type = 'card';
                    if (!cardData.name) {
                        cardData.name = t("Untitled");
                    }
                    if (!cardData.createTime) {
                        cardData.createTime = Date.now();
                        cardData.updateTime = Date.now();
                    }
                    window.showInfo('library', cardData)
                }),
                getItem(<div>{t("Version history")}<label className={'beta'}>{'Beta'}</label></div>, 'versionHistory', <IconVersionHistory/>, undefined, undefined, () => {
                    //历史记录
                    window.showDialogCardHistory(sliderCardData?.id,(newCard:any)=>{
                        //更新本界面
                        setSliderCardData(newCard);
                        //更新画布
                        postMessage(EVENT_UPDATE_FORCE_CARD_IIIINNNNNFFFFOOOOOO,{id:newCard.id,customData:{generationData:{html:newCard.doc,name:newCard.name}}});
                        //更新侧栏
                    });
                }),
                getItem(MENU_SEPARATOR, generateUUID2(), null, undefined, 'divider', () => {

                }),

                getItem(t("Copy link"), 'copyLink', <IconCopyLink/>, undefined, undefined, () => {
                    createCopyLink('library', sliderCardData?.id, null, null);
                }),

                getItem(t("Manage tags"), 'manageTags', <IconManagerTags/>, undefined, undefined, async () => {
                    //如果是新建的card,操作标签前先保存这个card
                    let card: any = await getCardById(sliderCardData?.id, false);
                    let ddddddatatataat = sliderCardData;

                    if (!card) {
                        // logger('save as a new card....');
                        const ccccccc = await editorRef.current?.save?.();
                        await updateCard({
                            ...ccccccc,
                            type: 'card'
                        }, true, true, 'fromManageTag');
                        card = await getCardById(sliderCardData.id, true);
                        setSliderCardData(card);
                        ddddddatatataat = card;
                        global.g_currentNoteData = card;

                        // logger('a new card....');
                        // logger(ddddddatatataat);
                    }
                    window.showManageTags([ddddddatatataat]);
                }),
                getItem(t("Add to project"), 'addToProject', <IconAddToProject/>, undefined, undefined, async () => {
                    const ccccccc = await editorRef.current?.save?.();
                    await updateCard({
                        ...ccccccc,
                        type: 'card',
                        isFavirated: (sliderCardData.isFavirated == 1) ? 0 : 1
                    })
                    const card:any = await getCardById(sliderCardData.id, true);
                    setSliderCardData(card);
                    window.showDialogChooseProject([card])
                }),

                getItem(t("Delete"), 'delete', <IconDelete/>, undefined, undefined, () => {
                    onSliderClickMenu('delete')
                }),
            ];

            //移除不要的.
            if (sliderCardData?.type == 'journal'){
                for (let i=MENU_MORE.length-1;i>=0;i--){
                    const item = MENU_MORE[i];
                    if (item.key == 'delete' || item.key == 'rename' || item.key == 'favor'){
                        MENU_MORE.splice(i,1);
                    }
                }
            }
            return MENU_MORE;
        }
        return [];
    }

    /**
     * 视频的菜单
     */
    const getVideoSliderMenu = (link:any)=>{
        let arrayLibraryMenus = createLibraryItemMenu('slider',false,{type:isAudio(link)?'audio':'video',link:link});
        const arrayMenus = [];
        arrayMenus.push({
            label: t("Open in popup"),
            key: 'openInPopup',
            icon: <IconOpenInPopup/>
        })
        if (!isAudio(link)){
            arrayMenus.push({
                label: t("Open in fullscreen"),
                key: 'openInFullscreen',
                icon: <IconOpenInFullscreen/>
            })
        }

        arrayMenus.push({
            key:'seper_1',
            type:'divider'
        })
        arrayMenus.push(...arrayLibraryMenus);
        return arrayMenus;

        /*
        return [
            getItem(t("Open in popup"), 'openInPopup', null, undefined, undefined, () => {
                postMessage(EVENT_OPEN_VIDEO_IN_POPUP,{isFullScreen:false,element:mSliderVideoNotes.element});
                setCommonSliderContainerWidth(0);
            }),
            getItem(t("Open in fullscreen"), 'openInFullscreen', null, undefined, undefined, () => {
                postMessage(EVENT_OPEN_VIDEO_IN_POPUP,{isFullScreen:true,element:mSliderVideoNotes.element});
                setCommonSliderContainerWidth(0);
            }),
            getItem(MENU_SEPARATOR, generateUUID2(), null, undefined, 'divider', () => {

            }),
            getItem(t("Export txt"), 'exportTxt', null, undefined, undefined, () => {
                const videoNotes = mSliderVideoNotes.element?.videoNotes;
                if (videoNotes){
                    saveElementVideoNotesAsJSON(exportCurrentElementVideoNotes(videoNotes));
                }else{
                    message.error(t("No data"))
                }
            }),
            getItem(t("Copy to clipboard"), 'copyToClipboard', null, undefined, undefined, () => {
                //获取内容
                const videoNotes = mSliderVideoNotes.element?.videoNotes;
                if (videoNotes){
                    let szTxt = '';
                    for (let i=0;i<videoNotes.length;i++){
                        let item = videoNotes[i];
                        szTxt += `[timestamp]:${getTimeText(item.time)}\n${item.title}${item.title?'\n':''}${item.content}\n\n`;
                    }
                    clipboard.write(szTxt);
                    message.info(t("Copied to clipboard"))
                }else{
                    message.error(t("No data"))
                }
            }),
        ]
         */
    }

    /**
     * 处理通用右键的更多菜单，视频.
     * @param info
     */
    const handleCommonMoreMenu = async (info:any)=>{
        if (info.domEvent?.ctrlKey || info.domEvent?.metaKey) {
            global.g_isCtrlPressed = true;
            setTimeout(()=>{
                global.g_isCtrlPressed = false;
            },2000);
        }

        const szAction = info.key;
        const item:any = await getCardById(mSliderVideoNotes.element.customData?.generationData?.id || mSliderVideoNotes.element.id);
        if (szAction == 'openInPopup'){
            postMessage(EVENT_OPEN_VIDEO_IN_POPUP,{isFullScreen:false,element:mSliderVideoNotes.element});
            // setCommonSliderContainerWidth(0);
        }else if (szAction == 'openInFullscreen'){
            postMessage(EVENT_OPEN_VIDEO_IN_POPUP,{isFullScreen:true,element:mSliderVideoNotes.element});
            // setCommonSliderContainerWidth(0);
        }else if (szAction == 'delete') {
            window.showMessageBox(t("Tips"),t("ConfirmDeleteLibraryItem"),t("Cancel"),t("Delete"),null,()=>{
                drawIndexSliderHeaderAction("collapse")
                item.isDeleted = 1;
                item.deleteTime = Date.now();
                updateCard(item).then(res=>{
                    postMessage(EVENT_FAVIRIATE_CHANGE);
                    postMessage(EVENT_REFRESH_RECENTS);
                    postMessage(EVENT_REFRESH_LIBRARY_LIST);
                    postMessage(EVENT_DELETE_ELEMENT_BY_ID,{id:item.id})
                });
                //删除这个card所关联的项目
                deleteAllCardFromRefProject(item);
            })
        }else if (szAction == 'rename'){
            window.showCommonInput(item.name,t("Rename"),"",t("Cancel"),t("Save"),(szContent:string)=>{
                window.closeCommonInput();
                item.name = szContent;
                // setData({...item});
                renameCard(item).then(res=>{
                    //不知道啥排序，直接刷新列表。。
                    postMessage(EVENT_REFRESH_LIBRARY_LIST)
                    postMessage(EVENT_REFRESH_HIGHLIGHT_LIST);
                    refreshSliderBreadcrumb(item);
                    //刷新画布上的...
                    postMessage(EVENT_RENAME_LIBRARY_ITEM,{...item})
                });
            });
        }else if (szAction == 'exportCardPdf'){
            //card to pdf
            const szHtmlDoc:any = await getCardDoc(item.id);
            editDoc(item.id,szHtmlDoc,item.name).then(res=>{
                nTimeoutId = setTimeout(() => {
                    ipcSend('save-pdf-to-system', item.id, item.name)
                }, 10);
                mArrayTimeoutIds.current.push(nTimeoutId);
            })
        }else if (szAction == 'exportPdf' || szAction == 'exportVideo' || szAction == 'exportAudio' || szAction == 'exportFile'){
            //导出文件
            const szFilePath = localStorage.getItem(KEY_FILE_DIR) + item.fileName;
            ipcSend('saveFile', {
                filters: [{name: "All file", extensions: ['*']}],
                filePath: szFilePath,
                fileName: item.name+'.'+getFileNameExt(item.fileName)
            })
        }else if (szAction == 'managerTags'){
            //管理标签
            window.showManageTags([item]);
        }else if (szAction == 'addToProject'){
            //添加到project.
            window.showDialogChooseProject([item]);
        }else if (szAction == 'makeACopy'){
            const szHtml = await getCardDoc(item.id);
            const newItem = {
                ...item,
                id:generateUUID2(),
                name:item.name+"("+t("Copy")+")",
                doc:szHtml
            }
            updateCard(newItem).then(res=>{
                postMessage(EVENT_REFRESH_LIBRARY_LIST);
                message.info(t("Copyed"))
            });
        }else if (szAction == 'viewAllHighlights'){
            window.showPdfPreview(item.name,item.id,item.fileName,true,true)
        }else if (szAction == 'addToProjectChecked'){
            // addToProjectEvent();
        }else if (szAction == 'managerTagsChecked'){
            // managerTagsEvent();
        }else if (szAction == 'deleteChecked'){
            // deleteSelectedEvent();
        }else if (szAction == 'favor'){
            if (item.isFavirated){
                item.isFavirated = 0;
            }else{
                item.isFavirated = 1;
            }
            item.favirateTime = Date.now();
            updateCard(item,false).then(res=>{
                postMessage(EVENT_FAVIRIATE_CHANGE);
                postMessage(EVENT_REFRESH_LIBRARY_LIST);
            });
        }else if (szAction == 'showInfo'){
            window.showInfo('library',item);
        }else if (szAction == 'versionHistory'){
            window.showDialogCardHistory(item.id);
        }
        else if (szAction == 'copyLink'){
            createCopyLink("library", item.id,item.type,null);
        }else if (szAction == 'exportMarkdown'){
            // onExportSingleMd(item);
        }else if (szAction == 'add'){
            // onAddNewItem();
        }else if (szAction == 'edit'){
            // const doc = await getCardDoc(item.id);
            // Global.g_currentNoteData = {...item, doc};
            // openEditor(item.id,false,props.from == FROM_LIBRARY,props.from);
        }else if (szAction == 'showInSystemExporler'){
            ipcSend("show-in-exporler",((item.isAbsolutePath?'':localStorage.getItem(KEY_FILE_DIR)))+item.fileName)
        }else if (szAction == "importHighlights"){
            //导入--笔记
            window.showDialogImportHighlight((file,content)=>{
                videoContentRef.current?.onImportHighlights(file,content);
            });
        }else if (szAction == "exportHighlights"){
            //导出注记
            videoContentRef.current?.saveExportElementVideoNotes();
        }else if (szAction == "copyToClipboard"){
            const text = videoContentRef.current!.getCurrentElementVideoNotes();
            await navigator.clipboard.writeText(text);
            message.info(t('Notes copied to clipboard'))
        }else if (szAction == 'importTranscript'){
            //导入--字幕
            window.showDialogImportTranscript((file,content)=>{
                let arrayResults = importTranscriptFromContent(content);
                //保存....
                console.log(arrayResults);
                if (arrayResults && arrayResults.length > 0) {
                    updateTranscript({
                        id: sliderVideoNotes.element.customData?.generationData?.id,
                        data: arrayResults
                    }).then(res => {
                        window.globalRefreshList('refresh_transcript_');
                        window.globalRefreshList('switch_to_transcript_');
                    });
                }
            })
        }
    }

    const exportCurrentElementVideoNotes = (elementVideoNotes) => {
        const exportValues = {
            videoTitle: formatDate(new Date(),'yyyyMMddhhmmss'),
            pastedText: elementVideoNotes.reduce((pre, item) => {
                return `${pre}[timestamp]:${getTimeText(item.time)}
${item.title}
${item.content}
`;
            }, ""),
        };
        return exportValues;
    };

    /**
     * 刷新侧栏顶上的名称
     * @param item
     */
    const refreshSliderBreadcrumb = (item:any)=>{
        if (selectSliderRightMenu == 'library'){
            setArrayBreadcrumb(createBreadcrumb('library',item.name))
        }else if (selectSliderRightMenu == 'highlight'){
            setArrayBreadcrumb(createBreadcrumb('highlight',item.name))
        }
    }

    /**
     * 右侧更多的点击事件
     * @param key
     */
    const onSliderClickMenu = async (key: string) => {
        switch (key) {
            case "openPdfInPopup":
                // setFileState({
                //     open: true,
                //     filePath: pdfFilePath,
                //     fileId: pdfFileId,
                //     fileName: pdfFileName,
                //     isFullScreen: false,
                //     isViewAllHighlight: false,
                // })
                window.showPdfPreview(pdfFileName,pdfFileId,pdfFilePath);
                break;
            case "openPdfInFullScreen":
                // setFileState({
                //     open: true,
                //     filePath: pdfFilePath,
                //     fileId: pdfFileId,
                //     fileName: pdfFileName,
                //     isFullScreen: true,
                //     isViewAllHighlight: false
                // })
                window.showPdfPreview(pdfFileName,pdfFileId,pdfFilePath,true);
                break;
            case "pdfRename": {
                // setIsShowDialogPdfRename(true);
                getCardById(pdfFileId)?.then(item=>{
                    if (item){
                        window.showCommonInput(item.name,t("Rename"),"",t("Cancel"),t("Rename"),(szContent:string)=>{
                            window.closeCommonInput();
                            item.name = szContent;
                            setPdfFileName(szContent);
                            renameCard(item);
                            //更新画布上的....
                            updateDrawElementName(pdfFileId,szContent);
                            refreshSliderBreadcrumb(item);
                        });
                    }
                })

                break;
            }
            case "pdfSearch": {
                const iframe = document.getElementById("pdf-iframe-slider") as HTMLIFrameElement;
                if (iframe) {
                    iframe.contentWindow._reader?.toggleFindPopup({primary: true, open: true})
                }
            }
                break;
            case "pdfViewHighlights": {
                const iframe = document.getElementById("pdf-iframe-slider") as HTMLIFrameElement;
                if (iframe) {
                    iframe.contentWindow._reader?.toggleSidebar(true)
                }
            }

                break;
            case "pdfExport": {
                const iframe = document.getElementById("pdf-iframe-slider") as HTMLIFrameElement;
                if (iframe) {
                    message.loading({
                        key: "export-loading",
                        type: "loading",
                        content: t("Exporting")
                    })
                    const szFileName = pdfFileName;
                    const szData = JSON.stringify({
                        isAnnotations: true,
                        fileName: szFileName,
                        type: "download-pdf"
                    });
                    iframe.contentWindow?.postMessage(szData, {
                        targetOrigin: '*'
                    })
                }
                break;
            }
            case  "pdfDelete": {
                dialogMessageBoxRef.current.onShowDialog(t("Tips"), t("ConfirmDeleteLibraryItem"), t("Confirm"), async () => {
                    postMessage(EVENT_DELETE_ELEMENT_BY_ID, {id: pdfFileId});
                    setRightSliderWidth(0);
                    setPdfFilePath('');
                    //从库中删除
                    const library:any = await getCardById(pdfFileId);
                    if (library){
                        library.isDeleted = 1;
                        updateCard(library).then(r=>{
                            postMessage(EVENT_REFRESH_LIBRARY_LIST);
                        })
                    }
                });

                break;
            }
            case "openInPopup": {
                const noteData = await editorRef.current?.save?.();
                postMessage(EVENT_UPDATE_NOTE, {data: noteData, isInsertCanvas: false});
                Global.g_currentNoteData = noteData;
                // Global.g_isNotePopupWindow = true;
                nTimeoutId = setTimeout(() => {
                    openEditor(mSliderCardId, true)
                }, 40);
                mArrayTimeoutIds.current.push(nTimeoutId);
            }
                break;
            case "openInFullScreen": {
                const noteData = await editorRef.current?.save?.();
                postMessage(EVENT_UPDATE_NOTE, {data: noteData, isInsertCanvas: false});
                Global.g_currentNoteData = noteData;
                // Global.g_currentNoteFullScreen = true;
                //
                // setTimeout(() => {
                //     setCardFullScreen(true);
                //     openEditor(mSliderCardId)
                // }, 40);
                window.navigate(getCardPath(),{cardId:mSliderCardId})
            }
                break;
            case "exportPdf":
                const data = await getSaveData()
                const name = getCardTitle(data);
                //保存到doc
                editDoc((data.id || LASTEST_NOTE_DOC), data.doc, data.name).then(res => {
                    nTimeoutId = setTimeout(() => {
                        ipcSend('save-pdf-to-system', (data.id || LASTEST_NOTE_DOC), name)
                    }, 10);
                    mArrayTimeoutIds.current.push(nTimeoutId);
                })
                break;
            case "exportMarkdown":
                const data0 = await getSaveData()
                excalidrawRef?.onExportSingleMd(data0);
                break;
            case "makeACopy":
                const noteSimpleData = await getSaveData();
                postMessage(EVENT_COPY_DOC_NOTE, noteSimpleData);
                message.info(t("Copyed"))
                break;
            case "rename":
                editorRef.current?.rename?.()
                break;
            case "delete":
                dialogMessageBoxRef.current.onShowDialog(t("Tips"), t("ConfirmDeleteLibraryItem"), t("Confirm"), () => {
                    if (sliderCardData) {
                        global.g_deletedCardIds[sliderCardData?.id] = true;
                        postMessage(EVENT_DELETE_HTML_NOTE, {id: sliderCardData?.id});
                        setRightSliderWidth(0);
                        setSliderCardData(null);
                        const newCard = {...sliderCardData};
                        newCard.isDeleted = 1;
                        updateCard(newCard).then(res=>{
                            // window.globalRefreshList('refresh_single_library_item_',sliderCardData.id,{isDeleted:1});
                            window.globalRefreshList('refreshLibraryList_')
                        })

                    }
                });
                break;
            case "search":
                window.GSearchOpen?.()
                break;
            case "showInfo-pdf":
                getCardById(pdfFileId)?.then(res=>{
                    window.showInfo('library',res);
                })
                break;
            case "manageTags-pdf":
                getCardById(pdfFileId)?.then(res=>{
                    window.showManageTags([res]);
                })
                break;
            case "addToProject-pdf":
                getCardById(pdfFileId).then(res=>{
                    window.showDialogChooseProject([res],res.name)
                })
                break;
            case "copyLink-pdf":
                createCopyLink('library',pdfFileId,'pdf');
                break;
        }
    }

    async function getSaveData() {
        window.GSearchClose?.()
        const data = await editorRef.current?.save?.();
        // const ret = noteServer[params.id ? "edit" : "add"]({
        //   ...data,
        // } as TNote);
        hideLoad()
        return data
    }

    /**
     * 显示激光笔
     */
    const showLaser = () => {

        if (hasLicense() || hasDesktopBaseLicense()) {
            excalidrawRef.onSetReadonlyStatus(false);
            excalidrawRef.onSetActiveTool('laser');
            mIsShowLaser.current = true;
        } else {
            window.showMessageBox(t("Upgrade required"),t("YouNeedToUpgradeToUseLaser"),t("Cancel"),t("Learn more"),null,()=>{
                if (isZh()) {
                    ipcSend('open-url',import.meta.env.VITE_HTTP_PURCHASE_PRICE_ZH)
                }else {
                    ipcSend('open-url', import.meta.env.VITE_HTTP_PURCHASE_PRICE);
                }
            })

            // showDesktopPro(DESKTOP_PRO_FROM_LASER_POINTER)
        }
    }

    const exitLaser = () => {
        //延迟一会设置，防止重复发送的按钮消息---
        nTimeoutId = setTimeout(()=>{
            mIsShowLaser.current = false;
        },500);
        mArrayTimeoutIds.current.push(nTimeoutId);

        excalidrawRef.onSetReadonlyStatus(true);
        excalidrawRef.onSetActiveTool('hand');
    }

    /**
     * 更新元素显示的名称
     * @param szId
     * @param szNewName
     */
    const updateDrawElementName = (szId:any,szNewName:any)=>{
        const arrayElements = excalidrawRef.getApp()?.getSceneElements().filter(p=>p.id == szId || p.customData?.generationData?.id == szId);
        for (let i=0;i<arrayElements.length;i++){
            const element = arrayElements[i];
            // mutateElement(element,{name:szNewName})  不更新？？？？
            if (element.customData && element.customData?.generationData){
                if (isVideoAnnoElement(element) || isAudioAnnoElement(element)){
                    element.customData.generationData.videoName = szNewName;
                }else if (isCardAnnoElement(element)){
                    element.customData.generationData.pdfData.name = szNewName;
                }
                else{
                    element.customData.generationData.name = szNewName;
                }

            }
            excalidrawRef.getApp()?.onUpdateElement(element,{name:szNewName});
        }
    }

    /**
     * 新canvas的背景
     */
    const getNewCanvasBackground = () => {
        if (isDarkMode()) {
            if (mAllCanvasBackground == DEFAULT_CANVAS_BACKGROUND) {
                mAllCanvasBackground = DEFAULT_CANVAS_BACKGROUND_DARK;
            }
        } else {
            if (mAllCanvasBackground == DEFAULT_CANVAS_BACKGROUND_DARK) {
                mAllCanvasBackground = DEFAULT_CANVAS_BACKGROUND;
            }
        }
        return mAllCanvasBackground;
    }

    /**
     * 关闭右侧弹窗
     */
    const animateSliderFade = async () => {
        setRightSliderWidth(0);

        // const divSlider = document.getElementById('div-slider-right');

        // let nWidth = divSlider.clientWidth - 15;
        // if (divSlider.clientWidth > 0){
        //     divSlider.style.width = nWidth+'px';
        //     requestAnimationFrame(animateFade);
        // }else{
        //     divSlider.style.width = 0+'px';
        // }

        if (mSliderContainerType == "pdf") {
            // setFileState({
            //     open: true,
            //     fileName: pdfFileName,
            //     filePath: pdfFilePath,
            //     fileId: pdfFileId
            // })
        } else if (mSliderContainerType == 'card') {
            //save card
            const data = await editorRef.current?.save?.();
            postMessage(EVENT_UPDATE_NOTE, {data, isInsertCanvas: false});
            // Global.g_currentNoteData = data;
            // setTimeout(()=>{
            //     openEditor(mSliderCardId)
            // },40);
        }
        mSliderContainerType = '';
    }

    /**
     * 显示搜索
     */
    const showSearch = ()=>{
        setIsSearchVisible(true);
        setTimeout(()=>{
            inputSearchRef.current?.focus();
        },100)
    }

    /**
     * 刷新侧栏info
     */
    const refreshInfo = ()=>{
        nTimeoutId = setTimeout(async ()=>{
            if ((sideInfoRef.current || window.refreshInfoInDraw) && excalidrawRef){
                //取当前选中的...
                const arraySelectedIds = excalidrawRef.getAppState().selectedElementIds;
                const nSelectCount = Object.keys(arraySelectedIds).length;
                if (nSelectCount > 1){
                    setSliderTitleInfo(null);
                    return;
                }

                if(nSelectCount == 0){
                    //取项目的info
                    saveNotes().then(res=>{
                        setSliderTitleInfo({
                            image:'deeplink_project',
                            title:mTitle.current || t("Untitled")
                        })
                        sideInfoRef.current?.onShowDialog('project',mNoteData.current,false);
                        if (window.refreshInfoInDraw){
                            window.refreshInfoInDraw('project',mNoteData.current);
                        }
                    })

                }else{
                    var element:any = excalidrawRef.onGetCurrentSelectedElement();
                    if (element){
                        let library:any = await getCardById(element.customData?.generationData?.videoData?.id || element.customData?.generationData?.pdfData?.id || element.customData?.generationData?.id || element.id);
                        if (isImageElement(element) && !library){
                            //是图片，并且没有加入到库中。那么，就自动加入到库中，并且在库中作隐藏...
                            const imageFile = excalidrawRef.getApp().files[element.fileId];
                            let szFileName = imageFile.id+"."+extFromMineType(imageFile.mimeType);
                            if (imageFile.fullPath){
                                szFileName = imageFile.fullPath;
                            }
                            const libraryNew = {
                                ...element.customData?.generationData || {},
                                id:generateUUID2(),
                                name:element.name || t("Untitled"),
                                fileName:szFileName,
                                type:'image',
                                isDeleted:2,//作为不可见的...
                                isAbsolutePath:!isStringNullOrEmpty(imageFile.fullPath),
                            }
                            await updateCard(libraryNew)

                            //更新元素的ID
                            const customData = {generationData:{...libraryNew}};
                            const ele0 = excalidrawRef.getApp().getSelectedElements().find(p=>p.id == element.id);
                            mutateElement(ele0,{customData:customData});

                            library = libraryNew;
                        }else if (isEmbeddableElement(element) && !library){
                            const item = element;
                            //embedable----
                            const libraryNew = {
                                id:item.customData?.generationData?.id || generateUUID2(),
                                name:item.customData?.generationData?.title,
                                type:'webLink',
                                fileName:item.link,
                                thumbImage:item.customData?.generationData?.image,
                                description:item.customData?.generationData?.description,
                                icon:item.customData?.generationData?.icon,
                                infoNotes:item.customData?.generationData?.infoNotes,
                                isDeleted:2,//标记为不可见...
                            }
                            await updateCard(libraryNew)

                            const customData = {generationData:{...libraryNew}};
                            const ele0 = excalidrawRef.getApp().getSelectedElements().find(p=>p.id == element.id);
                            mutateElement(ele0,{customData:customData});

                            library = libraryNew;
                        }
                        if (library){
                            let szName = library.name;
                            if (library.type == 'webLink'){
                                if (!szName){
                                    szName = t("Weblink")
                                }
                            }
                            setSliderTitleInfo({
                                image:getImageNameFromdeepLinkType(library.type),
                                title: szName
                            })
                        }else{
                            setSliderTitleInfo(null);
                        }
                        sideInfoRef.current?.onShowDialog('library',library,false);
                        if (window.refreshInfoInDraw){
                            window.refreshInfoInDraw('library',library);
                        }
                    }else{
                        //显示项目信息.
                        if (selectSliderRightMenu == 'info'){
                            setSliderTitleInfo({
                                image:'deeplink_project',
                                title:mTitle.current || t("Untitled")
                            })
                            sideInfoRef.current?.onShowDialog('project',mNoteData.current,false);
                            if (window.refreshInfoInDraw){
                                window.refreshInfoInDraw('project',mNoteData.current);
                            }
                        }
                    }
                }
            }
        },100);
        mArrayTimeoutIds.current.push(nTimeoutId);
    }

    /**
     * 刷新右侧栏项目列表
     */
    const refreshProjectList = ()=>{
        nTimeoutId = setTimeout(()=>{
            sideProjectRef.current?.updateNoteList();

            setSliderTitleInfo({
                image:'deeplink_project',
                title:t("Projects")
            })
        },100);
        mArrayTimeoutIds.current.push(nTimeoutId);
    }
    /**
     * 处理头部的点击事件
     * @param szAction
     */
    const drawIndexSliderHeaderAction = (szAction:any)=>{
        setRightSliderWidth(0);//如果是打开的card/pdf等也关闭
        // if(localStorage.getItem(KEY_SELECT_RIGHT_SLIDER_MENU) != 'highlight'){
            setCommonSliderContainerWidth(0);//视频
        // }
        setRightSliderLibraryWidth(0);
        setSliderVideoNotes(null);

        if (szAction == 'collapse') {
            setArrayBreadcrumb([]);
            setSliderHeaderVisible(false);
            setRightSliderLibraryWidth(0);
            setCommonSliderContainerWidth(0);
            setSliderProjectData(null);
            setSliderVideoNotes(null);//关闭后视频置空
        }else if (szAction == 'library'){
            let nWidth = getIntValue(localStorage.getItem(KEY_SLIDER_RIGHT_LIBRARY_WIDTH),DEFAULT_SLIDER_PDF_WIDTH);
            if (selectSliderRightMenu != 'library' && sliderCardData){
                //从数据库重新读取一下数据，路径->库里面打开journal-journal也打开journal ,更改了journal又切到库
                getCardById(sliderCardData.id).then(res=>{
                    setSliderCardData(res);
                })
                setRightSliderWidth(nWidth);
            }else{
                setSliderCardData(null);
                setRightSliderLibraryWidth(nWidth);
                nTimeoutId = setTimeout(() => {
                    pageLibraryRef.current?.onSliderEvent(nWidth);
                }, 100)
                mArrayTimeoutIds.current.push(nTimeoutId);
            }
        }
        else if (szAction == 'refresh'){
            //设置条目高度....
            let nWidth = getIntValue(localStorage.getItem(KEY_SLIDER_RIGHT_LIBRARY_WIDTH),DEFAULT_SLIDER_PDF_WIDTH);
            setRightSliderLibraryWidth(nWidth);
            nTimeoutId = setTimeout(() => {
                pageLibraryRef.current?.onSliderEvent(nWidth);
            }, 100)
            mArrayTimeoutIds.current.push(nTimeoutId);
        }else if (szAction == 'info'){
            setSliderType('info');
            let nWidth = getIntValue(localStorage.getItem(KEY_SLIDER_RIGHT_LIBRARY_WIDTH),DEFAULT_SLIDER_PDF_WIDTH);
            setCommonSliderContainerWidth(nWidth);
            refreshInfo();
        }else if (szAction == 'project'){
            setSliderVideoNotes(null);
            setArrayBreadcrumb([]);
            setSliderType('project');
            if (selectSliderRightMenu == 'project'){
                setSliderProjectData(null);
            }
            let nWidth = getIntValue(localStorage.getItem(KEY_SLIDER_RIGHT_LIBRARY_WIDTH),DEFAULT_SLIDER_PDF_WIDTH);
            setCommonSliderContainerWidth(nWidth);
            refreshProjectList();
            nTimeoutId = setTimeout(()=>{
                sideProjectRef.current?.onResizeEvent(nWidth);
            },100);
            mArrayTimeoutIds.current.push(nTimeoutId);
        }else if (szAction == 'webview'){
            let nWidth = getIntValue(localStorage.getItem(KEY_SLIDER_RIGHT_LIBRARY_WIDTH),DEFAULT_SLIDER_PDF_WIDTH);
            setCommonSliderContainerWidth(nWidth);
            setSliderType(szAction);
        }
    }

    /**
     * 导航条目点击，主要是返回第一个...
     * @param breadcrumbItem
     */
    const drawIndexBreadcrumbAction = (breadcrumbItem:any)=>{
        setRightSliderWidth(0);
        setCommonSliderContainerWidth(0);
        setSliderCardData(null);
        setPdfFileId('');
        setSliderVideoNotes(null);

        let nWidth = getIntValue(localStorage.getItem(KEY_SLIDER_RIGHT_LIBRARY_WIDTH),DEFAULT_SLIDER_PDF_WIDTH);
        setRightSliderLibraryWidth(nWidth);
        //设置条目高度....
        nTimeoutId = setTimeout(() => {
            pageLibraryRef.current?.onSliderEvent(nWidth);
        }, 100)
        mArrayTimeoutIds.current.push(nTimeoutId);

        if (breadcrumbItem.type == 'library'){

        }else if (breadcrumbItem.type == 'journal'){

        }else if (breadcrumbItem.type == 'highlight'){

        }
    }

    const getSliderTitle = ()=>{
        if (selectSliderRightMenu == 'library') {
            return t("Library")
        }else if(selectSliderRightMenu == 'highlight') {
            return t("Highlights")
        }
        return '';
    }

    /**
     * 打开/关闭右侧栏
     */
    const openRightSlider = (bCloseWhenOpened = true)=>{
        if (window.closeGlobalRightSide){
            window.closeGlobalRightSide();
        }

        if (bCloseWhenOpened && rightSliderLibraryWidth != 0) {
            setRightSliderLibraryWidth(0);
            setSliderHeaderVisible(false);
            return;
        }
        setSliderHeaderVisible(true);

        let szRightSliderMenu = localStorage.getItem(KEY_SELECT_RIGHT_SLIDER_MENU) || 'library';
        setSelectSliderRightMenu(szRightSliderMenu);
        let nWidth = getIntValue(localStorage.getItem(KEY_SLIDER_RIGHT_LIBRARY_WIDTH),DEFAULT_SLIDER_PDF_WIDTH);
        if (szRightSliderMenu == 'info'){
            setSliderType('info');
            setCommonSliderContainerWidth(nWidth);
            refreshInfo();
        }else if (szRightSliderMenu == 'project'){
            setSliderType('project');
            refreshProjectList();
            setCommonSliderContainerWidth(nWidth);
        }else if (szRightSliderMenu == 'webview'){
            setSliderType('webview');
            setCommonSliderContainerWidth(nWidth);
        }
        else{
            setRightSliderLibraryWidth(nWidth);
        }

        //关闭card..pdf
        setRightSliderWidth(0);
        nTimeoutId = setTimeout(() => {
            pageLibraryRef.current?.onSliderEvent(nWidth);
            sideProjectRef.current?.onResizeEvent(nWidth);
            pageHighlightRef.current?.onSliderEvent(nWidth);
        }, 100);
        mArrayTimeoutIds.current.push(nTimeoutId);
    }

    /**
     * 展示界面page的工具栏
     */
    const renderPresentToolbar = () => {
        return (
            <div className='presentHeaderStyle flex-row-vertical-center' style={{
                background: isPresentMode ? '#2C2C2C' : '#FFFFFF',
                borderBottom: isPresentMode ? '1px solid #212121' : '1px solid #efefef',
                display: isLoading ? 'none' : 'flex',
                top: isPresentMode ? '0px' : '29px'
            }}>
                {
                    !APP_WEB &&
                    <img className={`img-28 ${isPresentMode?'hovered-dark':'hovered'}`}
                         src={imgPathPerfix() + (isPresentMode ? "img_back_white.png" : "img_back.png")}
                         onClick={() => {
                             onExitPresentMode();
                         }}/>
                }

                {
                    APP_WEB &&
                    <span className={'cursor-pointer'} style={{color: 'white',marginTop:'-2px'}} onClick={() => {
                        ipcSend('open-url', import.meta.env.VITE_HTTP_WEB_URL);
                    }}>{t("AppName")}</span>
                }

                <img className={`img-28 ml-6 ${isPresentMode?'hovered-dark':'hovered'}`}
                     src={imgPathPerfix() + (isPresentMode ? "left_slider_white.png" : "left_slider.png")}
                     onClick={() => {
                         leftMenuRef.current?.onCollapsePages();
                         if (isFramePresent && !isFullScreen) {
                             excalidrawRef.onUpdateDisplaySize(isFullScreen, isCollapsePage ? LEFT_MENU_WIDTH : 0);
                         }
                     }}/>

                {
                    APP_WEB &&
                    <span style={{
                        color: '#EDEDED',
                        fontSize: '12px',
                        marginLeft: '12px',
                        maxWidth:'360px'
                    }} className={'span-single-line'}>{(title == t("Untitled")) ? '' : mTitle.current}</span>
                }
                <div style={{flexGrow: '1'}}></div>

                {
                    !APP_WEB && /*!mExportInfos?.isImport &&*/
                    <ConfigProvider
                        theme={{
                            components: {
                                // Dropdown: {
                                //     paddingBlock: 7.6,
                                //     colorBgElevated: isFramePresent ? '#2C2C2C' : 'white',
                                //     colorText: isFramePresent ? 'white' : 'black'
                                // },
                            },
                        }}>
                        <Dropdown
                            overlayClassName='default-dropdown-style'
                            overlayStyle={{minWidth: '240px'}}
                            menu={{items: isFramePresent ? SHARE_MENU_FRAME : SHARE_MENU}}
                            open={isDropdownExportVisible}
                            onOpenChange={(e) => setIsDropdownExportVisible(e)}
                            trigger={['click']}>
                            <div className='flex-center' style={{
                                borderRadius: '4px',
                                height: '30px',
                                width: '30px',
                                flexShrink: '0'
                            }}>
                                <img className={`img-28 ${isPresentMode?'hovered-dark':'hovered'}`}
                                     src={imgPathPerfix() + (isPresentMode ? "menu_download_white.png" : "menu_download_black.png")}/>
                            </div>
                        </Dropdown>
                    </ConfigProvider>
                }

                {/*frame 下载弹窗*/}
                <ConfigProvider
                    theme={{
                        components: {
                            Popover: {
                                colorBgElevated: isFramePresent ? '#2C2C2C' : 'white',
                                colorText: isFramePresent ? 'white' : 'black'
                            },
                        },
                    }}>

                    {/*导出frame弹窗*/}
                    <Popover overlayStyle={{width: '232px', height: '140px'}} trigger={['click']}
                             open={isPopoverExportPngFramePresentModeVisible} onOpenChange={async (e) => {
                        setIsPopoverExportPngVisible(e);
                    }} arrow={false} content={
                        <PopoverExportFrame ref={popoverExportPresentModeRef}
                                            onClosePopover={(e: any) => setIsPopoverExportPngFramePresentModeVisible(false)}
                                            onDoneEvent={(exportType: any, pageType: any) => {
                                                setIsPopoverExportPngFramePresentModeVisible(false);
                                                onShareMenuFrameEvent(exportType, pageType);
                                            }}/>
                    }>
                        <span style={{
                            height: '30px',
                            width: '30px',
                            right: '100px',
                            top: '40px',
                            background: 'transparent',
                            position: 'absolute',
                            zIndex: '1110'
                        }}></span>
                    </Popover>

                </ConfigProvider>

                {/*工具栏导出page弹窗*/}
                <Popover overlayStyle={{width: '240px', height: '150px'}} trigger={['click']} placement={"rightBottom"}
                         open={isPopoverExportPngPresentModeVisible} onOpenChange={async (e) => {
                    setIsPopoverExportPngPresentModeVisible(e);
                }} arrow={false} content={
                    <PopverExport ref={popoverExportPresentModeRef}
                                  onClosePopover={(e) => setIsPopoverExportPngPresentModeVisible(false)}
                                  onDoneEvent={(arrayPages: any, exportType: any) => {
                                      setIsPopoverExportPngPresentModeVisible(false);
                                      onShareMenuEvent((exportType === 'png' ? "exportPng" : "exportPdf"), arrayPages, {})
                                  }}/>
                }>
                    <span style={{
                        height: '30px',
                        width: '30px',
                        right: '100px',
                        top: '40px',
                        background: 'transparent',
                        position: 'absolute',
                        zIndex: '1110'
                    }}></span>
                </Popover>

                {
                    !APP_WEB && /*!mExportInfos?.isImport &&*/
                    <div className='flex-center button-solid-style hovered ml-12 no-drag' onClick={async () => {
                        if (mNoteData.current != null) {
                            mPublishId = mNoteData.current.id;
                        } else if (isStringNullOrEmpty(mPublishId)) {
                            mPublishId = await generateShortUUID();
                        }
                        saveNotes().then(res => {
                            //判断是否frame预览是否已发布--
                            dialogPublishToWebRef.current?.onShowDialog(mPublishId, isFramePresent);
                        })
                    }} style={{
                        minWidth: '90px',
                        height: '32px',
                        flexShrink: '0'
                    }}>
                        <img className='img-medium-small pointer-cursor'
                             src={imgPathPerfix() + "web_share.png"}/>
                        <span className='ml-6'>{t("Share")}</span>
                    </div>
                }


                {
                    APP_WEB && !isMobile &&
                    <img className={`img-28 ${APP_WEB?'hovered-dark':'hovered'} ml-12`}
                         src={imgPathPerfix() + (isAppWebFullScreen ? (isPresentMode ? "menu_exit_full_screen_white.png" : "menu_exit_full_screen.png") : (isPresentMode ? "full_screen_white.png" : "full_screen_black.png"))}
                         onClick={() => {
                             setIsShowOverlay(false);
                             onFullScreenByWeb(!isFullScreen);
                             setIsFullScreen(!isFullScreen);
                             if (isFramePresent) {
                                 excalidrawRef.onUpdateDisplaySize(!isFullScreen);
                             }
                         }}/>
                }
            </div>
        )
    }

    /**
     * 是否在右侧栏
     */
    const isInSlider = ()=>{
        return window.location.href.includes('sliderDraw');
    }

    /**
     * 取place holder
     */
    const getSearchPlaceHolder = ()=>{
        if (sliderType == 'highlight'){
            return t("Search highlights")
        }else if (sliderType == 'project'){
            return t("Search projects");
        }
        return '';
    }

    /**
     * 获取链接
     */
    const getSiderDrawSubLink = ()=>{
        if (!sliderProjectData)return '';
        if (isString(sliderProjectData.doc)){
            sliderProjectData.doc = JSON.parse(sliderProjectData.doc);
        }
        let selectedBoard = null;
        loopAllNode(sliderProjectData.doc.canvas,(node)=>{
            if (node.isSelected){
                selectedBoard = node;
            }
        })
        // const selectedBoard = sliderProjectData.doc.canvas.find(p=>p.isSelected);
        // if (selectedBoard && selectedBoard.key != sliderProjectData.doc.canvas[0].key){
        //     return sliderProjectData.id+'/'+selectedBoard.key;
        // }
        if (selectedBoard){
            if (selectedBoard.elementId){
                return sliderProjectData.id+'/'+selectedBoard.key+'/'+selectedBoard.elementId;
            }
            return sliderProjectData.id+'/'+selectedBoard.key;
        }
        return sliderProjectData?.id;
    }

    /**
     * 渲染右侧栏的board
     */
    const renderSliderProjectBoard = ()=>{
        let doc = sliderProjectData?.doc;
        if (doc && isString(doc)){
            doc = JSON.parse(doc);
        }
        //如果没有选中的，默认设置第一个选中
        if (doc?.canvas){
            const hasSelected = doc?.canvas?.some(p=>p.isSelected);
            if (!hasSelected){
                doc.canvas[0].isSelected = true;
            }
        }

        return(
            <div style={{minWidth:'160px',padding:'12px 0'}}>
                <span style={{marginLeft:'16px',marginBottom:'6px',display:'block'}}>{t("Board")}</span>
                {
                    // doc &&
                    doc?.canvas?.map(p=>{
                        return(
                            <div className={'flex-row-vertical-center hovered-blue'} style={{height:'36px',padding:'0 12px'}} onClick={()=>{
                                //切换sliderdraw中的board....
                                setIsShowPopupBoard(false);
                                sendMessageFromDraw('switchBoardSelect',p);
                            }}>
                                <img className={'img-16'} style={{opacity:p.isSelected?'1':'0'}} src={getImagePathWithTheme('check_black')}/>
                                <span className={'ml-4 default-font-size'}>{p.title}</span>
                            </div>
                        )
                    })
                }
            </div>

        );
    }

    /**
     * 底部栏距右边距
     */
    const getBottomZoomMarginRight = ()=>{
        return rightSliderWidth + rightSliderLibraryWidth + commonSliderContainerWidth + globalRightSliderWidth;
    }

    /**
     * 取当前选中的board的路径--包括文件夹
     */
    const refreshTitleBoardPath = ()=>{
        if (!currentSelectNode)return;
        const parents = findNodeWithParents(leftMenuRef.current?.getAllMenuData1(),currentSelectNode?.key);
        let szTitle = '';
        if (parents?.parents){
            for (let i=0;i<parents.parents.length;i++){
                szTitle += parents.parents[i].title + ' / ';
            }
        }
        szTitle += currentSelectNode.title;
        setBoardTitlePath(szTitle);
        setRandomRefreshTitle(crypto.randomUUID());
    }

    /**
     * 渲染搜索后缀
     */
    const renderLibrarySearchSuffix = ()=> {
        if (isSearching) {
            return <>
                <Spin indicator={<img className={'img-16 rotating-image'}
                                      src={getImagePathWithTheme('indicator_black')}/>} size={'small'}/>
            </>
        } else {
            return <img className='img-mini-small-8 cursor-pointer'
                        style={{display: isStringNullOrEmpty(searchKey) ? "inherit" : "inherit"}}
                        onClick={() => {
                            setLibrarySearchKey('');
                            pageLibraryRef.current?.onSearchEvent('');
                            pageHighlightRef.current?.onSearchEvent('');
                            setIsLibraySearch(false);
                        }}
                        src={imgPathPerfix() + (isDarkMode() ? "close_white_1.png" : "close_black.png")}/>
        }
    }


    return (
        <div id={'div-drawindex-container'} style={{display: 'flex', flexDirection: 'column', height: '100%'}}>
            {
                // !mIsDialogDrawIndex &&
                // <TitleBar title={t("AppName")} isDark={true} fromPage={'drawIndex'}></TitleBar>
            }
            {
                mIsDialogDrawIndex && !isDialogDrawIndexFullScreen &&
                <div style={{
                    height: '32px',
                    width: '100%',
                    position: 'relative',
                    borderBottom: '1px solid var(--line-color)',
                    display: 'flex',
                    alignItems: 'center',
                    padding: '0 16px'
                }}>
                    {/*<span style={{marginLeft:'16px'}} className={'dialog-title'}>{title}</span>*/}
                    <img style={{}} className={'img-12 cursor-pointer'}
                         src={imgPathPerfix() + (isDarkMode() ? (isDialogDrawIndexFullScreen ? "pdf_exit_full_screen.png" : "pdf_full_screen.png") : (isDialogDrawIndexFullScreen ? "pdf_exit_full_screen.png" : "pdf_full_screen.png"))}
                         onClick={() => {
                             setIsDialogDrawIndexFullScreen(!isDialogDrawIndexFullScreen);
                             // dialogDrawIndexRef.current?.onSetFullScreen(!isDialogDrawIndexFullScreen);
                             window.parent.postMessage({
                                 action: EVENT_DIALOG_DRAW_INDEX_ISFULLSCREEN,
                                 isFullScreen: !isDialogDrawIndexFullScreen
                             })
                         }}/>
                    <img style={{position: 'absolute', top: '10px', right: '12px'}} className={'img-10 cursor-pointer'}
                         src={imgPathPerfix() + (isDarkMode() ? "close_white_1.png" : "close_black.png")}
                         onClick={() => {
                             window.parent.postMessage({action: EVENT_CLOSE_IFRAME_DRAWINDEX})
                         }}/>
                    {/*<div className={'line'} style={{margin: '0px 0px'}}></div>*/}
                </div>
            }

            <div className="App" ref={appRef}>
                {
                    isPresentMode && !APP_WEB && isShowTopClosePresent &&
                    <img src={imgPathPerfix() + 'close_white.png'} onClick={onExitPresentMode} style={{
                        visibility: (isShowClosePresent && !isShowExitPresent) ? 'visible' : 'hidden',
                        background: 'rgba(0,0,0,0.5)', borderRadius: '50%', padding: '4px', marginTop: '16px'
                    }} className='close-button'/>
                }

                <div className='fullscreen-tips'
                     style={{display: (isShowExitPresent && isFullScreen) ? 'flex' : 'none'}}>
                    <span>Press</span>
                    <span style={{
                        border: '1px solid #efefef',
                        borderRadius: '2px',
                        margin: '0 4px',
                        padding: '5px 4px'
                    }}>Esc</span>
                    <span>{presentModeExitTip}</span>
                </div>
                <Layout className='layoutStyle'>
                    {
                        ((APP_WEB && (!isAppWebFullScreen || isShowClosePresent)) ||
                            (isPresentMode && (isShowClosePresent && !isShowExitPresent))) && isShowTopClosePresent &&
                        renderPresentToolbar()
                    }
                    <Header className='headerStyle' style={{
                        display: (isPresentMode || isZenMode || isInSlider()) ? 'none' : 'inline',
                        top: (isMac() || isDialogDrawIndexFullScreen || isOfflineWeb()) ? '0' : '30px',
                        left:homePaddingLeft+'px',
                        width:`calc(100% - ${homePaddingLeft}px)`
                    }}>
                        <div className='headerStyle-content'>
                            <div className='headerStyle-content-lr'
                                 style={{background: "transparent", width: `${headerTitleWidth}px`, overflow: 'hidden'}}>
                                {/*<Button type={"text"} shape={"circle"} className='padding-bottom-0' onClick={onBack}>*/}
                                {/*    <img className='img-medium-small' src={imgPathPerfix() + 'back.png'}/>*/}
                                {/*</Button>*/}

                                <HomeNavigator margin={'1px 6px 0 0'} onBeforeBack={()=>{
                                    if (!mStackHistory.current.isEmpty()) {
                                        const linkInfo = mStackHistory.current.pop();
                                        //添加到forward栈
                                        mStackForward.current.push({...linkInfo,pageId:leftMenuRef?.current.onGetCurrentSelectKey()});

                                        onLinkNav(linkInfo,true,false,true);
                                        return true;
                                    }
                                    return false;
                                }} onBeforeForward={()=>{
                                    if (!mStackForward.current.isEmpty()) {
                                        const linkInfo = mStackForward.current.pop();
                                        //添加到back栈
                                        mStackHistory.current.push({...linkInfo,pageId:leftMenuRef?.current.onGetCurrentSelectKey()});

                                        onLinkNav(linkInfo,false,true,true);
                                        return true;
                                    }
                                    return false;
                                }}/>

                                {
                                    /*
                                    !APP_WEB_WWW &&
                                    <img className='img-32 hovered-gray-radius' onClick={async () => {

                                        if (mIsDialogDrawIndex) {
                                            if (isDialogDrawIndexFullScreen) {
                                                window.parent.postMessage({action: EVENT_CLOSE_IFRAME_DRAWINDEX});
                                            }
                                            return;
                                        }

                                        if (APP_WEB_WWW || APP_WEB) {
                                            window.open(import.meta.env.VITE_HTTP_WEB_URL, '_blank');
                                        } else {
                                            //切到第一个，并且截图
                                            // if (mSaveTimes % 5 == 0) {
                                            //     await updateFirstThumb();
                                            // }
                                            // mSaveTimes++;

                                            try {
                                                document.getElementById('div-slider-right').style.width = '0px';
                                                document.getElementById('div-slider-right-library').style.width = '0px';
                                            } catch (e) {

                                            }

                                            await updateFirstThumb();

                                            //test....
                                            // const canvas = document.getElementById('canvas');
                                            // canvas.style.background = '#ff0000';
                                            // mFirstBase64Capture = canvas.toDataURL('image/png');

                                            saveNotes(true, '', true);
                                        }
                                    }}
                                         src={getImagePathWithTheme(mIsDialogDrawIndex ? (isDialogDrawIndexFullScreen ? 'home_close' : 'disable_home') : 'home')}/>
                                     */
                                }

                                {/*<Dropdown overlayClassName='default-dropdown-style' overlayStyle={{minWidth: '232px'}}*/}
                                {/*          forceRender={true}*/}
                                {/*          menu={{items: arrayMenuMore}} trigger={['click']}>*/}
                                {/*    <img className='img-32 hovered-gray-radius ml-10'*/}
                                {/*         style={{marginLeft: APP_WEB_WWW ? '0px' : '10px'}}*/}
                                {/*         src={getImagePathWithTheme('menu')}/>*/}
                                {/*</Dropdown>*/}

                                <Tooltip overlayClassName='font-size-12' title={
                                    <div>{t("Table of content")}<span className={'tooltip-shortcut-key'}>{getCtrlOrAlt("Ctrl + S")}</span></div>} arrow={true}>
                                <img className='img-32 hovered-gray-radius ml-2' style={{marginLeft:'4px',marginTop:'1px'}} onClick={() => {
                                        leftMenuRef.current?.onCollapsePages();
                                        //更新左边栏
                                        excalidrawRef?.setLeftMenuIsCollapse(!leftMenuRef?.current.getCollapseStatus());
                                    }} src={getImagePathWithTheme('left_slider_2.svg')}/>
                                </Tooltip>

                                {
                                    selectBoard &&
                                    <div className={'flex-row-vertical-center ml-14 mt-2'} style={{height:'32px',lineHeight:'32px',overflow:'hidden',color:'var(--text-color)',width:'100%'}} onClick={()=>{
                                        message.info(t("RenameInSidebar"))
                                    }}>
                                        <span key={randomRefreshTitle} className={'dialog-title cursor-pointer'} style={{fontWeight:'600',fontFamily:'PoppinsSemiBold',whiteSpace:'nowrap',fontSize:'12px'}} onClick={(event)=>{
                                            event.stopPropagation();
                                            //转到board1
                                            const fistBoard = leftMenuRef.current.getFirstCanvasNode();
                                            setSelectBoard(null);
                                            onNavSub(fistBoard.key,null,null);
                                        }}>{mTitle.current || t("Untitled")}</span>
                                        <span style={{marginTop:'2px',fontSize:'12px',fontFamily:'Poppins',}}>&nbsp;{'/ '}</span>
                                        <span className={'span-single-line'} style={{fontSize:'12px',fontFamily:'Poppins',color:'var(--item-no-select-color)'}}>&nbsp;{`${boardTitlePath}`}</span>
                                    </div>
                                }

                                {
                                    //编辑标题-------
                                    <input className='input-hover project-title' disabled={isTitleDisabled} ref={inputTitleRef}
                                           placeholder={t("Untitled")}
                                           onFocus={(e) => {
                                               e.currentTarget.select();
                                           }}
                                           style={{
                                               fontFamily:'PoppinsSemiBold',
                                               marginLeft: '14px',
                                               fontWeight: '600',
                                               width: '100%',
                                               // maxWidth: '320px',
                                               marginRight: '22px',
                                               marginTop: '2px',
                                               background: "transparent",
                                               display:selectBoard?'none':'inherit'
                                           }}
                                           defaultValue={mTitle.current == 'Untitled' ? '' : mTitle.current}
                                        // value={title == 'Untitled' ? '' : title}
                                           onChange={(e) => {
                                               mTitle.current = e.target.value;
                                               // setTitle(e.target.value)
                                               window.globalRefreshList('refresh_canvas_deeplink_card_title_',{id:mNoteData.current?.id,name:mTitle.current})
                                           }} onBlur={() => {
                                        saveNotes(false, mTitle.current).then(res => {
                                            postMessage(EVENT_FAVIRIATE_CHANGE);
                                            postMessage(EVENT_REFRESH_RECENTS);
                                        })
                                    }}/>
                                }


                                {/*导出page弹窗*/}
                                <Popover overlayStyle={{
                                    width: '240px',
                                    height: '150px',
                                    top: 'calc(50% - 75px)',
                                    left: 'calc(50% - 120px)'
                                }}
                                         trigger={['click']} arrow={false} placement={"rightBottom"}
                                         open={isPopoverExportPngVisible} onOpenChange={async (e) => {
                                    setIsPopoverExportPngVisible(e);
                                }} content={
                                    <PopverExport ref={popoverExportRef}
                                                  onClosePopover={(e) => setIsPopoverExportPngVisible(false)}
                                                  onDoneEvent={(arrayPages: any, exportType: any) => {
                                                      setIsPopoverExportPngVisible(false);
                                                      onShareMenuEvent((exportType === 'png' ? "exportPng" : "exportPdf"), arrayPages, {})
                                                  }}/>
                                }>
                                <span style={{
                                    height: '1px',
                                    width: '1px',
                                    left: '50%',
                                    top: '50%',
                                    background: 'transparent',
                                    position: 'absolute',
                                    zIndex: '0'
                                }}></span>
                                </Popover>

                                {/*<div className='footerStyle-tool-item-0 ml-10'*/}
                                {/*     style={{padding: '0px 6px', display: isPresentMode ? 'none' : 'inherit'}}>*/}
                                {/*    <Button className='small-button' type={'text'}>*/}
                                {/*        <img className='tool-small-img' src={imgPathPerfix() + 'undo.png'}*/}
                                {/*             onClick={undo}/>*/}
                                {/*    </Button>*/}

                                {/*    <Button className='small-button' style={{marginLeft: '6px'}} type={'text'}>*/}
                                {/*        <img className='tool-small-img' src={imgPathPerfix() + 'redo.png'}*/}
                                {/*             onClick={redo}/>*/}
                                {/*    </Button>*/}
                                {/*</div>*/}
                            </div>
                            {/*工具栏*/}
                            <div className='headerStyle-content-tool'
                                 style={{display: isToolbarVisible ? 'inherit' : 'none'}}>
                                <ConfigProvider
                                    theme={{
                                        components: {
                                            Popover: {
                                                /* 这里是你的组件 token */
                                                sizePopupArrow: 12
                                            },
                                        },
                                    }}
                                >
                                    {renderToolButtons()}
                                </ConfigProvider>
                            </div>

                            <div style={{flexGrow: '1'}}></div>
                            <div className='headerStyle-content-lr'>


                                {/*导出*/}
                                {/*<ConfigProvider*/}
                                {/*    theme={{*/}
                                {/*        components: {*/}
                                {/*            Dropdown: {*/}
                                {/*                paddingBlock: 7.6*/}
                                {/*            },*/}
                                {/*        },*/}
                                {/*    }}*/}
                                {/*>*/}
                                {/*    <Dropdown overlayClassName='default-dropdown-style'*/}
                                {/*              overlayStyle={{minWidth: '240px',top:'79px'}}*/}
                                {/*              arrow={true}*/}
                                {/*              placement={"bottomCenter"}*/}
                                {/*              menu={{items: SHARE_MENU}}*/}
                                {/*              trigger={['click']}>*/}
                                {/*        <div className='flex-center hovered-gray-radius ml-20' style={{*/}
                                {/*            borderRadius: '4px',*/}
                                {/*            height: '32px',*/}
                                {/*            width: '32px',*/}
                                {/*            flexShrink: '0'*/}
                                {/*        }}>*/}
                                {/*            <img className='img-20 pointer-cursor ' style={{width:'16px',height:'16px'}}*/}
                                {/*                 src={getImagePathWithTheme('canvas_export')}/>*/}
                                {/*        </div>*/}
                                {/*    </Dropdown>*/}
                                {/*</ConfigProvider>*/}

                                {/*预览*/}
                                <Popover trigger={'click'} open={isPopoverPresentModeVisible}
                                         overlayStyle={{top: isMac()?'52px':'84px'}}
                                         onOpenChange={(e) => setIsPopoverPresentModeVisible(e)} content={
                                    <div>
                                        <div className='flex hovered-present' style={{
                                            margin: '0 -12px',
                                            padding: '0 12px',
                                            minHeight: '46px',
                                            fontSize: '12px',
                                            alignItems: 'center'
                                        }} onClick={() => {
                                            setIsPopoverPresentModeVisible(false);
                                            onPresentClick();
                                        }}>
                                            <div className='flex '>
                                                <img
                                                    className={'img-medium-small mt-4 ' + (isDarkMode() ? "filter-img-white" : "")}
                                                    src={imgPathPerfix() + 'present_board.png'}/>
                                                <div className='flex-col ml-6'>
                                                    <span>{t("Boards")}</span>
                                                    <span datatype={'small-title'}>{t("Present all boards")}</span>
                                                </div>
                                            </div>
                                        </div>

                                        <div className='flex mt-8 hovered-present'
                                             style={{
                                                 margin: '10px -12px 0px -12px',
                                                 padding: '0 12px',
                                                 minHeight: '46px',
                                                 fontSize: '12px',
                                                 alignItems: 'center'
                                             }}
                                             onClick={async () => {
                                                 const arrayFrames = excalidrawRef.getFrameElements();
                                                 if (arrayFrames.length > 0) {
                                                     //预览之前保存一次....
                                                     saveNotes();
                                                     if (arrayFrames.length == 1){
                                                         excalidrawRef.onUpdateAppStates({
                                                             sortArrayFrames:arrayFrames
                                                         })
                                                         onPresentFrameClick();
                                                     }else {
                                                         window.showDialogFramePreview(leftMenuRef.current?.onGetSelectNode()?.key, arrayFrames,(arrayNewFrames:any)=>{
                                                             global.g_framePresentList = arrayNewFrames;
                                                             excalidrawRef.onUpdateAppStates({
                                                                 sortArrayFrames:arrayNewFrames
                                                             })
                                                             onPresentFrameClick();
                                                         });
                                                     }
                                                 } else {
                                                     dialogFrameTipsRef.current?.onShowDialog();
                                                 }
                                                 setIsPopoverPresentModeVisible(false);
                                             }}>
                                            <div className='flex'>
                                                <img
                                                    className={'img-medium-small mt-4 ' + (isDarkMode() ? "filter-img-white" : "")}
                                                    src={imgPathPerfix() + 'present_frame.png'}/>
                                                <div className='flex-col ml-6'>
                                                    <span>{t("Frames")}</span>
                                                    <span
                                                        datatype={'small-title'}>{t("Present frames as slides")}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                }>
                                    <div className='ml-18 hovered-gray-radius' style={{
                                        flexGrow: '1',
                                        display: "flex",
                                        alignItems: 'center',
                                        height: '32px',
                                        padding: '0 6px'
                                    }}>
                                        <Tooltip title={t("Present Mode")} arrow={false}>
                                        <img src={getImagePathWithTheme('draw_present_t.svg')} className={'img-32'}/>
                                        </Tooltip>
                                        <img style={{width: '10px', height: '9px'}}
                                             src={getImagePathWithTheme('draw_present_small_dropdown.svg')}
                                             className={'img-18 ml-2'}/>

                                        {/*<span style={{flexGrow: '1'}} onClick={(e) => {*/}
                                        {/*    e.stopPropagation();*/}
                                        {/*    e.preventDefault();*/}

                                        {/*    const nFrameCount = excalidrawRef?.getFrameCount();*/}
                                        {/*    if (nFrameCount > 0) {*/}
                                        {/*        setIsPopoverPresentModeVisible(!isPopoverPresentModeVisible);*/}
                                        {/*    } else {*/}
                                        {/*        setTimeout(() => {*/}
                                        {/*            setIsPopoverPresentModeVisible(false);*/}
                                        {/*        }, 10)*/}

                                        {/*        onPresentClick();*/}
                                        {/*    }*/}
                                        {/*}}>{t("Present")}</span>*/}
                                        {/*<div className={'flex-row-vertical-center'}*/}
                                        {/*     style={{*/}
                                        {/*         width: '30px',*/}
                                        {/*         height: '32px',*/}
                                        {/*         flexShrink: '0',*/}
                                        {/*         justifyContent: 'center',*/}
                                        {/*         borderLeft: '1px solid var(--line-color)'*/}
                                        {/*     }}>*/}
                                        {/*    /!*<img className='img-20' style={{width:'12px',height:'14px'}} src={getImagePathWithTheme('canvas_preview_new')}/>*!/*/}
                                        {/*    <img className='img-mini-small-10 filter-img-white'*/}
                                        {/*         src={getImagePathWithTheme('drop_down_home')}/>*/}
                                        {/*</div>*/}
                                    </div>
                                </Popover>

                                {/*分享*/}
                                <Tooltip title={t("Share1")} arrow={false}>
                                <div className='flex-center hovered-gray-radius ml-6' onClick={async () => {
                                    if (mNoteData.current != null) {
                                        mPublishId = mNoteData.current.id;
                                    } else if (isStringNullOrEmpty(mPublishId)) {
                                        mPublishId = await generateShortUUID();
                                    }
                                    saveNotes().then(res => {
                                        dialogPublishToWebRef.current?.onShowDialog(mPublishId);
                                    })
                                }} style={{
                                    // minWidth: '70px',
                                    height: '32px',
                                    // borderLeft: '0px solid #ffffffaa',
                                    flexShrink: '0',
                                }}>
                                    <img className='img-32 pointer-cursor'
                                         src={getImagePathWithTheme("draw_share_new.svg")}/>
                                    {/*<span className='font-size-12'>{t("Share")}</span>*/}
                                </div>
                                </Tooltip>


                                {/*<Button className='button-border-style' onClick={() => setDisplayMode("preview")}>Frame Preview</Button>*/}

                                {/*<Button className='padding-bottom-0 visibility-hidden'>*/}
                                {/*    <img className='img-button-small' src={imgPathPerfix() + 'canvas_save.png'}/>*/}
                                {/*</Button>*/}
                                {/*<Button className='ml-12 padding-bottom-0 flex-row-vertical-center' style={{paddingTop:'0px',height:'30px'}} onClick={onPresentClick}>*/}
                                {/*    <img className='img-button-small' src={imgPathPerfix() + 'canvas_preview.png'}/>*/}
                                {/*    <span className='ml-6'>{t("Present")}</span>*/}
                                {/*</Button>*/}
                                {/*<Dropdown menu={{ items:SHARE_MENU }} trigger={['click']}>*/}
                                {/*    <Button className='ml-16 padding-bottom-0' type="primary">*/}
                                {/*        <img className='img-button-small' src={imgPathPerfix() + 'canvas_share.png'} />*/}
                                {/*    </Button>*/}
                                {/*</Dropdown>*/}
                                {/*<Button className='ml-12 padding-bottom-0 flex-row-vertical-center button-solid-style' style={{paddingTop:'0px',height:'30px'}} type="primary" onClick={onShareClick}>*/}
                                {/*    /!*<img className='img-button-small' src={imgPathPerfix() + 'canvas_share.png'}/>*!/*/}
                                {/*    <span>{t("Share")}</span>*/}
                                {/*</Button>*/}

                                {/*更多*/}
                                <Dropdown overlayClassName='default-dropdown-style' open={isShowMenuMore} onOpenChange={(e)=>{
                                    setIsShowMenuMore(e);
                                    patchMenuFavor();
                                }} overlayStyle={{minWidth: '232px'}}
                                          forceRender={true}
                                          menu={{items: arrayMenuMore}} trigger={['click']}>
                                    <img className='img-32 hovered-gray-radius ml-6'
                                         style={{marginLeft: APP_WEB_WWW ? '0px' : '3px'}}
                                         src={getImagePathWithTheme('library_more_1.svg')}/>
                                </Dropdown>

                                {/*百分比*/}
                                {
                                    false &&
                                    <ConfigProvider
                                        theme={{
                                            components: {
                                                Popover: {
                                                    /* 这里是你的组件 token */
                                                    sizePopupArrow: 10,
                                                    colorBgElevated: '#ffffff00',
                                                    boxShadowSecondary: 'none'
                                                },
                                            },
                                        }}>
                                        <Popover trigger={'click'} open={isPopoverZoomVisible} arrow={true}
                                                 overlayStyle={{
                                                     top: '52px',
                                                 }}
                                                 onVisibleChange={(e) => setIsPopoverZoomVisible(e)} onOpenChange={(e) => {
                                            if (e) {
                                                try {
                                                    var zoomValue = parseInt(excalidrawRef.getAppState()?.zoom?.value * 100 + '', 10);
                                                    setInputZoom(Math.floor(zoomValue) + '%')
                                                } catch (e) {

                                                }
                                                // setInputZoom((inputZoom+'').replaceAll('%','')+'%');
                                            }
                                        }} content={
                                            <div>
                                                <div className='div-zoom font-size-12 popover-box-shadow'>
                                                    <Input variant={"borderless"} value={inputZoom}
                                                           className='default-font-size input-border'
                                                           onFocus={(e) => {
                                                               e.currentTarget.select();
                                                           }}
                                                           placeholder={Math.floor(excalidrawRef?.getAppState()?.zoom?.value * 100) + '%'}
                                                           maxLength={'4'}
                                                           onKeyDown={(e) => {
                                                               const fZoom = parseFloat(inputZoom);
                                                               if (e.keyCode == 13 && fZoom > 0 && !isNaN(fZoom)) {
                                                                   zoomSize(0, (fZoom / 100));
                                                                   setZoom((fZoom / 100) + '');
                                                               }
                                                           }} onChange={(e) => {
                                                        let value: any = e.currentTarget.value.replaceAll("%", '');
                                                        value = parseFloat(value);
                                                        if (!isNaN(value) && value > 0) {
                                                            setInputZoom(value)
                                                        }
                                                    }}/>
                                                    <span onClick={() => zoomSize(1)} className='mt-8'
                                                          style={{marginTop: '8px'}}>{t("Zoom in")}</span>
                                                    <span onClick={() => zoomSize(-1)}>{t("Zoom out")}</span>
                                                    <div style={{margin: '8px -12px'}} className='line'></div>
                                                    <span onClick={() => zoomSize(1, 0.5)}>50%</span>
                                                    <span onClick={() => zoomSize(1, 1.0)}>100%</span>
                                                    <span onClick={() => zoomSize(1, 2.0)}>200%</span>
                                                </div>

                                                <img style={{
                                                    width: '8px',
                                                    height: '8px',
                                                    position: 'absolute',
                                                    background: 'transparent',
                                                    top: '3px',
                                                    right: '60px'
                                                }}
                                                     src={getImagePathWithTheme('small_sanjiao')}/>
                                            </div>

                                        }>
                                            <div className='flex-center ml-4 hovered-gray-radius' style={{
                                                padding: '0 8px',
                                                height: '32px',
                                                borderRadius: '8px',
                                                color: 'var(--text-color)'
                                            }}>
                                                <span className='font-size-12' style={{width: '32px'}}>{zoom + '%'}</span>
                                                <img className='img-mini-small-10 ml-6'
                                                     src={getImagePathWithTheme('drop_down_home')}/>
                                            </div>
                                        </Popover>
                                    </ConfigProvider>
                                }


                                {/*侧栏*/}
                                <Tooltip arrow={false} placement={"bottom"} title={<div className={'default-font-size'}>{t("Side panel")}<span
                                    className={'tooltip-shortcut-key'}>{getCtrlOrAlt("Ctrl + 1")}</span></div>}>
                                    <img className='img-32 hovered-gray-radius ml-6'
                                         style={{marginLeft: APP_WEB_WWW ? '0px' : '8px',marginRight:'-4px',marginTop:'1px'}}
                                         src={getImagePathWithTheme('home_slider_library.svg')} onClick={()=>{
                                             //保存一下...
                                        saveNotes();
                                        openRightSlider();
                                    }}/>
                                </Tooltip>

                            </div>
                        </div>
                    </Header>

                    <Layout>
                        <Sider className="siderStyle" width={drawLeftMenuWidth} style={{
                            background: (isPresentMode || isCollapsePage) ? 'transparent' : "var(--right-slider-background-color)",
                            position:'absolute',
                            display:isInSlider()? 'inherit' :'inherit',
                            left: homePaddingLeft+'px',
                            top: APP_WEB?'46px':(isInSlider()?'0px':(isMac()?(APP_WEB?`${HEADER_HEIGHT - 16}px`:`${HEADER_HEIGHT}px`):(isPresentMode ? `${HEADER_HEIGHT}px` : (isWeb() || isDialogDrawIndexFullScreen ? '48px' : '76px')))),
                            borderRight: isShowLeftMenuRightBorder() ? '1px solid var(--draw-border-top-color)' : '0px',
                            height: isInSlider()?'100%':(isMac()?(APP_WEB?`calc(100% - ${HEADER_HEIGHT-16}px)`:`calc(100% - ${HEADER_HEIGHT}px)`):(isPresentMode ? 'calc(100% - 30px)' : (isWeb() ? 'calc(100% - 48px)' : 'calc(100% - 70px)'))),
                            zIndex: '12',
                            opacity: (isZenMode) ? '0' : '1',
                            pointerEvents: isCollapsePage ? 'none' : 'auto',
                        }}>
                            <div className="left-menu" style={{padding:isPresentMode?'0px':'6px 0px'}}>
                                <LeftMenu ref={leftMenuRef}
                                          onDragEnd={()=>{
                                              return new Promise(resolve => {
                                                  setTimeout(()=>{
                                                      refreshTitleBoardPath()
                                                      saveNotes().then(res=>{
                                                          resolve('ok');
                                                      });
                                                  },100);
                                              })
                                          }}
                                          isNew={params.state?.usr?.isNew}
                                          leftMenuItemClicked={leftMenuItemClicked}
                                          setFirstItem={setFirstItem}
                                          getCurrentDrawJson={getExcalidrawJson}
                                          onInsertNoteData={onInsertNoteData}
                                          onSubNoteClick={onSubNoteClick}
                                          onSelectedElement={(element) => {
                                              let nLeftOffset = homePaddingLeft;
                                              if (!isCollapsePage) {
                                                  nLeftOffset += LEFT_MENU_WIDTH;
                                              }
                                              excalidrawRef.onScrollToElement(element.id,null,nLeftOffset);
                                              //刷新info.
                                              setTimeout(()=>{
                                                  refreshInfo();
                                              },200)
                                          }}
                                          onCollapseClick={(isCollapse) => {
                                              setIsCollapsePage(isCollapse);
                                              excalidrawRef?.setLeftMenuIsCollapse(isCollapse);
                                          }}
                                          onFramePresentClick={(szDisplayMode) => {
                                              setDisplayMode(szDisplayMode)
                                          }}
                                          onChangeCanvasBackgroundClick={() => {
                                              dialogColorChooseRef.current?.onShowDialog(excalidrawRef?.getAppState()?.viewBackgroundColor, excalidrawRef?.getAppState(), false);
                                          }}
                                          onNewCanvasClick={() => {
                                              excalidrawRef?.getApp()?.updateScene({
                                                  appState: {
                                                      viewBackgroundColor: getNewCanvasBackground(),
                                                  }
                                              })
                                          }}
                                          onSetUpdateElementId={(szId: string) => {
                                              excalidrawRef?.setUpdateElementId(szId);
                                          }}
                                          onGetCanvasData={async ()=>{
                                              return new Promise(resolve => {
                                                  getCanvasNoteDatas().then(res=>{
                                                      resolve(res);
                                                  })
                                              })
                                          }}
                                          onSaveNotes={async ()=>{
                                              return await saveNotes();
                                          }}
                                          onBoardClicked={(board,hasProgress,menuData)=>{
                                              if (hasProgress) {
                                                  setIsSaving(true);
                                              }
                                              if (menuData) {
                                                  const arrayBoards = menuData;
                                                  if (arrayBoards[0].key == board.key) {
                                                      setSelectBoard(null);
                                                  } else {
                                                      setSelectBoard(board);
                                                  }

                                                  //刷新当前选择的标题
                                                  refreshTitleBoardPath();
                                              }
                                          }}
                                          onBoardTitleUpdate = {(board:any)=>{
                                              setTimeout(()=>{
                                                  refreshTitleBoardPath();
                                              },100)
                                              if (board.isFolder) {

                                              }else {
                                                  if (selectBoard?.key == board.key) {
                                                      setSelectBoard({...board});
                                                  }
                                              }
                                              if (currentSelectNode?.key == board.key) {
                                                  currentSelectNode.title = currentSelectNode.editValue = board.editValue;
                                              }
                                          }}
                                          onIsLoading = {()=>{
                                              return isSaving;
                                          }}
                                          onAction={(szAction:any,data,extra)=>{
                                              if ("moveTo" == szAction) {
                                                  setIsShowDialogMoveTo(true);
                                                  nTimeoutId = setTimeout(()=>{
                                                      dialogMoveToRef.current?.onShowDialog(data,extra?.oldKey,leftMenuRef.current?.getAllNoteData(),PROJECT_ID, async(szOperator:any,selectProject)=>{
                                                          if (szOperator == 'delete'){
                                                              //删除当前key--
                                                              await leftMenuRef.current?.onRemoveSelectedItem(extra?.oldKey,selectProject?.id,data?.key);
                                                          }
                                                      });
                                                  },100);
                                                  mArrayTimeoutIds.current.push(nTimeoutId);
                                              }else if ('openElement' == szAction) {
                                                  excalidrawRef.onOpenElement(data);
                                              }else if ('sendMessage-refreshContent' == szAction) {
                                                  sendMessageFromSliderDraw('sendMessage-refreshContent')
                                              }else if ('draw2Slider-sendMessage-refreshContent' == szAction) {
                                                  sendMessageFromDraw('draw2Slider-sendMessage-refreshContent')
                                              }
                                          }}
                                />
                                <div className={'drag-line-1'} style={{top:'0',right:'0'}} onMouseDown={(e)=>{
                                    mIsLeftMouseDownPressed.current = true;
                                }}/>
                            </div>
                        </Sider>

                        <Layout>
                            <Content className='contentStyle' style={{
                                borderLeft: isPresentMode ? '0px' : '0px solid #F7F9FC',
                                // 186px
                                marginLeft: `-${homePaddingLeft}px`,
                                width:`calc(100% + ${homePaddingLeft}px)`
                            }}>
                                <div className="excalidraw-wrapper"
                                     style={{background: isDarkMode() ? DEFAULT_CANVAS_BACKGROUND_DARK : DEFAULT_CANVAS_BACKGROUND}}>
                                    {/*<div style={{position:'absolute',width:'500px',height:'500px',zIndex:'9999',backgroundColor:'green',right:'0'}}>*/}
                                    {/*    <MyExcalidraw value={drawJson} onRef={onRefExcalidrawForHidden}*/}
                                    {/*                  parentOnExcalidrawInitComplete={onExcalidrawInitComplete}*/}
                                    {/*    />*/}
                                    {/*</div>*/}

                                    {/*画布***************/}
                                    <MyExcalidraw value={drawJson} onRef={onRefExcalidraw}
                                                  parentOnCanvasChange={onCanvasChange}
                                                  parentOnEditNoteData={onEditNoteData}
                                                  parentOnExcalidrawInitComplete={onExcalidrawInitComplete}
                                                  parentOnLinkNav={onLinkNav}
                                                  parentOnResetTool={() => {
                                                      var arrayNew = [...toolButtons];
                                                      arrayNew.forEach(p => {
                                                          p.isActive = false;
                                                          if (p.id == 'selection') {
                                                              p.isActive = true;
                                                          }
                                                      });
                                                      setActivityTool('selection');

                                                      setTimeout(()=>{
                                                          setToolButtons(arrayNew);
                                                      },300)
                                                  }}
                                                  parentOnPointDown={() => {
                                                      closeAllPopoverOrDropdown();
                                                  }}
                                                  parentOnPointerUp={(event: any) => {
                                                      if (APP_WEB_WWW) {

                                                      }
                                                      if (!isPresentMode || APP_WEB_WWW) {
                                                          if (mAutosaveTimeId && (Date.now() - lastAutoSavingTime) < AUTO_SAVE_TIME_INTERVAL) {
                                                              clearTimeout(mAutosaveTimeId);
                                                          }
                                                          setLastAutoSavingTime(Date.now())
                                                          mAutosaveTimeId = window.setTimeout(() => {
                                                              if (leftMenuRef?.current) {
                                                                  //没有关闭的情况下....
                                                                  // saveNotes(false);
                                                                  setIsAutoSaving(true);
                                                              }
                                                          }, AUTO_SAVE_TIME_INTERVAL);
                                                      }
                                                      onUpdateFrameList();

                                                      if (isInSidebar()) {
                                                          //右侧栏发送个通知，关闭可能存在的board弹窗
                                                          sendMessageFromSliderDraw('MOUSE_UP',{})
                                                      }
                                                  }}
                                                  parentOnSelectElement={(element: any) => {
                                                      if ((Date.now() - mSelectElementLastTime.current) < 300) {
                                                          if (element?.locked && excalidrawRef?.onGetActiveTool() != 'hand') {
                                                              setIsSelectElementLocked(true);
                                                          } else {
                                                              setIsSelectElementLocked(false);
                                                          }
                                                          //刷新右侧栏的info--如果有打开的话
                                                          refreshInfo();
                                                      }
                                                      mSelectElementLastTime.current = Date.now();
                                                  }}
                                                  parentOnSelectElementChanged={(szAction:any,extra:any)=>{
                                                      //刷新右侧栏的info--如果有打开的话
                                                      refreshInfo();
                                                      saveNotes();
                                                  }}
                                                  parentOnSceneElementUpdate={(action,extra)=>{
                                                      //元素有改动都会执行到这里.
                                                      if (action == 'remove' || action == 'add' || action == 'update') {
                                                          leftMenuRef.current?.onRefreshContentElements(extra?.elements)
                                                      }
                                                  }}
                                                  setDisplayMode={(displayMode: DisplayMode) => {

                                                  }}
                                                  parentOnShowTip={(szType, szTitle, szContent) => {
                                                      if (szType == 'ocr') {
                                                          // if (import.meta.env.DEV) {
                                                          //     showDesktopPro(DESKTOP_PRO_FROM_OCR)
                                                          // }else {
                                                          //     setIsShowDialogImportFileVip(true);
                                                          //     setTimeout(() => {
                                                          //         dialogImportFileVipRef.current?.onShowDialog(szTitle, szContent)
                                                          //     }, 100);
                                                          // }
                                                          // showDesktopPro(DESKTOP_PRO_FROM_OCR)
                                                          window.showMessageBox(t("Upgrade required"),t("NeedUpgradeToUseOCR"),t("Cancel"),t("Learn more"),null,()=>{
                                                              if (isZh()) {
                                                                  ipcSend('open-url',import.meta.env.VITE_HTTP_PURCHASE_PRICE_ZH)
                                                              }else {
                                                                  ipcSend('open-url', import.meta.env.VITE_HTTP_PURCHASE_PRICE);
                                                              }
                                                          })
                                                      } else if (szType == 'ocrResult') {
                                                          setIsShowDialogOcrResult(true);
                                                          nTimeoutId = setTimeout(() => {
                                                              dialogOcrResultRef.current?.onShowDialog(szContent)
                                                          }, 100);
                                                          mArrayTimeoutIds.current.push(nTimeoutId);
                                                      }
                                                  }}
                                                  parentOnOpenPdfFile={(id: string, szFilePath: string, szShowName: string, openType: string | 'slider' | 'dialog') => {

                                                      if (openType == 'dialog') {
                                                          window.showPdfPreview(szShowName,id,szFilePath);
                                                      }else {
                                                          if (szFilePath.startsWith('http')) {
                                                              const url = (szFilePath);
                                                              if (openType == 'slider') {
                                                                  //右侧打开.
                                                                  postMessage(EVENT_PDF_ON_SLIDER_RIGHT, {
                                                                      pdfPath: url,
                                                                      fileId: id,
                                                                      fileName: szShowName ?? getFileName(szFilePath),
                                                                      pdfFileName: szFilePath,
                                                                      breadcrumb:createBreadcrumb("library", szShowName ?? getFileName(szFilePath))
                                                                  });
                                                                  excalidrawRef.clearSelectElements();
                                                              } else if (openType == 'dialog') {
                                                                  setFileState({
                                                                      open: true,
                                                                      fileName: szShowName ?? getFileName(szFilePath),
                                                                      filePath: url,
                                                                      fileId: id,
                                                                      isFullScreen: false
                                                                  })
                                                              }
                                                          }else {
                                                              ipcInvoke('read-file-absolute-path', {filePath: szFilePath}).then(res => {
                                                                  const blob = new Blob([res]);
                                                                  const url = URL.createObjectURL(blob);
                                                                  if (openType == 'slider') {
                                                                      //右侧打开.
                                                                      postMessage(EVENT_PDF_ON_SLIDER_RIGHT, {
                                                                          pdfPath: url,
                                                                          fileId: id,
                                                                          fileName: szShowName ?? getFileName(szFilePath),
                                                                          pdfFileName: szFilePath,
                                                                          breadcrumb:createBreadcrumb("library", szShowName ?? getFileName(szFilePath))
                                                                      });
                                                                      excalidrawRef.clearSelectElements();
                                                                  } else if (openType == 'dialog') {
                                                                      setFileState({
                                                                          open: true,
                                                                          fileName: szShowName ?? getFileName(szFilePath),
                                                                          filePath: url,
                                                                          fileId: id,
                                                                          isFullScreen: false
                                                                      })
                                                                  }
                                                              })
                                                          }
                                                      }
                                                  }}
                                                  parentOnGetSelectedBoard={() => {
                                                      return leftMenuRef?.current.onGetSelectNode();
                                                  }}
                                                  parentOnSaveNotes={() => {
                                                      return saveNotes();
                                                  }}
                                                  parentOnMenuAction={async (action, data) => {
                                                      if (action == 'zenMode') {
                                                          if (data) {
                                                              //禅模式

                                                          } else {
                                                              //退出
                                                          }
                                                          setIsZenMode(data);
                                                      }else if (action == 'addFile'){
                                                          // toolsClicked({currentTarget:{dataset:{id:'file'}}})
                                                          const szImportMode:any = localStorage.getItem(KEY_FILE_IMPORT_MODE) || IMPORT_FILE_MODE_IMPORTMODE;
                                                          if (szImportMode == IMPORT_FILE_MODE_ASKME) {
                                                              //显示选择文件..
                                                              window.showDialogFileImportDrag(async (szAction: any) => {
                                                                  mFileImportMode = szAction;
                                                                  fileImportInputRef.current?.click();
                                                              });
                                                          }else {
                                                              mFileImportMode = szImportMode;
                                                              fileImportInputRef.current?.click();
                                                          }
                                                      }else if (action == 'project_rename') {
                                                          window.showCommonInput(inputTitleRef.current?.value,t("Rename"),"",t("Cancel"),t("Save"),(szContent)=>{
                                                              inputTitleRef.current.value = szContent;
                                                              mTitle.current = szContent;
                                                              refreshTitleBoardPath();
                                                              window.closeCommonInput();
                                                              //如果是在右侧栏的--那么要刷新下项目名称，
                                                              if (isInSidebar()) {
                                                                  saveNotes();
                                                                  sendMessageFromSliderDraw('refresh-project-name', {id:PROJECT_ID,name:szContent});
                                                              }
                                                          })
                                                      }else if (action == 'project_background') {
                                                          dialogColorChooseRef.current?.onShowDialog(excalidrawRef?.getAppState()?.viewBackgroundColor, excalidrawRef?.getAppState());
                                                      }else if (action == 'updateThumbUrl') {
                                                          if (!mNoteData.current) {
                                                              await saveNotes()
                                                          }
                                                          //修改缩略图.
                                                          if (mNoteData.current) {
                                                              mNoteData.current.thumbUrl = data;
                                                          }
                                                      }else if (action == 'set_project_name') {
                                                          inputTitleRef.current.value = data;
                                                          mTitle.current = data;
                                                          refreshTitleBoardPath();
                                                          await saveNotes();//保存一下.
                                                      }
                                                  }}
                                                  parentOnLoadBoardFinished={()=>{
                                                      refreshHasElement();
                                                  }}
                                                  parentOnFirstLoadFinished={()=>{
                                                      //搜索---必须在第一次
                                                      if (!isStringNullOrEmpty(params.state?.usr?.searchKey)){
                                                          nTimeoutId = setTimeout(() => {
                                                              setIsSearchVisible(true);
                                                              setTimeout(()=>{
                                                                  onSearchElement(null,params.state?.usr?.linkInfo?.pageId);
                                                                  inputSearchRef.current.value = params.state?.usr?.searchKey;
                                                                  inputSearchRef.current?.focus();//获取焦点.
                                                              },300)
                                                          }, 200);
                                                          mArrayTimeoutIds.current.push(nTimeoutId);

                                                          setTimeout(()=>{
                                                              params.state.usr.searchKey = '';
                                                          },3000)
                                                      }
                                                  }}
                                                  parentOnZoomChanged={()=>{
                                                      setInputZoom(Math.floor(excalidrawRef?.getExcalidrawApi()?.getApp().state.zoom.value*100)+'%');
                                                  }}
                                    />

                                    {/*//默认的工具栏--没有东西选中*/}
                                    {
                                        // !isPresentMode &&
                                        // <div style={{
                                        //     background: 'var(--draw-tool-bar-color)',
                                        //     left: isCollapsePage ? "0px" : TOOL_BAR_LEFT_WIDTH + 'px', top: '0px',
                                        //     height: '48px', width: '100%', position: 'absolute',
                                        //     zIndex: '8',
                                        //     display: "flex", alignItems: 'center'
                                        // }}>
                                        //     <img className='ml-12 img-30 cursor-pointer'
                                        //          style={{
                                        //              background: activityTool == 'hand' ? COLOR_E5E5E5() : COLOR_TRANSPARENT,
                                        //              borderRadius: '8px'
                                        //          }}
                                        //          src={getImagePathWithTheme('tool_default_pan')} onClick={() => {
                                        //         var arrayTools = [...toolButtons];
                                        //         arrayTools.forEach(p => p.isActive = false);
                                        //         let tool = 'hand';
                                        //         if (activityTool == 'hand') {
                                        //             tool = 'selection';
                                        //             arrayTools.forEach((p) => {
                                        //                 if (p.id == 'selection') {
                                        //                     p.isActive = true;
                                        //                 }
                                        //             })
                                        //         } else {
                                        //             tool = ('hand');
                                        //         }
                                        //         setActivityTool(tool);
                                        //         excalidrawRef?.onSetActiveTool(tool)
                                        //         setToolButtons(arrayTools);
                                        //
                                        //     }}/>
                                        //
                                        //     <img className='ml-12 img-30 cursor-pointer'
                                        //          src={getImagePathWithTheme("tool_default_search")} onClick={() => {
                                        //         setIsSearchVisible(true);
                                        //     }}/>
                                        //
                                        //     <img className='ml-12 img-30 cursor-pointer'
                                        //          src={getImagePathWithTheme("tool_default_react")}
                                        //          onClick={() => {
                                        //              excalidrawRef?.onSetActiveTool('rectangle')
                                        //          }}/>
                                        //
                                        //     <img className='ml-12 img-30 cursor-pointer'
                                        //          src={getImagePathWithTheme("tool_default_arrow")} onClick={() => {
                                        //         excalidrawRef?.onSetActiveTool('arrow')
                                        //     }}/>
                                        //
                                        //     {/*<Button onClick={()=>{*/}
                                        //     {/*    appJotaiStore.set(isCollaboratingAtom, true);*/}
                                        //     {/*}}>Room</Button>*/}
                                        // </div>
                                    }

                                    {/*//锁定的工具栏*/}
                                    {
                                        // !isPresentMode &&
                                        // <div style={{
                                        //     background: 'var(--draw-tool-bar-color)',
                                        //     left: isCollapsePage ? "0px" : TOOL_BAR_LEFT_WIDTH + 'px', top: '0px',
                                        //     height: '48px', width: '100%', position: 'absolute',
                                        //     zIndex: '9',
                                        //     display: isSelectElementLocked ? 'flex' : 'none', alignItems: 'center'
                                        // }}>
                                        //     <img className='ml-12 img-30 cursor-pointer'
                                        //          src={imgPathPerfix() + 'toolbar_locked_element.png'} onClick={() => {
                                        //         excalidrawRef?.getApp()?.executeContextMenuAction('toggleElementLock');
                                        //         setIsSelectElementLocked(false);
                                        //     }}/>
                                        // </div>
                                    }

                                    {
                                        isAutoSaving &&
                                        <div style={{
                                            position: "absolute",
                                            zIndex: '10',
                                            right: '10px',
                                            top: '13px',
                                            fontSize: '12px'
                                        }}></div>
                                    }

                                    {
                                        isShowSmallLoading &&
                                        <div className={'flex-center'} style={{
                                            position: 'fixed',
                                            zIndex: '99',
                                            left: 0 + 'px',
                                            top: 'calc(50% - 10px)',
                                            width: '100%'
                                        }}>
                                            <Spin indicator={<LoadingOutlined spin/>} size="large"/>
                                        </div>
                                    }

                                </div>


                                <div className='contentStyle-search font-size-12'
                                     style={{
                                         display: isSearchVisible ? 'inline' : 'none',
                                         background: 'var(--dialog-background-color)',
                                         boxShadow: 'var(--dialog-box-shadow)',
                                         marginTop:`${HEADER_HEIGHT}px`,
                                     }}>
                                    <div className='flex-row'>
                                        <h4 style={{color:'var(--text-color)'}}>{t("Search")}</h4>
                                        <span style={{flexGrow: 1}}/>
                                        <img className='img-mini-small-10 cursor-pointer'
                                             src={getImagePathWithTheme("close_black")} onClick={onCloseSearch}/>
                                    </div>
                                    <div style={{display: 'flex', marginTop: '12px'}}>
                                        <div style={{display: 'flex', alignItems: 'center', position: 'relative'}}>
                                            <Input variant={"borderless"}
                                                   className='contentStyle-search-input input-border-5f'
                                                   ref={inputSearchRef}
                                                   value={searchKey}
                                                   onChange={e => {
                                                       setSearchKey(e.currentTarget.value);
                                                   }}/>
                                            <div style={{position: "absolute", right: '8px'}}>
                                            <span style={{display: arraySearchResult.length != 0 ? 'inline' : 'none',color:'var(--text-color)'}}>
                                                <LeftOutlined
                                                    onClick={() => onSearchNextOrPre(-1)}/>{currentSearchIndex + 1}/{arraySearchResult.length}<RightOutlined
                                                onClick={() => onSearchNextOrPre(1)}/>
                                            </span>

                                                <span
                                                    style={{display: (arraySearchResult.length === 0 && !isStringNullOrEmpty(searchKey)) ? 'inline' : 'none',color:'var(--text-color)'}}>{t("No found")}</span>
                                            </div>
                                        </div>

                                        <ConfigProvider
                                            theme={{
                                                components: {
                                                    Select: {
                                                        /* 这里是你的组件 token */
                                                        colorBgElevated:'var(--dialog-dialog-background-color-2c)',
                                                        colorText:'var(--text-dark-gray-color)',
                                                        fontSize:12,
                                                        fontFamily:'Poppins',
                                                        colorBgContainer:'transparent',
                                                        colorBorder:'var(--input-border-color-5f5f5f)',
                                                        colorTextPlaceholder:'var(--input-place-holder-color)',
                                                        colorPrimaryHover:'var(--input-border-color-5f5f5f)',
                                                        colorPrimary:'var(--input-border-color-5f5f5f)',
                                                        controlOutline:'transparent',
                                                        boxShadowSecondary:'var(--box-shadow-border)'
                                                    },
                                                },
                                            }}>
                                            {/*颜色只换了一半的东西.*/}
                                            <Select className='font-size-12' style={{marginLeft: '8px', fontSize: '12px'}}
                                                    dropdownStyle={{minWidth: '150px'}} value={defaultSearch}
                                                    suffixIcon={<IconDropdownBlack/>}
                                                    onChange={onSearchOptionChange} options={[
                                                {label: t("Current page"), value: 'currentPage'},
                                                {label: t("Whole project"), value: 'wholeProject'},
                                            ]}/>
                                        </ConfigProvider>

                                    </div>
                                </div>
                            </Content>
                        </Layout>
                    </Layout>
                </Layout>

                <DialogExport ref={dialogShareRef} isShowDialog={isShowShareDialog}
                              onCloseDialog={() => setIsShowShareDialog(false)}
                              onExportEvent={onShareMenuEvent}
                />

                {
                    isShowLinkDialog &&
                    <DialogLink ref={dialogLinkRef}
                                isShowDialog={isShowLinkDialog}
                                onCloseDialog={() => setIsShowLinkDialog(false)}
                                onInsertLink={onInsertLink}/>
                }


                <DialogExportInfo
                    ref={dialogExportInfoRef}
                    isShowDialog={isShowDialogExportInfo}
                    onCloseDialogEvent={() => setIsShowDialogExportInfo(false)}
                    onExportEvent={onExportEventWithInfo}
                />

                <DialogMessageBox ref={dialogMessageBoxRef}/>

                <DialogColorChoose ref={dialogColorChooseRef} appState={excalidrawRef?.getAppState()}
                                   onCanvasBackgroundEvent={(szHexColor, isClose, isAllPage, type) => {
                                       if (COLOR_CHOOSE_TYPE_MINDMAP_LINE_COLOR == type) {
                                           postMessage(EVENT_MINDMAP_LINE_COLOR_OK, {color: szHexColor});
                                       } else {
                                           setCanvasBackgroundColor("", szHexColor as string, isAllPage)
                                           if (isClose) {
                                               dialogColorChooseRef.current?.onCloseDialog();
                                           }
                                       }
                                   }}/>

                <DialogPageSize ref={dialogPageSizeRef} onDialogOkEvent={onCustomPageSize}/>

                <DialogPublishToWeb ref={dialogPublishToWebRef} onExportEvent={(szId: string) => {
                    if (szId == 'exportPng' || szId == 'exportPdf') {
                        setIsDialogExportPngVisible(true);
                        nTimeoutId = setTimeout(() => {
                            dialogExportRef.current.onDialogShow(mPublishId, leftMenuRef.current?.getAllMenuData(), leftMenuRef?.current.getSelectMenuKeys(), szId == 'exportPng' ? 'png' : 'pdf');
                        }, 100);
                        mArrayTimeoutIds.current.push(nTimeoutId);
                    } else {
                        onShareMenuEvent(szId);
                    }
                }}/>

                <DialogFrameTips ref={dialogFrameTipsRef} onCreateFrame={() => {
                    setIsFramePopoverOpen(true);
                }}/>

                <DialogFontChoose ref={dialogFontChooseRef}/>
                <DialogProgress ref={dialogProgressRef}/>
                <DialogRename ref={dialogRenameRef} onOKEvent={async (itemId, content: string) => {
                    //update.....
                    let font = await getFontInfo(itemId);
                    font.fontName = content;
                    updateFontInfo(font);
                    createFontFamily(font);

                    FONT_FAMILY[font.fontName] = font.fontName;
                    //创建一个无用的span 强制加载字体....
                    var span = document.createElement('span');
                    span.style.fontFamily = font.fontName;
                    document.body.appendChild(span);

                    nTimeoutId = setTimeout(() => {
                        postMessage(EVENT_OPEN_SELECT_FONT_FAMILY);
                    }, 200);
                    mArrayTimeoutIds.current.push(nTimeoutId);
                }}/>

                {
                    isShowDialogImportFileVip &&
                    <DialogImportFileVip ref={dialogImportFileVipRef} onCloseEvent={() => {
                        setIsShowDialogImportFileVip(false);
                    }}/>
                }

                {
                    isShowDialogOcrResult &&
                    <DialogOcrResult ref={dialogOcrResultRef}/>
                }

                {
                    isShowDialogDesktopPro &&
                    <DialogDesktopPro ref={dialogDesktopProRef}/>
                }

                {
                    isShowDialogExportTips &&
                    <DialogExportTips ref={dialogExportTipsRef}/>
                }

                {
                    isShowDialogMoveTo &&
                    <DialogMoveTo ref={dialogMoveToRef} onCloseCallback={()=>{setIsShowDialogMoveTo(false)}}/>
                }

                {
                    //
                    isDialogExportPngVisible &&
                    <Modal width={'240px'} bodyStyle={{marginBottom: '-16px'}} closeIcon={<IconClose/>} centered={true}
                           footer={''} open={isDialogExportPngVisible} onCancel={() => {
                        setIsDialogExportPngVisible(false)
                    }}>
                        <PopverExport ref={dialogExportRef}
                                      onClosePopover={(e) => setIsDialogExportPngVisible(false)}
                                      onDoneEvent={(arrayPages: any, exportType: any) => {
                                          setIsDialogExportPngVisible(false);
                                          onShareMenuEvent((exportType === 'png' ? "exportPng" : "exportPdf"), arrayPages, {})
                                      }}/>
                    </Modal>
                }

                {/*<RenameModal*/}
                {/*    open={isShowDialogPdfRename}*/}
                {/*    fileName={pdfFileName}*/}
                {/*    fileId={pdfFileId}*/}
                {/*    onClose={(isUpdate, _fileName) => {*/}
                {/*        setIsShowDialogPdfRename(false);*/}
                {/*        setPdfFileName(_fileName);*/}
                {/*    }}*/}
                {/*/>*/}

                {/*{*/}
                {/*    excalidrawAPI && !isCollabDisabled &&*/}
                {/*    <Collab excalidrawAPI={excalidrawAPI} />*/}
                {/*}*/}

                {/*pdfviewer*/}
                <FileModal
                    fileId={fileState.fileId}
                    fileName={fileState.fileName}
                    filePath={fileState.filePath}
                    isFullScreen={fileState.isFullScreen}
                    isViewAllHighlight={fileState.isViewAllHighlight}
                    open={fileState.open}
                    isShowMoreMenu={true}
                    onClose={(isUpdate) => {
                        if (isUpdate) {

                        }
                        setFileState({
                            open: false,
                            filePath: "",
                            fileName: "",
                            fileId: "",
                            isFullScreen: false,
                            isViewAllHighlight: false
                        })
                    }}
                />


                {
                    isSaving &&
                    <div style={{
                        position: "fixed",
                        left: '0px', top: '0px', zIndex: '9999',
                        height: '100%', width: '100%', display: 'flex',
                        flexDirection: 'column',
                        // backgroundColor: '#00000055',
                        // backdropFilter: 'blur(2px)',
                        alignItems: 'center', justifyContent: 'center',
                        pointerEvents:'none'
                    }} onClick={()=>{
                        //点击---按30s后才关闭....不能立即关。。。。。
                        nTimeoutId = setTimeout(()=>{
                            setIsSaving(false);
                        },30000);
                        mArrayTimeoutIds.current.push(nTimeoutId);
                    }}>
                        <Spin indicator={IconIndicatorWhite}/>
                        <span className={'mt-8'} style={{color: 'white'}}>{loadingTips}</span>
                    </div>
                }


                {
                    //********************************* 底部工具栏 *********************************
                    // ((APP_WEB && (leftMenuRef?.current?.getPagesCount() > 1) && (!isAppWebFullScreen || isShowClosePresent) && !isLoading && !isFramePresent) ||
                    //     (isPresentMode && ((isShowClosePresent && !isShowExitPresent))) &&
                    //     excalidrawRef.getAppState()?.displayMode != 'preview') &&

                    // ((APP_WEB && (leftMenuRef?.current?.getPagesCount() > 1) && (!isAppWebFullScreen || isShowClosePresent) && !isLoading) ||
                    //     (isPresentMode && ((isShowClosePresent && !isShowExitPresent)))) && (isShowBottomPresent || isPopoverPresentMore) &&
                    (leftMenuRef?.current?.getPagesCount() > 0 || leftMenuRef?.current?.getCurrentPageFrameCount() > 1)
                    && (isShowBottomPresent || isPopoverPresentMore) &&
                    <div className='bottom-present-page flex-center'>
                        <img className='img-mini-small-10 cursor-pointer' src={imgPathPerfix() + 'small_arrow_left.png'}
                             onClick={() => {
                                 if (excalidrawRef.getExcalidrawState().displayMode === "preview") {
                                     postMessage(EVENT_FRAME_PREVIEW_LAST)
                                 } else {
                                     const pages = leftMenuRef?.current?.onMoveToPre();
                                     setPageSizeNumber(pages);
                                 }
                             }}/>
                        <span style={{color: "white", margin: '0 6px'}}>{pageSizeNumber}</span>
                        <img className='img-mini-small-10 cursor-pointer'
                             src={imgPathPerfix() + 'small_arrow_right.png'}
                             onClick={() => {
                                 if (excalidrawRef.getExcalidrawState().displayMode === "preview") {
                                     postMessage(EVENT_FRAME_PREVIEW_NEXT)
                                 } else {
                                     const pages = leftMenuRef?.current?.onMoveToNext();
                                     setPageSizeNumber(pages);
                                 }
                             }}/>
                        {/*<div className='small-v ml-16'></div>*/}
                        {
                            !APP_WEB &&
                            <ConfigProvider
                                theme={{
                                    components: {
                                        Popover: {
                                            /* 这里是你的组件 token */
                                            colorBgElevated: 'transparent'
                                        },
                                    },
                                }}>
                                <Popover open={isPopoverPresentMore} overlayClassName='popover-laser-container'
                                         trigger={'click'} onOpenChange={(e) => setIsPopoverPresentMore(e)} content={
                                    <div>
                                        <div className='flex-row-vertical-center popover-laser-item cursor-pointer'
                                             onClick={() => {
                                                 if (excalidrawRef.getAppState()?.activeTool?.type == 'laser') {
                                                     exitLaser();
                                                 } else {
                                                     showLaser();
                                                 }
                                                 setIsPopoverPresentMore(false);
                                             }}>
                                            <img className='img-16' src={imgPathPerfix() + 'tumn_on_laser.png'}/>
                                            <span
                                                className='ml-12'>{t(excalidrawRef.getAppState()?.activeTool?.type == 'laser' ? "Turn off the laser pointer" : "Turn on the laser pointer")}</span>
                                            {
                                                !hasLicense() && !hasDesktopBaseLicense() &&
                                                <img className='img-18 ml-6' src={imgPathPerfix() + 'vip.png'}/>
                                            }

                                            <div style={{flexGrow: '1'}}></div>
                                            <span className='key-board-container'>L</span>
                                        </div>
                                        <div className='flex-row-vertical-center popover-laser-item cursor-pointer'
                                             onClick={() => {
                                                 onKeydownListener({key: KEYS.ESCAPE});
                                                 setIsPopoverPresentMore(false)
                                             }}>
                                            <img className='img-16' src={imgPathPerfix() + 'close_white.png'}/>
                                            <span className='ml-12'>{t("Exit presentation")}</span>
                                            <div style={{flexGrow: '1'}}></div>
                                            <span style={{width: '38px'}} className='key-board-container'>ESC</span>
                                        </div>
                                    </div>
                                }>
                                    <img id={'vertical_more_1'} className='pointer-cursor'
                                         style={{
                                             width: '15px',
                                             height: '22px',
                                             marginLeft: '16px',
                                             background: isPopoverPresentMore ? '#00000033' : '#00000000',
                                             borderRadius: '3px'
                                         }}
                                         src={imgPathPerfix() + 'vertical_more_w.png'}/>
                                </Popover>
                            </ConfigProvider>
                        }


                    </div>
                }

                {
                    // APP_WEB &&
                    // isShowOverlay &&
                    // <>
                    //     <div className='div-overlay'>
                    //         {
                    //             isEnableNavKey &&
                    //             <>
                    //                 <LeftOutlined style={{color:"white"}} onClick={()=>{
                    //                     const pages = leftMenuRef?.current?.onMoveToPre();
                    //                     setPageSizeNumber(pages);
                    //                 }}/>
                    //                 <span style={{margin:'0 6px'}}>{pageSizeNumber}</span>
                    //                 <RightOutlined style={{color:"white"}} onClick={()=>{
                    //                     const pages = leftMenuRef?.current?.onMoveToNext();
                    //                     setPageSizeNumber(pages);
                    //                 }}/>
                    //             </>
                    //         }
                    //     </div>
                    //     <img onClick={()=>{
                    //         onFullScreenByWeb();
                    //     }} style={{zIndex:'9999',position:"absolute",right:'26px',bottom:'20px'}} className='img-16 pointer-cursor' src={imgPathPerfix()+'web_fullscreen.png'}/>
                    // </>
                }

                {/*{*/}
                {/*    isLoading &&*/}
                {/*    <div className='flex-center'*/}
                {/*         style={{position: "absolute", left: '0', top: '0', width: '100%', height: '100%', zIndex: '9999',backgroundColor:'#ffffff33'}}>*/}
                {/*        <Spin indicator={<LoadingOutlined style={{fontSize: 24}} spin/>}></Spin>*/}
                {/*    </div>*/}
                {/*}*/}


                {
                    isLoading &&
                    <div style={{
                        position: 'absolute', zIndex: '999',
                        left: '0', top: '0',
                        background: isLoadingFramePresent ? '#1E1E1E' : 'transparent',
                        width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center'
                    }}>
                        <Progress size={"small"} strokeColor={isLoadingFramePresent ? '#EAEAEA' : 'black'}
                                  trailColor={isLoadingFramePresent ? '#2C2C2C' : 'white'}
                                  style={{width: '248px', height: '5px'}} percent={progressPercent} showInfo={false}/>
                    </div>
                }

                {
                    isWebAlphaVisible &&
                    <DialogOfflineAlpha onOpenProjectEvent={(szAction) => {
                        // const nCount = getNoteListCount();

                        if ("newProject" == szAction) {
                            setIsWebAlphaVisible(false);
                        } else if ("openProject" == szAction) {
                            onOpenFromLocalfile();
                        }
                    }}/>
                }

                {
                    isShowDialogHelper &&
                    <DialogHelper ref={dialogHelperRef}/>
                }

                <DialogTagManager ref={dialogTagManagerRef} from={"project"}
                                  onDismissCallback={(isTagChange: boolean) => {
                                      //标签更改了，需要刷新数据....

                                  }}/>


                {/*隐藏的文件选择*/}
                <div className="file-selector">
                    <input
                        ref={fileInputRef}
                        type="file"
                        id="file-input"
                        accept=".pcanvas,.pcanvasx"
                        style={{display: 'none'}}
                        onChange={handleFileChange}
                    />
                </div>

                {/*隐藏的文件选择*/}
                <div className="file-selector">
                    <input
                        ref={filePdfInputRef}
                        type="file"
                        id="file-input-0"
                        accept=".pdf"
                        style={{display: 'none'}}
                        onChange={handlePdfFileChange}
                    />
                </div>

                {/*隐藏的文件选择*/}
                <div className="file-selector">
                    <input
                        ref={fileImportInputRef}
                        type="file"
                        id="file-input-1"
                        accept="*"
                        multiple={true}
                        style={{display: 'none'}}
                        onChange={async (event:any)=>{
                            const files = event.target.files;
                            if (files.length > 20) {
                                message.error(t("MaxFile"));
                                return;
                            }

                            if (!mFileImportMode) {
                                mFileImportMode = getFileImportMode();
                            }

                            for (let i=0;i<files.length;i++) {
                                const selectedFile = files[i];
                                await handleImportFile(selectedFile,mFileImportMode,files.length == 1);
                            }
                            // global.g_importFileCount = 0;
                            fileImportInputRef.current.value = null;
                        }}
                    />
                </div>

            </div>

            {/*右侧浮动PDF card*/}
            <div className={'float-popup flex-row'} id={'div-slider-right'} data-type={'noDrag'} style={{
                width: rightSliderWidth + 'px',
                top: isMac()?'0':((isPresentMode || APP_WEB_WWW || APP_WEB) ? '0px' : '30px'),
                height: '100%',
                overflow:'hidden',
                // paddingBottom: '44px'
            }}>
                <div className={'drag-line'} onMouseDown={(event) => {
                    mSliderX = event.clientX;
                    mIsSliderDownPress = true;
                    // event.preventDefault();
                }}>&nbsp;</div>
                <div style={{
                    width: '100%',
                    height: isMac()?'100vh':`calc(100vh - ${TITLE_BAR_HEIGHT}px)`,
                    display: 'flex',
                    flexDirection: 'column',
                    marginLeft: '0px'
                }}>
                    {/*//头部*/}
                    {
                        sliderHeaderVisible &&
                        <DrawIndexSliderHeader onAction={(szAction:any)=>{
                            drawIndexSliderHeaderAction(szAction);
                        }}/>
                    }

                    <div className={'flex-row-vertical-center'} style={{padding: '0px 12px 0px 4px', height: `${HEADER_HEIGHT}px`}}>
                        {
                            sliderCardData &&
                            <img className='img-32 hovered-gray-radius ml-6' onClick={() => {
                                sideBarFoldRef.current?.onToggleBar();
                            }} src={getImagePathWithTheme('left_slider_2.svg')}/>
                        }
                        {
                            (sliderHeaderVisible && !sliderCardData) ?
                                //导航
                                <DrawIndexBreadcrumb arrayBreadcrumb={arrayBreadcrumb}
                                                     onAction={(breadcrumbItem: any) => {
                                                         drawIndexBreadcrumbAction(breadcrumbItem);
                                                     }}/> : <>
                                {
                                    (!sliderCardData || isPresentMode) &&
                                    <img className={'img-14 cursor-pointer ml-8'}
                                         src={getImagePathWithTheme('collapse_library')}
                                         onClick={async () => {
                                             //open card or pdf
                                             animateSliderFade()
                                         }}/>
                                }
                                    <div className={'dialog-title'} style={{
                                        whiteSpace: 'nowrap',
                                        textOverflow: 'ellipsis',
                                        overflow: 'hidden',
                                        margin: '2px 8px 0px 8px'
                                    }}>{pdfFileName || (sliderCardData?.name || '')}</div>
                                </>
                        }

                        <div style={{flexGrow:'1'}}></div>

                        {
                            !isSearchVisible && (pdfFileId || sliderCardData) && !APP_WEB && !isPresentMode &&
                            <img className={'img-16 cursor-pointer mr-12 card-info'} src={getImagePathWithTheme('context_menu_info.svg')} onClick={()=>{
                                if (pdfFileId){
                                    getCardById(pdfFileId).then(res=>{
                                        window.showInfo('library',res);
                                    })
                                }else if (sliderCardData){
                                    getCardById(sliderCardData.id).then(res=>{
                                        window.showInfo('library',res);
                                    })
                                }

                            }}/>
                        }

                        {/*card 卡片分享 发布*/}
                        {
                            sliderCardData && !isPresentMode &&
                            <Tooltip overlayClassName='font-size-12' title={t('Share')} zIndex={9999} arrow={false}>
                                <img className='img-25 hovered-gray-radius ml-0' style={{marginLeft:'-6px',marginRight:'2px'}} onClick={() => {
                                    window.showDialogPublishCardToWeb(sliderCardData.id,async (szId,dialogPublishToWebRef)=>{
                                        if (szId == 'exportPdf') {
                                            onSliderClickMenu('exportPdf')
                                        }else if (szId == 'exportMarkdown'){
                                            onSliderClickMenu('exportMarkdown')
                                        }
                                        else {
                                            shareCardData(sliderCardData,null,dialogPublishToWebRef);
                                        }
                                    });
                                }} src={getImagePathWithThemeSvg('share_card')}/>
                            </Tooltip>
                        }


                        {
                            !isPresentMode &&
                            <Dropdown trigger={["click"]}
                                      menu={{items: getSliderMoreItems(), onClick: onSliderClickMenu}}>
                                <img id={'vertical_more_2'} style={{flexShrink: '0',opacity:isDarkMode()?'0.55':'1'}} className={'img-14 cursor-pointer'}
                                     src={getImagePathWithTheme('vertical_more')}/>
                            </Dropdown>
                        }
                    </div>
                    {
                        !sliderCardData &&
                        <div className={'line'} style={{margin: '1px 0px 6px 0px'}}></div>
                    }

                    {
                    sliderContainerHtml &&
                        <div ref={divSliderContainerRef} style={{overflowY: 'auto', height: '100%'}}
                             dangerouslySetInnerHTML={{__html: sliderContainerHtml}}>

                        </div>
                    }


                    {
                        sliderCardData && rightSliderWidth > 0 &&
                        <div ref={divSliderContainerRef} id='div-edit-container' className={'editor-container------'}
                             style={{overflowY: 'auto', height: '100%', margin: '0px -20px', padding: '0 36px',display:'flex',borderTop:sideBarStatus == 2?'1px solid var(--line-color)':'none'}}>

                            <div style={{
                                position: 'relative', /*minWidth: `${headerTreeWidth}px`,*/
                                overflow: 'hidden',
                                width: '220px',
                                flexShrink:'0',
                                marginLeft:'-18px',
                                display: sideBarStatus == 2 ? 'inherit' : 'none'
                            }}>
                                {
                                    editor &&
                                    <SideBarFold ref={sideBarFoldRef} editor={editor} from={FROM_RIGHT_SIDE}
                                                 data={sliderCardData} onCollapseCallback={(sidebarStatus: any) => {
                                                     setSideBarStatus(sidebarStatus);
                                    }}/>
                                }
                            </div>

                            <div style={{
                                background: 'var(--draw-slider-card-background-color)',
                                height: '100%',
                                border: '1px solid var(--draw-slider-card-border-color)',
                                borderTop:sideBarStatus == 2?'none':'1px solid var(--draw-slider-card-border-color)',
                                // borderRadius: '8px',
                                // margin: '0 -8px',
                                padding: '0 8px',
                                overflowY: 'auto',
                                width:'100%',
                            }}>
                                <Editor ref={editorRef} data={sliderCardData} from={FROM_LIBRARY} onUpdate={(data) => {
                                    setArrayBreadcrumb(createBreadcrumb('library', data.name));
                                    setPdfFileName(data.name);
                                }} onInitComplete={(editor)=>{
                                    setEditor(editor);
                                }}/>
                            </div>
                        </div>
                    }

                    {
                        pdfFilePath &&
                        <iframe
                            ref={iframeRef}
                            key={pdfFileId}
                            id={"pdf-iframe-slider"}
                            src={(APP_WEB ? "/" : "") + "pdf/reader.html?type=pdf"}
                            style={{
                                border: 'none',
                                width: "100%",
                                height: "100vh",
                                pointerEvents: iframePdfContainerPointerEvent
                            }}
                        />
                    }
                </div>
            </div>

            {/*library*/}
            {
                //region
                rightSliderLibraryWidth > 0 &&
                <div className={'float-popup flex-row'} id={'div-slider-right-library'} data-type={'noDrag'} style={{
                    width: rightSliderLibraryWidth + 'px',
                    height: '100%',
                    top: isMac() ? '0' : ((isPresentMode || isWeb()) ? '0px' : '29px'),
                }}>
                {/*//线条 */}
                    <div className={'drag-line'} onMouseDown={(event) => {
                        mSliderX = event.clientX;
                        mIsSliderLibraryDownPress = true;
                    }}>&nbsp;</div>

                    <div style={{
                        width: '100%',
                        height: '100%',
                        display: 'flex',
                        flexDirection: 'column',
                        marginLeft: '0px'
                    }}>
                        {/*//头部*/}
                        {
                            sliderHeaderVisible &&
                            <DrawIndexSliderHeader onAction={(szAction) => {
                                drawIndexSliderHeaderAction(szAction);
                            }}/>
                        }

                        {/*//下面的不同条目*/}
                        {
                            selectSliderRightMenu != 'journal' &&
                            <div className={'flex-row-vertical-center'} style={{
                                height: `${HEADER_HEIGHT}px`,
                                padding: '0 16px',
                                // borderBottom: '1px solid var(--line-color)',
                                marginLeft: '0px',
                                zIndex: '9',
                                flexShrink: '0'
                            }}>
                                <div className={'flex-row-vertical-center'} onClick={() => {
                                    // setRightSliderLibraryWidth(0);
                                }}>
                                    {/*<img className={'img-14'} src={getImagePathWithTheme('collapse_library')}/>*/}
                                    {
                                        !isLibrarySearch &&
                                        <span className={'ml-6'}>{getSliderTitle()}</span>
                                    }
                                </div>

                                {
                                    isLibrarySearch &&
                                    <Input prefix={<IconHomeSearch/>} id={'input-library-search'}
                                           suffix={renderLibrarySearchSuffix()}
                                           variant={"borderless"}
                                           style={{
                                               width: '100%',
                                               height: '32px',
                                               backgroundColor: 'var(--input-background-color)',
                                               margin: '0 0px 0 6px'
                                           }}
                                           placeholder={t("Search library")} value={librarySearchKey}
                                           onChange={(event) => {
                                               setIsSearching(true);
                                               setLibrarySearchKey(event.currentTarget.value);
                                               if (selectSliderRightMenu == 'library'){
                                                   pageLibraryRef.current?.onSearchEvent(event.currentTarget.value);
                                               }else if (selectSliderRightMenu == 'highlight'){
                                                   pageHighlightRef.current?.onSearchEvent(event.currentTarget.value);
                                               }
                                           }}
                                    />
                                }

                                {
                                    !isLibrarySearch &&
                                    <>
                                        <div style={{flexGrow: '1'}}></div>

                                        <img id={'img-home-search-0'} className={'img-16 cursor-pointer mr-4'} onClick={() => {
                                            setIsLibraySearch(!isLibrarySearch);
                                            nTimeoutId = setTimeout(() => {
                                                document.getElementById('input-library-search')?.focus();
                                            }, 100);
                                            mArrayTimeoutIds.current.push(nTimeoutId);
                                        }} src={getImagePathWithTheme('search_black.svg')}/>
                                    </>
                                }
                            </div>
                        }

                        {
                            selectSliderRightMenu == 'library' &&
                            <div style={{marginTop:'0px',height:isMac()?'calc(100% - 90px)':'calc(100% - 106px)'}}>
                                {

                                    <div style={{marginTop:'0px',height:'100%'}}>
                                    <PageLibrary ref={pageLibraryRef} from={FROM_LIBRARY} subFromPage={FROM_LIBRARY} isInsertNewLibrary={true} type={''}
                                                 pointerEvent={libraryContainerPointerEvent}/>
                                    </div>
                                }
                            </div>
                        }

                        {
                            selectSliderRightMenu == 'journal' &&
                            <div style={{marginTop:'0px',height:isMac()?'calc(100% - 40px)':'calc(100% - 76px)'}}>
                                <PageJournal from={FROM_LIBRARY}/>
                            </div>
                        }

                        {
                            selectSliderRightMenu == 'highlight' &&
                            <div style={{
                                marginTop: '0px',
                                height: isMac() ? 'calc(100% - 80px)' : 'calc(100% - 126px)'
                            }}>
                                <div style={{marginTop: '-10px', height: '100%'}}>
                                    <PageHighlight ref={pageHighlightRef} from={FROM_LIBRARY}/>
                                </div>
                            </div>
                        }


                    </div>
                </div>
                //endregion
            }

            {
                //region 通用的右侧container....
                // commonSliderContainerWidth > 0 &&
                <div className={'float-popup flex-row'} id={'div-slider-right-common'} data-type={'noDrag'} style={{
                    width: commonSliderContainerWidth + 'px',
                    height: '100%',
                    top: isMac() ? '0' : ((isPresentMode || isWeb()) ? '0px' : '29px'),
                    visibility: commonSliderContainerWidth > 0 ? 'visible' : 'collapse'
                }}>
                    <div id={'div-common-drag-line'} className={'drag-line'} onMouseDown={(event) => {
                        mSliderX = event.clientX;
                        mIsSliderCommonDownPress = true;
                    }} style={{background:sliderProjectData?'var(--right-slider-project-split-color)':'var(--drag-line-color)'}}>&nbsp;</div>
                    <div style={{
                        width: '100%',
                        height: '100%',
                        display: 'flex',
                        flexDirection: 'column',
                        marginLeft: '0px'
                    }}>
                        {/*//头部*/}
                        {
                            sliderHeaderVisible &&
                            <DrawIndexSliderHeader onAction={(szAction) => {
                                drawIndexSliderHeaderAction(szAction);
                            }}/>
                        }

                        {/*//这里是头部*/}
                        {
                            //project / info 的时候隐藏这个，使用自定义的头部...
                            sliderType != 'info' && sliderType != 'webview' && (!sliderProjectData || sliderVideoNotes) &&
                            <div className={'flex-row-vertical-center'} style={{
                                height: `${HEADER_HEIGHT}px`,
                                padding: '0 16px',
                                borderBottom: sliderType == 'project'?'none':'1px solid var(--line-color)',
                                marginLeft: '0px',
                                zIndex: '9',
                                flexShrink: '0'
                            }}>
                                {
                                    !isCommonSearchVisible ?
                                        <>
                                            {
                                                (sliderHeaderVisible) ?
                                                    //导航
                                                    <DrawIndexBreadcrumb arrayBreadcrumb={arrayBreadcrumb}
                                                                         marginLeft={'4px'}
                                                                         onAction={(breadcrumbItem: any) => {
                                                                             drawIndexBreadcrumbAction(breadcrumbItem);
                                                                         }}/> : <>
                                                        <div className={'flex-row-vertical-center cursor-pointer'}
                                                             onClick={() => {
                                                                 setCommonSliderContainerWidth(0);
                                                             }}>
                                                            <img className={'img-14'}
                                                                 src={getImagePathWithTheme('collapse_library')}/>
                                                            {
                                                                !isCommonSearchVisible &&
                                                                <span
                                                                    className={'ml-12'}>{(isFileVideoElement(sliderVideoNotes?.element) || isSupportVideoAnnoUrl(sliderVideoNotes?.element?.link)) ? t("Video notes") : t("Audio notes")}</span>
                                                            }
                                                        </div>
                                                    </>
                                            }
                                        </> : <></>
                                }

                                {
                                    //图标+标题的显示...各种情况，各种内容
                                    sliderType == 'project' && !isCommonSearchVisible && sliderTitleInfo &&
                                    <div className={'flex-row-vertical-center'}
                                         style={{height: '56px'}}>
                                        <img className={'img-16'}
                                             src={getImagePathWithTheme(sliderTitleInfo?.image)}/>
                                        <span className={'ml-6'}>{sliderTitleInfo?.title}</span>
                                    </div>
                                }


                                {
                                    isCommonSearchVisible &&
                                    <Input prefix={<IconHomeSearch/>} id={'input-common-search'}
                                           suffix={<img className='img-mini-small-8 cursor-pointer'
                                                        style={{display: isStringNullOrEmpty(commonSearchKey) ? "inherit" : "inherit"}}
                                                        onClick={() => {
                                                            setCommonSearchKey('');
                                                            videoContentRef.current?.onSearch('');
                                                            sideProjectRef.current?.onSearch('');
                                                            setIsCommonSearchVisible(false);
                                                        }}
                                                        src={imgPathPerfix() + (isDarkMode() ? "close_white_1.png" : "close_black.png")}/>}
                                           variant={"borderless"}
                                           style={{
                                               width: '100%',
                                               height: '32px',
                                               backgroundColor: 'var(--input-background-color)',
                                               margin: '0 0px 0 6px'
                                           }}
                                           placeholder={getSearchPlaceHolder()} value={commonSearchKey}
                                           onChange={(event) => {
                                               setCommonSearchKey(event.currentTarget.value);
                                               videoContentRef.current?.onSearch(event.currentTarget.value.toLowerCase());
                                               sideProjectRef.current?.onSearch(event.currentTarget.value.toLowerCase());
                                           }}
                                    />
                                }

                                {
                                    !isCommonSearchVisible && !isPresentMode &&
                                    <>
                                        <div style={{flexGrow: '1'}}></div>

                                        {
                                            //视频截图。。。。
                                            sliderVideoNotes && !isAudio(sliderVideoNotes.element?.customData?.generationData?.fileName) && HAS_VIDEO_CAPTURE_TEST &&
                                            <img className={'img-16 cursor-pointer mr-2'} style={{display:'block',marginTop:'-2px'}} src={getImagePathWithTheme('video_capture')} onClick={() => {
                                                videoContentRef.current?.onGetCapture().then(async (res)=>{
                                                    if (res == 'data:,'){
                                                        message.error(t("PleasePlayBefore"));
                                                        return;
                                                    }
                                                    const blob = base64ToBlob(res,'image/png');
                                                    const item = new ClipboardItem({'image/png':blob})
                                                    await navigator.clipboard.write([item]);
                                                    window.showMessageBox(t("ScreenshotCopiedToClipboard"),t("YouCanDownload"),t("Download"),t("OK"),async ()=>{
                                                        const library = await getCardById(sliderVideoNotes.element.customData?.generationData?.id || sliderVideoNotes.element.id);
                                                        ipcSend('saveFile',{streamType:'image',stream:res.split(',')[1],filters:'[{ name: \'Images\', extensions: [\'png\'] }]',fileName:library?.name +'.png'});
                                                    },null)
                                                })
                                            }}/>
                                        }

                                        {
                                            selectTag &&
                                            <div className={'flex-row-vertical-center mr-12'} style={{background:'var(--draw-tool-bar-selected-color)',borderRadius:'100px',height:'32px',padding:'0 10px',}}>
                                                <span>{selectTag.label}</span>
                                                <img className={'img-14 cursor-pointer'} src={getImagePathWithTheme('tag_close')} onClick={()=>{
                                                    setSelectTag(null);
                                                    projectTagFilterRef.current?.onResetTag();
                                                }}/>
                                            </div>
                                        }

                                        {
                                            sliderType == 'project' &&
                                            <img id={'img-home-search-1'} className={'img-16 cursor-pointer mr-16'} style={{marginTop: '-2px',padding:'1px'}} onClick={async ()=>{
                                                //转到首页..
                                                let home = await getNoteById(KEY_DEFAULT_PROJECT_ID);
                                                if (!home){
                                                    home = createEmptyProject(KEY_DEFAULT_PROJECT_ID,t("Home"));
                                                }

                                                setSliderProjectData(home)
                                            }} src={getImagePathWithTheme('slider_home_project_home.svg')}/>
                                        }

                                        {
                                            !sliderVideoNotes &&
                                            <img id={'img-home-search-1'} className={'img-16 cursor-pointer'}
                                                 style={{marginTop: '0px'}}
                                                 onClick={() => {
                                                     setIsCommonSearchVisible(!isCommonSearchVisible);
                                                     nTimeoutId = setTimeout(() => {
                                                         document.getElementById('input-common-search')?.focus();
                                                     }, 100);
                                                     mArrayTimeoutIds.current.push(nTimeoutId);
                                                 }} src={getImagePathWithTheme('search_black.svg')}/>
                                        }

                                        {
                                            sliderType == 'project' &&
                                            <>
                                                <ProjectTagFilter ref={projectTagFilterRef} margin={'0 0 0 12px'} onRefreshData={(szTagName:any)=>{
                                                    sideProjectRef.current?.updateNoteList(szTagName);
                                                }} onTagSelected={(tag)=>{
                                                    setSelectTag(tag);
                                                }}/>
                                                <ProjectSort margin={'0 0 0 4px'} onRefreshData={()=>{
                                                    sideProjectRef.current?.updateNoteList();
                                                }}/>
                                            </>
                                        }

                                        {/*<Tooltip arrow={false} title={i18next.t("Export")}>*/}
                                        {/*    <img className={'img-24 cursor-pointer ml-8'} src={getImagePathWithTheme('local_video_export')}*/}
                                        {/*         onClick={()=>{*/}
                                        {/*             const exportValues =*/}
                                        {/*                 videoContentRef.current!.exportCurrentElementVideoNotes();*/}
                                        {/*             saveElementVideoNotesAsJSON(exportValues);*/}
                                        {/*         }}/>*/}
                                        {/*</Tooltip>*/}
                                        {/*<Tooltip arrow={false} title={i18next.t("Copy to clipboard")}>*/}
                                        {/*    <img className={'img-24 cursor-pointer ml-6'} src={getImagePathWithTheme('local_video_copy')}*/}
                                        {/*         onClick={async ()=>{*/}
                                        {/*             const text = videoContentRef.current!.getCurrentElementVideoNotes();*/}
                                        {/*             await navigator.clipboard.writeText(text);*/}
                                        {/*             message.info('Notes copied to clipboard')*/}
                                        {/*         }}/>*/}
                                        {/*</Tooltip>*/}
                                    </>
                                }

                                {/*<div style={{flexGrow:'1'}}></div>*/}
                                {
                                    !isPresentMode && sliderType != 'project' &&
                                    <Dropdown trigger={["click"]}
                                              menu={{items: arrayCommonSliderMoreMenu,onClick:handleCommonMoreMenu}}>
                                        <img id={'vertical_more_3'} style={{flexShrink: '0'}} className={'ml-12 img-14 cursor-pointer'}
                                             src={getImagePathWithTheme('vertical_more')}/>
                                    </Dropdown>
                                }
                            </div>
                        }

                        {/*//这里是头部  end.......*/}

                        {
                            //这里是不同的container
                            sliderType == 'video' &&
                            <div style={{
                                padding: '0 16px',
                                overflow: 'hidden',
                                height: sliderHeaderVisible ? (isMac() ? 'calc(100% - 92px)' : 'calc(100% - 122px)') : (isMac() ? 'calc(100% - 60px)' : 'calc(100% - 92px)'),
                                paddingBottom: '16px',
                                background: isDarkMode() ? 'transparent' : 'white'
                            }}/*className={clsx("excalidraw excalidraw-container", {})}*/>
                                {(isFileVideoElement(sliderVideoNotes?.element) || isAudioFileElement(sliderVideoNotes?.element)) && (
                                    <VideoLocalContent videoNotes={sliderVideoNotes} from={'slider'}
                                                       subFrom={FROM_LIBRARY} hasHeader={sliderHeaderVisible}
                                                       ref={videoContentRef}/>
                                )}
                                {isEmbeddableElement(sliderVideoNotes?.element) && (
                                    <VideoContent videoNotes={sliderVideoNotes} from={'slider'} subFrom={FROM_LIBRARY}
                                                  hasHeader={sliderHeaderVisible}
                                                  pointerEvents={commonContainerPointerEvent} ref={videoContentRef}/>
                                )}
                            </div>
                        }

                        {
                            //project
                            // sliderType == 'project' &&
                            <>
                                {
                                    <div style={{height:'calc(100% - 46px)',display: sliderType == 'project'?'inline':'none'}}>
                                        {
                                            !sliderProjectData &&
                                            <HomeIndex ref={sideProjectRef} from={FROM_RIGHT_SIDE} onCallback={async (szAction:any,data:any)=>{
                                                if (szAction == 'nagivator') {
                                                    const doc = await getNoteJsonDoc(data.id);
                                                    setSliderProjectData({...data,doc});
                                                    // setSliderHeaderVisible(false);
                                                }
                                            }}/>
                                        }
                                        {
                                            <div style={{height:'100%'}}>
                                                <div className={'flex-row-vertical-center'}
                                                     style={{height: '45px', padding: '0 16px',borderBottom:'1px solid var(--right-slider-project-split-color)'}}>
                                                    {/*<Popover arrow={false} align={{offset:[46,6]}} placement={"bottom"} trigger={['click']} open={isShowPopupBoard} onOpenChange={(e)=>setIsShowPopupBoard(e)} overlayInnerStyle={{padding:'0',margin:'0'}} content={renderSliderProjectBoard()}>*/}
                                                    {/*    <img className='img-32 hovered-gray-radius ml-0'*/}
                                                    {/*         src={getImagePathWithTheme('left_slider_2')}/>*/}
                                                    {/*</Popover>*/}
                                                    <img className='img-32 hovered-gray-radius ml-0'
                                                         src={getImagePathWithTheme('left_slider_2.svg')} onClick={()=>{
                                                        sendMessageFromDraw('toggleLeftMenu');
                                                    }}/>

                                                    <span className={'ml-6'}>{sliderProjectData?.name}</span>

                                                    <div className={'flex-row-vertical-center'} style={{marginLeft: 'auto'}}>
                                                        {/*//交互侧栏和主画布*/}
                                                        <img className='img-16 ml-0 cursor-pointer'
                                                             onClick={() => {
                                                                 //保存侧栏的项目...
                                                                 sendMessageFromDraw('saveNotes');
                                                                 //侧栏换为当前的project
                                                                 saveNotes().then(res => {
                                                                     const newSliderProjectData = {...sliderProjectData};
                                                                     const newCurrentNoteData = {...mNoteData.current};
                                                                     window.navigateOrigin(getDrawPath(), {
                                                                         state: {
                                                                             noteData: newSliderProjectData,
                                                                             searchKey: ''
                                                                         }
                                                                     });
                                                                     nTimeoutId = setTimeout(() => {
                                                                         if (isString(newCurrentNoteData.doc)) {
                                                                             newCurrentNoteData.doc = JSON.parse(newCurrentNoteData.doc);
                                                                         }
                                                                         setSliderProjectData(newCurrentNoteData);
                                                                     }, 500)
                                                                     // mArrayTimeoutIds.current.push(nTimeoutId);//这里不能加进来。延迟被清了。。这个要执行的.
                                                                 })
                                                             }} src={getImagePathWithTheme('switch_draw')}/>
                                                        {/*//侧栏画布全屏*/}
                                                        <img className='img-16 ml-16 cursor-pointer'
                                                             onClick={() => {
                                                                 drawIndexSliderHeaderAction("collapse");
                                                                 window.navigateOrigin(getDrawPath(), {
                                                                     state: {
                                                                         noteData: sliderProjectData,
                                                                         searchKey: ''
                                                                     }
                                                                 });
                                                             }} src={getImagePathWithTheme('draw_fullscreen')}/>
                                                    </div>
                                                </div>

                                                <iframe id={'iframe-slider-drawindex-container'} style={{
                                                    display: sliderProjectData ? 'inherit' : 'none',
                                                    width: '100%',
                                                    height: '100%',
                                                    border: 'none',
                                                    pointerEvents:commonContainerPointerEvent
                                                }}
                                                        src={sliderProjectData ? (DEBUG ? `/#/sliderDraw/${getSiderDrawSubLink()}` : global.g_base_url + `#sliderDraw/${getSiderDrawSubLink()}`) : ''}
                                                />
                                            </div>
                                        }
                                    </div>
                                }
                            </>
                        }

                        {
                            sliderType == 'info' &&
                            <div style={{padding: '0 20px', height: '100%'}}>
                                {
                                sliderTitleInfo &&
                                    <div className={'flex-row-vertical-center'} style={{height: '56px'}}>
                                        <img className={'img-16'}
                                             src={getImagePathWithTheme(sliderTitleInfo?.image)}/>
                                        <span className={'ml-6'}>{sliderTitleInfo?.title}</span>
                                    </div>
                                }
                                {
                                    !sliderTitleInfo &&
                                    <span style={{color: 'var(--text-color-bab8b8)',marginTop:'22px',display:'block'}}>{t("NoInformation")}</span>
                                }

                                <div style={{opacity: sliderTitleInfo?'1':'0',marginTop:'0px',borderTopLeftRadius:'8px',borderTopRightRadius:'8px',border:'1px solid var(--line-color)',padding:'16px',background:'var(--background-color-white)',height:'100%',overflowX:'hidden'}}>
                                    <div style={{marginTop: '-12px', }}>
                                        <LibraryInfos from={FROM_RIGHT_SIDEBAR} ref={sideInfoRef} from={'RightSlider'} height={0}/>
                                    </div>
                                </div>
                            </div>
                        }

                        {
                            sliderType == 'webview' &&
                            <CustomWebView pointerEvents={commonContainerPointerEvent} selectType ={sliderType} url={sliderWebviewItem?.link} from={'drawIndex'}/>
                        }
                    </div>
                </div>
                //endregion
            }

            {
                !hasElement && !APP_WEB && !isInSlider() &&
                <span style={{
                    color: 'var(--canvas-new-card-tip-color)',
                    position: 'absolute',
                    left: `calc(50% + ${homePaddingLeft / 2 + (isCollapsePage ? 0 : LEFT_MENU_WIDTH / 2)}px)`,
                    top: '50%',
                    zIndex: '2',
                    fontSize: '12px',
                    transform: 'translate(-50%,-50%)'
                }}>{t("DoubleClickCreateCard")}</span>
            }

            {
                !isPresentMode &&
                <div className={'flex-row-vertical-center'} style={{
                    background: 'var(--background-color-white)',
                    position: 'absolute',
                    zIndex: '3',
                    right: `${getBottomZoomMarginRight() + 190}px`,
                    bottom: '12px',
                    padding: '2px 10px',
                    borderRadius: '8px'
                }}>
                    <Tooltip arrow={false} title={<div>{t("SelectAndPan")}<span
                        className={'tooltip-shortcut-key'}>{getCtrlOrAlt("H")}</span></div>}>
                        <img style={{
                            background: (activityTool == 'selection' || activityTool == 'hand') ? 'var(--draw-tool-bar-selected-color)' : 'transparent',
                            borderRadius: '8px'
                        }} className={'img-32 cursor-pointer hovered-gray-radius'}
                             src={getImagePathWithTheme(activityTool == 'hand'?'draw_tool_hand.svg':'draw_tool_selection.svg')}
                             onClick={() => {
                                 toolsClicked({currentTarget: {dataset: {id: 'selection'}}})
                             }}/>
                    </Tooltip>

                    <Tooltip arrow={false} title={<div>{t("Arrow")}<span
                        className={'tooltip-shortcut-key'}>{getCtrlOrAlt("A")}</span></div>}>
                        <img style={{
                            background: activityTool == 'arrow' ? 'var(--draw-tool-bar-selected-color)' : 'transparent',
                            borderRadius: '8px'
                        }} className={'img-32 cursor-pointer hovered-gray-radius ml-10'}
                             src={getImagePathWithTheme('draw_tool_arrow.svg')}
                             onClick={() => {
                                 toolsClicked({currentTarget: {dataset: {id: 'arrow'}}})
                             }}/>
                    </Tooltip>

                    <Tooltip arrow={false} title={<div>{t("Search")}<span
                        className={'tooltip-shortcut-key'}>{getCtrlOrAlt("Ctrl + F")}</span></div>}>
                        <img className={'img-32 cursor-pointer hovered-gray-radius ml-10'}
                             src={getImagePathWithTheme('draw_tool_search.svg')}
                             onClick={() => {
                                 showSearch();
                             }}/>
                    </Tooltip>

                    {/*怎么着都不会刷新这个content???????*/}
                    <Popover open={isShowCanvasConfig} arrow={false} trigger={['click']} align={{offset:[0,-6]}}
                             content={<DrawIndexCanvasConfig ref={drawIndexCanvasConfigRef} isShow={isShowCanvasConfig} callback={(szAction)=>{
                        if ('useScrollWheel' == szAction){
                            refreshMenuMore();
                        }else if ('backgroundColor' == szAction){
                            setIsShowCanvasConfig(false);
                            dialogColorChooseRef.current?.onShowDialog(excalidrawRef?.getAppState()?.viewBackgroundColor, excalidrawRef?.getAppState());
                        }
                    }}/>} onOpenChange={(e)=>{
                        drawIndexCanvasConfigRef.current?.onRefresh();
                        setIsShowCanvasConfig(e);
                    }}>
                        <Tooltip arrow={false} title={t('ViewSettings')}>
                            <img className={'img-32 cursor-pointer hovered-gray-radius ml-10'}
                                 src={getImagePathWithTheme('canvas_setting.svg')}/>
                        </Tooltip>

                    </Popover>
                </div>
            }

            {
                !isPresentMode &&
                //底部工具栏百分比缩放
                <div className={'flex-row-vertical-center'} style={{
                    background: 'var(--background-color-white)',
                    position: 'absolute',
                    zIndex: '3',
                    right: `${getBottomZoomMarginRight() + 12}px`,
                    bottom: '12px',
                    padding: '2px 10px',
                    borderRadius: '8px'
                }}>
                    <Tooltip title={t("Zoom out")} arrow={false}>
                    <img className={'img-32 cursor-pointer hovered-gray-radius'} src={getImagePathWithTheme('zoom_in.svg')}
                         onClick={() => {
                             zoomSize(-1)
                         }}/>
                    </Tooltip>
                    {/*<input className={'button-no-border flex-row-vertical-center'} value={inputZoom} maxLength={4} style={{width:'46px',background:'transparent',textAlign:'center'}}*/}
                    {/*       onFocus={(e)=>{*/}
                    {/*    e.currentTarget.select();*/}
                    {/*}} onKeyDown={(e) => {*/}
                    {/*    const fZoom = parseFloat(inputZoom);*/}
                    {/*    if (e.keyCode == 13 ) {*/}
                    {/*        if (fZoom > 0 && !isNaN(fZoom)) {*/}
                    {/*            zoomSize(0, (fZoom / 100));*/}
                    {/*            setZoom((fZoom / 100) + '');*/}
                    {/*        }else {*/}
                    {/*            setInputZoom(Math.floor(excalidrawAPI.getApp().state.zoom.value * 100) + '%');*/}
                    {/*        }*/}
                    {/*    }*/}
                    {/*}} onChange={(e) => {*/}
                    {/*    let value: any = e.currentTarget.value.replaceAll("%", '');*/}
                    {/*    value = parseFloat(value);*/}
                    {/*    if (isNaN(value)) {*/}
                    {/*        value = '';*/}
                    {/*    }*/}
                    {/*    setInputZoom(value)*/}
                    {/*}}/>*/}
                    <ConfigProvider
                        theme={{
                            components: {
                                Popover: {
                                    /* 这里是你的组件 token */
                                    // sizePopupArrow: 10,
                                    colorBgElevated: '#ffffff00',
                                    boxShadowSecondary: 'none'
                                },
                            },
                        }}>
                        <Popover trigger={'click'} open={isPopoverZoomVisible} arrow={false}
                                 // overlayStyle={{
                                 //     top: '52px',
                                 // }}
                                 onVisibleChange={(e) => setIsPopoverZoomVisible(e)} onOpenChange={(e) => {
                            if (e) {
                                try {
                                    var zoomValue = parseInt(excalidrawRef.getAppState()?.zoom?.value * 100 + '', 10);
                                    setInputZoom(Math.floor(zoomValue) + '%')
                                } catch (e) {

                                }
                                // setInputZoom((inputZoom+'').replaceAll('%','')+'%');
                            }
                        }} content={
                            <div>
                                <div className='div-zoom font-size-12 popover-box-shadow'>
                                    <Input variant={"borderless"} value={inputZoom}
                                           className='default-font-size input-border'
                                           onFocus={(e) => {
                                               e.currentTarget.select();
                                           }}
                                           placeholder={Math.floor(excalidrawRef?.getAppState()?.zoom?.value * 100) + '%'}
                                           maxLength={'4'}
                                           onKeyDown={(e) => {
                                               const fZoom = parseFloat(inputZoom);
                                               if (e.keyCode == 13 && fZoom > 0 && !isNaN(fZoom)) {
                                                   zoomSize(0, (fZoom / 100));
                                                   setZoom((fZoom / 100) + '');
                                               }
                                           }} onChange={(e) => {
                                        let value: any = e.currentTarget.value.replaceAll("%", '');
                                        value = parseFloat(value);
                                        if (!isNaN(value) && value > 0) {
                                            setInputZoom(value)
                                        }
                                    }}/>
                                    <span onClick={() => zoomSize(1)} className='mt-8'
                                          style={{marginTop: '8px'}}>{t("Zoom in")}</span>
                                    <span onClick={() => zoomSize(-1)}>{t("Zoom out")}</span>
                                    <div style={{margin: '8px -12px'}} className='line'></div>
                                    <span onClick={() => zoomSize(1, 0.5)}>50%</span>
                                    <span onClick={() => zoomSize(1, 1.0)}>100%</span>
                                    <span onClick={() => zoomSize(1, 2.0)}>200%</span>
                                </div>

                                {/*<img style={{*/}
                                {/*    width: '8px',*/}
                                {/*    height: '8px',*/}
                                {/*    position: 'absolute',*/}
                                {/*    background: 'transparent',*/}
                                {/*    top: '3px',*/}
                                {/*    right: '60px'*/}
                                {/*}}*/}
                                {/*     src={getImagePathWithTheme('small_sanjiao')}/>*/}
                            </div>

                        }>
                            <div className='flex-center ml-4 hovered-gray-radius' style={{
                                padding: '0 5px',
                                height: '32px',
                                borderRadius: '8px',
                                color: 'var(--home-left-normal-item-color)'
                            }}>
                                <span className='font-size-12' style={{width: '32px',textAlign:'center'}}>{zoom + '%'}</span>
                            </div>
                        </Popover>
                    </ConfigProvider>
                    <Tooltip title={t("Zoom in")} arrow={false}>
                    <img className={'img-32 cursor-pointer hovered-gray-radius'} src={getImagePathWithTheme('zoom_out.svg')} onClick={()=>{
                        zoomSize(1)
                    }}/>
                    </Tooltip>
                    {/*<Dropdown menu={{items:MENU_HELPER_MORE}} trigger={["click"]} align={{*/}
                    {/*    offset:[0,8]*/}
                    {/*}}>*/}
                    {/*    <Tooltip title={t("HelpAndResource")} arrow={false}>*/}
                    {/*    <img className={'img-32 cursor-pointer hovered-gray-radius'}*/}
                    {/*         src={getImagePathWithTheme('draw_button_helper')}/>*/}
                    {/*    </Tooltip>*/}
                    {/*</Dropdown>*/}

                    <Tooltip title={<div>{t("ZoomToFit")}<span
                        className={'tooltip-shortcut-key'}>{getCtrlOrAlt("1")}</span></div>} arrow={false}>
                        <img className={'img-32 cursor-pointer hovered-gray-radius'}
                             src={getImagePathWithTheme('canvas_zoom_to_fit.svg')} onClick={(e)=>{
                                 excalidrawRef.getApp().scrollToContent(excalidrawRef.getApp().getSceneElements(),{fitToContent:true})
                        }}/>
                    </Tooltip>
                </div>
            }

            {
                isShareCardPage &&
                <SharePageCard/>
            }
        </div>
    )
})

export default memo(withGuard(DrawIndex))

















